import Z, { createContext as Ar, useContext as nr, useDebugValue as pt, useState as ut, useCallback as ge, useEffect as Oe, memo as pl, forwardRef as Qa, useRef as it, useImperativeHandle as Jf, useMemo as Pt } from "react";
import Hf from "loglevel";
import hl from "react-dom";
var kt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Gf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var sa = { exports: {} }, xn = {};
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ls;
function Kf() {
  if (Ls)
    return xn;
  Ls = 1;
  var e = Z, t = 60103;
  if (xn.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var n = Symbol.for;
    t = n("react.element"), xn.Fragment = n("react.fragment");
  }
  var r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = Object.prototype.hasOwnProperty, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(u, c, l) {
    var d, h = {}, g = null, b = null;
    l !== void 0 && (g = "" + l), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (b = c.ref);
    for (d in c)
      i.call(c, d) && !o.hasOwnProperty(d) && (h[d] = c[d]);
    if (u && u.defaultProps)
      for (d in c = u.defaultProps, c)
        h[d] === void 0 && (h[d] = c[d]);
    return { $$typeof: t, type: u, key: g, ref: b, props: h, _owner: r.current };
  }
  return xn.jsx = a, xn.jsxs = a, xn;
}
var Ao = {};
/** @license React v16.14.0
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Is;
function Yf() {
  return Is || (Is = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = Z, n = 60103, r = 60106;
      e.Fragment = 60107;
      var i = 60108, o = 60114, a = 60109, u = 60110, c = 60112, l = 60113, d = 60120, h = 60115, g = 60116, b = 60121, y = 60122, v = 60117, _ = 60129, w = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var k = Symbol.for;
        n = k("react.element"), r = k("react.portal"), e.Fragment = k("react.fragment"), i = k("react.strict_mode"), o = k("react.profiler"), a = k("react.provider"), u = k("react.context"), c = k("react.forward_ref"), l = k("react.suspense"), d = k("react.suspense_list"), h = k("react.memo"), g = k("react.lazy"), b = k("react.block"), y = k("react.server.block"), v = k("react.fundamental"), k("react.scope"), k("react.opaque.id"), _ = k("react.debug_trace_mode"), k("react.offscreen"), w = k("react.legacy_hidden");
      }
      var O = typeof Symbol == "function" && Symbol.iterator, I = "@@iterator";
      function N(P) {
        if (P === null || typeof P != "object")
          return null;
        var z = O && P[O] || P[I];
        return typeof z == "function" ? z : null;
      }
      var E = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function L(P) {
        {
          for (var z = arguments.length, X = new Array(z > 1 ? z - 1 : 0), _e = 1; _e < z; _e++)
            X[_e - 1] = arguments[_e];
          B("error", P, X);
        }
      }
      function B(P, z, X) {
        {
          var _e = E.ReactDebugCurrentFrame, R = "";
          if (ke) {
            var T = se(ke.type), j = ke._owner;
            R += ie(T, ke._source, j && se(j.type));
          }
          R += _e.getStackAddendum(), R !== "" && (z += "%s", X = X.concat([R]));
          var V = X.map(function(U) {
            return "" + U;
          });
          V.unshift("Warning: " + z), Function.prototype.apply.call(console[P], console, V);
        }
      }
      var Q = !1;
      function G(P) {
        return !!(typeof P == "string" || typeof P == "function" || P === e.Fragment || P === o || P === _ || P === i || P === l || P === d || P === w || Q || typeof P == "object" && P !== null && (P.$$typeof === g || P.$$typeof === h || P.$$typeof === a || P.$$typeof === u || P.$$typeof === c || P.$$typeof === v || P.$$typeof === b || P[0] === y));
      }
      var te = /^(.*)[\\\/]/;
      function ie(P, z, X) {
        var _e = "";
        if (z) {
          var R = z.fileName, T = R.replace(te, "");
          if (/^index\./.test(T)) {
            var j = R.match(te);
            if (j) {
              var V = j[1];
              if (V) {
                var U = V.replace(te, "");
                T = U + "/" + T;
              }
            }
          }
          _e = " (at " + T + ":" + z.lineNumber + ")";
        } else
          X && (_e = " (created by " + X + ")");
        return `
    in ` + (P || "Unknown") + _e;
      }
      var J = 1;
      function ce(P) {
        return P._status === J ? P._result : null;
      }
      function Me(P, z, X) {
        var _e = z.displayName || z.name || "";
        return P.displayName || (_e !== "" ? X + "(" + _e + ")" : X);
      }
      function se(P) {
        if (P == null)
          return null;
        if (typeof P.tag == "number" && L("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof P == "function")
          return P.displayName || P.name || null;
        if (typeof P == "string")
          return P;
        switch (P) {
          case e.Fragment:
            return "Fragment";
          case r:
            return "Portal";
          case o:
            return "Profiler";
          case i:
            return "StrictMode";
          case l:
            return "Suspense";
          case d:
            return "SuspenseList";
        }
        if (typeof P == "object")
          switch (P.$$typeof) {
            case u:
              return "Context.Consumer";
            case a:
              return "Context.Provider";
            case c:
              return Me(P, P.render, "ForwardRef");
            case h:
              return se(P.type);
            case b:
              return se(P.render);
            case g: {
              var z = P, X = ce(z);
              if (X)
                return se(X);
              break;
            }
          }
        return null;
      }
      var Re = {};
      E.ReactDebugCurrentFrame;
      var ke = null;
      function Ae(P) {
        ke = P;
      }
      function K(P, z, X, _e, R) {
        {
          var T = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var j in P)
            if (T(P, j)) {
              var V = void 0;
              try {
                if (typeof P[j] != "function") {
                  var U = Error((_e || "React class") + ": " + X + " type `" + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof P[j] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw U.name = "Invariant Violation", U;
                }
                V = P[j](z, j, _e, X, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (q) {
                V = q;
              }
              V && !(V instanceof Error) && (Ae(R), L("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _e || "React class", X, j, typeof V), Ae(null)), V instanceof Error && !(V.message in Re) && (Re[V.message] = !0, Ae(R), L("Failed %s type: %s", X, V.message), Ae(null));
            }
        }
      }
      var Y = E.ReactCurrentOwner, M = Object.prototype.hasOwnProperty, s = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, p, f, m;
      m = {};
      function S(P) {
        if (M.call(P, "ref")) {
          var z = Object.getOwnPropertyDescriptor(P, "ref").get;
          if (z && z.isReactWarning)
            return !1;
        }
        return P.ref !== void 0;
      }
      function C(P) {
        if (M.call(P, "key")) {
          var z = Object.getOwnPropertyDescriptor(P, "key").get;
          if (z && z.isReactWarning)
            return !1;
        }
        return P.key !== void 0;
      }
      function A(P, z) {
        if (typeof P.ref == "string" && Y.current && z && Y.current.stateNode !== z) {
          var X = se(Y.current.type);
          m[X] || (L('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', se(Y.current.type), P.ref), m[X] = !0);
        }
      }
      function x(P, z) {
        {
          var X = function() {
            p || (p = !0, L("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", z));
          };
          X.isReactWarning = !0, Object.defineProperty(P, "key", {
            get: X,
            configurable: !0
          });
        }
      }
      function F(P, z) {
        {
          var X = function() {
            f || (f = !0, L("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", z));
          };
          X.isReactWarning = !0, Object.defineProperty(P, "ref", {
            get: X,
            configurable: !0
          });
        }
      }
      var W = function(P, z, X, _e, R, T, j) {
        var V = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: n,
          // Built-in properties that belong on the element
          type: P,
          key: z,
          ref: X,
          props: j,
          // Record the component responsible for creating this element.
          _owner: T
        };
        return V._store = {}, Object.defineProperty(V._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(V, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: _e
        }), Object.defineProperty(V, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: R
        }), Object.freeze && (Object.freeze(V.props), Object.freeze(V)), V;
      };
      function H(P, z, X, _e, R) {
        {
          var T, j = {}, V = null, U = null;
          X !== void 0 && (V = "" + X), C(z) && (V = "" + z.key), S(z) && (U = z.ref, A(z, R));
          for (T in z)
            M.call(z, T) && !s.hasOwnProperty(T) && (j[T] = z[T]);
          if (P && P.defaultProps) {
            var q = P.defaultProps;
            for (T in q)
              j[T] === void 0 && (j[T] = q[T]);
          }
          if (V || U) {
            var ne = typeof P == "function" ? P.displayName || P.name || "Unknown" : P;
            V && x(j, ne), U && F(j, ne);
          }
          return W(P, V, U, R, _e, Y.current, j);
        }
      }
      var ve = E.ReactCurrentOwner;
      E.ReactDebugCurrentFrame;
      function Ee(P) {
        ke = P;
      }
      var me;
      me = !1;
      function oe(P) {
        return typeof P == "object" && P !== null && P.$$typeof === n;
      }
      function Ne() {
        {
          if (ve.current) {
            var P = se(ve.current.type);
            if (P)
              return `

Check the render method of \`` + P + "`.";
          }
          return "";
        }
      }
      function tt(P) {
        {
          if (P !== void 0) {
            var z = P.fileName.replace(/^.*[\\\/]/, ""), X = P.lineNumber;
            return `

Check your code at ` + z + ":" + X + ".";
          }
          return "";
        }
      }
      var Ue = {};
      function he(P) {
        {
          var z = Ne();
          if (!z) {
            var X = typeof P == "string" ? P : P.displayName || P.name;
            X && (z = `

Check the top-level render call using <` + X + ">.");
          }
          return z;
        }
      }
      function We(P, z) {
        {
          if (!P._store || P._store.validated || P.key != null)
            return;
          P._store.validated = !0;
          var X = he(z);
          if (Ue[X])
            return;
          Ue[X] = !0;
          var _e = "";
          P && P._owner && P._owner !== ve.current && (_e = " It was passed a child from " + se(P._owner.type) + "."), Ee(P), L('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', X, _e), Ee(null);
        }
      }
      function Ke(P, z) {
        {
          if (typeof P != "object")
            return;
          if (Array.isArray(P))
            for (var X = 0; X < P.length; X++) {
              var _e = P[X];
              oe(_e) && We(_e, z);
            }
          else if (oe(P))
            P._store && (P._store.validated = !0);
          else if (P) {
            var R = N(P);
            if (typeof R == "function" && R !== P.entries)
              for (var T = R.call(P), j; !(j = T.next()).done; )
                oe(j.value) && We(j.value, z);
          }
        }
      }
      function _t(P) {
        {
          var z = P.type;
          if (z == null || typeof z == "string")
            return;
          var X;
          if (typeof z == "function")
            X = z.propTypes;
          else if (typeof z == "object" && (z.$$typeof === c || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          z.$$typeof === h))
            X = z.propTypes;
          else
            return;
          if (X) {
            var _e = se(z);
            K(X, P.props, "prop", _e, P);
          } else if (z.PropTypes !== void 0 && !me) {
            me = !0;
            var R = se(z);
            L("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", R || "Unknown");
          }
          typeof z.getDefaultProps == "function" && !z.getDefaultProps.isReactClassApproved && L("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function jt(P) {
        {
          for (var z = Object.keys(P.props), X = 0; X < z.length; X++) {
            var _e = z[X];
            if (_e !== "children" && _e !== "key") {
              Ee(P), L("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _e), Ee(null);
              break;
            }
          }
          P.ref !== null && (Ee(P), L("Invalid attribute `ref` supplied to `React.Fragment`."), Ee(null));
        }
      }
      function Dt(P, z, X, _e, R, T) {
        {
          var j = G(P);
          if (!j) {
            var V = "";
            (P === void 0 || typeof P == "object" && P !== null && Object.keys(P).length === 0) && (V += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var U = tt(R);
            U ? V += U : V += Ne();
            var q;
            P === null ? q = "null" : Array.isArray(P) ? q = "array" : P !== void 0 && P.$$typeof === n ? (q = "<" + (se(P.type) || "Unknown") + " />", V = " Did you accidentally export a JSX literal instead of a component?") : q = typeof P, L("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", q, V);
          }
          var ne = H(P, z, X, R, T);
          if (ne == null)
            return ne;
          if (j) {
            var re = z.children;
            if (re !== void 0)
              if (_e)
                if (Array.isArray(re)) {
                  for (var ae = 0; ae < re.length; ae++)
                    Ke(re[ae], P);
                  Object.freeze && Object.freeze(re);
                } else
                  L("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Ke(re, P);
          }
          return P === e.Fragment ? jt(ne) : _t(ne), ne;
        }
      }
      function To(P, z, X) {
        return Dt(P, z, X, !0);
      }
      function Ro(P, z, X) {
        return Dt(P, z, X, !1);
      }
      var Co = Ro, Mo = To;
      e.jsx = Co, e.jsxs = Mo;
    }();
  }(Ao)), Ao;
}
process.env.NODE_ENV === "production" ? sa.exports = Kf() : sa.exports = Yf();
var D = sa.exports;
const qe = Hf.getLogger("boutiq-video");
function Fk() {
  return qe;
}
const vl = Ar(null), zt = {
  cta_mute_audio: {
    id: "cta_mute_audio",
    default: () => "Mute Audio"
  },
  cta_unmute_audio: {
    id: "cta_unmute_audio",
    default: () => "Unmute Audio"
  },
  cta_mute_video: {
    id: "cta_mute_video",
    default: () => "Mute Video"
  },
  cta_unmute_video: {
    id: "cta_unmute_video",
    default: () => "Unmute Video"
  },
  cta_bye: {
    id: "cta_bye",
    default: () => "bye"
  },
  cta_switch_camera: {
    id: "cta_switch_camera",
    default: () => "Switch Camera"
  },
  cta_start_screen_share: {
    id: "cta_start_screen_share",
    default: () => "Share Screen"
  },
  cta_stop_screen_share: {
    id: "cta_stop_screen_share",
    default: () => "Stop Share Screen"
  },
  screen_share_in_progress: {
    id: "screen_share_in_progress",
    default: () => "Cannot share screen when another user is sharing"
  },
  screen_share_not_supported: {
    id: "screen_share_not_supported",
    default: () => "Screen sharing is not supported with this browser"
  },
  remote_muted_audio: {
    id: "remote_muted_audio",
    default: ({ name: e }) => `${e} is muted`
  },
  remote_muted_video: {
    id: "remote_muted_video",
    default: ({ name: e }) => `${e}'s camera is off`
  },
  local_muted_audio: {
    id: "local_muted_audio",
    default: () => "You are muted"
  },
  local_muted_video: {
    id: "local_muted_video",
    default: () => "Your camera is off"
  },
  reconnecting: {
    id: "reconnecting",
    default: () => "Reconnecting"
  },
  end_call: {
    id: "end_call",
    default: () => "End Call"
  }
};
function Qf({ children: e, formatter: t }) {
  const n = (r, i) => {
    if (t)
      try {
        return t({ id: r.id, params: i });
      } catch (o) {
        return qe.error(`VideoRoomI18nProvider ${r.id}`, o), r.default(i);
      }
    else
      return r.default(i);
  };
  return /* @__PURE__ */ D.jsx(vl.Provider, { value: {
    format: n
  }, children: e });
}
function rr() {
  const e = nr(vl);
  if (!e)
    throw new Error("useVideoRoomI18nProvider must be used within the scope of VideoRoomI18nContext");
  return e;
}
function xs(e, t) {
  if (e == null)
    return {};
  var n, r, i = function(a, u) {
    if (a == null)
      return {};
    var c = {};
    for (var l in a)
      if ({}.hasOwnProperty.call(a, l)) {
        if (u.indexOf(l) !== -1)
          continue;
        c[l] = a[l];
      }
    return c;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++)
      n = o[r], t.indexOf(n) === -1 && {}.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
  }
  return i;
}
function gt(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function Te(e) {
  return Te = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, Te(e);
}
function ml(e) {
  var t = function(n, r) {
    if (Te(n) != "object" || !n)
      return n;
    var i = n[Symbol.toPrimitive];
    if (i !== void 0) {
      var o = i.call(n, r || "default");
      if (Te(o) != "object")
        return o;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (r === "string" ? String : Number)(n);
  }(e, "string");
  return Te(t) == "symbol" ? t : t + "";
}
function js(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, ml(r.key), r);
  }
}
function yt(e, t, n) {
  return t && js(e.prototype, t), n && js(e, n), Object.defineProperty(e, "prototype", { writable: !1 }), e;
}
function Vi(e, t) {
  if (t && (Te(t) == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return function(n) {
    if (n === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return n;
  }(e);
}
function Lt(e) {
  return Lt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Lt(e);
}
function Rr(e, t) {
  return Rr = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, Rr(e, t);
}
function $i(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rr(e, t);
}
function Ft(e, t, n) {
  return (t = ml(t)) in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Ds(e, t, n, r, i, o, a) {
  try {
    var u = e[o](a), c = u.value;
  } catch (l) {
    return void n(l);
  }
  u.done ? t(c) : Promise.resolve(c).then(r, i);
}
function ue(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(c) {
        Ds(o, r, i, a, u, "next", c);
      }
      function u(c) {
        Ds(o, r, i, a, u, "throw", c);
      }
      a(void 0);
    });
  };
}
function Vs(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function rt(e, t) {
  return function(n) {
    if (Array.isArray(n))
      return n;
  }(e) || function(n, r) {
    var i = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
    if (i != null) {
      var o, a, u, c, l = [], d = !0, h = !1;
      try {
        if (u = (i = i.call(n)).next, r === 0) {
          if (Object(i) !== i)
            return;
          d = !1;
        } else
          for (; !(d = (o = u.call(i)).done) && (l.push(o.value), l.length !== r); d = !0)
            ;
      } catch (g) {
        h = !0, a = g;
      } finally {
        try {
          if (!d && i.return != null && (c = i.return(), Object(c) !== c))
            return;
        } finally {
          if (h)
            throw a;
        }
      }
      return l;
    }
  }(e, t) || function(n, r) {
    if (n) {
      if (typeof n == "string")
        return Vs(n, r);
      var i = {}.toString.call(n).slice(8, -1);
      return i === "Object" && n.constructor && (i = n.constructor.name), i === "Map" || i === "Set" ? Array.from(n) : i === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? Vs(n, r) : void 0;
    }
  }(e, t) || function() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }();
}
function Zf(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var $s, zr = { exports: {} }, ca = function() {
  if ($s)
    return zr.exports;
  $s = 1;
  var e, t = typeof Reflect == "object" ? Reflect : null, n = t && typeof t.apply == "function" ? t.apply : function(v, _, w) {
    return Function.prototype.apply.call(v, _, w);
  };
  e = t && typeof t.ownKeys == "function" ? t.ownKeys : Object.getOwnPropertySymbols ? function(v) {
    return Object.getOwnPropertyNames(v).concat(Object.getOwnPropertySymbols(v));
  } : function(v) {
    return Object.getOwnPropertyNames(v);
  };
  var r = Number.isNaN || function(v) {
    return v != v;
  };
  function i() {
    i.init.call(this);
  }
  zr.exports = i, zr.exports.once = function(v, _) {
    return new Promise(function(w, k) {
      function O(N) {
        v.removeListener(_, I), k(N);
      }
      function I() {
        typeof v.removeListener == "function" && v.removeListener("error", O), w([].slice.call(arguments));
      }
      y(v, _, I, { once: !0 }), _ !== "error" && function(N, E, L) {
        typeof N.on == "function" && y(N, "error", E, L);
      }(v, O, { once: !0 });
    });
  }, i.EventEmitter = i, i.prototype._events = void 0, i.prototype._eventsCount = 0, i.prototype._maxListeners = void 0;
  var o = 10;
  function a(v) {
    if (typeof v != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof v);
  }
  function u(v) {
    return v._maxListeners === void 0 ? i.defaultMaxListeners : v._maxListeners;
  }
  function c(v, _, w, k) {
    var O, I, N, E;
    if (a(w), (I = v._events) === void 0 ? (I = v._events = /* @__PURE__ */ Object.create(null), v._eventsCount = 0) : (I.newListener !== void 0 && (v.emit("newListener", _, w.listener ? w.listener : w), I = v._events), N = I[_]), N === void 0)
      N = I[_] = w, ++v._eventsCount;
    else if (typeof N == "function" ? N = I[_] = k ? [w, N] : [N, w] : k ? N.unshift(w) : N.push(w), (O = u(v)) > 0 && N.length > O && !N.warned) {
      N.warned = !0;
      var L = new Error("Possible EventEmitter memory leak detected. " + N.length + " " + String(_) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      L.name = "MaxListenersExceededWarning", L.emitter = v, L.type = _, L.count = N.length, E = L, console && console.warn && console.warn(E);
    }
    return v;
  }
  function l() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function d(v, _, w) {
    var k = { fired: !1, wrapFn: void 0, target: v, type: _, listener: w }, O = l.bind(k);
    return O.listener = w, k.wrapFn = O, O;
  }
  function h(v, _, w) {
    var k = v._events;
    if (k === void 0)
      return [];
    var O = k[_];
    return O === void 0 ? [] : typeof O == "function" ? w ? [O.listener || O] : [O] : w ? function(I) {
      for (var N = new Array(I.length), E = 0; E < N.length; ++E)
        N[E] = I[E].listener || I[E];
      return N;
    }(O) : b(O, O.length);
  }
  function g(v) {
    var _ = this._events;
    if (_ !== void 0) {
      var w = _[v];
      if (typeof w == "function")
        return 1;
      if (w !== void 0)
        return w.length;
    }
    return 0;
  }
  function b(v, _) {
    for (var w = new Array(_), k = 0; k < _; ++k)
      w[k] = v[k];
    return w;
  }
  function y(v, _, w, k) {
    if (typeof v.on == "function")
      k.once ? v.once(_, w) : v.on(_, w);
    else {
      if (typeof v.addEventListener != "function")
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof v);
      v.addEventListener(_, function O(I) {
        k.once && v.removeEventListener(_, O), w(I);
      });
    }
  }
  return Object.defineProperty(i, "defaultMaxListeners", { enumerable: !0, get: function() {
    return o;
  }, set: function(v) {
    if (typeof v != "number" || v < 0 || r(v))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + v + ".");
    o = v;
  } }), i.init = function() {
    this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, i.prototype.setMaxListeners = function(v) {
    if (typeof v != "number" || v < 0 || r(v))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + v + ".");
    return this._maxListeners = v, this;
  }, i.prototype.getMaxListeners = function() {
    return u(this);
  }, i.prototype.emit = function(v) {
    for (var _ = [], w = 1; w < arguments.length; w++)
      _.push(arguments[w]);
    var k = v === "error", O = this._events;
    if (O !== void 0)
      k = k && O.error === void 0;
    else if (!k)
      return !1;
    if (k) {
      var I;
      if (_.length > 0 && (I = _[0]), I instanceof Error)
        throw I;
      var N = new Error("Unhandled error." + (I ? " (" + I.message + ")" : ""));
      throw N.context = I, N;
    }
    var E = O[v];
    if (E === void 0)
      return !1;
    if (typeof E == "function")
      n(E, this, _);
    else {
      var L = E.length, B = b(E, L);
      for (w = 0; w < L; ++w)
        n(B[w], this, _);
    }
    return !0;
  }, i.prototype.addListener = function(v, _) {
    return c(this, v, _, !1);
  }, i.prototype.on = i.prototype.addListener, i.prototype.prependListener = function(v, _) {
    return c(this, v, _, !0);
  }, i.prototype.once = function(v, _) {
    return a(_), this.on(v, d(this, v, _)), this;
  }, i.prototype.prependOnceListener = function(v, _) {
    return a(_), this.prependListener(v, d(this, v, _)), this;
  }, i.prototype.removeListener = function(v, _) {
    var w, k, O, I, N;
    if (a(_), (k = this._events) === void 0)
      return this;
    if ((w = k[v]) === void 0)
      return this;
    if (w === _ || w.listener === _)
      --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete k[v], k.removeListener && this.emit("removeListener", v, w.listener || _));
    else if (typeof w != "function") {
      for (O = -1, I = w.length - 1; I >= 0; I--)
        if (w[I] === _ || w[I].listener === _) {
          N = w[I].listener, O = I;
          break;
        }
      if (O < 0)
        return this;
      O === 0 ? w.shift() : function(E, L) {
        for (; L + 1 < E.length; L++)
          E[L] = E[L + 1];
        E.pop();
      }(w, O), w.length === 1 && (k[v] = w[0]), k.removeListener !== void 0 && this.emit("removeListener", v, N || _);
    }
    return this;
  }, i.prototype.off = i.prototype.removeListener, i.prototype.removeAllListeners = function(v) {
    var _, w, k;
    if ((w = this._events) === void 0)
      return this;
    if (w.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : w[v] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete w[v]), this;
    if (arguments.length === 0) {
      var O, I = Object.keys(w);
      for (k = 0; k < I.length; ++k)
        (O = I[k]) !== "removeListener" && this.removeAllListeners(O);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (typeof (_ = w[v]) == "function")
      this.removeListener(v, _);
    else if (_ !== void 0)
      for (k = _.length - 1; k >= 0; k--)
        this.removeListener(v, _[k]);
    return this;
  }, i.prototype.listeners = function(v) {
    return h(this, v, !0);
  }, i.prototype.rawListeners = function(v) {
    return h(this, v, !1);
  }, i.listenerCount = function(v, _) {
    return typeof v.listenerCount == "function" ? v.listenerCount(_) : g.call(v, _);
  }, i.prototype.listenerCount = g, i.prototype.eventNames = function() {
    return this._eventsCount > 0 ? e(this._events) : [];
  }, zr.exports;
}(), Wr = Zf(ca), Bs = Object.prototype.hasOwnProperty;
function Fs(e, t, n) {
  for (n of e.keys())
    if (at(n, t))
      return n;
}
function at(e, t) {
  var n, r, i;
  if (e === t)
    return !0;
  if (e && t && (n = e.constructor) === t.constructor) {
    if (n === Date)
      return e.getTime() === t.getTime();
    if (n === RegExp)
      return e.toString() === t.toString();
    if (n === Array) {
      if ((r = e.length) === t.length)
        for (; r-- && at(e[r], t[r]); )
          ;
      return r === -1;
    }
    if (n === Set) {
      if (e.size !== t.size)
        return !1;
      for (r of e)
        if ((i = r) && typeof i == "object" && !(i = Fs(t, i)) || !t.has(i))
          return !1;
      return !0;
    }
    if (n === Map) {
      if (e.size !== t.size)
        return !1;
      for (r of e)
        if ((i = r[0]) && typeof i == "object" && !(i = Fs(t, i)) || !at(r[1], t.get(i)))
          return !1;
      return !0;
    }
    if (n === ArrayBuffer)
      e = new Uint8Array(e), t = new Uint8Array(t);
    else if (n === DataView) {
      if ((r = e.byteLength) === t.byteLength)
        for (; r-- && e.getInt8(r) === t.getInt8(r); )
          ;
      return r === -1;
    }
    if (ArrayBuffer.isView(e)) {
      if ((r = e.byteLength) === t.byteLength)
        for (; r-- && e[r] === t[r]; )
          ;
      return r === -1;
    }
    if (!n || typeof e == "object") {
      for (n in r = 0, e)
        if (Bs.call(e, n) && ++r && !Bs.call(t, n) || !(n in t) || !at(e[n], t[n]))
          return !1;
      return Object.keys(t).length === r;
    }
  }
  return e != e && t != t;
}
const Xf = { "Amazon Silk": "amazon_silk", "Android Browser": "android", Bada: "bada", BlackBerry: "blackberry", Chrome: "chrome", Chromium: "chromium", Electron: "electron", Epiphany: "epiphany", Firefox: "firefox", Focus: "focus", Generic: "generic", "Google Search": "google_search", Googlebot: "googlebot", "Internet Explorer": "ie", "K-Meleon": "k_meleon", Maxthon: "maxthon", "Microsoft Edge": "edge", "MZ Browser": "mz", "NAVER Whale Browser": "naver", Opera: "opera", "Opera Coast": "opera_coast", PhantomJS: "phantomjs", Puffin: "puffin", QupZilla: "qupzilla", QQ: "qq", QQLite: "qqlite", Safari: "safari", Sailfish: "sailfish", "Samsung Internet for Android": "samsung_internet", SeaMonkey: "seamonkey", Sleipnir: "sleipnir", Swing: "swing", Tizen: "tizen", "UC Browser": "uc", Vivaldi: "vivaldi", "WebOS Browser": "webos", WeChat: "wechat", "Yandex Browser": "yandex", Roku: "roku" }, gl = { amazon_silk: "Amazon Silk", android: "Android Browser", bada: "Bada", blackberry: "BlackBerry", chrome: "Chrome", chromium: "Chromium", electron: "Electron", epiphany: "Epiphany", firefox: "Firefox", focus: "Focus", generic: "Generic", googlebot: "Googlebot", google_search: "Google Search", ie: "Internet Explorer", k_meleon: "K-Meleon", maxthon: "Maxthon", edge: "Microsoft Edge", mz: "MZ Browser", naver: "NAVER Whale Browser", opera: "Opera", opera_coast: "Opera Coast", phantomjs: "PhantomJS", puffin: "Puffin", qupzilla: "QupZilla", qq: "QQ Browser", qqlite: "QQ Browser Lite", safari: "Safari", sailfish: "Sailfish", samsung_internet: "Samsung Internet for Android", seamonkey: "SeaMonkey", sleipnir: "Sleipnir", swing: "Swing", tizen: "Tizen", uc: "UC Browser", vivaldi: "Vivaldi", webos: "WebOS Browser", wechat: "WeChat", yandex: "Yandex Browser" }, ze = { tablet: "tablet", mobile: "mobile", desktop: "desktop", tv: "tv" }, ot = { WindowsPhone: "Windows Phone", Windows: "Windows", MacOS: "macOS", iOS: "iOS", Android: "Android", WebOS: "WebOS", BlackBerry: "BlackBerry", Bada: "Bada", Tizen: "Tizen", Linux: "Linux", ChromeOS: "Chrome OS", PlayStation4: "PlayStation 4", Roku: "Roku" }, nn = { EdgeHTML: "EdgeHTML", Blink: "Blink", Trident: "Trident", Presto: "Presto", Gecko: "Gecko", WebKit: "WebKit" };
class $ {
  static getFirstMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 0 && r[1] || "";
  }
  static getSecondMatch(t, n) {
    const r = n.match(t);
    return r && r.length > 1 && r[2] || "";
  }
  static matchAndReturnConst(t, n, r) {
    if (t.test(n))
      return r;
  }
  static getWindowsVersionName(t) {
    switch (t) {
      case "NT":
        return "NT";
      case "XP":
      case "NT 5.1":
        return "XP";
      case "NT 5.0":
        return "2000";
      case "NT 5.2":
        return "2003";
      case "NT 6.0":
        return "Vista";
      case "NT 6.1":
        return "7";
      case "NT 6.2":
        return "8";
      case "NT 6.3":
        return "8.1";
      case "NT 10.0":
        return "10";
      default:
        return;
    }
  }
  static getMacOSVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), n[0] === 10)
      switch (n[1]) {
        case 5:
          return "Leopard";
        case 6:
          return "Snow Leopard";
        case 7:
          return "Lion";
        case 8:
          return "Mountain Lion";
        case 9:
          return "Mavericks";
        case 10:
          return "Yosemite";
        case 11:
          return "El Capitan";
        case 12:
          return "Sierra";
        case 13:
          return "High Sierra";
        case 14:
          return "Mojave";
        case 15:
          return "Catalina";
        default:
          return;
      }
  }
  static getAndroidVersionName(t) {
    const n = t.split(".").splice(0, 2).map((r) => parseInt(r, 10) || 0);
    if (n.push(0), !(n[0] === 1 && n[1] < 5))
      return n[0] === 1 && n[1] < 6 ? "Cupcake" : n[0] === 1 && n[1] >= 6 ? "Donut" : n[0] === 2 && n[1] < 2 ? "Eclair" : n[0] === 2 && n[1] === 2 ? "Froyo" : n[0] === 2 && n[1] > 2 ? "Gingerbread" : n[0] === 3 ? "Honeycomb" : n[0] === 4 && n[1] < 1 ? "Ice Cream Sandwich" : n[0] === 4 && n[1] < 4 ? "Jelly Bean" : n[0] === 4 && n[1] >= 4 ? "KitKat" : n[0] === 5 ? "Lollipop" : n[0] === 6 ? "Marshmallow" : n[0] === 7 ? "Nougat" : n[0] === 8 ? "Oreo" : n[0] === 9 ? "Pie" : void 0;
  }
  static getVersionPrecision(t) {
    return t.split(".").length;
  }
  static compareVersions(t, n, r = !1) {
    const i = $.getVersionPrecision(t), o = $.getVersionPrecision(n);
    let a = Math.max(i, o), u = 0;
    const c = $.map([t, n], (l) => {
      const d = a - $.getVersionPrecision(l), h = l + new Array(d + 1).join(".0");
      return $.map(h.split("."), (g) => new Array(20 - g.length).join("0") + g).reverse();
    });
    for (r && (u = a - Math.min(i, o)), a -= 1; a >= u; ) {
      if (c[0][a] > c[1][a])
        return 1;
      if (c[0][a] === c[1][a]) {
        if (a === u)
          return 0;
        a -= 1;
      } else if (c[0][a] < c[1][a])
        return -1;
    }
  }
  static map(t, n) {
    const r = [];
    let i;
    if (Array.prototype.map)
      return Array.prototype.map.call(t, n);
    for (i = 0; i < t.length; i += 1)
      r.push(n(t[i]));
    return r;
  }
  static find(t, n) {
    let r, i;
    if (Array.prototype.find)
      return Array.prototype.find.call(t, n);
    for (r = 0, i = t.length; r < i; r += 1) {
      const o = t[r];
      if (n(o, r))
        return o;
    }
  }
  static assign(t, ...n) {
    const r = t;
    let i, o;
    if (Object.assign)
      return Object.assign(t, ...n);
    for (i = 0, o = n.length; i < o; i += 1) {
      const a = n[i];
      typeof a == "object" && a !== null && Object.keys(a).forEach((u) => {
        r[u] = a[u];
      });
    }
    return t;
  }
  static getBrowserAlias(t) {
    return Xf[t];
  }
  static getBrowserTypeByAlias(t) {
    return gl[t] || "";
  }
}
const Le = /version\/(\d+(\.?_?\d+)+)/i, ep = [{ test: [/googlebot/i], describe(e) {
  const t = { name: "Googlebot" }, n = $.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/opera/i], describe(e) {
  const t = { name: "Opera" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/opr\/|opios/i], describe(e) {
  const t = { name: "Opera" }, n = $.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/SamsungBrowser/i], describe(e) {
  const t = { name: "Samsung Internet for Android" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/Whale/i], describe(e) {
  const t = { name: "NAVER Whale Browser" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/MZBrowser/i], describe(e) {
  const t = { name: "MZ Browser" }, n = $.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/focus/i], describe(e) {
  const t = { name: "Focus" }, n = $.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/swing/i], describe(e) {
  const t = { name: "Swing" }, n = $.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/coast/i], describe(e) {
  const t = { name: "Opera Coast" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/opt\/\d+(?:.?_?\d+)+/i], describe(e) {
  const t = { name: "Opera Touch" }, n = $.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/yabrowser/i], describe(e) {
  const t = { name: "Yandex Browser" }, n = $.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/ucbrowser/i], describe(e) {
  const t = { name: "UC Browser" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/Maxthon|mxios/i], describe(e) {
  const t = { name: "Maxthon" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/epiphany/i], describe(e) {
  const t = { name: "Epiphany" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/puffin/i], describe(e) {
  const t = { name: "Puffin" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/sleipnir/i], describe(e) {
  const t = { name: "Sleipnir" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/k-meleon/i], describe(e) {
  const t = { name: "K-Meleon" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/micromessenger/i], describe(e) {
  const t = { name: "WeChat" }, n = $.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/qqbrowser/i], describe(e) {
  const t = { name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser" }, n = $.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/msie|trident/i], describe(e) {
  const t = { name: "Internet Explorer" }, n = $.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/\sedg\//i], describe(e) {
  const t = { name: "Microsoft Edge" }, n = $.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/edg([ea]|ios)/i], describe(e) {
  const t = { name: "Microsoft Edge" }, n = $.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/vivaldi/i], describe(e) {
  const t = { name: "Vivaldi" }, n = $.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/seamonkey/i], describe(e) {
  const t = { name: "SeaMonkey" }, n = $.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/sailfish/i], describe(e) {
  const t = { name: "Sailfish" }, n = $.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
  return n && (t.version = n), t;
} }, { test: [/silk/i], describe(e) {
  const t = { name: "Amazon Silk" }, n = $.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/phantom/i], describe(e) {
  const t = { name: "PhantomJS" }, n = $.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/slimerjs/i], describe(e) {
  const t = { name: "SlimerJS" }, n = $.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe(e) {
  const t = { name: "BlackBerry" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/(web|hpw)[o0]s/i], describe(e) {
  const t = { name: "WebOS Browser" }, n = $.getFirstMatch(Le, e) || $.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/bada/i], describe(e) {
  const t = { name: "Bada" }, n = $.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/tizen/i], describe(e) {
  const t = { name: "Tizen" }, n = $.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/qupzilla/i], describe(e) {
  const t = { name: "QupZilla" }, n = $.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/firefox|iceweasel|fxios/i], describe(e) {
  const t = { name: "Firefox" }, n = $.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/electron/i], describe(e) {
  const t = { name: "Electron" }, n = $.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/MiuiBrowser/i], describe(e) {
  const t = { name: "Miui" }, n = $.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/chromium/i], describe(e) {
  const t = { name: "Chromium" }, n = $.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/chrome|crios|crmo/i], describe(e) {
  const t = { name: "Chrome" }, n = $.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/GSA/i], describe(e) {
  const t = { name: "Google Search" }, n = $.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test(e) {
  const t = !e.test(/like android/i), n = e.test(/android/i);
  return t && n;
}, describe(e) {
  const t = { name: "Android Browser" }, n = $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/playstation 4/i], describe(e) {
  const t = { name: "PlayStation 4" }, n = $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/safari|applewebkit/i], describe(e) {
  const t = { name: "Safari" }, n = $.getFirstMatch(Le, e);
  return n && (t.version = n), t;
} }, { test: [/.*/i], describe(e) {
  const t = e.search("\\(") !== -1 ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
  return { name: $.getFirstMatch(t, e), version: $.getSecondMatch(t, e) };
} }];
var tp = [{ test: [/Roku\/DVP/], describe(e) {
  const t = $.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
  return { name: ot.Roku, version: t };
} }, { test: [/windows phone/i], describe(e) {
  const t = $.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
  return { name: ot.WindowsPhone, version: t };
} }, { test: [/windows /i], describe(e) {
  const t = $.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), n = $.getWindowsVersionName(t);
  return { name: ot.Windows, version: t, versionName: n };
} }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe(e) {
  const t = { name: ot.iOS }, n = $.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
  return n && (t.version = n), t;
} }, { test: [/macintosh/i], describe(e) {
  const t = $.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), n = $.getMacOSVersionName(t), r = { name: ot.MacOS, version: t };
  return n && (r.versionName = n), r;
} }, { test: [/(ipod|iphone|ipad)/i], describe(e) {
  const t = $.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
  return { name: ot.iOS, version: t };
} }, { test(e) {
  const t = !e.test(/like android/i), n = e.test(/android/i);
  return t && n;
}, describe(e) {
  const t = $.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), n = $.getAndroidVersionName(t), r = { name: ot.Android, version: t };
  return n && (r.versionName = n), r;
} }, { test: [/(web|hpw)[o0]s/i], describe(e) {
  const t = $.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), n = { name: ot.WebOS };
  return t && t.length && (n.version = t), n;
} }, { test: [/blackberry|\bbb\d+/i, /rim\stablet/i], describe(e) {
  const t = $.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || $.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || $.getFirstMatch(/\bbb(\d+)/i, e);
  return { name: ot.BlackBerry, version: t };
} }, { test: [/bada/i], describe(e) {
  const t = $.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
  return { name: ot.Bada, version: t };
} }, { test: [/tizen/i], describe(e) {
  const t = $.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
  return { name: ot.Tizen, version: t };
} }, { test: [/linux/i], describe: () => ({ name: ot.Linux }) }, { test: [/CrOS/], describe: () => ({ name: ot.ChromeOS }) }, { test: [/PlayStation 4/], describe(e) {
  const t = $.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
  return { name: ot.PlayStation4, version: t };
} }], np = [{ test: [/googlebot/i], describe: () => ({ type: "bot", vendor: "Google" }) }, { test: [/huawei/i], describe(e) {
  const t = $.getFirstMatch(/(can-l01)/i, e) && "Nova", n = { type: ze.mobile, vendor: "Huawei" };
  return t && (n.model = t), n;
} }, { test: [/nexus\s*(?:7|8|9|10).*/i], describe: () => ({ type: ze.tablet, vendor: "Nexus" }) }, { test: [/ipad/i], describe: () => ({ type: ze.tablet, vendor: "Apple", model: "iPad" }) }, { test: [/Macintosh(.*?) FxiOS(.*?)\//], describe: () => ({ type: ze.tablet, vendor: "Apple", model: "iPad" }) }, { test: [/kftt build/i], describe: () => ({ type: ze.tablet, vendor: "Amazon", model: "Kindle Fire HD 7" }) }, { test: [/silk/i], describe: () => ({ type: ze.tablet, vendor: "Amazon" }) }, { test: [/tablet(?! pc)/i], describe: () => ({ type: ze.tablet }) }, { test(e) {
  const t = e.test(/ipod|iphone/i), n = e.test(/like (ipod|iphone)/i);
  return t && !n;
}, describe(e) {
  const t = $.getFirstMatch(/(ipod|iphone)/i, e);
  return { type: ze.mobile, vendor: "Apple", model: t };
} }, { test: [/nexus\s*[0-6].*/i, /galaxy nexus/i], describe: () => ({ type: ze.mobile, vendor: "Nexus" }) }, { test: [/[^-]mobi/i], describe: () => ({ type: ze.mobile }) }, { test: (e) => e.getBrowserName(!0) === "blackberry", describe: () => ({ type: ze.mobile, vendor: "BlackBerry" }) }, { test: (e) => e.getBrowserName(!0) === "bada", describe: () => ({ type: ze.mobile }) }, { test: (e) => e.getBrowserName() === "windows phone", describe: () => ({ type: ze.mobile, vendor: "Microsoft" }) }, { test(e) {
  const t = Number(String(e.getOSVersion()).split(".")[0]);
  return e.getOSName(!0) === "android" && t >= 3;
}, describe: () => ({ type: ze.tablet }) }, { test: (e) => e.getOSName(!0) === "android", describe: () => ({ type: ze.mobile }) }, { test: (e) => e.getOSName(!0) === "macos", describe: () => ({ type: ze.desktop, vendor: "Apple" }) }, { test: (e) => e.getOSName(!0) === "windows", describe: () => ({ type: ze.desktop }) }, { test: (e) => e.getOSName(!0) === "linux", describe: () => ({ type: ze.desktop }) }, { test: (e) => e.getOSName(!0) === "playstation 4", describe: () => ({ type: ze.tv }) }, { test: (e) => e.getOSName(!0) === "roku", describe: () => ({ type: ze.tv }) }], rp = [{ test: (e) => e.getBrowserName(!0) === "microsoft edge", describe(e) {
  if (/\sedg\//i.test(e))
    return { name: nn.Blink };
  const t = $.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
  return { name: nn.EdgeHTML, version: t };
} }, { test: [/trident/i], describe(e) {
  const t = { name: nn.Trident }, n = $.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: (e) => e.test(/presto/i), describe(e) {
  const t = { name: nn.Presto }, n = $.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test(e) {
  const t = e.test(/gecko/i), n = e.test(/like gecko/i);
  return t && !n;
}, describe(e) {
  const t = { name: nn.Gecko }, n = $.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }, { test: [/(apple)?webkit\/537\.36/i], describe: () => ({ name: nn.Blink }) }, { test: [/(apple)?webkit/i], describe(e) {
  const t = { name: nn.WebKit }, n = $.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
  return n && (t.version = n), t;
} }];
class Us {
  constructor(t, n = !1) {
    if (t == null || t === "")
      throw new Error("UserAgent parameter can't be empty");
    this._ua = t, this.parsedResult = {}, n !== !0 && this.parse();
  }
  getUA() {
    return this._ua;
  }
  test(t) {
    return t.test(this._ua);
  }
  parseBrowser() {
    this.parsedResult.browser = {};
    const t = $.find(ep, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
  }
  getBrowser() {
    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
  }
  getBrowserName(t) {
    return t ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
  }
  getBrowserVersion() {
    return this.getBrowser().version;
  }
  getOS() {
    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
  }
  parseOS() {
    this.parsedResult.os = {};
    const t = $.find(tp, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
  }
  getOSName(t) {
    const { name: n } = this.getOS();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  getOSVersion() {
    return this.getOS().version;
  }
  getPlatform() {
    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
  }
  getPlatformType(t = !1) {
    const { type: n } = this.getPlatform();
    return t ? String(n).toLowerCase() || "" : n || "";
  }
  parsePlatform() {
    this.parsedResult.platform = {};
    const t = $.find(np, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
  }
  getEngine() {
    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
  }
  getEngineName(t) {
    return t ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
  }
  parseEngine() {
    this.parsedResult.engine = {};
    const t = $.find(rp, (n) => {
      if (typeof n.test == "function")
        return n.test(this);
      if (n.test instanceof Array)
        return n.test.some((r) => this.test(r));
      throw new Error("Browser's test function is not valid");
    });
    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
  }
  parse() {
    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
  }
  getResult() {
    return $.assign({}, this.parsedResult);
  }
  satisfies(t) {
    const n = {};
    let r = 0;
    const i = {};
    let o = 0;
    if (Object.keys(t).forEach((a) => {
      const u = t[a];
      typeof u == "string" ? (i[a] = u, o += 1) : typeof u == "object" && (n[a] = u, r += 1);
    }), r > 0) {
      const a = Object.keys(n), u = $.find(a, (l) => this.isOS(l));
      if (u) {
        const l = this.satisfies(n[u]);
        if (l !== void 0)
          return l;
      }
      const c = $.find(a, (l) => this.isPlatform(l));
      if (c) {
        const l = this.satisfies(n[c]);
        if (l !== void 0)
          return l;
      }
    }
    if (o > 0) {
      const a = Object.keys(i), u = $.find(a, (c) => this.isBrowser(c, !0));
      if (u !== void 0)
        return this.compareVersion(i[u]);
    }
  }
  isBrowser(t, n = !1) {
    const r = this.getBrowserName().toLowerCase();
    let i = t.toLowerCase();
    const o = $.getBrowserTypeByAlias(i);
    return n && o && (i = o.toLowerCase()), i === r;
  }
  compareVersion(t) {
    let n = [0], r = t, i = !1;
    const o = this.getBrowserVersion();
    if (typeof o == "string")
      return t[0] === ">" || t[0] === "<" ? (r = t.substr(1), t[1] === "=" ? (i = !0, r = t.substr(2)) : n = [], t[0] === ">" ? n.push(1) : n.push(-1)) : t[0] === "=" ? r = t.substr(1) : t[0] === "~" && (i = !0, r = t.substr(1)), n.indexOf($.compareVersions(o, r, i)) > -1;
  }
  isOS(t) {
    return this.getOSName(!0) === String(t).toLowerCase();
  }
  isPlatform(t) {
    return this.getPlatformType(!0) === String(t).toLowerCase();
  }
  isEngine(t) {
    return this.getEngineName(!0) === String(t).toLowerCase();
  }
  is(t, n = !1) {
    return this.isBrowser(t, n) || this.isOS(t) || this.isPlatform(t);
  }
  some(t = []) {
    return t.some((n) => this.is(n));
  }
}
/*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */
class ip {
  static getParser(t, n = !1) {
    if (typeof t != "string")
      throw new Error("UserAgent should be a string");
    return new Us(t, n);
  }
  static parse(t) {
    return new Us(t).getResult();
  }
  static get BROWSER_MAP() {
    return gl;
  }
  static get ENGINE_MAP() {
    return nn;
  }
  static get OS_MAP() {
    return ot;
  }
  static get PLATFORMS_MAP() {
    return ze;
  }
}
function Bi() {
  return Date.now() + Math.random().toString();
}
function lr() {
  throw new Error("Method must be implemented in subclass");
}
function yl(e, t) {
  return t != null && t.proxyUrl ? t.proxyUrl + (t.proxyUrl.slice(-1) === "/" ? "" : "/") + e.substring(8) : e;
}
function ki(e) {
  return e != null && e.callObjectBundleUrlOverride ? e.callObjectBundleUrlOverride : yl("https://c.daily.co/call-machine/versioned/".concat("0.83.1", "/static/call-machine-object-bundle.js"), e);
}
function Ei(e) {
  try {
    new URL(e);
  } catch {
    return !1;
  }
  return !0;
}
const De = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, bn = "8.55.0", Ce = globalThis;
function Ti(e, t, n) {
  const r = n || Ce, i = r.__SENTRY__ = r.__SENTRY__ || {}, o = i[bn] = i[bn] || {};
  return o[e] || (o[e] = t());
}
const An = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ua = ["debug", "info", "warn", "error", "log", "assert", "trace"], Ri = {};
function Pr(e) {
  if (!("console" in Ce))
    return e();
  const t = Ce.console, n = {}, r = Object.keys(Ri);
  r.forEach((i) => {
    const o = Ri[i];
    n[i] = t[i], t[i] = o;
  });
  try {
    return e();
  } finally {
    r.forEach((i) => {
      t[i] = n[i];
    });
  }
}
const fe = Ti("logger", function() {
  let e = !1;
  const t = { enable: () => {
    e = !0;
  }, disable: () => {
    e = !1;
  }, isEnabled: () => e };
  return An ? ua.forEach((n) => {
    t[n] = (...r) => {
      e && Pr(() => {
        Ce.console[n](`Sentry Logger [${n}]:`, ...r);
      });
    };
  }) : ua.forEach((n) => {
    t[n] = () => {
    };
  }), t;
}), _n = "?", zs = /\(error: (.*)\)/, Ws = /captureMessage|captureException/;
function qr(e) {
  return e[e.length - 1] || {};
}
const qs = "<anonymous>";
function sn(e) {
  try {
    return e && typeof e == "function" && e.name || qs;
  } catch {
    return qs;
  }
}
function Js(e) {
  const t = e.exception;
  if (t) {
    const n = [];
    try {
      return t.values.forEach((r) => {
        r.stacktrace.frames && n.push(...r.stacktrace.frames);
      }), n;
    } catch {
      return;
    }
  }
}
const fi = {}, Hs = {};
function Sn(e, t) {
  fi[e] = fi[e] || [], fi[e].push(t);
}
function wn(e, t) {
  if (!Hs[e]) {
    Hs[e] = !0;
    try {
      t();
    } catch (n) {
      An && fe.error(`Error while instrumenting ${e}`, n);
    }
  }
}
function Ot(e, t) {
  const n = e && fi[e];
  if (n)
    for (const r of n)
      try {
        r(t);
      } catch (i) {
        An && fe.error(`Error while triggering instrumentation handler.
Type: ${e}
Name: ${sn(r)}
Error:`, i);
      }
}
let Po = null;
function op() {
  Po = Ce.onerror, Ce.onerror = function(e, t, n, r, i) {
    return Ot("error", { column: r, error: i, line: n, msg: e, url: t }), !!Po && Po.apply(this, arguments);
  }, Ce.onerror.__SENTRY_INSTRUMENTED__ = !0;
}
let Oo = null;
function ap() {
  Oo = Ce.onunhandledrejection, Ce.onunhandledrejection = function(e) {
    return Ot("unhandledrejection", e), !Oo || Oo.apply(this, arguments);
  }, Ce.onunhandledrejection.__SENTRY_INSTRUMENTED__ = !0;
}
function Fi() {
  return Za(Ce), Ce;
}
function Za(e) {
  const t = e.__SENTRY__ = e.__SENTRY__ || {};
  return t.version = t.version || bn, t[bn] = t[bn] || {};
}
const _l = Object.prototype.toString;
function Xa(e) {
  switch (_l.call(e)) {
    case "[object Error]":
    case "[object Exception]":
    case "[object DOMException]":
    case "[object WebAssembly.Exception]":
      return !0;
    default:
      return kn(e, Error);
  }
}
function ir(e, t) {
  return _l.call(e) === `[object ${t}]`;
}
function bl(e) {
  return ir(e, "ErrorEvent");
}
function Gs(e) {
  return ir(e, "DOMError");
}
function Gt(e) {
  return ir(e, "String");
}
function es(e) {
  return typeof e == "object" && e !== null && "__sentry_template_string__" in e && "__sentry_template_values__" in e;
}
function la(e) {
  return e === null || es(e) || typeof e != "object" && typeof e != "function";
}
function Hn(e) {
  return ir(e, "Object");
}
function Ui(e) {
  return typeof Event < "u" && kn(e, Event);
}
function zi(e) {
  return !!(e && e.then && typeof e.then == "function");
}
function kn(e, t) {
  try {
    return e instanceof t;
  } catch {
    return !1;
  }
}
function Sl(e) {
  return !(typeof e != "object" || e === null || !e.__isVue && !e._isVue);
}
const ts = Ce;
function wl(e, t = {}) {
  if (!e)
    return "<unknown>";
  try {
    let n = e;
    const r = 5, i = [];
    let o = 0, a = 0;
    const u = " > ", c = u.length;
    let l;
    const d = Array.isArray(t) ? t : t.keyAttrs, h = !Array.isArray(t) && t.maxStringLength || 80;
    for (; n && o++ < r && (l = sp(n, d), !(l === "html" || o > 1 && a + i.length * c + l.length >= h)); )
      i.push(l), a += l.length, n = n.parentNode;
    return i.reverse().join(u);
  } catch {
    return "<unknown>";
  }
}
function sp(e, t) {
  const n = e, r = [];
  if (!n || !n.tagName)
    return "";
  if (ts.HTMLElement && n instanceof HTMLElement && n.dataset) {
    if (n.dataset.sentryComponent)
      return n.dataset.sentryComponent;
    if (n.dataset.sentryElement)
      return n.dataset.sentryElement;
  }
  r.push(n.tagName.toLowerCase());
  const i = t && t.length ? t.filter((a) => n.getAttribute(a)).map((a) => [a, n.getAttribute(a)]) : null;
  if (i && i.length)
    i.forEach((a) => {
      r.push(`[${a[0]}="${a[1]}"]`);
    });
  else {
    n.id && r.push(`#${n.id}`);
    const a = n.className;
    if (a && Gt(a)) {
      const u = a.split(/\s+/);
      for (const c of u)
        r.push(`.${c}`);
    }
  }
  const o = ["aria-label", "type", "name", "title", "alt"];
  for (const a of o) {
    const u = n.getAttribute(a);
    u && r.push(`[${a}="${u}"]`);
  }
  return r.join("");
}
function Wn(e, t = 0) {
  return typeof e != "string" || t === 0 || e.length <= t ? e : `${e.slice(0, t)}...`;
}
function Ks(e, t) {
  if (!Array.isArray(e))
    return "";
  const n = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    try {
      Sl(i) ? n.push("[VueViewModel]") : n.push(String(i));
    } catch {
      n.push("[value cannot be serialized]");
    }
  }
  return n.join(t);
}
function cp(e, t, n = !1) {
  return !!Gt(e) && (ir(t, "RegExp") ? t.test(e) : !!Gt(t) && (n ? e === t : e.includes(t)));
}
function Jr(e, t = [], n = !1) {
  return t.some((r) => cp(e, r, n));
}
function mt(e, t, n) {
  if (!(t in e))
    return;
  const r = e[t], i = n(r);
  typeof i == "function" && kl(i, r);
  try {
    e[t] = i;
  } catch {
    An && fe.log(`Failed to replace method "${t}" in object`, e);
  }
}
function En(e, t, n) {
  try {
    Object.defineProperty(e, t, { value: n, writable: !0, configurable: !0 });
  } catch {
    An && fe.log(`Failed to add non-enumerable property "${t}" to object`, e);
  }
}
function kl(e, t) {
  try {
    const n = t.prototype || {};
    e.prototype = t.prototype = n, En(e, "__sentry_original__", t);
  } catch {
  }
}
function ns(e) {
  return e.__sentry_original__;
}
function El(e) {
  if (Xa(e))
    return { message: e.message, name: e.name, stack: e.stack, ...Qs(e) };
  if (Ui(e)) {
    const t = { type: e.type, target: Ys(e.target), currentTarget: Ys(e.currentTarget), ...Qs(e) };
    return typeof CustomEvent < "u" && kn(e, CustomEvent) && (t.detail = e.detail), t;
  }
  return e;
}
function Ys(e) {
  try {
    return t = e, typeof Element < "u" && kn(t, Element) ? wl(e) : Object.prototype.toString.call(e);
  } catch {
    return "<unknown>";
  }
  var t;
}
function Qs(e) {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (t[n] = e[n]);
    return t;
  }
  return {};
}
function Et(e) {
  return da(e, /* @__PURE__ */ new Map());
}
function da(e, t) {
  if (function(n) {
    if (!Hn(n))
      return !1;
    try {
      const r = Object.getPrototypeOf(n).constructor.name;
      return !r || r === "Object";
    } catch {
      return !0;
    }
  }(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = {};
    t.set(e, r);
    for (const i of Object.getOwnPropertyNames(e))
      e[i] !== void 0 && (r[i] = da(e[i], t));
    return r;
  }
  if (Array.isArray(e)) {
    const n = t.get(e);
    if (n !== void 0)
      return n;
    const r = [];
    return t.set(e, r), e.forEach((i) => {
      r.push(da(i, t));
    }), r;
  }
  return e;
}
function Or() {
  return Date.now() / 1e3;
}
const Yt = function() {
  const { performance: e } = Ce;
  if (!e || !e.now)
    return Or;
  const t = Date.now() - e.now(), n = e.timeOrigin == null ? t : e.timeOrigin;
  return () => (n + e.now()) / 1e3;
}();
function Tt() {
  const e = Ce, t = e.crypto || e.msCrypto;
  let n = () => 16 * Math.random();
  try {
    if (t && t.randomUUID)
      return t.randomUUID().replace(/-/g, "");
    t && t.getRandomValues && (n = () => {
      const r = new Uint8Array(1);
      return t.getRandomValues(r), r[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(/[018]/g, (r) => (r ^ (15 & n()) >> r / 4).toString(16));
}
function Tl(e) {
  return e.exception && e.exception.values ? e.exception.values[0] : void 0;
}
function rn(e) {
  const { message: t, event_id: n } = e;
  if (t)
    return t;
  const r = Tl(e);
  return r ? r.type && r.value ? `${r.type}: ${r.value}` : r.type || r.value || n || "<unknown>" : n || "<unknown>";
}
function fa(e, t, n) {
  const r = e.exception = e.exception || {}, i = r.values = r.values || [], o = i[0] = i[0] || {};
  o.value || (o.value = t || ""), o.type || (o.type = n || "Error");
}
function Gn(e, t) {
  const n = Tl(e);
  if (!n)
    return;
  const r = n.mechanism;
  if (n.mechanism = { type: "generic", handled: !0, ...r, ...t }, t && "data" in t) {
    const i = { ...r && r.data, ...t.data };
    n.mechanism.data = i;
  }
}
function Zs(e) {
  if (function(t) {
    try {
      return t.__sentry_captured__;
    } catch {
    }
  }(e))
    return !0;
  try {
    En(e, "__sentry_captured__", !0);
  } catch {
  }
  return !1;
}
var Jt;
function Tn(e) {
  return new wt((t) => {
    t(e);
  });
}
function Ci(e) {
  return new wt((t, n) => {
    n(e);
  });
}
(() => {
  const { performance: e } = Ce;
  if (!e || !e.now)
    return;
  const t = 36e5, n = e.now(), r = Date.now(), i = e.timeOrigin ? Math.abs(e.timeOrigin + n - r) : t, o = i < t, a = e.timing && e.timing.navigationStart, u = typeof a == "number" ? Math.abs(a + n - r) : t;
  (o || u < t) && i <= u && e.timeOrigin;
})(), function(e) {
  e[e.PENDING = 0] = "PENDING", e[e.RESOLVED = 1] = "RESOLVED", e[e.REJECTED = 2] = "REJECTED";
}(Jt || (Jt = {}));
class wt {
  constructor(t) {
    wt.prototype.__init.call(this), wt.prototype.__init2.call(this), wt.prototype.__init3.call(this), wt.prototype.__init4.call(this), this._state = Jt.PENDING, this._handlers = [];
    try {
      t(this._resolve, this._reject);
    } catch (n) {
      this._reject(n);
    }
  }
  then(t, n) {
    return new wt((r, i) => {
      this._handlers.push([!1, (o) => {
        if (t)
          try {
            r(t(o));
          } catch (a) {
            i(a);
          }
        else
          r(o);
      }, (o) => {
        if (n)
          try {
            r(n(o));
          } catch (a) {
            i(a);
          }
        else
          i(o);
      }]), this._executeHandlers();
    });
  }
  catch(t) {
    return this.then((n) => n, t);
  }
  finally(t) {
    return new wt((n, r) => {
      let i, o;
      return this.then((a) => {
        o = !1, i = a, t && t();
      }, (a) => {
        o = !0, i = a, t && t();
      }).then(() => {
        o ? r(i) : n(i);
      });
    });
  }
  __init() {
    this._resolve = (t) => {
      this._setResult(Jt.RESOLVED, t);
    };
  }
  __init2() {
    this._reject = (t) => {
      this._setResult(Jt.REJECTED, t);
    };
  }
  __init3() {
    this._setResult = (t, n) => {
      this._state === Jt.PENDING && (zi(n) ? n.then(this._resolve, this._reject) : (this._state = t, this._value = n, this._executeHandlers()));
    };
  }
  __init4() {
    this._executeHandlers = () => {
      if (this._state === Jt.PENDING)
        return;
      const t = this._handlers.slice();
      this._handlers = [], t.forEach((n) => {
        n[0] || (this._state === Jt.RESOLVED && n[1](this._value), this._state === Jt.REJECTED && n[2](this._value), n[0] = !0);
      });
    };
  }
}
function up(e) {
  const t = Yt(), n = { sid: Tt(), init: !0, timestamp: t, started: t, duration: 0, status: "ok", errors: 0, ignoreDuration: !1, toJSON: () => function(r) {
    return Et({ sid: `${r.sid}`, init: r.init, started: new Date(1e3 * r.started).toISOString(), timestamp: new Date(1e3 * r.timestamp).toISOString(), status: r.status, errors: r.errors, did: typeof r.did == "number" || typeof r.did == "string" ? `${r.did}` : void 0, duration: r.duration, abnormal_mechanism: r.abnormal_mechanism, attrs: { release: r.release, environment: r.environment, ip_address: r.ipAddress, user_agent: r.userAgent } });
  }(n) };
  return e && Kn(n, e), n;
}
function Kn(e, t = {}) {
  if (t.user && (!e.ipAddress && t.user.ip_address && (e.ipAddress = t.user.ip_address), e.did || t.did || (e.did = t.user.id || t.user.email || t.user.username)), e.timestamp = t.timestamp || Yt(), t.abnormal_mechanism && (e.abnormal_mechanism = t.abnormal_mechanism), t.ignoreDuration && (e.ignoreDuration = t.ignoreDuration), t.sid && (e.sid = t.sid.length === 32 ? t.sid : Tt()), t.init !== void 0 && (e.init = t.init), !e.did && t.did && (e.did = `${t.did}`), typeof t.started == "number" && (e.started = t.started), e.ignoreDuration)
    e.duration = void 0;
  else if (typeof t.duration == "number")
    e.duration = t.duration;
  else {
    const n = e.timestamp - e.started;
    e.duration = n >= 0 ? n : 0;
  }
  t.release && (e.release = t.release), t.environment && (e.environment = t.environment), !e.ipAddress && t.ipAddress && (e.ipAddress = t.ipAddress), !e.userAgent && t.userAgent && (e.userAgent = t.userAgent), typeof t.errors == "number" && (e.errors = t.errors), t.status && (e.status = t.status);
}
function Xs() {
  return Tt();
}
function pa() {
  return Tt().substring(16);
}
function Wi(e, t, n = 2) {
  if (!t || typeof t != "object" || n <= 0)
    return t;
  if (e && t && Object.keys(t).length === 0)
    return e;
  const r = { ...e };
  for (const i in t)
    Object.prototype.hasOwnProperty.call(t, i) && (r[i] = Wi(r[i], t[i], n - 1));
  return r;
}
const ha = "_sentrySpan";
function ec(e, t) {
  t ? En(e, ha, t) : delete e[ha];
}
function tc(e) {
  return e[ha];
}
class rs {
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = { traceId: Xs(), spanId: pa() };
  }
  clone() {
    const t = new rs();
    return t._breadcrumbs = [...this._breadcrumbs], t._tags = { ...this._tags }, t._extra = { ...this._extra }, t._contexts = { ...this._contexts }, this._contexts.flags && (t._contexts.flags = { values: [...this._contexts.flags.values] }), t._user = this._user, t._level = this._level, t._session = this._session, t._transactionName = this._transactionName, t._fingerprint = this._fingerprint, t._eventProcessors = [...this._eventProcessors], t._requestSession = this._requestSession, t._attachments = [...this._attachments], t._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, t._propagationContext = { ...this._propagationContext }, t._client = this._client, t._lastEventId = this._lastEventId, ec(t, tc(this)), t;
  }
  setClient(t) {
    this._client = t;
  }
  setLastEventId(t) {
    this._lastEventId = t;
  }
  getClient() {
    return this._client;
  }
  lastEventId() {
    return this._lastEventId;
  }
  addScopeListener(t) {
    this._scopeListeners.push(t);
  }
  addEventProcessor(t) {
    return this._eventProcessors.push(t), this;
  }
  setUser(t) {
    return this._user = t || { email: void 0, id: void 0, ip_address: void 0, username: void 0 }, this._session && Kn(this._session, { user: t }), this._notifyScopeListeners(), this;
  }
  getUser() {
    return this._user;
  }
  getRequestSession() {
    return this._requestSession;
  }
  setRequestSession(t) {
    return this._requestSession = t, this;
  }
  setTags(t) {
    return this._tags = { ...this._tags, ...t }, this._notifyScopeListeners(), this;
  }
  setTag(t, n) {
    return this._tags = { ...this._tags, [t]: n }, this._notifyScopeListeners(), this;
  }
  setExtras(t) {
    return this._extra = { ...this._extra, ...t }, this._notifyScopeListeners(), this;
  }
  setExtra(t, n) {
    return this._extra = { ...this._extra, [t]: n }, this._notifyScopeListeners(), this;
  }
  setFingerprint(t) {
    return this._fingerprint = t, this._notifyScopeListeners(), this;
  }
  setLevel(t) {
    return this._level = t, this._notifyScopeListeners(), this;
  }
  setTransactionName(t) {
    return this._transactionName = t, this._notifyScopeListeners(), this;
  }
  setContext(t, n) {
    return n === null ? delete this._contexts[t] : this._contexts[t] = n, this._notifyScopeListeners(), this;
  }
  setSession(t) {
    return t ? this._session = t : delete this._session, this._notifyScopeListeners(), this;
  }
  getSession() {
    return this._session;
  }
  update(t) {
    if (!t)
      return this;
    const n = typeof t == "function" ? t(this) : t, [r, i] = n instanceof Zt ? [n.getScopeData(), n.getRequestSession()] : Hn(n) ? [t, t.requestSession] : [], { tags: o, extra: a, user: u, contexts: c, level: l, fingerprint: d = [], propagationContext: h } = r || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...a }, this._contexts = { ...this._contexts, ...c }, u && Object.keys(u).length && (this._user = u), l && (this._level = l), d.length && (this._fingerprint = d), h && (this._propagationContext = h), i && (this._requestSession = i), this;
  }
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, ec(this, void 0), this._attachments = [], this.setPropagationContext({ traceId: Xs() }), this._notifyScopeListeners(), this;
  }
  addBreadcrumb(t, n) {
    const r = typeof n == "number" ? n : 100;
    if (r <= 0)
      return this;
    const i = { timestamp: Or(), ...t };
    return this._breadcrumbs.push(i), this._breadcrumbs.length > r && (this._breadcrumbs = this._breadcrumbs.slice(-r), this._client && this._client.recordDroppedEvent("buffer_overflow", "log_item")), this._notifyScopeListeners(), this;
  }
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  addAttachment(t) {
    return this._attachments.push(t), this;
  }
  clearAttachments() {
    return this._attachments = [], this;
  }
  getScopeData() {
    return { breadcrumbs: this._breadcrumbs, attachments: this._attachments, contexts: this._contexts, tags: this._tags, extra: this._extra, user: this._user, level: this._level, fingerprint: this._fingerprint || [], eventProcessors: this._eventProcessors, propagationContext: this._propagationContext, sdkProcessingMetadata: this._sdkProcessingMetadata, transactionName: this._transactionName, span: tc(this) };
  }
  setSDKProcessingMetadata(t) {
    return this._sdkProcessingMetadata = Wi(this._sdkProcessingMetadata, t, 2), this;
  }
  setPropagationContext(t) {
    return this._propagationContext = { spanId: pa(), ...t }, this;
  }
  getPropagationContext() {
    return this._propagationContext;
  }
  captureException(t, n) {
    const r = n && n.event_id ? n.event_id : Tt();
    if (!this._client)
      return fe.warn("No client configured on scope - will not capture exception!"), r;
    const i = new Error("Sentry syntheticException");
    return this._client.captureException(t, { originalException: t, syntheticException: i, ...n, event_id: r }, this), r;
  }
  captureMessage(t, n, r) {
    const i = r && r.event_id ? r.event_id : Tt();
    if (!this._client)
      return fe.warn("No client configured on scope - will not capture message!"), i;
    const o = new Error(t);
    return this._client.captureMessage(t, n, { originalException: t, syntheticException: o, ...r, event_id: i }, this), i;
  }
  captureEvent(t, n) {
    const r = n && n.event_id ? n.event_id : Tt();
    return this._client ? (this._client.captureEvent(t, { ...n, event_id: r }, this), r) : (fe.warn("No client configured on scope - will not capture event!"), r);
  }
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((t) => {
      t(this);
    }), this._notifyingListeners = !1);
  }
}
const Zt = rs;
class lp {
  constructor(t, n) {
    let r, i;
    r = t || new Zt(), i = n || new Zt(), this._stack = [{ scope: r }], this._isolationScope = i;
  }
  withScope(t) {
    const n = this._pushScope();
    let r;
    try {
      r = t(n);
    } catch (i) {
      throw this._popScope(), i;
    }
    return zi(r) ? r.then((i) => (this._popScope(), i), (i) => {
      throw this._popScope(), i;
    }) : (this._popScope(), r);
  }
  getClient() {
    return this.getStackTop().client;
  }
  getScope() {
    return this.getStackTop().scope;
  }
  getIsolationScope() {
    return this._isolationScope;
  }
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  _pushScope() {
    const t = this.getScope().clone();
    return this._stack.push({ client: this.getClient(), scope: t }), t;
  }
  _popScope() {
    return !(this._stack.length <= 1) && !!this._stack.pop();
  }
}
function Yn() {
  const e = Za(Fi());
  return e.stack = e.stack || new lp(Ti("defaultCurrentScope", () => new Zt()), Ti("defaultIsolationScope", () => new Zt()));
}
function dp(e) {
  return Yn().withScope(e);
}
function fp(e, t) {
  const n = Yn();
  return n.withScope(() => (n.getStackTop().scope = e, t(e)));
}
function nc(e) {
  return Yn().withScope(() => e(Yn().getIsolationScope()));
}
function is(e) {
  const t = Za(e);
  return t.acs ? t.acs : { withIsolationScope: nc, withScope: dp, withSetScope: fp, withSetIsolationScope: (n, r) => nc(r), getCurrentScope: () => Yn().getScope(), getIsolationScope: () => Yn().getIsolationScope() };
}
function Pn() {
  return is(Fi()).getCurrentScope();
}
function Nr() {
  return is(Fi()).getIsolationScope();
}
function nt() {
  return Pn().getClient();
}
function pp(e) {
  const t = e.getPropagationContext(), { traceId: n, spanId: r, parentSpanId: i } = t;
  return Et({ trace_id: n, span_id: r, parent_span_id: i });
}
function hp(e) {
  const t = e._sentryMetrics;
  if (!t)
    return;
  const n = {};
  for (const [, [r, i]] of t)
    (n[r] || (n[r] = [])).push(Et(i));
  return n;
}
const vp = /^sentry-/;
function mp(e) {
  const t = function(r) {
    if (!(!r || !Gt(r) && !Array.isArray(r)))
      return Array.isArray(r) ? r.reduce((i, o) => {
        const a = rc(o);
        return Object.entries(a).forEach(([u, c]) => {
          i[u] = c;
        }), i;
      }, {}) : rc(r);
  }(e);
  if (!t)
    return;
  const n = Object.entries(t).reduce((r, [i, o]) => (i.match(vp) && (r[i.slice(7)] = o), r), {});
  return Object.keys(n).length > 0 ? n : void 0;
}
function rc(e) {
  return e.split(",").map((t) => t.split("=").map((n) => decodeURIComponent(n.trim()))).reduce((t, [n, r]) => (n && r && (t[n] = r), t), {});
}
let ic = !1;
function gp(e) {
  const { spanId: t, traceId: n, isRemote: r } = e.spanContext();
  return Et({ parent_span_id: r ? t : os(e).parent_span_id, span_id: r ? pa() : t, trace_id: n });
}
function oc(e) {
  return typeof e == "number" ? ac(e) : Array.isArray(e) ? e[0] + e[1] / 1e9 : e instanceof Date ? ac(e.getTime()) : Yt();
}
function ac(e) {
  return e > 9999999999 ? e / 1e3 : e;
}
function os(e) {
  if (function(t) {
    return typeof t.getSpanJSON == "function";
  }(e))
    return e.getSpanJSON();
  try {
    const { spanId: t, traceId: n } = e.spanContext();
    if (function(r) {
      const i = r;
      return !!(i.attributes && i.startTime && i.name && i.endTime && i.status);
    }(e)) {
      const { attributes: r, startTime: i, name: o, endTime: a, parentSpanId: u, status: c } = e;
      return Et({ span_id: t, trace_id: n, data: r, description: o, parent_span_id: u, start_timestamp: oc(i), timestamp: oc(a) || void 0, status: yp(c), op: r["sentry.op"], origin: r["sentry.origin"], _metrics_summary: hp(e) });
    }
    return { span_id: t, trace_id: n };
  } catch {
    return {};
  }
}
function yp(e) {
  if (e && e.code !== 0)
    return e.code === 1 ? "ok" : e.message || "unknown_error";
}
function Rl(e) {
  return e._sentryRootSpan || e;
}
function _p() {
  ic || (Pr(() => {
    console.warn("[Sentry] Deprecation warning: Returning null from `beforeSendSpan` will be disallowed from SDK version 9.0.0 onwards. The callback will only support mutating spans. To drop certain spans, configure the respective integrations directly.");
  }), ic = !0);
}
const as = "production";
function Cl(e, t) {
  const n = t.getOptions(), { publicKey: r } = t.getDsn() || {}, i = Et({ environment: n.environment || as, release: n.release, public_key: r, trace_id: e });
  return t.emit("createDsc", i), i;
}
function bp(e) {
  const t = nt();
  if (!t)
    return {};
  const n = Rl(e), r = n._frozenDsc;
  if (r)
    return r;
  const i = n.spanContext().traceState, o = i && i.get("sentry.dsc"), a = o && mp(o);
  if (a)
    return a;
  const u = Cl(e.spanContext().traceId, t), c = os(n), l = c.data || {}, d = l["sentry.sample_rate"];
  d != null && (u.sample_rate = `${d}`);
  const h = l["sentry.source"], g = c.description;
  return h !== "url" && g && (u.transaction = g), function(b) {
    if (typeof __SENTRY_TRACING__ == "boolean" && !__SENTRY_TRACING__)
      return !1;
    const y = nt(), v = b || y && y.getOptions();
    return !!v && (v.enableTracing || "tracesSampleRate" in v || "tracesSampler" in v);
  }() && (u.sampled = String(function(b) {
    const { traceFlags: y } = b.spanContext();
    return y === 1;
  }(n))), t.emit("createDsc", u, n), u;
}
const Sp = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function Mi(e, t = !1) {
  const { host: n, path: r, pass: i, port: o, projectId: a, protocol: u, publicKey: c } = e;
  return `${u}://${c}${t && i ? `:${i}` : ""}@${n}${o ? `:${o}` : ""}/${r && `${r}/`}${a}`;
}
function sc(e) {
  return { protocol: e.protocol, publicKey: e.publicKey || "", pass: e.pass || "", host: e.host, port: e.port || "", path: e.path || "", projectId: e.projectId };
}
function wp(e) {
  const t = typeof e == "string" ? function(n) {
    const r = Sp.exec(n);
    if (!r)
      return void Pr(() => {
        console.error(`Invalid Sentry Dsn: ${n}`);
      });
    const [i, o, a = "", u = "", c = "", l = ""] = r.slice(1);
    let d = "", h = l;
    const g = h.split("/");
    if (g.length > 1 && (d = g.slice(0, -1).join("/"), h = g.pop()), h) {
      const b = h.match(/^\d+/);
      b && (h = b[0]);
    }
    return sc({ host: u, pass: a, path: d, projectId: h, port: c, protocol: i, publicKey: o });
  }(e) : sc(e);
  if (t && function(n) {
    if (!An)
      return !0;
    const { port: r, projectId: i, protocol: o } = n;
    return !(["protocol", "publicKey", "host", "projectId"].find((a) => !n[a] && (fe.error(`Invalid Sentry Dsn: ${a} missing`), !0)) || (i.match(/^\d+$/) ? /* @__PURE__ */ function(a) {
      return a === "http" || a === "https";
    }(o) ? r && isNaN(parseInt(r, 10)) && (fe.error(`Invalid Sentry Dsn: Invalid port ${r}`), 1) : (fe.error(`Invalid Sentry Dsn: Invalid protocol ${o}`), 1) : (fe.error(`Invalid Sentry Dsn: Invalid projectId ${i}`), 1)));
  }(t))
    return t;
}
function Ht(e, t = 100, n = 1 / 0) {
  try {
    return va("", e, t, n);
  } catch (r) {
    return { ERROR: `**non-serializable** (${r})` };
  }
}
function Ml(e, t = 3, n = 102400) {
  const r = Ht(e, t);
  return i = r, function(o) {
    return ~-encodeURI(o).split(/%..|./).length;
  }(JSON.stringify(i)) > n ? Ml(e, t - 1, n) : r;
  var i;
}
function va(e, t, n = 1 / 0, r = 1 / 0, i = /* @__PURE__ */ function() {
  const o = typeof WeakSet == "function", a = o ? /* @__PURE__ */ new WeakSet() : [];
  return [function(u) {
    if (o)
      return !!a.has(u) || (a.add(u), !1);
    for (let c = 0; c < a.length; c++)
      if (a[c] === u)
        return !0;
    return a.push(u), !1;
  }, function(u) {
    if (o)
      a.delete(u);
    else
      for (let c = 0; c < a.length; c++)
        if (a[c] === u) {
          a.splice(c, 1);
          break;
        }
  }];
}()) {
  const [o, a] = i;
  if (t == null || ["boolean", "string"].includes(typeof t) || typeof t == "number" && Number.isFinite(t))
    return t;
  const u = function(b, y) {
    try {
      if (b === "domain" && y && typeof y == "object" && y._events)
        return "[Domain]";
      if (b === "domainEmitter")
        return "[DomainEmitter]";
      if (typeof global < "u" && y === global)
        return "[Global]";
      if (typeof window < "u" && y === window)
        return "[Window]";
      if (typeof document < "u" && y === document)
        return "[Document]";
      if (Sl(y))
        return "[VueViewModel]";
      if (Hn(v = y) && "nativeEvent" in v && "preventDefault" in v && "stopPropagation" in v)
        return "[SyntheticEvent]";
      if (typeof y == "number" && !Number.isFinite(y))
        return `[${y}]`;
      if (typeof y == "function")
        return `[Function: ${sn(y)}]`;
      if (typeof y == "symbol")
        return `[${String(y)}]`;
      if (typeof y == "bigint")
        return `[BigInt: ${String(y)}]`;
      const _ = function(w) {
        const k = Object.getPrototypeOf(w);
        return k ? k.constructor.name : "null prototype";
      }(y);
      return /^HTML(\w*)Element$/.test(_) ? `[HTMLElement: ${_}]` : `[object ${_}]`;
    } catch (_) {
      return `**non-serializable** (${_})`;
    }
    var v;
  }(e, t);
  if (!u.startsWith("[object "))
    return u;
  if (t.__sentry_skip_normalization__)
    return t;
  const c = typeof t.__sentry_override_normalization_depth__ == "number" ? t.__sentry_override_normalization_depth__ : n;
  if (c === 0)
    return u.replace("object ", "");
  if (o(t))
    return "[Circular ~]";
  const l = t;
  if (l && typeof l.toJSON == "function")
    try {
      return va("", l.toJSON(), c - 1, r, i);
    } catch {
    }
  const d = Array.isArray(t) ? [] : {};
  let h = 0;
  const g = El(t);
  for (const b in g) {
    if (!Object.prototype.hasOwnProperty.call(g, b))
      continue;
    if (h >= r) {
      d[b] = "[MaxProperties ~]";
      break;
    }
    const y = g[b];
    d[b] = va(b, y, c - 1, r, i), h++;
  }
  return a(t), d;
}
function Cr(e, t = []) {
  return [e, t];
}
function kp(e, t) {
  const [n, r] = e;
  return [n, [...r, t]];
}
function cc(e, t) {
  const n = e[1];
  for (const r of n)
    if (t(r, r[0].type))
      return !0;
  return !1;
}
function ma(e) {
  return Ce.__SENTRY__ && Ce.__SENTRY__.encodePolyfill ? Ce.__SENTRY__.encodePolyfill(e) : new TextEncoder().encode(e);
}
function Ep(e) {
  const [t, n] = e;
  let r = JSON.stringify(t);
  function i(o) {
    typeof r == "string" ? r = typeof o == "string" ? r + o : [ma(r), o] : r.push(typeof o == "string" ? ma(o) : o);
  }
  for (const o of n) {
    const [a, u] = o;
    if (i(`
${JSON.stringify(a)}
`), typeof u == "string" || u instanceof Uint8Array)
      i(u);
    else {
      let c;
      try {
        c = JSON.stringify(u);
      } catch {
        c = JSON.stringify(Ht(u));
      }
      i(c);
    }
  }
  return typeof r == "string" ? r : function(o) {
    const a = o.reduce((l, d) => l + d.length, 0), u = new Uint8Array(a);
    let c = 0;
    for (const l of o)
      u.set(l, c), c += l.length;
    return u;
  }(r);
}
function Tp(e) {
  const t = typeof e.data == "string" ? ma(e.data) : e.data;
  return [Et({ type: "attachment", length: t.length, filename: e.filename, content_type: e.contentType, attachment_type: e.attachmentType }), t];
}
const Rp = { session: "session", sessions: "session", attachment: "attachment", transaction: "transaction", event: "error", client_report: "internal", user_report: "default", profile: "profile", profile_chunk: "profile", replay_event: "replay", replay_recording: "replay", check_in: "monitor", feedback: "feedback", span: "span", statsd: "metric_bucket", raw_security: "security" };
function uc(e) {
  return Rp[e];
}
function Al(e) {
  if (!e || !e.sdk)
    return;
  const { name: t, version: n } = e.sdk;
  return { name: t, version: n };
}
function Cp(e, t, n, r) {
  const i = Al(n), o = e.type && e.type !== "replay_event" ? e.type : "event";
  (function(u, c) {
    c && (u.sdk = u.sdk || {}, u.sdk.name = u.sdk.name || c.name, u.sdk.version = u.sdk.version || c.version, u.sdk.integrations = [...u.sdk.integrations || [], ...c.integrations || []], u.sdk.packages = [...u.sdk.packages || [], ...c.packages || []]);
  })(e, n && n.sdk);
  const a = function(u, c, l, d) {
    const h = u.sdkProcessingMetadata && u.sdkProcessingMetadata.dynamicSamplingContext;
    return { event_id: u.event_id, sent_at: (/* @__PURE__ */ new Date()).toISOString(), ...c && { sdk: c }, ...!!l && d && { dsn: Mi(d) }, ...h && { trace: Et({ ...h }) } };
  }(e, i, r, t);
  return delete e.sdkProcessingMetadata, Cr(a, [[{ type: o }, e]]);
}
function ga(e, t, n, r = 0) {
  return new wt((i, o) => {
    const a = e[r];
    if (t === null || typeof a != "function")
      i(t);
    else {
      const u = a({ ...t }, n);
      De && a.id && u === null && fe.log(`Event processor "${a.id}" dropped event`), zi(u) ? u.then((c) => ga(e, c, n, r + 1).then(i)).then(null, o) : ga(e, u, n, r + 1).then(i).then(null, o);
    }
  });
}
let Hr, lc, No;
function Mp(e, t) {
  const { fingerprint: n, span: r, breadcrumbs: i, sdkProcessingMetadata: o } = t;
  (function(a, u) {
    const { extra: c, tags: l, user: d, contexts: h, level: g, transactionName: b } = u, y = Et(c);
    y && Object.keys(y).length && (a.extra = { ...y, ...a.extra });
    const v = Et(l);
    v && Object.keys(v).length && (a.tags = { ...v, ...a.tags });
    const _ = Et(d);
    _ && Object.keys(_).length && (a.user = { ..._, ...a.user });
    const w = Et(h);
    w && Object.keys(w).length && (a.contexts = { ...w, ...a.contexts }), g && (a.level = g), b && a.type !== "transaction" && (a.transaction = b);
  })(e, t), r && function(a, u) {
    a.contexts = { trace: gp(u), ...a.contexts }, a.sdkProcessingMetadata = { dynamicSamplingContext: bp(u), ...a.sdkProcessingMetadata };
    const c = Rl(u), l = os(c).description;
    l && !a.transaction && a.type === "transaction" && (a.transaction = l);
  }(e, r), function(a, u) {
    a.fingerprint = a.fingerprint ? Array.isArray(a.fingerprint) ? a.fingerprint : [a.fingerprint] : [], u && (a.fingerprint = a.fingerprint.concat(u)), a.fingerprint && !a.fingerprint.length && delete a.fingerprint;
  }(e, n), function(a, u) {
    const c = [...a.breadcrumbs || [], ...u];
    a.breadcrumbs = c.length ? c : void 0;
  }(e, i), function(a, u) {
    a.sdkProcessingMetadata = { ...a.sdkProcessingMetadata, ...u };
  }(e, o);
}
function dc(e, t) {
  const { extra: n, tags: r, user: i, contexts: o, level: a, sdkProcessingMetadata: u, breadcrumbs: c, fingerprint: l, eventProcessors: d, attachments: h, propagationContext: g, transactionName: b, span: y } = t;
  Gr(e, "extra", n), Gr(e, "tags", r), Gr(e, "user", i), Gr(e, "contexts", o), e.sdkProcessingMetadata = Wi(e.sdkProcessingMetadata, u, 2), a && (e.level = a), b && (e.transactionName = b), y && (e.span = y), c.length && (e.breadcrumbs = [...e.breadcrumbs, ...c]), l.length && (e.fingerprint = [...e.fingerprint, ...l]), d.length && (e.eventProcessors = [...e.eventProcessors, ...d]), h.length && (e.attachments = [...e.attachments, ...h]), e.propagationContext = { ...e.propagationContext, ...g };
}
function Gr(e, t, n) {
  e[t] = Wi(e[t], n, 1);
}
function Ap(e, t, n, r, i, o) {
  const { normalizeDepth: a = 3, normalizeMaxBreadth: u = 1e3 } = e, c = { ...t, event_id: t.event_id || n.event_id || Tt(), timestamp: t.timestamp || Or() }, l = n.integrations || e.integrations.map((y) => y.name);
  (function(y, v) {
    const { environment: _, release: w, dist: k, maxValueLength: O = 250 } = v;
    y.environment = y.environment || _ || as, !y.release && w && (y.release = w), !y.dist && k && (y.dist = k), y.message && (y.message = Wn(y.message, O));
    const I = y.exception && y.exception.values && y.exception.values[0];
    I && I.value && (I.value = Wn(I.value, O));
    const N = y.request;
    N && N.url && (N.url = Wn(N.url, O));
  })(c, e), function(y, v) {
    v.length > 0 && (y.sdk = y.sdk || {}, y.sdk.integrations = [...y.sdk.integrations || [], ...v]);
  }(c, l), i && i.emit("applyFrameMetadata", t), t.type === void 0 && function(y, v) {
    const _ = function(w) {
      const k = Ce._sentryDebugIds;
      if (!k)
        return {};
      const O = Object.keys(k);
      return No && O.length === lc || (lc = O.length, No = O.reduce((I, N) => {
        Hr || (Hr = {});
        const E = Hr[N];
        if (E)
          I[E[0]] = E[1];
        else {
          const L = w(N);
          for (let B = L.length - 1; B >= 0; B--) {
            const Q = L[B], G = Q && Q.filename, te = k[N];
            if (G && te) {
              I[G] = te, Hr[N] = [G, te];
              break;
            }
          }
        }
        return I;
      }, {})), No;
    }(v);
    try {
      y.exception.values.forEach((w) => {
        w.stacktrace.frames.forEach((k) => {
          _ && k.filename && (k.debug_id = _[k.filename]);
        });
      });
    } catch {
    }
  }(c, e.stackParser);
  const d = function(y, v) {
    if (!v)
      return y;
    const _ = y ? y.clone() : new Zt();
    return _.update(v), _;
  }(r, n.captureContext);
  n.mechanism && Gn(c, n.mechanism);
  const h = i ? i.getEventProcessors() : [], g = Ti("globalScope", () => new Zt()).getScopeData();
  o && dc(g, o.getScopeData()), d && dc(g, d.getScopeData());
  const b = [...n.attachments || [], ...g.attachments];
  return b.length && (n.attachments = b), Mp(c, g), ga([...h, ...g.eventProcessors], c, n).then((y) => (y && function(v) {
    const _ = {};
    try {
      v.exception.values.forEach((k) => {
        k.stacktrace.frames.forEach((O) => {
          O.debug_id && (O.abs_path ? _[O.abs_path] = O.debug_id : O.filename && (_[O.filename] = O.debug_id), delete O.debug_id);
        });
      });
    } catch {
    }
    if (Object.keys(_).length === 0)
      return;
    v.debug_meta = v.debug_meta || {}, v.debug_meta.images = v.debug_meta.images || [];
    const w = v.debug_meta.images;
    Object.entries(_).forEach(([k, O]) => {
      w.push({ type: "sourcemap", code_file: k, debug_id: O });
    });
  }(y), typeof a == "number" && a > 0 ? function(v, _, w) {
    if (!v)
      return null;
    const k = { ...v, ...v.breadcrumbs && { breadcrumbs: v.breadcrumbs.map((O) => ({ ...O, ...O.data && { data: Ht(O.data, _, w) } })) }, ...v.user && { user: Ht(v.user, _, w) }, ...v.contexts && { contexts: Ht(v.contexts, _, w) }, ...v.extra && { extra: Ht(v.extra, _, w) } };
    return v.contexts && v.contexts.trace && k.contexts && (k.contexts.trace = v.contexts.trace, v.contexts.trace.data && (k.contexts.trace.data = Ht(v.contexts.trace.data, _, w))), v.spans && (k.spans = v.spans.map((O) => ({ ...O, ...O.data && { data: Ht(O.data, _, w) } }))), v.contexts && v.contexts.flags && k.contexts && (k.contexts.flags = Ht(v.contexts.flags, 3, w)), k;
  }(y, a, u) : y));
}
function Pp(e) {
  if (e)
    return function(t) {
      return t instanceof Zt || typeof t == "function";
    }(e) || function(t) {
      return Object.keys(t).some((n) => Op.includes(n));
    }(e) ? { captureContext: e } : e;
}
const Op = ["user", "level", "extra", "contexts", "tags", "fingerprint", "requestSession", "propagationContext"];
function fc(e, t) {
  return Pn().captureEvent(e, t);
}
function pc(e) {
  const t = nt(), n = Nr(), r = Pn(), { release: i, environment: o = as } = t && t.getOptions() || {}, { userAgent: a } = Ce.navigator || {}, u = up({ release: i, environment: o, user: r.getUser() || n.getUser(), ...a && { userAgent: a }, ...e }), c = n.getSession();
  return c && c.status === "ok" && Kn(c, { status: "exited" }), Pl(), n.setSession(u), r.setSession(u), u;
}
function Pl() {
  const e = Nr(), t = Pn(), n = t.getSession() || e.getSession();
  n && function(r, i) {
    let o = {};
    i ? o = { status: i } : r.status === "ok" && (o = { status: "exited" }), Kn(r, o);
  }(n), Ol(), e.setSession(), t.setSession();
}
function Ol() {
  const e = Nr(), t = Pn(), n = nt(), r = t.getSession() || e.getSession();
  r && n && n.captureSession(r);
}
function hc(e = !1) {
  e ? Pl() : Ol();
}
function Np(e, t, n) {
  return t || `${function(r) {
    return `${function(i) {
      const o = i.protocol ? `${i.protocol}:` : "", a = i.port ? `:${i.port}` : "";
      return `${o}//${i.host}${a}${i.path ? `/${i.path}` : ""}/api/`;
    }(r)}${r.projectId}/envelope/`;
  }(e)}?${function(r, i) {
    const o = { sentry_version: "7" };
    return r.publicKey && (o.sentry_key = r.publicKey), i && (o.sentry_client = `${i.name}/${i.version}`), new URLSearchParams(o).toString();
  }(e, n)}`;
}
const vc = [];
function mc(e, t) {
  for (const n of t)
    n && n.afterAllSetup && n.afterAllSetup(e);
}
function gc(e, t, n) {
  if (n[t.name])
    De && fe.log(`Integration skipped because it was already installed: ${t.name}`);
  else {
    if (n[t.name] = t, vc.indexOf(t.name) === -1 && typeof t.setupOnce == "function" && (t.setupOnce(), vc.push(t.name)), t.setup && typeof t.setup == "function" && t.setup(e), typeof t.preprocessEvent == "function") {
      const r = t.preprocessEvent.bind(t);
      e.on("preprocessEvent", (i, o) => r(i, o, e));
    }
    if (typeof t.processEvent == "function") {
      const r = t.processEvent.bind(t), i = Object.assign((o, a) => r(o, a, e), { id: t.name });
      e.addEventProcessor(i);
    }
    De && fe.log(`Integration installed: ${t.name}`);
  }
}
class At extends Error {
  constructor(t, n = "warn") {
    super(t), this.message = t, this.logLevel = n;
  }
}
const yc = "Not capturing exception because it's already been captured.";
class Lp {
  constructor(t) {
    if (this._options = t, this._integrations = {}, this._numProcessing = 0, this._outcomes = {}, this._hooks = {}, this._eventProcessors = [], t.dsn ? this._dsn = wp(t.dsn) : De && fe.warn("No DSN provided, client will not send events."), this._dsn) {
      const r = Np(this._dsn, t.tunnel, t._metadata ? t._metadata.sdk : void 0);
      this._transport = t.transport({ tunnel: this._options.tunnel, recordDroppedEvent: this.recordDroppedEvent.bind(this), ...t.transportOptions, url: r });
    }
    const n = ["enableTracing", "tracesSampleRate", "tracesSampler"].find((r) => r in t && t[r] == null);
    n && Pr(() => {
      console.warn(`[Sentry] Deprecation warning: \`${n}\` is set to undefined, which leads to tracing being enabled. In v9, a value of \`undefined\` will result in tracing being disabled.`);
    });
  }
  captureException(t, n, r) {
    const i = Tt();
    if (Zs(t))
      return De && fe.log(yc), i;
    const o = { event_id: i, ...n };
    return this._process(this.eventFromException(t, o).then((a) => this._captureEvent(a, o, r))), o.event_id;
  }
  captureMessage(t, n, r, i) {
    const o = { event_id: Tt(), ...r }, a = es(t) ? t : String(t), u = la(t) ? this.eventFromMessage(a, n, o) : this.eventFromException(t, o);
    return this._process(u.then((c) => this._captureEvent(c, o, i))), o.event_id;
  }
  captureEvent(t, n, r) {
    const i = Tt();
    if (n && n.originalException && Zs(n.originalException))
      return De && fe.log(yc), i;
    const o = { event_id: i, ...n }, a = (t.sdkProcessingMetadata || {}).capturedSpanScope;
    return this._process(this._captureEvent(t, o, a || r)), o.event_id;
  }
  captureSession(t) {
    typeof t.release != "string" ? De && fe.warn("Discarded session because of missing or non-string release") : (this.sendSession(t), Kn(t, { init: !1 }));
  }
  getDsn() {
    return this._dsn;
  }
  getOptions() {
    return this._options;
  }
  getSdkMetadata() {
    return this._options._metadata;
  }
  getTransport() {
    return this._transport;
  }
  flush(t) {
    const n = this._transport;
    return n ? (this.emit("flush"), this._isClientDoneProcessing(t).then((r) => n.flush(t).then((i) => r && i))) : Tn(!0);
  }
  close(t) {
    return this.flush(t).then((n) => (this.getOptions().enabled = !1, this.emit("close"), n));
  }
  getEventProcessors() {
    return this._eventProcessors;
  }
  addEventProcessor(t) {
    this._eventProcessors.push(t);
  }
  init() {
    (this._isEnabled() || this._options.integrations.some(({ name: t }) => t.startsWith("Spotlight"))) && this._setupIntegrations();
  }
  getIntegrationByName(t) {
    return this._integrations[t];
  }
  addIntegration(t) {
    const n = this._integrations[t.name];
    gc(this, t, this._integrations), n || mc(this, [t]);
  }
  sendEvent(t, n = {}) {
    this.emit("beforeSendEvent", t, n);
    let r = Cp(t, this._dsn, this._options._metadata, this._options.tunnel);
    for (const o of n.attachments || [])
      r = kp(r, Tp(o));
    const i = this.sendEnvelope(r);
    i && i.then((o) => this.emit("afterSendEvent", t, o), null);
  }
  sendSession(t) {
    const n = function(r, i, o, a) {
      const u = Al(o);
      return Cr({ sent_at: (/* @__PURE__ */ new Date()).toISOString(), ...u && { sdk: u }, ...!!a && i && { dsn: Mi(i) } }, ["aggregates" in r ? [{ type: "sessions" }, r] : [{ type: "session" }, r.toJSON()]]);
    }(t, this._dsn, this._options._metadata, this._options.tunnel);
    this.sendEnvelope(n);
  }
  recordDroppedEvent(t, n, r) {
    if (this._options.sendClientReports) {
      const i = typeof r == "number" ? r : 1, o = `${t}:${n}`;
      De && fe.log(`Recording outcome: "${o}"${i > 1 ? ` (${i} times)` : ""}`), this._outcomes[o] = (this._outcomes[o] || 0) + i;
    }
  }
  on(t, n) {
    const r = this._hooks[t] = this._hooks[t] || [];
    return r.push(n), () => {
      const i = r.indexOf(n);
      i > -1 && r.splice(i, 1);
    };
  }
  emit(t, ...n) {
    const r = this._hooks[t];
    r && r.forEach((i) => i(...n));
  }
  sendEnvelope(t) {
    return this.emit("beforeEnvelope", t), this._isEnabled() && this._transport ? this._transport.send(t).then(null, (n) => (De && fe.error("Error while sending envelope:", n), n)) : (De && fe.error("Transport disabled"), Tn({}));
  }
  _setupIntegrations() {
    const { integrations: t } = this._options;
    this._integrations = function(n, r) {
      const i = {};
      return r.forEach((o) => {
        o && gc(n, o, i);
      }), i;
    }(this, t), mc(this, t);
  }
  _updateSessionFromEvent(t, n) {
    let r = n.level === "fatal", i = !1;
    const o = n.exception && n.exception.values;
    if (o) {
      i = !0;
      for (const u of o) {
        const c = u.mechanism;
        if (c && c.handled === !1) {
          r = !0;
          break;
        }
      }
    }
    const a = t.status === "ok";
    (a && t.errors === 0 || a && r) && (Kn(t, { ...r && { status: "crashed" }, errors: t.errors || Number(i || r) }), this.captureSession(t));
  }
  _isClientDoneProcessing(t) {
    return new wt((n) => {
      let r = 0;
      const i = setInterval(() => {
        this._numProcessing == 0 ? (clearInterval(i), n(!0)) : (r += 1, t && r >= t && (clearInterval(i), n(!1)));
      }, 1);
    });
  }
  _isEnabled() {
    return this.getOptions().enabled !== !1 && this._transport !== void 0;
  }
  _prepareEvent(t, n, r = Pn(), i = Nr()) {
    const o = this.getOptions(), a = Object.keys(this._integrations);
    return !n.integrations && a.length > 0 && (n.integrations = a), this.emit("preprocessEvent", t, n), t.type || i.setLastEventId(t.event_id || n.event_id), Ap(o, t, n, r, this, i).then((u) => {
      if (u === null)
        return u;
      u.contexts = { trace: pp(r), ...u.contexts };
      const c = function(l, d) {
        const h = d.getPropagationContext();
        return h.dsc || Cl(h.traceId, l);
      }(this, r);
      return u.sdkProcessingMetadata = { dynamicSamplingContext: c, ...u.sdkProcessingMetadata }, u;
    });
  }
  _captureEvent(t, n = {}, r) {
    return this._processEvent(t, n, r).then((i) => i.event_id, (i) => {
      De && (i instanceof At && i.logLevel === "log" ? fe.log(i.message) : fe.warn(i));
    });
  }
  _processEvent(t, n, r) {
    const i = this.getOptions(), { sampleRate: o } = i, a = bc(t), u = _c(t), c = t.type || "error", l = `before send for type \`${c}\``, d = o === void 0 ? void 0 : function(b) {
      if (typeof b == "boolean")
        return Number(b);
      const y = typeof b == "string" ? parseFloat(b) : b;
      if (!(typeof y != "number" || isNaN(y) || y < 0 || y > 1))
        return y;
      De && fe.warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(b)} of type ${JSON.stringify(typeof b)}.`);
    }(o);
    if (u && typeof d == "number" && Math.random() > d)
      return this.recordDroppedEvent("sample_rate", "error", t), Ci(new At(`Discarding event because it's not included in the random sample (sampling rate = ${o})`, "log"));
    const h = c === "replay_event" ? "replay" : c, g = (t.sdkProcessingMetadata || {}).capturedSpanIsolationScope;
    return this._prepareEvent(t, n, r, g).then((b) => {
      if (b === null)
        throw this.recordDroppedEvent("event_processor", h, t), new At("An event processor returned `null`, will not send event.", "log");
      if (n.data && n.data.__sentry__ === !0)
        return b;
      const y = function(v, _, w, k) {
        const { beforeSend: O, beforeSendTransaction: I, beforeSendSpan: N } = _;
        if (_c(w) && O)
          return O(w, k);
        if (bc(w)) {
          if (w.spans && N) {
            const E = [];
            for (const L of w.spans) {
              const B = N(L);
              B ? E.push(B) : (_p(), v.recordDroppedEvent("before_send", "span"));
            }
            w.spans = E;
          }
          if (I) {
            if (w.spans) {
              const E = w.spans.length;
              w.sdkProcessingMetadata = { ...w.sdkProcessingMetadata, spanCountBeforeProcessing: E };
            }
            return I(w, k);
          }
        }
        return w;
      }(this, i, b, n);
      return function(v, _) {
        const w = `${_} must return \`null\` or a valid event.`;
        if (zi(v))
          return v.then((k) => {
            if (!Hn(k) && k !== null)
              throw new At(w);
            return k;
          }, (k) => {
            throw new At(`${_} rejected with ${k}`);
          });
        if (!Hn(v) && v !== null)
          throw new At(w);
        return v;
      }(y, l);
    }).then((b) => {
      if (b === null) {
        if (this.recordDroppedEvent("before_send", h, t), a) {
          const _ = 1 + (t.spans || []).length;
          this.recordDroppedEvent("before_send", "span", _);
        }
        throw new At(`${l} returned \`null\`, will not send event.`, "log");
      }
      const y = r && r.getSession();
      if (!a && y && this._updateSessionFromEvent(y, b), a) {
        const _ = (b.sdkProcessingMetadata && b.sdkProcessingMetadata.spanCountBeforeProcessing || 0) - (b.spans ? b.spans.length : 0);
        _ > 0 && this.recordDroppedEvent("before_send", "span", _);
      }
      const v = b.transaction_info;
      if (a && v && b.transaction !== t.transaction) {
        const _ = "custom";
        b.transaction_info = { ...v, source: _ };
      }
      return this.sendEvent(b, n), b;
    }).then(null, (b) => {
      throw b instanceof At ? b : (this.captureException(b, { data: { __sentry__: !0 }, originalException: b }), new At(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.
Reason: ${b}`));
    });
  }
  _process(t) {
    this._numProcessing++, t.then((n) => (this._numProcessing--, n), (n) => (this._numProcessing--, n));
  }
  _clearOutcomes() {
    const t = this._outcomes;
    return this._outcomes = {}, Object.entries(t).map(([n, r]) => {
      const [i, o] = n.split(":");
      return { reason: i, category: o, quantity: r };
    });
  }
  _flushOutcomes() {
    De && fe.log("Flushing outcomes...");
    const t = this._clearOutcomes();
    if (t.length === 0)
      return void (De && fe.log("No outcomes to send"));
    if (!this._dsn)
      return void (De && fe.log("No dsn provided, will not send outcomes"));
    De && fe.log("Sending outcomes:", t);
    const n = (r = t, Cr((i = this._options.tunnel && Mi(this._dsn)) ? { dsn: i } : {}, [[{ type: "client_report" }, { timestamp: o || Or(), discarded_events: r }]]));
    var r, i, o;
    this.sendEnvelope(n);
  }
}
function _c(e) {
  return e.type === void 0;
}
function bc(e) {
  return e.type === "transaction";
}
function Ip(e) {
  const t = [];
  function n(r) {
    return t.splice(t.indexOf(r), 1)[0] || Promise.resolve(void 0);
  }
  return { $: t, add: function(r) {
    if (!(e === void 0 || t.length < e))
      return Ci(new At("Not adding Promise because buffer limit was reached."));
    const i = r();
    return t.indexOf(i) === -1 && t.push(i), i.then(() => n(i)).then(null, () => n(i).then(null, () => {
    })), i;
  }, drain: function(r) {
    return new wt((i, o) => {
      let a = t.length;
      if (!a)
        return i(!0);
      const u = setTimeout(() => {
        r && r > 0 && i(!1);
      }, r);
      t.forEach((c) => {
        Tn(c).then(() => {
          --a || (clearTimeout(u), i(!0));
        }, o);
      });
    });
  } };
}
function xp(e, { statusCode: t, headers: n }, r = Date.now()) {
  const i = { ...e }, o = n && n["x-sentry-rate-limits"], a = n && n["retry-after"];
  if (o)
    for (const u of o.trim().split(",")) {
      const [c, l, , , d] = u.split(":", 5), h = parseInt(c, 10), g = 1e3 * (isNaN(h) ? 60 : h);
      if (l)
        for (const b of l.split(";"))
          b === "metric_bucket" && d && !d.split(";").includes("custom") || (i[b] = r + g);
      else
        i.all = r + g;
    }
  else
    a ? i.all = r + function(u, c = Date.now()) {
      const l = parseInt(`${u}`, 10);
      if (!isNaN(l))
        return 1e3 * l;
      const d = Date.parse(`${u}`);
      return isNaN(d) ? 6e4 : d - c;
    }(a, r) : t === 429 && (i.all = r + 6e4);
  return i;
}
function jp(e, t, n = Ip(e.bufferSize || 64)) {
  let r = {};
  return { send: function(i) {
    const o = [];
    if (cc(i, (c, l) => {
      const d = uc(l);
      if (function(h, g, b = Date.now()) {
        return function(y, v) {
          return y[v] || y.all || 0;
        }(h, g) > b;
      }(r, d)) {
        const h = Sc(c, l);
        e.recordDroppedEvent("ratelimit_backoff", d, h);
      } else
        o.push(c);
    }), o.length === 0)
      return Tn({});
    const a = Cr(i[0], o), u = (c) => {
      cc(a, (l, d) => {
        const h = Sc(l, d);
        e.recordDroppedEvent(c, uc(d), h);
      });
    };
    return n.add(() => t({ body: Ep(a) }).then((c) => (c.statusCode !== void 0 && (c.statusCode < 200 || c.statusCode >= 300) && De && fe.warn(`Sentry responded with status code ${c.statusCode} to sent event.`), r = xp(r, c), c), (c) => {
      throw u("network_error"), c;
    })).then((c) => c, (c) => {
      if (c instanceof At)
        return De && fe.error("Skipped sending event because buffer is full."), u("queue_overflow"), Tn({});
      throw c;
    });
  }, flush: (i) => n.drain(i) };
}
function Sc(e, t) {
  if (t === "event" || t === "transaction")
    return Array.isArray(e) ? e[1] : void 0;
}
const Dp = 100;
function fn(e, t) {
  const n = nt(), r = Nr();
  if (!n)
    return;
  const { beforeBreadcrumb: i = null, maxBreadcrumbs: o = Dp } = n.getOptions();
  if (o <= 0)
    return;
  const a = { timestamp: Or(), ...e }, u = i ? Pr(() => i(a, t)) : a;
  u !== null && (n.emit && n.emit("beforeAddBreadcrumb", u, t), r.addBreadcrumb(u, o));
}
let wc;
const kc = /* @__PURE__ */ new WeakMap(), Vp = () => ({ name: "FunctionToString", setupOnce() {
  wc = Function.prototype.toString;
  try {
    Function.prototype.toString = function(...e) {
      const t = ns(this), n = kc.has(nt()) && t !== void 0 ? t : this;
      return wc.apply(n, e);
    };
  } catch {
  }
}, setup(e) {
  kc.set(e, !0);
} }), $p = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/, /^ResizeObserver loop completed with undelivered notifications.$/, /^Cannot redefine property: googletag$/, "undefined is not an object (evaluating 'a.L')", `can't redefine non-configurable property "solana"`, "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)", "Can't find variable: _AutofillCallbackHandler", /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/], Bp = (e = {}) => ({ name: "InboundFilters", processEvent(t, n, r) {
  const i = r.getOptions(), o = function(a = {}, u = {}) {
    return { allowUrls: [...a.allowUrls || [], ...u.allowUrls || []], denyUrls: [...a.denyUrls || [], ...u.denyUrls || []], ignoreErrors: [...a.ignoreErrors || [], ...u.ignoreErrors || [], ...a.disableErrorDefaults ? [] : $p], ignoreTransactions: [...a.ignoreTransactions || [], ...u.ignoreTransactions || []], ignoreInternal: a.ignoreInternal === void 0 || a.ignoreInternal };
  }(e, i);
  return function(a, u) {
    return u.ignoreInternal && function(c) {
      try {
        return c.exception.values[0].type === "SentryError";
      } catch {
      }
      return !1;
    }(a) ? (De && fe.warn(`Event dropped due to being internal Sentry Error.
Event: ${rn(a)}`), !0) : function(c, l) {
      return c.type || !l || !l.length ? !1 : function(d) {
        const h = [];
        d.message && h.push(d.message);
        let g;
        try {
          g = d.exception.values[d.exception.values.length - 1];
        } catch {
        }
        return g && g.value && (h.push(g.value), g.type && h.push(`${g.type}: ${g.value}`)), h;
      }(c).some((d) => Jr(d, l));
    }(a, u.ignoreErrors) ? (De && fe.warn(`Event dropped due to being matched by \`ignoreErrors\` option.
Event: ${rn(a)}`), !0) : function(c) {
      return c.type || !c.exception || !c.exception.values || c.exception.values.length === 0 ? !1 : !c.message && !c.exception.values.some((l) => l.stacktrace || l.type && l.type !== "Error" || l.value);
    }(a) ? (De && fe.warn(`Event dropped due to not having an error message, error type or stacktrace.
Event: ${rn(a)}`), !0) : function(c, l) {
      if (c.type !== "transaction" || !l || !l.length)
        return !1;
      const d = c.transaction;
      return !!d && Jr(d, l);
    }(a, u.ignoreTransactions) ? (De && fe.warn(`Event dropped due to being matched by \`ignoreTransactions\` option.
Event: ${rn(a)}`), !0) : function(c, l) {
      if (!l || !l.length)
        return !1;
      const d = Kr(c);
      return !!d && Jr(d, l);
    }(a, u.denyUrls) ? (De && fe.warn(`Event dropped due to being matched by \`denyUrls\` option.
Event: ${rn(a)}.
Url: ${Kr(a)}`), !0) : function(c, l) {
      if (!l || !l.length)
        return !0;
      const d = Kr(c);
      return !d || Jr(d, l);
    }(a, u.allowUrls) ? !1 : (De && fe.warn(`Event dropped due to not being matched by \`allowUrls\` option.
Event: ${rn(a)}.
Url: ${Kr(a)}`), !0);
  }(t, o) ? null : t;
} });
function Kr(e) {
  try {
    let t;
    try {
      t = e.exception.values[0].stacktrace.frames;
    } catch {
    }
    return t ? function(n = []) {
      for (let r = n.length - 1; r >= 0; r--) {
        const i = n[r];
        if (i && i.filename !== "<anonymous>" && i.filename !== "[native code]")
          return i.filename || null;
      }
      return null;
    }(t) : null;
  } catch {
    return De && fe.error(`Cannot extract url for event ${rn(e)}`), null;
  }
}
function Fp(e, t, n = 250, r, i, o, a) {
  if (!(o.exception && o.exception.values && a && kn(a.originalException, Error)))
    return;
  const u = o.exception.values.length > 0 ? o.exception.values[o.exception.values.length - 1] : void 0;
  var c, l;
  u && (o.exception.values = (c = ya(e, t, i, a.originalException, r, o.exception.values, u, 0), l = n, c.map((d) => (d.value && (d.value = Wn(d.value, l)), d))));
}
function ya(e, t, n, r, i, o, a, u) {
  if (o.length >= n + 1)
    return o;
  let c = [...o];
  if (kn(r[i], Error)) {
    Ec(a, u);
    const l = e(t, r[i]), d = c.length;
    Tc(l, i, d, u), c = ya(e, t, n, r[i], i, [l, ...c], l, d);
  }
  return Array.isArray(r.errors) && r.errors.forEach((l, d) => {
    if (kn(l, Error)) {
      Ec(a, u);
      const h = e(t, l), g = c.length;
      Tc(h, `errors[${d}]`, g, u), c = ya(e, t, n, l, i, [h, ...c], h, g);
    }
  }), c;
}
function Ec(e, t) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = { ...e.mechanism, ...e.type === "AggregateError" && { is_exception_group: !0 }, exception_id: t };
}
function Tc(e, t, n, r) {
  e.mechanism = e.mechanism || { type: "generic", handled: !0 }, e.mechanism = { ...e.mechanism, type: "chained", source: t, exception_id: n, parent_id: r };
}
function Lo(e) {
  if (!e)
    return {};
  const t = e.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
  if (!t)
    return {};
  const n = t[6] || "", r = t[8] || "";
  return { host: t[4], path: t[5], protocol: t[2], search: n, hash: r, relative: t[5] + n + r };
}
function Up() {
  "console" in Ce && ua.forEach(function(e) {
    e in Ce.console && mt(Ce.console, e, function(t) {
      return Ri[e] = t, function(...n) {
        Ot("console", { args: n, level: e });
        const r = Ri[e];
        r && r.apply(Ce.console, n);
      };
    });
  });
}
function zp(e) {
  return e === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(e) ? e : "log";
}
const Wp = () => {
  let e;
  return { name: "Dedupe", processEvent(t) {
    if (t.type)
      return t;
    try {
      if (function(n, r) {
        return r ? !!(function(i, o) {
          const a = i.message, u = o.message;
          return !(!a && !u || a && !u || !a && u || a !== u || !Cc(i, o) || !Rc(i, o));
        }(n, r) || function(i, o) {
          const a = Mc(o), u = Mc(i);
          return !(!a || !u || a.type !== u.type || a.value !== u.value || !Cc(i, o) || !Rc(i, o));
        }(n, r)) : !1;
      }(t, e))
        return De && fe.warn("Event dropped due to being a duplicate of previously captured event."), null;
    } catch {
    }
    return e = t;
  } };
};
function Rc(e, t) {
  let n = Js(e), r = Js(t);
  if (!n && !r)
    return !0;
  if (n && !r || !n && r || r.length !== n.length)
    return !1;
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = n[i];
    if (o.filename !== a.filename || o.lineno !== a.lineno || o.colno !== a.colno || o.function !== a.function)
      return !1;
  }
  return !0;
}
function Cc(e, t) {
  let n = e.fingerprint, r = t.fingerprint;
  if (!n && !r)
    return !0;
  if (n && !r || !n && r)
    return !1;
  try {
    return n.join("") === r.join("");
  } catch {
    return !1;
  }
}
function Mc(e) {
  return e.exception && e.exception.values && e.exception.values[0];
}
function Ac(e) {
  return e === void 0 ? void 0 : e >= 400 && e < 500 ? "warning" : e >= 500 ? "error" : void 0;
}
const Io = Ce;
function _a(e) {
  return e && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(e.toString());
}
function qp() {
  if (typeof EdgeRuntime == "string")
    return !0;
  if (!function() {
    if (!("fetch" in Io))
      return !1;
    try {
      return new Headers(), new Request("http://www.example.com"), new Response(), !0;
    } catch {
      return !1;
    }
  }())
    return !1;
  if (_a(Io.fetch))
    return !0;
  let e = !1;
  const t = Io.document;
  if (t && typeof t.createElement == "function")
    try {
      const n = t.createElement("iframe");
      n.hidden = !0, t.head.appendChild(n), n.contentWindow && n.contentWindow.fetch && (e = _a(n.contentWindow.fetch)), t.head.removeChild(n);
    } catch (n) {
      An && fe.warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", n);
    }
  return e;
}
function Jp(e, t) {
  const n = "fetch";
  Sn(n, e), wn(n, () => function(r, i = !1) {
    i && !qp() || mt(Ce, "fetch", function(o) {
      return function(...a) {
        const u = new Error(), { method: c, url: l } = function(h) {
          if (h.length === 0)
            return { method: "GET", url: "" };
          if (h.length === 2) {
            const [b, y] = h;
            return { url: Pc(b), method: ba(y, "method") ? String(y.method).toUpperCase() : "GET" };
          }
          const g = h[0];
          return { url: Pc(g), method: ba(g, "method") ? String(g.method).toUpperCase() : "GET" };
        }(a), d = { args: a, fetchData: { method: c, url: l }, startTimestamp: 1e3 * Yt(), virtualError: u };
        return r || Ot("fetch", { ...d }), o.apply(Ce, a).then(async (h) => (r ? r(h) : Ot("fetch", { ...d, endTimestamp: 1e3 * Yt(), response: h }), h), (h) => {
          throw Ot("fetch", { ...d, endTimestamp: 1e3 * Yt(), error: h }), Xa(h) && h.stack === void 0 && (h.stack = u.stack, En(h, "framesToPop", 1)), h;
        });
      };
    });
  }(void 0, t));
}
function ba(e, t) {
  return !!e && typeof e == "object" && !!e[t];
}
function Pc(e) {
  return typeof e == "string" ? e : e ? ba(e, "url") ? e.url : e.toString ? e.toString() : "" : "";
}
const Yr = Ce, Qe = Ce;
let Sa = 0;
function Oc() {
  return Sa > 0;
}
function Qn(e, t = {}) {
  if (!/* @__PURE__ */ function(r) {
    return typeof r == "function";
  }(e))
    return e;
  try {
    const r = e.__sentry_wrapped__;
    if (r)
      return typeof r == "function" ? r : e;
    if (ns(e))
      return e;
  } catch {
    return e;
  }
  const n = function(...r) {
    try {
      const i = r.map((o) => Qn(o, t));
      return e.apply(this, i);
    } catch (i) {
      throw Sa++, setTimeout(() => {
        Sa--;
      }), function(...o) {
        const a = is(Fi());
        if (o.length === 2) {
          const [u, c] = o;
          return u ? a.withSetScope(u, c) : a.withScope(c);
        }
        a.withScope(o[0]);
      }((o) => {
        var a, u;
        o.addEventProcessor((c) => (t.mechanism && (fa(c, void 0, void 0), Gn(c, t.mechanism)), c.extra = { ...c.extra, arguments: r }, c)), a = i, Pn().captureException(a, Pp(u));
      }), i;
    }
  };
  try {
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = e[r]);
  } catch {
  }
  kl(n, e), En(e, "__sentry_wrapped__", n);
  try {
    Object.getOwnPropertyDescriptor(n, "name").configurable && Object.defineProperty(n, "name", { get: () => e.name });
  } catch {
  }
  return n;
}
const qi = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__;
function ss(e, t) {
  const n = cs(e, t), r = { type: Kp(t), value: Yp(t) };
  return n.length && (r.stacktrace = { frames: n }), r.type === void 0 && r.value === "" && (r.value = "Unrecoverable error caught"), r;
}
function Hp(e, t, n, r) {
  const i = nt(), o = i && i.getOptions().normalizeDepth, a = function(l) {
    for (const d in l)
      if (Object.prototype.hasOwnProperty.call(l, d)) {
        const h = l[d];
        if (h instanceof Error)
          return h;
      }
  }(t), u = { __serialized__: Ml(t, o) };
  if (a)
    return { exception: { values: [ss(e, a)] }, extra: u };
  const c = { exception: { values: [{ type: Ui(t) ? t.constructor.name : r ? "UnhandledRejection" : "Error", value: Qp(t, { isUnhandledRejection: r }) }] }, extra: u };
  if (n) {
    const l = cs(e, n);
    l.length && (c.exception.values[0].stacktrace = { frames: l });
  }
  return c;
}
function xo(e, t) {
  return { exception: { values: [ss(e, t)] } };
}
function cs(e, t) {
  const n = t.stacktrace || t.stack || "", r = function(o) {
    return o && Gp.test(o.message) ? 1 : 0;
  }(t), i = function(o) {
    return typeof o.framesToPop == "number" ? o.framesToPop : 0;
  }(t);
  try {
    return e(n, r, i);
  } catch {
  }
  return [];
}
const Gp = /Minified React error #\d+;/i;
function Nl(e) {
  return typeof WebAssembly < "u" && WebAssembly.Exception !== void 0 && e instanceof WebAssembly.Exception;
}
function Kp(e) {
  const t = e && e.name;
  return !t && Nl(e) ? e.message && Array.isArray(e.message) && e.message.length == 2 ? e.message[0] : "WebAssembly.Exception" : t;
}
function Yp(e) {
  const t = e && e.message;
  return t ? t.error && typeof t.error.message == "string" ? t.error.message : Nl(e) && Array.isArray(e.message) && e.message.length == 2 ? e.message[1] : t : "No error message";
}
function wa(e, t, n, r, i) {
  let o;
  if (bl(t) && t.error)
    return xo(e, t.error);
  if (Gs(t) || ir(t, "DOMException")) {
    const a = t;
    if ("stack" in t)
      o = xo(e, t);
    else {
      const u = a.name || (Gs(a) ? "DOMError" : "DOMException"), c = a.message ? `${u}: ${a.message}` : u;
      o = ka(e, c, n, r), fa(o, c);
    }
    return "code" in a && (o.tags = { ...o.tags, "DOMException.code": `${a.code}` }), o;
  }
  return Xa(t) ? xo(e, t) : Hn(t) || Ui(t) ? (o = Hp(e, t, n, i), Gn(o, { synthetic: !0 }), o) : (o = ka(e, t, n, r), fa(o, `${t}`, void 0), Gn(o, { synthetic: !0 }), o);
}
function ka(e, t, n, r) {
  const i = {};
  if (r && n) {
    const o = cs(e, n);
    o.length && (i.exception = { values: [{ value: t, stacktrace: { frames: o } }] }), Gn(i, { synthetic: !0 });
  }
  if (es(t)) {
    const { __sentry_template_string__: o, __sentry_template_values__: a } = t;
    return i.logentry = { message: o, params: a }, i;
  }
  return i.message = t, i;
}
function Qp(e, { isUnhandledRejection: t }) {
  const n = function(i, o = 40) {
    const a = Object.keys(El(i));
    a.sort();
    const u = a[0];
    if (!u)
      return "[object has no keys]";
    if (u.length >= o)
      return Wn(u, o);
    for (let c = a.length; c > 0; c--) {
      const l = a.slice(0, c).join(", ");
      if (!(l.length > o))
        return c === a.length ? l : Wn(l, o);
    }
    return "";
  }(e), r = t ? "promise rejection" : "exception";
  return bl(e) ? `Event \`ErrorEvent\` captured as ${r} with message \`${e.message}\`` : Ui(e) ? `Event \`${function(i) {
    try {
      const o = Object.getPrototypeOf(i);
      return o ? o.constructor.name : void 0;
    } catch {
    }
  }(e)}\` (type=${e.type}) captured as ${r}` : `Object captured as ${r} with keys: ${n}`;
}
class Zp extends Lp {
  constructor(t) {
    const n = { parentSpanIsAlwaysRootSpan: !0, ...t };
    (function(r, i, o = [i], a = "npm") {
      const u = r._metadata || {};
      u.sdk || (u.sdk = { name: `sentry.javascript.${i}`, packages: o.map((c) => ({ name: `${a}:@sentry/${c}`, version: bn })), version: bn }), r._metadata = u;
    })(n, "browser", ["browser"], Qe.SENTRY_SDK_SOURCE || "npm"), super(n), n.sendClientReports && Qe.document && Qe.document.addEventListener("visibilitychange", () => {
      Qe.document.visibilityState === "hidden" && this._flushOutcomes();
    });
  }
  eventFromException(t, n) {
    return function(r, i, o, a) {
      const u = wa(r, i, o && o.syntheticException || void 0, a);
      return Gn(u), u.level = "error", o && o.event_id && (u.event_id = o.event_id), Tn(u);
    }(this._options.stackParser, t, n, this._options.attachStacktrace);
  }
  eventFromMessage(t, n = "info", r) {
    return function(i, o, a = "info", u, c) {
      const l = ka(i, o, u && u.syntheticException || void 0, c);
      return l.level = a, u && u.event_id && (l.event_id = u.event_id), Tn(l);
    }(this._options.stackParser, t, n, r, this._options.attachStacktrace);
  }
  captureUserFeedback(t) {
    if (!this._isEnabled())
      return void (qi && fe.warn("SDK not enabled, will not capture user feedback."));
    const n = function(r, { metadata: i, tunnel: o, dsn: a }) {
      const u = { event_id: r.event_id, sent_at: (/* @__PURE__ */ new Date()).toISOString(), ...i && i.sdk && { sdk: { name: i.sdk.name, version: i.sdk.version } }, ...!!o && !!a && { dsn: Mi(a) } };
      return Cr(u, [/* @__PURE__ */ function(l) {
        return [{ type: "user_report" }, l];
      }(r)]);
    }(t, { metadata: this.getSdkMetadata(), dsn: this.getDsn(), tunnel: this.getOptions().tunnel });
    this.sendEnvelope(n);
  }
  _prepareEvent(t, n, r) {
    return t.platform = t.platform || "javascript", super._prepareEvent(t, n, r);
  }
}
const Xp = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ct = Ce;
let Nc, jo, Do, Qr;
function eh() {
  if (!ct.document)
    return;
  const e = Ot.bind(null, "dom"), t = Lc(e, !0);
  ct.document.addEventListener("click", t, !1), ct.document.addEventListener("keypress", t, !1), ["EventTarget", "Node"].forEach((n) => {
    const r = ct[n], i = r && r.prototype;
    i && i.hasOwnProperty && i.hasOwnProperty("addEventListener") && (mt(i, "addEventListener", function(o) {
      return function(a, u, c) {
        if (a === "click" || a == "keypress")
          try {
            const l = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {}, d = l[a] = l[a] || { refCount: 0 };
            if (!d.handler) {
              const h = Lc(e);
              d.handler = h, o.call(this, a, h, c);
            }
            d.refCount++;
          } catch {
          }
        return o.call(this, a, u, c);
      };
    }), mt(i, "removeEventListener", function(o) {
      return function(a, u, c) {
        if (a === "click" || a == "keypress")
          try {
            const l = this.__sentry_instrumentation_handlers__ || {}, d = l[a];
            d && (d.refCount--, d.refCount <= 0 && (o.call(this, a, d.handler, c), d.handler = void 0, delete l[a]), Object.keys(l).length === 0 && delete this.__sentry_instrumentation_handlers__);
          } catch {
          }
        return o.call(this, a, u, c);
      };
    }));
  });
}
function Lc(e, t = !1) {
  return (n) => {
    if (!n || n._sentryCaptured)
      return;
    const r = function(o) {
      try {
        return o.target;
      } catch {
        return null;
      }
    }(n);
    if (function(o, a) {
      return o === "keypress" && (!a || !a.tagName || a.tagName !== "INPUT" && a.tagName !== "TEXTAREA" && !a.isContentEditable);
    }(n.type, r))
      return;
    En(n, "_sentryCaptured", !0), r && !r._sentryId && En(r, "_sentryId", Tt());
    const i = n.type === "keypress" ? "input" : n.type;
    (function(o) {
      if (o.type !== jo)
        return !1;
      try {
        if (!o.target || o.target._sentryId !== Do)
          return !1;
      } catch {
      }
      return !0;
    })(n) || (e({ event: n, name: i, global: t }), jo = n.type, Do = r ? r._sentryId : void 0), clearTimeout(Nc), Nc = ct.setTimeout(() => {
      Do = void 0, jo = void 0;
    }, 1e3);
  };
}
function Ll(e) {
  const t = "history";
  Sn(t, e), wn(t, th);
}
function th() {
  if (!function() {
    const n = Yr.chrome, r = n && n.app && n.app.runtime, i = "history" in Yr && !!Yr.history.pushState && !!Yr.history.replaceState;
    return !r && i;
  }())
    return;
  const e = ct.onpopstate;
  function t(n) {
    return function(...r) {
      const i = r.length > 2 ? r[2] : void 0;
      if (i) {
        const o = Qr, a = String(i);
        Qr = a, Ot("history", { from: o, to: a });
      }
      return n.apply(this, r);
    };
  }
  ct.onpopstate = function(...n) {
    const r = ct.location.href, i = Qr;
    if (Qr = r, Ot("history", { from: i, to: r }), e)
      try {
        return e.apply(this, n);
      } catch {
      }
  }, mt(ct.history, "pushState", t), mt(ct.history, "replaceState", t);
}
const pi = {};
function Ic(e) {
  pi[e] = void 0;
}
const _r = "__sentry_xhr_v3__";
function nh() {
  if (!ct.XMLHttpRequest)
    return;
  const e = XMLHttpRequest.prototype;
  e.open = new Proxy(e.open, { apply(t, n, r) {
    const i = new Error(), o = 1e3 * Yt(), a = Gt(r[0]) ? r[0].toUpperCase() : void 0, u = function(l) {
      if (Gt(l))
        return l;
      try {
        return l.toString();
      } catch {
      }
    }(r[1]);
    if (!a || !u)
      return t.apply(n, r);
    n[_r] = { method: a, url: u, request_headers: {} }, a === "POST" && u.match(/sentry_key/) && (n.__sentry_own_request__ = !0);
    const c = () => {
      const l = n[_r];
      if (l && n.readyState === 4) {
        try {
          l.status_code = n.status;
        } catch {
        }
        Ot("xhr", { endTimestamp: 1e3 * Yt(), startTimestamp: o, xhr: n, virtualError: i });
      }
    };
    return "onreadystatechange" in n && typeof n.onreadystatechange == "function" ? n.onreadystatechange = new Proxy(n.onreadystatechange, { apply: (l, d, h) => (c(), l.apply(d, h)) }) : n.addEventListener("readystatechange", c), n.setRequestHeader = new Proxy(n.setRequestHeader, { apply(l, d, h) {
      const [g, b] = h, y = d[_r];
      return y && Gt(g) && Gt(b) && (y.request_headers[g.toLowerCase()] = b), l.apply(d, h);
    } }), t.apply(n, r);
  } }), e.send = new Proxy(e.send, { apply(t, n, r) {
    const i = n[_r];
    return i ? (r[0] !== void 0 && (i.body = r[0]), Ot("xhr", { startTimestamp: 1e3 * Yt(), xhr: n }), t.apply(n, r)) : t.apply(n, r);
  } });
}
function rh(e, t = function(n) {
  const r = pi[n];
  if (r)
    return r;
  let i = ct[n];
  if (_a(i))
    return pi[n] = i.bind(ct);
  const o = ct.document;
  if (o && typeof o.createElement == "function")
    try {
      const a = o.createElement("iframe");
      a.hidden = !0, o.head.appendChild(a);
      const u = a.contentWindow;
      u && u[n] && (i = u[n]), o.head.removeChild(a);
    } catch (a) {
      Xp && fe.warn(`Could not create sandbox iframe for ${n} check, bailing to window.${n}: `, a);
    }
  return i && (pi[n] = i.bind(ct));
}("fetch")) {
  let n = 0, r = 0;
  return jp(e, function(i) {
    const o = i.body.length;
    n += o, r++;
    const a = { body: i.body, method: "POST", referrerPolicy: "origin", headers: e.headers, keepalive: n <= 6e4 && r < 15, ...e.fetchOptions };
    if (!t)
      return Ic("fetch"), Ci("No fetch implementation available");
    try {
      return t(e.url, a).then((u) => (n -= o, r--, { statusCode: u.status, headers: { "x-sentry-rate-limits": u.headers.get("X-Sentry-Rate-Limits"), "retry-after": u.headers.get("Retry-After") } }));
    } catch (u) {
      return Ic("fetch"), n -= o, r--, Ci(u);
    }
  });
}
function Vo(e, t, n, r) {
  const i = { filename: e, function: t === "<anonymous>" ? _n : t, in_app: !0 };
  return n !== void 0 && (i.lineno = n), r !== void 0 && (i.colno = r), i;
}
const ih = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i, oh = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, ah = /\((\S*)(?::(\d+))(?::(\d+))\)/, sh = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i, ch = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, uh = function(...e) {
  const t = e.sort((n, r) => n[0] - r[0]).map((n) => n[1]);
  return (n, r = 0, i = 0) => {
    const o = [], a = n.split(`
`);
    for (let u = r; u < a.length; u++) {
      const c = a[u];
      if (c.length > 1024)
        continue;
      const l = zs.test(c) ? c.replace(zs, "$1") : c;
      if (!l.match(/\S*Error: /)) {
        for (const d of t) {
          const h = d(l);
          if (h) {
            o.push(h);
            break;
          }
        }
        if (o.length >= 50 + i)
          break;
      }
    }
    return function(u) {
      if (!u.length)
        return [];
      const c = Array.from(u);
      return /sentryWrapped/.test(qr(c).function || "") && c.pop(), c.reverse(), Ws.test(qr(c).function || "") && (c.pop(), Ws.test(qr(c).function || "") && c.pop()), c.slice(0, 50).map((l) => ({ ...l, filename: l.filename || qr(c).filename, function: l.function || _n }));
    }(o.slice(i));
  };
}([30, (e) => {
  const t = ih.exec(e);
  if (t) {
    const [, r, i, o] = t;
    return Vo(r, _n, +i, +o);
  }
  const n = oh.exec(e);
  if (n) {
    if (n[2] && n[2].indexOf("eval") === 0) {
      const o = ah.exec(n[2]);
      o && (n[2] = o[1], n[3] = o[2], n[4] = o[3]);
    }
    const [r, i] = xc(n[1] || _n, n[2]);
    return Vo(i, r, n[3] ? +n[3] : void 0, n[4] ? +n[4] : void 0);
  }
}], [50, (e) => {
  const t = sh.exec(e);
  if (t) {
    if (t[3] && t[3].indexOf(" > eval") > -1) {
      const i = ch.exec(t[3]);
      i && (t[1] = t[1] || "eval", t[3] = i[1], t[4] = i[2], t[5] = "");
    }
    let n = t[3], r = t[1] || _n;
    return [r, n] = xc(r, n), Vo(n, r, t[4] ? +t[4] : void 0, t[5] ? +t[5] : void 0);
  }
}]), xc = (e, t) => {
  const n = e.indexOf("safari-extension") !== -1, r = e.indexOf("safari-web-extension") !== -1;
  return n || r ? [e.indexOf("@") !== -1 ? e.split("@")[0] : _n, n ? `safari-extension:${t}` : `safari-web-extension:${t}`] : [e, t];
}, jc = 1024, lh = (e = {}) => {
  const t = { console: !0, dom: !0, fetch: !0, history: !0, sentry: !0, xhr: !0, ...e };
  return { name: "Breadcrumbs", setup(n) {
    var r;
    t.console && function(i) {
      const o = "console";
      Sn(o, i), wn(o, Up);
    }(/* @__PURE__ */ function(i) {
      return function(o) {
        if (nt() !== i)
          return;
        const a = { category: "console", data: { arguments: o.args, logger: "console" }, level: zp(o.level), message: Ks(o.args, " ") };
        if (o.level === "assert") {
          if (o.args[0] !== !1)
            return;
          a.message = `Assertion failed: ${Ks(o.args.slice(1), " ") || "console.assert"}`, a.data.arguments = o.args.slice(1);
        }
        fn(a, { input: o.args, level: o.level });
      };
    }(n)), t.dom && (r = /* @__PURE__ */ function(i, o) {
      return function(a) {
        if (nt() !== i)
          return;
        let u, c, l = typeof o == "object" ? o.serializeAttribute : void 0, d = typeof o == "object" && typeof o.maxStringLength == "number" ? o.maxStringLength : void 0;
        d && d > jc && (qi && fe.warn(`\`dom.maxStringLength\` cannot exceed 1024, but a value of ${d} was configured. Sentry will use 1024 instead.`), d = jc), typeof l == "string" && (l = [l]);
        try {
          const g = a.event, b = function(y) {
            return !!y && !!y.target;
          }(g) ? g.target : g;
          u = wl(b, { keyAttrs: l, maxStringLength: d }), c = function(y) {
            if (!ts.HTMLElement)
              return null;
            let v = y;
            for (let _ = 0; _ < 5; _++) {
              if (!v)
                return null;
              if (v instanceof HTMLElement) {
                if (v.dataset.sentryComponent)
                  return v.dataset.sentryComponent;
                if (v.dataset.sentryElement)
                  return v.dataset.sentryElement;
              }
              v = v.parentNode;
            }
            return null;
          }(b);
        } catch {
          u = "<unknown>";
        }
        if (u.length === 0)
          return;
        const h = { category: `ui.${a.name}`, message: u };
        c && (h.data = { "ui.component_name": c }), fn(h, { event: a.event, name: a.name, global: a.global });
      };
    }(n, t.dom), Sn("dom", r), wn("dom", eh)), t.xhr && function(i) {
      Sn("xhr", i), wn("xhr", nh);
    }(/* @__PURE__ */ function(i) {
      return function(o) {
        if (nt() !== i)
          return;
        const { startTimestamp: a, endTimestamp: u } = o, c = o.xhr[_r];
        if (!a || !u || !c)
          return;
        const { method: l, url: d, status_code: h, body: g } = c, b = { method: l, url: d, status_code: h }, y = { xhr: o.xhr, input: g, startTimestamp: a, endTimestamp: u };
        fn({ category: "xhr", data: b, type: "http", level: Ac(h) }, y);
      };
    }(n)), t.fetch && Jp(/* @__PURE__ */ function(i) {
      return function(o) {
        if (nt() !== i)
          return;
        const { startTimestamp: a, endTimestamp: u } = o;
        if (u && (!o.fetchData.url.match(/sentry_key/) || o.fetchData.method !== "POST"))
          if (o.error)
            fn({ category: "fetch", data: o.fetchData, level: "error", type: "http" }, { data: o.error, input: o.args, startTimestamp: a, endTimestamp: u });
          else {
            const c = o.response, l = { ...o.fetchData, status_code: c && c.status }, d = { input: o.args, response: c, startTimestamp: a, endTimestamp: u };
            fn({ category: "fetch", data: l, type: "http", level: Ac(l.status_code) }, d);
          }
      };
    }(n)), t.history && Ll(/* @__PURE__ */ function(i) {
      return function(o) {
        if (nt() !== i)
          return;
        let a = o.from, u = o.to;
        const c = Lo(Qe.location.href);
        let l = a ? Lo(a) : void 0;
        const d = Lo(u);
        l && l.path || (l = c), c.protocol === d.protocol && c.host === d.host && (u = d.relative), c.protocol === l.protocol && c.host === l.host && (a = l.relative), fn({ category: "navigation", data: { from: a, to: u } });
      };
    }(n)), t.sentry && n.on("beforeSendEvent", /* @__PURE__ */ function(i) {
      return function(o) {
        nt() === i && fn({ category: "sentry." + (o.type === "transaction" ? "transaction" : "event"), event_id: o.event_id, level: o.level, message: rn(o) }, { event: o });
      };
    }(n));
  } };
}, dh = ["EventTarget", "Window", "Node", "ApplicationCache", "AudioTrackList", "BroadcastChannel", "ChannelMergerNode", "CryptoOperation", "EventSource", "FileReader", "HTMLUnknownElement", "IDBDatabase", "IDBRequest", "IDBTransaction", "KeyOperation", "MediaController", "MessagePort", "ModalWindow", "Notification", "SVGElementInstance", "Screen", "SharedWorker", "TextTrack", "TextTrackCue", "TextTrackList", "WebSocket", "WebSocketWorker", "Worker", "XMLHttpRequest", "XMLHttpRequestEventTarget", "XMLHttpRequestUpload"], fh = (e = {}) => {
  const t = { XMLHttpRequest: !0, eventTarget: !0, requestAnimationFrame: !0, setInterval: !0, setTimeout: !0, ...e };
  return { name: "BrowserApiErrors", setupOnce() {
    t.setTimeout && mt(Qe, "setTimeout", Dc), t.setInterval && mt(Qe, "setInterval", Dc), t.requestAnimationFrame && mt(Qe, "requestAnimationFrame", ph), t.XMLHttpRequest && "XMLHttpRequest" in Qe && mt(XMLHttpRequest.prototype, "send", hh);
    const n = t.eventTarget;
    n && (Array.isArray(n) ? n : dh).forEach(vh);
  } };
};
function Dc(e) {
  return function(...t) {
    const n = t[0];
    return t[0] = Qn(n, { mechanism: { data: { function: sn(e) }, handled: !1, type: "instrument" } }), e.apply(this, t);
  };
}
function ph(e) {
  return function(t) {
    return e.apply(this, [Qn(t, { mechanism: { data: { function: "requestAnimationFrame", handler: sn(e) }, handled: !1, type: "instrument" } })]);
  };
}
function hh(e) {
  return function(...t) {
    const n = this;
    return ["onload", "onerror", "onprogress", "onreadystatechange"].forEach((r) => {
      r in n && typeof n[r] == "function" && mt(n, r, function(i) {
        const o = { mechanism: { data: { function: r, handler: sn(i) }, handled: !1, type: "instrument" } }, a = ns(i);
        return a && (o.mechanism.data.handler = sn(a)), Qn(i, o);
      });
    }), e.apply(this, t);
  };
}
function vh(e) {
  const t = Qe[e], n = t && t.prototype;
  n && n.hasOwnProperty && n.hasOwnProperty("addEventListener") && (mt(n, "addEventListener", function(r) {
    return function(i, o, a) {
      try {
        typeof o.handleEvent == "function" && (o.handleEvent = Qn(o.handleEvent, { mechanism: { data: { function: "handleEvent", handler: sn(o), target: e }, handled: !1, type: "instrument" } }));
      } catch {
      }
      return r.apply(this, [i, Qn(o, { mechanism: { data: { function: "addEventListener", handler: sn(o), target: e }, handled: !1, type: "instrument" } }), a]);
    };
  }), mt(n, "removeEventListener", function(r) {
    return function(i, o, a) {
      try {
        const u = o.__sentry_wrapped__;
        u && r.call(this, i, u, a);
      } catch {
      }
      return r.call(this, i, o, a);
    };
  }));
}
const mh = () => ({ name: "BrowserSession", setupOnce() {
  Qe.document !== void 0 ? (pc({ ignoreDuration: !0 }), hc(), Ll(({ from: e, to: t }) => {
    e !== void 0 && e !== t && (pc({ ignoreDuration: !0 }), hc());
  })) : qi && fe.warn("Using the `browserSessionIntegration` in non-browser environments is not supported.");
} }), gh = (e = {}) => {
  const t = { onerror: !0, onunhandledrejection: !0, ...e };
  return { name: "GlobalHandlers", setupOnce() {
    Error.stackTraceLimit = 50;
  }, setup(n) {
    t.onerror && (function(r) {
      (function(i) {
        const o = "error";
        Sn(o, i), wn(o, op);
      })((i) => {
        const { stackParser: o, attachStacktrace: a } = $c();
        if (nt() !== r || Oc())
          return;
        const { msg: u, url: c, line: l, column: d, error: h } = i, g = function(b, y, v, _) {
          const w = b.exception = b.exception || {}, k = w.values = w.values || [], O = k[0] = k[0] || {}, I = O.stacktrace = O.stacktrace || {}, N = I.frames = I.frames || [], E = _, L = v, B = Gt(y) && y.length > 0 ? y : function() {
            try {
              return ts.document.location.href;
            } catch {
              return "";
            }
          }();
          return N.length === 0 && N.push({ colno: E, filename: B, function: _n, in_app: !0, lineno: L }), b;
        }(wa(o, h || u, void 0, a, !1), c, l, d);
        g.level = "error", fc(g, { originalException: h, mechanism: { handled: !1, type: "onerror" } });
      });
    }(n), Vc("onerror")), t.onunhandledrejection && (function(r) {
      (function(i) {
        const o = "unhandledrejection";
        Sn(o, i), wn(o, ap);
      })((i) => {
        const { stackParser: o, attachStacktrace: a } = $c();
        if (nt() !== r || Oc())
          return;
        const u = function(l) {
          if (la(l))
            return l;
          try {
            if ("reason" in l)
              return l.reason;
            if ("detail" in l && "reason" in l.detail)
              return l.detail.reason;
          } catch {
          }
          return l;
        }(i), c = la(u) ? { exception: { values: [{ type: "UnhandledRejection", value: `Non-Error promise rejection captured with value: ${String(u)}` }] } } : wa(o, u, void 0, a, !0);
        c.level = "error", fc(c, { originalException: u, mechanism: { handled: !1, type: "onunhandledrejection" } });
      });
    }(n), Vc("onunhandledrejection"));
  } };
};
function Vc(e) {
  qi && fe.log(`Global Handler attached: ${e}`);
}
function $c() {
  const e = nt();
  return e && e.getOptions() || { stackParser: () => [], attachStacktrace: !1 };
}
const yh = () => ({ name: "HttpContext", preprocessEvent(e) {
  if (!Qe.navigator && !Qe.location && !Qe.document)
    return;
  const t = e.request && e.request.url || Qe.location && Qe.location.href, { referrer: n } = Qe.document || {}, { userAgent: r } = Qe.navigator || {}, i = { ...e.request && e.request.headers, ...n && { Referer: n }, ...r && { "User-Agent": r } }, o = { ...e.request, ...t && { url: t }, headers: i };
  e.request = o;
} }), _h = (e = {}) => {
  const t = e.limit || 5, n = e.key || "cause";
  return { name: "LinkedErrors", preprocessEvent(r, i, o) {
    const a = o.getOptions();
    Fp(ss, a.stackParser, a.maxValueLength, n, t, r, i);
  } };
};
var Bc = "new", Fc = "loading", Uc = "loaded", Ea = "joining-meeting", gn = "joined-meeting", pn = "left-meeting", en = "error", bh = "playable", $o = "unknown", Sh = "full", wh = "base", zc = "no-room", kh = "end-of-life", Eh = "connection-error", Th = "iframe-ready-for-launch-config", Rh = "iframe-launch-config", Ch = "theme-updated", Mh = "loading", Ah = "load-attempt-failed", Wc = "loaded", Ph = "started-camera", Oh = "camera-error", Nh = "joining-meeting", Lh = "joined-meeting", Ih = "left-meeting", xh = "participant-joined", jh = "participant-updated", Dh = "participant-left", Vh = "participant-counts-updated", $h = "access-state-updated", Bh = "meeting-session-summary-updated", Fh = "meeting-session-state-updated", Uh = "waiting-participant-added", zh = "waiting-participant-updated", Wh = "waiting-participant-removed", qh = "track-started", Jh = "track-stopped", Hh = "transcription-started", Gh = "transcription-stopped", Kh = "transcription-error", qc = "recording-started", Jc = "recording-stopped", Yh = "recording-stats", Qh = "recording-error", Zh = "recording-upload-completed", Xh = "recording-data", ev = "app-message", tv = "transcription-message", nv = "remote-media-player-started", rv = "remote-media-player-updated", iv = "remote-media-player-stopped", ov = "local-screen-share-started", av = "local-screen-share-stopped", sv = "local-screen-share-canceled", cv = "active-speaker-change", uv = "active-speaker-mode-change", lv = "network-quality-change", dv = "network-connection", fv = "cpu-load-change", pv = "face-counts-updated", Zr = "fullscreen", Xr = "exited-fullscreen", hv = "live-streaming-started", vv = "live-streaming-updated", mv = "live-streaming-stopped", gv = "live-streaming-error", yv = "lang-updated", _v = "receive-settings-updated", Hc = "input-settings-updated", Gc = "nonfatal-error", Kc = "error", Bo = 4096, Yc = 102400, Fo = "iframe-call-message", Qc = "local-screen-start", Zc = "daily-method-update-live-streaming-endpoints", ei = "transmit-log", Kt = "daily-custom-track", hi = { NONE: "none", BGBLUR: "background-blur", BGIMAGE: "background-image", FACE_DETECTION: "face-detection" }, Il = { NONE: "none", NOISE_CANCELLATION: "noise-cancellation" }, Ta = { PLAY: "play", PAUSE: "pause" }, Uo = ["jpg", "png", "jpeg"], bv = "add-endpoints", Sv = "remove-endpoints", Xc = "sip-call-transfer";
function Rt() {
  return !we() && typeof window < "u" && window.navigator && window.navigator.userAgent ? window.navigator.userAgent : "";
}
function we() {
  return typeof navigator < "u" && navigator.product && navigator.product === "ReactNative";
}
function xl() {
  return navigator && navigator.mediaDevices && navigator.mediaDevices.getUserMedia;
}
function wv() {
  return !!(navigator && navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia) && (function(e, t) {
    if (!e || !t)
      return !0;
    switch (e) {
      case "Chrome":
        return t.major >= 75;
      case "Safari":
        return RTCRtpTransceiver.prototype.hasOwnProperty("currentDirection") && !(t.major === 13 && t.minor === 0 && t.point === 0);
      case "Firefox":
        return t.major >= 67;
    }
    return !0;
  }(cn(), Ai()) || we());
}
function eu() {
  if (we() || !document)
    return !1;
  var e = document.createElement("iframe");
  return !!e.requestFullscreen || !!e.webkitRequestFullscreen;
}
var Ra = "none", kv = "software", Ev = "hardware", Tv = function() {
  try {
    var e, t = document.createElement("canvas"), n = !1;
    (e = t.getContext("webgl2", { failIfMajorPerformanceCaveat: !0 })) || (n = !0, e = t.getContext("webgl2"));
    var r = e != null;
    return t.remove(), r ? n ? kv : Ev : Ra;
  } catch {
    return Ra;
  }
}();
function jl() {
  var e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
  return !we() && Tv !== Ra && (e ? function() {
    return nu() ? !1 : ["Chrome", "Firefox"].includes(cn());
  }() : function() {
    if (nu())
      return !1;
    var t = cn();
    if (t === "Safari") {
      var n = ls();
      if (n.major < 15 || n.major === 15 && n.minor < 4)
        return !1;
    }
    return t === "Chrome" ? us().major >= 77 : t === "Firefox" ? ds().major >= 97 : ["Chrome", "Firefox", "Safari"].includes(t);
  }());
}
function Dl() {
  if (we() || Vl() || typeof AudioWorkletNode > "u")
    return !1;
  switch (cn()) {
    case "Chrome":
    case "Firefox":
      return !0;
    case "Safari":
      var e = Ai();
      return e.major > 17 || e.major === 17 && e.minor >= 4;
  }
  return !1;
}
function tu() {
  return xl() && !function() {
    var e, t = cn();
    if (!Rt())
      return !0;
    switch (t) {
      case "Chrome":
        return (e = us()).major && e.major > 0 && e.major < 75;
      case "Firefox":
        return (e = ds()).major < 91;
      case "Safari":
        return (e = ls()).major < 13 || e.major === 13 && e.minor < 1;
      default:
        return !0;
    }
  }();
}
function Vl() {
  return Rt().match(/Linux; Android/);
}
function nu() {
  var e, t = Rt(), n = t.match(/Mac/) && (!we() && typeof window < "u" && (e = window) !== null && e !== void 0 && (e = e.navigator) !== null && e !== void 0 && e.maxTouchPoints ? window.navigator.maxTouchPoints : 0) >= 5;
  return !!(t.match(/Mobi/) || t.match(/Android/) || n) || !!Rt().match(/DailyAnd\//) || void 0;
}
function cn() {
  if (typeof window < "u") {
    var e = Rt();
    return $l() ? "Safari" : e.indexOf("Edge") > -1 ? "Edge" : e.match(/Chrome\//) ? "Chrome" : e.indexOf("Safari") > -1 || Bl() ? "Safari" : e.indexOf("Firefox") > -1 ? "Firefox" : e.indexOf("MSIE") > -1 || e.indexOf(".NET") > -1 ? "IE" : "Unknown Browser";
  }
}
function Ai() {
  switch (cn()) {
    case "Chrome":
      return us();
    case "Safari":
      return ls();
    case "Firefox":
      return ds();
    case "Edge":
      return function() {
        var e = 0, t = 0;
        if (typeof window < "u") {
          var n = Rt().match(/Edge\/(\d+).(\d+)/);
          if (n)
            try {
              e = parseInt(n[1]), t = parseInt(n[2]);
            } catch {
            }
        }
        return { major: e, minor: t };
      }();
  }
}
function us() {
  var e = 0, t = 0, n = 0, r = 0, i = !1;
  if (typeof window < "u") {
    var o = Rt(), a = o.match(/Chrome\/(\d+).(\d+).(\d+).(\d+)/);
    if (a)
      try {
        e = parseInt(a[1]), t = parseInt(a[2]), n = parseInt(a[3]), r = parseInt(a[4]), i = o.indexOf("OPR/") > -1;
      } catch {
      }
  }
  return { major: e, minor: t, build: n, patch: r, opera: i };
}
function $l() {
  return !!Rt().match(/iPad|iPhone|iPod/i) && xl();
}
function Bl() {
  return Rt().indexOf("AppleWebKit/605.1.15") > -1;
}
function ls() {
  var e = 0, t = 0, n = 0;
  if (typeof window < "u") {
    var r = Rt().match(/Version\/(\d+).(\d+)(.(\d+))?/);
    if (r)
      try {
        e = parseInt(r[1]), t = parseInt(r[2]), n = parseInt(r[4]);
      } catch {
      }
    else
      ($l() || Bl()) && (e = 14, t = 0, n = 3);
  }
  return { major: e, minor: t, point: n };
}
function ds() {
  var e = 0, t = 0;
  if (typeof window < "u") {
    var n = Rt().match(/Firefox\/(\d+).(\d+)/);
    if (n)
      try {
        e = parseInt(n[1]), t = parseInt(n[2]);
      } catch {
      }
  }
  return { major: e, minor: t };
}
var Fl = function() {
  return yt(function e() {
    gt(this, e);
  }, [{ key: "addListenerForMessagesFromCallMachine", value: function(e, t, n) {
    lr();
  } }, { key: "addListenerForMessagesFromDailyJs", value: function(e, t, n) {
    lr();
  } }, { key: "sendMessageToCallMachine", value: function(e, t, n, r) {
    lr();
  } }, { key: "sendMessageToDailyJs", value: function(e, t) {
    lr();
  } }, { key: "removeListener", value: function(e) {
    lr();
  } }]);
}();
function ru(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zo(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? ru(Object(n), !0).forEach(function(r) {
      Ft(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ru(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ul() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Ul = function() {
    return !!e;
  })();
}
var Rv = function() {
  function e() {
    var t, n, r, i;
    return gt(this, e), n = this, r = Lt(r = e), (t = Vi(n, Ul() ? Reflect.construct(r, [], Lt(n).constructor) : r.apply(n, i)))._wrappedListeners = {}, t._messageCallbacks = {}, t;
  }
  return $i(e, Fl), yt(e, [{ key: "addListenerForMessagesFromCallMachine", value: function(t, n, r) {
    var i = this, o = function(a) {
      if (a.data && a.data.what === "iframe-call-message" && (!a.data.callClientId || a.data.callClientId === n) && (!a.data.from || a.data.from !== "module")) {
        var u = zo({}, a.data);
        if (delete u.from, u.callbackStamp && i._messageCallbacks[u.callbackStamp]) {
          var c = u.callbackStamp;
          i._messageCallbacks[c].call(r, u), delete i._messageCallbacks[c];
        }
        delete u.what, delete u.callbackStamp, t.call(r, u);
      }
    };
    this._wrappedListeners[t] = o, window.addEventListener("message", o);
  } }, { key: "addListenerForMessagesFromDailyJs", value: function(t, n, r) {
    var i = function(o) {
      var a;
      if (!(!o.data || o.data.what !== Fo || !o.data.action || o.data.from && o.data.from !== "module" || o.data.callClientId && n && o.data.callClientId !== n || o != null && (a = o.data) !== null && a !== void 0 && a.callFrameId)) {
        var u = o.data;
        t.call(r, u);
      }
    };
    this._wrappedListeners[t] = i, window.addEventListener("message", i);
  } }, { key: "sendMessageToCallMachine", value: function(t, n, r, i) {
    if (!r)
      throw new Error("undefined callClientId. Are you trying to use a DailyCall instance previously destroyed?");
    var o = zo({}, t);
    if (o.what = Fo, o.from = "module", o.callClientId = r, n) {
      var a = Bi();
      this._messageCallbacks[a] = n, o.callbackStamp = a;
    }
    var u = i ? i.contentWindow : window, c = this._callMachineTargetOrigin(i);
    c && u.postMessage(o, c);
  } }, { key: "sendMessageToDailyJs", value: function(t, n) {
    t.what = Fo, t.callClientId = n, t.from = "embedded", window.postMessage(t, this._targetOriginFromWindowLocation());
  } }, { key: "removeListener", value: function(t) {
    var n = this._wrappedListeners[t];
    n && (window.removeEventListener("message", n), delete this._wrappedListeners[t]);
  } }, { key: "forwardPackagedMessageToCallMachine", value: function(t, n, r) {
    var i = zo({}, t);
    i.callClientId = r;
    var o = n ? n.contentWindow : window, a = this._callMachineTargetOrigin(n);
    a && o.postMessage(i, a);
  } }, { key: "addListenerForPackagedMessagesFromCallMachine", value: function(t, n) {
    var r = function(i) {
      if (i.data && i.data.what === "iframe-call-message" && (!i.data.callClientId || i.data.callClientId === n) && (!i.data.from || i.data.from !== "module")) {
        var o = i.data;
        t(o);
      }
    };
    return this._wrappedListeners[t] = r, window.addEventListener("message", r), t;
  } }, { key: "removeListenerForPackagedMessagesFromCallMachine", value: function(t) {
    var n = this._wrappedListeners[t];
    n && (window.removeEventListener("message", n), delete this._wrappedListeners[t]);
  } }, { key: "_callMachineTargetOrigin", value: function(t) {
    return t ? t.src ? new URL(t.src).origin : void 0 : this._targetOriginFromWindowLocation();
  } }, { key: "_targetOriginFromWindowLocation", value: function() {
    return window.location.protocol === "file:" ? "*" : window.location.origin;
  } }]);
}();
function iu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function zl() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (zl = function() {
    return !!e;
  })();
}
var Cv = function() {
  function e() {
    var t, n, r, i;
    return gt(this, e), n = this, r = Lt(r = e), t = Vi(n, zl() ? Reflect.construct(r, [], Lt(n).constructor) : r.apply(n, i)), global.callMachineToDailyJsEmitter = global.callMachineToDailyJsEmitter || new ca.EventEmitter(), global.dailyJsToCallMachineEmitter = global.dailyJsToCallMachineEmitter || new ca.EventEmitter(), t._wrappedListeners = {}, t._messageCallbacks = {}, t;
  }
  return $i(e, Fl), yt(e, [{ key: "addListenerForMessagesFromCallMachine", value: function(t, n, r) {
    this._addListener(t, global.callMachineToDailyJsEmitter, n, r, "received call machine message");
  } }, { key: "addListenerForMessagesFromDailyJs", value: function(t, n, r) {
    this._addListener(t, global.dailyJsToCallMachineEmitter, n, r, "received daily-js message");
  } }, { key: "sendMessageToCallMachine", value: function(t, n, r) {
    this._sendMessage(t, global.dailyJsToCallMachineEmitter, r, n, "sending message to call machine");
  } }, { key: "sendMessageToDailyJs", value: function(t, n) {
    this._sendMessage(t, global.callMachineToDailyJsEmitter, n, null, "sending message to daily-js");
  } }, { key: "removeListener", value: function(t) {
    var n = this._wrappedListeners[t];
    n && (global.callMachineToDailyJsEmitter.removeListener("message", n), global.dailyJsToCallMachineEmitter.removeListener("message", n), delete this._wrappedListeners[t]);
  } }, { key: "_addListener", value: function(t, n, r, i, o) {
    var a = this, u = function(c) {
      if (c.callClientId === r) {
        if (c.callbackStamp && a._messageCallbacks[c.callbackStamp]) {
          var l = c.callbackStamp;
          a._messageCallbacks[l].call(i, c), delete a._messageCallbacks[l];
        }
        t.call(i, c);
      }
    };
    this._wrappedListeners[t] = u, n.addListener("message", u);
  } }, { key: "_sendMessage", value: function(t, n, r, i, o) {
    var a = function(c) {
      for (var l = 1; l < arguments.length; l++) {
        var d = arguments[l] != null ? arguments[l] : {};
        l % 2 ? iu(Object(d), !0).forEach(function(h) {
          Ft(c, h, d[h]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : iu(Object(d)).forEach(function(h) {
          Object.defineProperty(c, h, Object.getOwnPropertyDescriptor(d, h));
        });
      }
      return c;
    }({}, t);
    if (a.callClientId = r, i) {
      var u = Bi();
      this._messageCallbacks[u] = i, a.callbackStamp = u;
    }
    n.emit("message", a);
  } }]);
}(), Ca = "replace", Ma = "shallow-merge", ou = [Ca, Ma], Mv = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.data, r = t.mergeStrategy, i = r === void 0 ? Ca : r;
    gt(this, e), e._validateMergeStrategy(i), e._validateData(n, i), this.mergeStrategy = i, this.data = n;
  }
  return yt(e, [{ key: "isNoOp", value: function() {
    return e.isNoOpUpdate(this.data, this.mergeStrategy);
  } }], [{ key: "isNoOpUpdate", value: function(t, n) {
    return Object.keys(t).length === 0 && n === Ma;
  } }, { key: "_validateMergeStrategy", value: function(t) {
    if (!ou.includes(t))
      throw Error("Unrecognized mergeStrategy provided. Options are: [".concat(ou, "]"));
  } }, { key: "_validateData", value: function(t, n) {
    if (!function(u) {
      if (u == null || Te(u) !== "object")
        return !1;
      var c = Object.getPrototypeOf(u);
      return c == null || c === Object.prototype;
    }(t))
      throw Error("Meeting session data must be a plain (map-like) object");
    var r;
    try {
      if (r = JSON.stringify(t), n === Ca) {
        var i = JSON.parse(r);
        at(i, t) || console.warn("The meeting session data provided will be modified when serialized.", i, t);
      } else if (n === Ma) {
        for (var o in t)
          if (Object.hasOwnProperty.call(t, o) && t[o] !== void 0) {
            var a = JSON.parse(JSON.stringify(t[o]));
            at(t[o], a) || console.warn("At least one key in the meeting session data provided will be modified when serialized.", a, t[o]);
          }
      }
    } catch (u) {
      throw Error("Meeting session data must be serializable to JSON: ".concat(u));
    }
    if (r.length > Yc)
      throw Error("Meeting session data is too large (".concat(r.length, " characters). Maximum size suppported is ").concat(Yc, "."));
  } }]);
}();
function Wl() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Wl = function() {
    return !!e;
  })();
}
function Aa(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return Aa = function(n) {
    if (n === null || !function(i) {
      try {
        return Function.toString.call(i).indexOf("[native code]") !== -1;
      } catch {
        return typeof i == "function";
      }
    }(n))
      return n;
    if (typeof n != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (t !== void 0) {
      if (t.has(n))
        return t.get(n);
      t.set(n, r);
    }
    function r() {
      return function(i, o, a) {
        if (Wl())
          return Reflect.construct.apply(null, arguments);
        var u = [null];
        u.push.apply(u, o);
        var c = new (i.bind.apply(i, u))();
        return a && Rr(c, a.prototype), c;
      }(n, arguments, Lt(this).constructor);
    }
    return r.prototype = Object.create(n.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } }), Rr(r, n);
  }, Aa(e);
}
function ql() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ql = function() {
    return !!e;
  })();
}
function au(e) {
  var t, n = (t = window._daily) === null || t === void 0 ? void 0 : t.pendings;
  if (n) {
    var r = n.indexOf(e);
    r !== -1 && n.splice(r, 1);
  }
}
var Av = function() {
  return yt(function e(t) {
    gt(this, e), this._currentLoad = null, this._callClientId = t;
  }, [{ key: "load", value: function() {
    var e, t = this, n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = arguments.length > 1 ? arguments[1] : void 0, i = arguments.length > 2 ? arguments[2] : void 0;
    if (this.loaded)
      return window._daily.instances[this._callClientId].callMachine.reset(), void r(!0);
    e = this._callClientId, window._daily.pendings.push(e), this._currentLoad && this._currentLoad.cancel(), this._currentLoad = new Pv(n, function() {
      r(!1);
    }, function(o, a) {
      a || au(t._callClientId), i(o, a);
    }), this._currentLoad.start();
  } }, { key: "cancel", value: function() {
    this._currentLoad && this._currentLoad.cancel(), au(this._callClientId);
  } }, { key: "loaded", get: function() {
    return this._currentLoad && this._currentLoad.succeeded;
  } }]);
}(), Pv = function() {
  return yt(function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
    gt(this, e), this._attemptsRemaining = 3, this._currentAttempt = null, this._dailyConfig = t, this._successCallback = n, this._failureCallback = r;
  }, [{ key: "start", value: function() {
    var e = this;
    if (!this._currentAttempt) {
      var t = function(n) {
        e._currentAttempt.cancelled || (e._attemptsRemaining--, e._failureCallback(n, e._attemptsRemaining > 0), e._attemptsRemaining <= 0 || setTimeout(function() {
          e._currentAttempt.cancelled || (e._currentAttempt = new su(e._dailyConfig, e._successCallback, t), e._currentAttempt.start());
        }, 3e3));
      };
      this._currentAttempt = new su(this._dailyConfig, this._successCallback, t), this._currentAttempt.start();
    }
  } }, { key: "cancel", value: function() {
    this._currentAttempt && this._currentAttempt.cancel();
  } }, { key: "cancelled", get: function() {
    return this._currentAttempt && this._currentAttempt.cancelled;
  } }, { key: "succeeded", get: function() {
    return this._currentAttempt && this._currentAttempt.succeeded;
  } }]);
}(), Wo = function() {
  function e() {
    return gt(this, e), t = this, r = arguments, n = Lt(n = e), Vi(t, ql() ? Reflect.construct(n, r || [], Lt(t).constructor) : n.apply(t, r));
    var t, n, r;
  }
  return $i(e, Aa(Error)), yt(e);
}(), Pi = 2e4, su = function() {
  return yt(function t(n, r, i) {
    gt(this, t), this._loadAttemptImpl = we() || !n.avoidEval ? new Ov(n, r, i) : new Nv(n, r, i);
  }, [{ key: "start", value: (e = ue(function* () {
    return this._loadAttemptImpl.start();
  }), function() {
    return e.apply(this, arguments);
  }) }, { key: "cancel", value: function() {
    this._loadAttemptImpl.cancel();
  } }, { key: "cancelled", get: function() {
    return this._loadAttemptImpl.cancelled;
  } }, { key: "succeeded", get: function() {
    return this._loadAttemptImpl.succeeded;
  } }]);
  var e;
}(), Ov = function() {
  return yt(function i(o, a, u) {
    gt(this, i), this.cancelled = !1, this.succeeded = !1, this._networkTimedOut = !1, this._networkTimeout = null, this._iosCache = typeof iOSCallObjectBundleCache < "u" && iOSCallObjectBundleCache, this._refetchHeaders = null, this._dailyConfig = o, this._successCallback = a, this._failureCallback = u;
  }, [{ key: "start", value: (r = ue(function* () {
    var i = ki(this._dailyConfig);
    !(yield this._tryLoadFromIOSCache(i)) && this._loadFromNetwork(i);
  }), function() {
    return r.apply(this, arguments);
  }) }, { key: "cancel", value: function() {
    clearTimeout(this._networkTimeout), this.cancelled = !0;
  } }, { key: "_tryLoadFromIOSCache", value: (n = ue(function* (i) {
    if (!this._iosCache)
      return !1;
    try {
      var o = yield this._iosCache.get(i);
      return !!this.cancelled || !!o && (o.code ? (Function('"use strict";' + o.code)(), this.succeeded = !0, this._successCallback(), !0) : (this._refetchHeaders = o.refetchHeaders, !1));
    } catch {
      return !1;
    }
  }), function(i) {
    return n.apply(this, arguments);
  }) }, { key: "_loadFromNetwork", value: (t = ue(function* (i) {
    var o = this;
    this._networkTimeout = setTimeout(function() {
      o._networkTimedOut = !0, o._failureCallback({ msg: "Timed out (>".concat(Pi, " ms) when loading call object bundle ").concat(i), type: "timeout" });
    }, Pi);
    try {
      var a = this._refetchHeaders ? { headers: this._refetchHeaders } : {}, u = yield fetch(i, a);
      if (clearTimeout(this._networkTimeout), this.cancelled || this._networkTimedOut)
        throw new Wo();
      var c = yield this._getBundleCodeFromResponse(i, u);
      if (this.cancelled)
        throw new Wo();
      Function('"use strict";' + c)(), this._iosCache && this._iosCache.set(i, c, u.headers), this.succeeded = !0, this._successCallback();
    } catch (l) {
      if (clearTimeout(this._networkTimeout), l instanceof Wo || this.cancelled || this._networkTimedOut)
        return;
      this._failureCallback({ msg: "Failed to load call object bundle ".concat(i, ": ").concat(l), type: l.message });
    }
  }), function(i) {
    return t.apply(this, arguments);
  }) }, { key: "_getBundleCodeFromResponse", value: (e = ue(function* (i, o) {
    if (o.ok)
      return yield o.text();
    if (this._iosCache && o.status === 304)
      return (yield this._iosCache.renew(i, o.headers)).code;
    throw new Error("Received ".concat(o.status, " response"));
  }), function(i, o) {
    return e.apply(this, arguments);
  }) }]);
  var e, t, n, r;
}(), Nv = function() {
  return yt(function e(t, n, r) {
    gt(this, e), this.cancelled = !1, this.succeeded = !1, this._dailyConfig = t, this._successCallback = n, this._failureCallback = r, this._attemptId = Bi(), this._networkTimeout = null, this._scriptElement = null;
  }, [{ key: "start", value: function() {
    window._dailyCallMachineLoadWaitlist || (window._dailyCallMachineLoadWaitlist = /* @__PURE__ */ new Set());
    var e = ki(this._dailyConfig);
    (typeof document > "u" ? "undefined" : Te(document)) === "object" ? this._startLoading(e) : this._failureCallback({ msg: "Call object bundle must be loaded in a DOM/web context", type: "missing context" });
  } }, { key: "cancel", value: function() {
    this._stopLoading(), this.cancelled = !0;
  } }, { key: "_startLoading", value: function(e) {
    var t = this;
    this._signUpForCallMachineLoadWaitlist(), this._networkTimeout = setTimeout(function() {
      t._stopLoading(), t._failureCallback({ msg: "Timed out (>".concat(Pi, " ms) when loading call object bundle ").concat(e), type: "timeout" });
    }, Pi);
    var n = document.getElementsByTagName("head")[0], r = document.createElement("script");
    this._scriptElement = r, r.onload = function() {
      t._stopLoading(), t.succeeded = !0, t._successCallback();
    }, r.onerror = function(i) {
      t._stopLoading(), t._failureCallback({ msg: "Failed to load call object bundle ".concat(i.target.src), type: i.message });
    }, r.src = e, n.appendChild(r);
  } }, { key: "_stopLoading", value: function() {
    this._withdrawFromCallMachineLoadWaitlist(), clearTimeout(this._networkTimeout), this._scriptElement && (this._scriptElement.onload = null, this._scriptElement.onerror = null);
  } }, { key: "_signUpForCallMachineLoadWaitlist", value: function() {
    window._dailyCallMachineLoadWaitlist.add(this._attemptId);
  } }, { key: "_withdrawFromCallMachineLoadWaitlist", value: function() {
    window._dailyCallMachineLoadWaitlist.delete(this._attemptId);
  } }]);
}(), ti = function(e, t, n) {
  return Iv(e.local, t, n) === !0;
}, Lv = function(e, t, n) {
  return e.local.streams && e.local.streams[t] && e.local.streams[t].stream && e.local.streams[t].stream["get".concat(n === "video" ? "Video" : "Audio", "Tracks")]()[0];
}, Un = function(e, t, n, r) {
  var i = xv(e, t, n, r);
  return i && i.pendingTrack;
}, Iv = function(e, t, n) {
  if (!e)
    return !1;
  var r = function(o) {
    switch (o) {
      case "avatar":
        return !0;
      case "staged":
        return o;
      default:
        return !!o;
    }
  }, i = e.public.subscribedTracks;
  return i && i[t] ? ["cam-audio", "cam-video", "screen-video", "screen-audio", "rmpAudio", "rmpVideo"].indexOf(n) === -1 && i[t].custom ? [!0, "staged"].includes(i[t].custom) ? r(i[t].custom) : r(i[t].custom[n]) : r(i[t][n]) : !i || r(i.ALL);
}, xv = function(e, t, n, r) {
  var i = Object.values(e.streams || {}).filter(function(o) {
    return o.participantId === t && o.type === n && o.pendingTrack && o.pendingTrack.kind === r;
  }).sort(function(o, a) {
    return new Date(a.starttime) - new Date(o.starttime);
  });
  return i && i[0];
}, jv = function(e, t) {
  var n = e.local.public.customTracks;
  if (n && n[t])
    return n[t].track;
};
function cu(e, t) {
  for (var n = t.getState(), r = 0, i = ["cam", "screen"]; r < i.length; r++)
    for (var o = i[r], a = 0, u = ["video", "audio"]; a < u.length; a++) {
      var c = u[a], l = o === "cam" ? c : "screen".concat(c.charAt(0).toUpperCase() + c.slice(1)), d = e.tracks[l];
      if (d) {
        var h = e.local ? Lv(n, o, c) : Un(n, e.session_id, o, c);
        d.state === "playable" && (d.track = h), d.persistentTrack = h;
      }
    }
}
function uu(e, t) {
  try {
    var n = t.getState();
    for (var r in e.tracks)
      if (!Dv(r)) {
        var i = e.tracks[r].kind;
        if (i) {
          var o = e.tracks[r];
          if (o) {
            var a = e.local ? jv(n, r) : Un(n, e.session_id, r, i);
            o.state === "playable" && (e.tracks[r].track = a), o.persistentTrack = a;
          }
        } else
          console.error("unknown type for custom track");
      }
  } catch (u) {
    console.error(u);
  }
}
function Dv(e) {
  return ["video", "audio", "screenVideo", "screenAudio"].includes(e);
}
function lu(e, t, n) {
  var r = n.getState();
  if (e.local) {
    if (e.audio)
      try {
        e.audioTrack = r.local.streams.cam.stream.getAudioTracks()[0], e.audioTrack || (e.audio = !1);
      } catch {
      }
    if (e.video)
      try {
        e.videoTrack = r.local.streams.cam.stream.getVideoTracks()[0], e.videoTrack || (e.video = !1);
      } catch {
      }
    if (e.screen)
      try {
        e.screenVideoTrack = r.local.streams.screen.stream.getVideoTracks()[0], e.screenAudioTrack = r.local.streams.screen.stream.getAudioTracks()[0], e.screenVideoTrack || e.screenAudioTrack || (e.screen = !1);
      } catch {
      }
  } else {
    var i = !0;
    try {
      var o = r.participants[e.session_id];
      o && o.public && o.public.rtcType && o.public.rtcType.impl === "peer-to-peer" && o.private && !["connected", "completed"].includes(o.private.peeringState) && (i = !1);
    } catch (d) {
      console.error(d);
    }
    if (!i)
      return e.audio = !1, e.audioTrack = !1, e.video = !1, e.videoTrack = !1, e.screen = !1, void (e.screenTrack = !1);
    try {
      if (r.streams, e.audio && ti(r, e.session_id, "cam-audio")) {
        var a = Un(r, e.session_id, "cam", "audio");
        a && (t && t.audioTrack && t.audioTrack.id === a.id ? e.audioTrack = a : a.muted || (e.audioTrack = a)), e.audioTrack || (e.audio = !1);
      }
      if (e.video && ti(r, e.session_id, "cam-video")) {
        var u = Un(r, e.session_id, "cam", "video");
        u && (t && t.videoTrack && t.videoTrack.id === u.id ? e.videoTrack = u : u.muted || (e.videoTrack = u)), e.videoTrack || (e.video = !1);
      }
      if (e.screen && ti(r, e.session_id, "screen-audio")) {
        var c = Un(r, e.session_id, "screen", "audio");
        c && (t && t.screenAudioTrack && t.screenAudioTrack.id === c.id ? e.screenAudioTrack = c : c.muted || (e.screenAudioTrack = c));
      }
      if (e.screen && ti(r, e.session_id, "screen-video")) {
        var l = Un(r, e.session_id, "screen", "video");
        l && (t && t.screenVideoTrack && t.screenVideoTrack.id === l.id ? e.screenVideoTrack = l : l.muted || (e.screenVideoTrack = l));
      }
      e.screenVideoTrack || e.screenAudioTrack || (e.screen = !1);
    } catch (d) {
      console.error("unexpected error matching up tracks", d);
    }
  }
}
function Vv(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = function(c, l) {
      if (c) {
        if (typeof c == "string")
          return du(c, l);
        var d = {}.toString.call(c).slice(8, -1);
        return d === "Object" && c.constructor && (d = c.constructor.name), d === "Map" || d === "Set" ? Array.from(c) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? du(c, l) : void 0;
      }
    }(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(c) {
        throw c;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, a = !0, u = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var c = n.next();
    return a = c.done, c;
  }, e: function(c) {
    u = !0, o = c;
  }, f: function() {
    try {
      a || n.return == null || n.return();
    } finally {
      if (u)
        throw o;
    }
  } };
}
function du(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var $t = /* @__PURE__ */ new Map(), qn = null;
function $v(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = function(c, l) {
      if (c) {
        if (typeof c == "string")
          return fu(c, l);
        var d = {}.toString.call(c).slice(8, -1);
        return d === "Object" && c.constructor && (d = c.constructor.name), d === "Map" || d === "Set" ? Array.from(c) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? fu(c, l) : void 0;
      }
    }(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(c) {
        throw c;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, a = !0, u = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var c = n.next();
    return a = c.done, c;
  }, e: function(c) {
    u = !0, o = c;
  }, f: function() {
    try {
      a || n.return == null || n.return();
    } finally {
      if (u)
        throw o;
    }
  } };
}
function fu(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var Bt = /* @__PURE__ */ new Map(), Sr = null;
function Bv(e) {
  Jl() ? function(t) {
    $t.has(t) || ($t.set(t, {}), navigator.mediaDevices.enumerateDevices().then(function(n) {
      $t.has(t) && ($t.get(t).lastDevicesString = JSON.stringify(n), qn || (qn = function() {
        var r = ue(function* () {
          var i, o = yield navigator.mediaDevices.enumerateDevices(), a = Vv($t.keys());
          try {
            for (a.s(); !(i = a.n()).done; ) {
              var u = i.value, c = JSON.stringify(o);
              c !== $t.get(u).lastDevicesString && ($t.get(u).lastDevicesString = c, u(o));
            }
          } catch (l) {
            a.e(l);
          } finally {
            a.f();
          }
        });
        return function() {
          return r.apply(this, arguments);
        };
      }(), navigator.mediaDevices.addEventListener("devicechange", qn)));
    }).catch(function() {
    }));
  }(e) : function(t) {
    Bt.has(t) || (Bt.set(t, {}), navigator.mediaDevices.enumerateDevices().then(function(n) {
      Bt.has(t) && (Bt.get(t).lastDevicesString = JSON.stringify(n), Sr || (Sr = setInterval(ue(function* () {
        var r, i = yield navigator.mediaDevices.enumerateDevices(), o = $v(Bt.keys());
        try {
          for (o.s(); !(r = o.n()).done; ) {
            var a = r.value, u = JSON.stringify(i);
            u !== Bt.get(a).lastDevicesString && (Bt.get(a).lastDevicesString = u, a(i));
          }
        } catch (c) {
          o.e(c);
        } finally {
          o.f();
        }
      }), 3e3)));
    }));
  }(e);
}
function Fv(e) {
  Jl() ? function(t) {
    $t.has(t) && ($t.delete(t), $t.size === 0 && qn && (navigator.mediaDevices.removeEventListener("devicechange", qn), qn = null));
  }(e) : function(t) {
    Bt.has(t) && (Bt.delete(t), Bt.size === 0 && Sr && (clearInterval(Sr), Sr = null));
  }(e);
}
function Jl() {
  var e;
  return we() || ((e = navigator.mediaDevices) === null || e === void 0 ? void 0 : e.ondevicechange) !== void 0;
}
var Uv = /* @__PURE__ */ new Set();
function zv(e, t) {
  var n = t.isLocalScreenVideo;
  return e && e.readyState === "live" && !function(r, i) {
    return (!i.isLocalScreenVideo || cn() !== "Chrome") && r.muted && !Uv.has(r.id);
  }(e, { isLocalScreenVideo: n });
}
function pu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function tn(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? pu(Object(n), !0).forEach(function(r) {
      Ft(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : pu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
var br = Object.freeze({ VIDEO: "video", AUDIO: "audio", SCREEN_VIDEO: "screenVideo", SCREEN_AUDIO: "screenAudio", CUSTOM_VIDEO: "customVideo", CUSTOM_AUDIO: "customAudio" }), Wv = Object.freeze({ PARTICIPANTS: "participants", STREAMING: "streaming", TRANSCRIPTION: "transcription" }), wr = Object.values(br), hu = ["v", "a", "sv", "sa", "cv", "ca"];
Object.freeze(wr.reduce(function(e, t, n) {
  return e[t] = hu[n], e;
}, {})), Object.freeze(hu.reduce(function(e, t, n) {
  return e[t] = wr[n], e;
}, {}));
var qv = [br.VIDEO, br.AUDIO, br.SCREEN_VIDEO, br.SCREEN_AUDIO], vu = Object.values(Wv), mu = ["p", "s", "t"];
Object.freeze(vu.reduce(function(e, t, n) {
  return e[t] = mu[n], e;
}, {})), Object.freeze(mu.reduce(function(e, t, n) {
  return e[t] = vu[n], e;
}, {}));
var Hl = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.base, r = t.byUserId, i = t.byParticipantId;
    gt(this, e), this.base = n, this.byUserId = r, this.byParticipantId = i;
  }
  return yt(e, [{ key: "clone", value: function() {
    var t = new e();
    if (this.base instanceof et ? t.base = this.base.clone() : t.base = this.base, this.byUserId !== void 0)
      for (var n in t.byUserId = {}, this.byUserId) {
        var r = this.byUserId[n];
        t.byUserId[n] = r instanceof et ? r.clone() : r;
      }
    if (this.byParticipantId !== void 0)
      for (var i in t.byParticipantId = {}, this.byParticipantId) {
        var o = this.byParticipantId[i];
        t.byParticipantId[i] = o instanceof et ? o.clone() : o;
      }
    return t;
  } }, { key: "toJSONObject", value: function() {
    var t = {};
    if (typeof this.base == "boolean" ? t.base = this.base : this.base instanceof et && (t.base = this.base.toJSONObject()), this.byUserId !== void 0)
      for (var n in t.byUserId = {}, this.byUserId) {
        var r = this.byUserId[n];
        t.byUserId[n] = r instanceof et ? r.toJSONObject() : r;
      }
    if (this.byParticipantId !== void 0)
      for (var i in t.byParticipantId = {}, this.byParticipantId) {
        var o = this.byParticipantId[i];
        t.byParticipantId[i] = o instanceof et ? o.toJSONObject() : o;
      }
    return t;
  } }, { key: "toMinifiedJSONObject", value: function() {
    var t = {};
    if (this.base !== void 0 && (typeof this.base == "boolean" ? t.b = this.base : t.b = this.base.toMinifiedJSONObject()), this.byUserId !== void 0)
      for (var n in t.u = {}, this.byUserId) {
        var r = this.byUserId[n];
        t.u[n] = typeof r == "boolean" ? r : r.toMinifiedJSONObject();
      }
    if (this.byParticipantId !== void 0)
      for (var i in t.p = {}, this.byParticipantId) {
        var o = this.byParticipantId[i];
        t.p[i] = typeof o == "boolean" ? o : o.toMinifiedJSONObject();
      }
    return t;
  } }, { key: "normalize", value: function() {
    return this.base instanceof et && (this.base = this.base.normalize()), this.byUserId && (this.byUserId = Object.fromEntries(Object.entries(this.byUserId).map(function(t) {
      var n = rt(t, 2), r = n[0], i = n[1];
      return [r, i instanceof et ? i.normalize() : i];
    }))), this.byParticipantId && (this.byParticipantId = Object.fromEntries(Object.entries(this.byParticipantId).map(function(t) {
      var n = rt(t, 2), r = n[0], i = n[1];
      return [r, i instanceof et ? i.normalize() : i];
    }))), this;
  } }], [{ key: "fromJSONObject", value: function(t) {
    var n, r, i;
    if (t.base !== void 0 && (n = typeof t.base == "boolean" ? t.base : et.fromJSONObject(t.base)), t.byUserId !== void 0)
      for (var o in r = {}, t.byUserId) {
        var a = t.byUserId[o];
        r[o] = typeof a == "boolean" ? a : et.fromJSONObject(a);
      }
    if (t.byParticipantId !== void 0)
      for (var u in i = {}, t.byParticipantId) {
        var c = t.byParticipantId[u];
        i[u] = typeof c == "boolean" ? c : et.fromJSONObject(c);
      }
    return new e({ base: n, byUserId: r, byParticipantId: i });
  } }, { key: "fromMinifiedJSONObject", value: function(t) {
    var n, r, i;
    if (t.b !== void 0 && (n = typeof t.b == "boolean" ? t.b : et.fromMinifiedJSONObject(t.b)), t.u !== void 0)
      for (var o in r = {}, t.u) {
        var a = t.u[o];
        r[o] = typeof a == "boolean" ? a : et.fromMinifiedJSONObject(a);
      }
    if (t.p !== void 0)
      for (var u in i = {}, t.p) {
        var c = t.p[u];
        i[u] = typeof c == "boolean" ? c : et.fromMinifiedJSONObject(c);
      }
    return new e({ base: n, byUserId: r, byParticipantId: i });
  } }, { key: "validateJSONObject", value: function(t) {
    if (Te(t) !== "object")
      return [!1, "canReceive must be an object"];
    for (var n = ["base", "byUserId", "byParticipantId"], r = 0, i = Object.keys(t); r < i.length; r++) {
      var o = i[r];
      if (!n.includes(o))
        return [!1, "canReceive can only contain keys (".concat(n.join(", "), ")")];
      if (o === "base") {
        var a = rt(et.validateJSONObject(t.base, !0), 2), u = a[0], c = a[1];
        if (!u)
          return [!1, c];
      } else {
        if (Te(t[o]) !== "object")
          return [!1, "invalid (non-object) value for field '".concat(o, "' in canReceive")];
        for (var l = 0, d = Object.values(t[o]); l < d.length; l++) {
          var h = d[l], g = rt(et.validateJSONObject(h), 2), b = g[0], y = g[1];
          if (!b)
            return [!1, y];
        }
      }
    }
    return [!0];
  } }]);
}(), et = function() {
  function e() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.video, r = t.audio, i = t.screenVideo, o = t.screenAudio, a = t.customVideo, u = t.customAudio;
    gt(this, e), this.video = n, this.audio = r, this.screenVideo = i, this.screenAudio = o, this.customVideo = a, this.customAudio = u;
  }
  return yt(e, [{ key: "clone", value: function() {
    var t = new e();
    return this.video !== void 0 && (t.video = this.video), this.audio !== void 0 && (t.audio = this.audio), this.screenVideo !== void 0 && (t.screenVideo = this.screenVideo), this.screenAudio !== void 0 && (t.screenAudio = this.screenAudio), this.customVideo !== void 0 && (t.customVideo = tn({}, this.customVideo)), this.customAudio !== void 0 && (t.customAudio = tn({}, this.customAudio)), t;
  } }, { key: "toJSONObject", value: function() {
    var t = {};
    return this.video !== void 0 && (t.video = this.video), this.audio !== void 0 && (t.audio = this.audio), this.screenVideo !== void 0 && (t.screenVideo = this.screenVideo), this.screenAudio !== void 0 && (t.screenAudio = this.screenAudio), this.customVideo !== void 0 && (t.customVideo = tn({}, this.customVideo)), this.customAudio !== void 0 && (t.customAudio = tn({}, this.customAudio)), t;
  } }, { key: "toMinifiedJSONObject", value: function() {
    var t = {};
    return this.video !== void 0 && (t.v = this.video), this.audio !== void 0 && (t.a = this.audio), this.screenVideo !== void 0 && (t.sv = this.screenVideo), this.screenAudio !== void 0 && (t.sa = this.screenAudio), this.customVideo !== void 0 && (t.cv = tn({}, this.customVideo)), this.customAudio !== void 0 && (t.ca = tn({}, this.customAudio)), t;
  } }, { key: "normalize", value: function() {
    function t(n, r) {
      return n && Object.keys(n).length === 1 && n["*"] === r;
    }
    return !(this.video !== !0 || this.audio !== !0 || this.screenVideo !== !0 || this.screenAudio !== !0 || !t(this.customVideo, !0) || !t(this.customAudio, !0)) || (this.video !== !1 || this.audio !== !1 || this.screenVideo !== !1 || this.screenAudio !== !1 || !t(this.customVideo, !1) || !t(this.customAudio, !1)) && this;
  } }], [{ key: "fromBoolean", value: function(t) {
    return new e({ video: t, audio: t, screenVideo: t, screenAudio: t, customVideo: { "*": t }, customAudio: { "*": t } });
  } }, { key: "fromJSONObject", value: function(t) {
    return new e({ video: t.video, audio: t.audio, screenVideo: t.screenVideo, screenAudio: t.screenAudio, customVideo: t.customVideo !== void 0 ? tn({}, t.customVideo) : void 0, customAudio: t.customAudio !== void 0 ? tn({}, t.customAudio) : void 0 });
  } }, { key: "fromMinifiedJSONObject", value: function(t) {
    return new e({ video: t.v, audio: t.a, screenVideo: t.sv, screenAudio: t.sa, customVideo: t.cv, customAudio: t.ca });
  } }, { key: "validateJSONObject", value: function(t, n) {
    if (typeof t == "boolean")
      return [!0];
    if (Te(t) !== "object")
      return [!1, "invalid (non-object, non-boolean) value in canReceive"];
    for (var r = Object.keys(t), i = 0, o = r; i < o.length; i++) {
      var a = o[i];
      if (!wr.includes(a))
        return [!1, "invalid media type '".concat(a, "' in canReceive")];
      if (qv.includes(a)) {
        if (typeof t[a] != "boolean")
          return [!1, "invalid (non-boolean) value for media type '".concat(a, "' in canReceive")];
      } else {
        if (Te(t[a]) !== "object")
          return [!1, "invalid (non-object) value for media type '".concat(a, "' in canReceive")];
        for (var u = 0, c = Object.values(t[a]); u < c.length; u++)
          if (typeof c[u] != "boolean")
            return [!1, "invalid (non-boolean) value for entry within '".concat(a, "' in canReceive")];
        if (n && t[a]["*"] === void 0)
          return [!1, `canReceive "base" permission must specify "*" as an entry within '`.concat(a, "'")];
      }
    }
    return n && r.length !== wr.length ? [!1, 'canReceive "base" permission must specify all media types: '.concat(wr.join(", "), " (or be set to a boolean shorthand)")] : [!0];
  } }]);
}(), Jv = ["result"], Hv = ["preserveIframe"];
function gu(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ee(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? gu(Object(n), !0).forEach(function(r) {
      Ft(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gu(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Gl() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (Gl = function() {
    return !!e;
  })();
}
function yu(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!n) {
    if (Array.isArray(e) || (n = function(c, l) {
      if (c) {
        if (typeof c == "string")
          return _u(c, l);
        var d = {}.toString.call(c).slice(8, -1);
        return d === "Object" && c.constructor && (d = c.constructor.name), d === "Map" || d === "Set" ? Array.from(c) : d === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(d) ? _u(c, l) : void 0;
      }
    }(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, i = function() {
      };
      return { s: i, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(c) {
        throw c;
      }, f: i };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var o, a = !0, u = !1;
  return { s: function() {
    n = n.call(e);
  }, n: function() {
    var c = n.next();
    return a = c.done, c;
  }, e: function(c) {
    u = !0, o = c;
  }, f: function() {
    try {
      a || n.return == null || n.return();
    } finally {
      if (u)
        throw o;
    }
  } };
}
function _u(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var hn = {}, bu = "video", Gv = "voice", Su = we() ? { data: {} } : { data: {}, topology: "none" }, wu = { present: 0, hidden: 0 }, Kl = { maxBitrate: { min: 1e5, max: 25e5 }, maxFramerate: { min: 1, max: 30 }, scaleResolutionDownBy: { min: 1, max: 8 } }, qo = Object.keys(Kl), ku = ["state", "volume", "simulcastEncodings"], Eu = { androidInCallNotification: { title: "string", subtitle: "string", iconName: "string", disableForCustomOverride: "boolean" }, disableAutoDeviceManagement: { audio: "boolean", video: "boolean" } }, Oi = { id: { iconPath: "string", iconPathDarkMode: "string", label: "string", tooltip: "string", visualState: "'default' | 'sidebar-open' | 'active'" } }, Pa = { id: { allow: "string", controlledBy: "'*' | 'owners' | string[]", csp: "string", iconURL: "string", label: "string", loading: "'eager' | 'lazy'", location: "'main' | 'sidebar'", name: "string", referrerPolicy: "string", sandbox: "string", src: "string", srcdoc: "string", shared: "string[] | 'owners' | boolean" } }, vn = { customIntegrations: { validate: rd, help: td() }, customTrayButtons: { validate: nd, help: "customTrayButtons should be a dictionary of the type ".concat(JSON.stringify(Oi)) }, url: { validate: function(e) {
  return typeof e == "string";
}, help: "url should be a string" }, baseUrl: { validate: function(e) {
  return typeof e == "string";
}, help: "baseUrl should be a string" }, token: { validate: function(e) {
  return typeof e == "string";
}, help: "token should be a string", queryString: "t" }, dailyConfig: { validate: function(e, t) {
  try {
    return t.validateDailyConfig(e), !0;
  } catch (n) {
    console.error("Failed to validate dailyConfig", n);
  }
  return !1;
}, help: "Unsupported dailyConfig. Check error logs for detailed info." }, reactNativeConfig: { validate: function(e) {
  return id(e, Eu);
}, help: "reactNativeConfig should look like ".concat(JSON.stringify(Eu), ", all fields optional") }, lang: { validate: function(e) {
  return ["da", "de", "en-us", "en", "es", "fi", "fr", "it", "jp", "ka", "nl", "no", "pl", "pt", "pt-BR", "ru", "sv", "tr", "user"].includes(e);
}, help: "language not supported. Options are: da, de, en-us, en, es, fi, fr, it, jp, ka, nl, no, pl, pt, pt-BR, ru, sv, tr, user" }, userName: !0, userData: { validate: function(e) {
  try {
    return Yl(e), !0;
  } catch (t) {
    return console.error(t), !1;
  }
}, help: "invalid userData type provided" }, startVideoOff: !0, startAudioOff: !0, allowLocalVideo: !0, allowLocalAudio: !0, activeSpeakerMode: !0, showLeaveButton: !0, showLocalVideo: !0, showParticipantsBar: !0, showFullscreenButton: !0, showUserNameChangeUI: !0, iframeStyle: !0, customLayout: !0, cssFile: !0, cssText: !0, bodyClass: !0, videoSource: { validate: function(e, t) {
  if (typeof e == "boolean")
    return t._preloadCache.allowLocalVideo = e, !0;
  var n;
  if (e instanceof MediaStreamTrack)
    t._sharedTracks.videoTrack = e, n = { customTrack: Kt };
  else {
    if (delete t._sharedTracks.videoTrack, typeof e != "string")
      return console.error("videoSource must be a MediaStreamTrack, boolean, or a string"), !1;
    n = { deviceId: e };
  }
  return t._updatePreloadCacheInputSettings({ video: { settings: n } }, !1), !0;
} }, audioSource: { validate: function(e, t) {
  if (typeof e == "boolean")
    return t._preloadCache.allowLocalAudio = e, !0;
  var n;
  if (e instanceof MediaStreamTrack)
    t._sharedTracks.audioTrack = e, n = { customTrack: Kt };
  else {
    if (delete t._sharedTracks.audioTrack, typeof e != "string")
      return console.error("audioSource must be a MediaStreamTrack, boolean, or a string"), !1;
    n = { deviceId: e };
  }
  return t._updatePreloadCacheInputSettings({ audio: { settings: n } }, !1), !0;
} }, subscribeToTracksAutomatically: { validate: function(e, t) {
  return t._preloadCache.subscribeToTracksAutomatically = e, !0;
} }, theme: { validate: function(e) {
  var t = ["accent", "accentText", "background", "backgroundAccent", "baseText", "border", "mainAreaBg", "mainAreaBgAccent", "mainAreaText", "supportiveText"], n = function(r) {
    for (var i = 0, o = Object.keys(r); i < o.length; i++) {
      var a = o[i];
      if (!t.includes(a))
        return console.error('unsupported color "'.concat(a, '". Valid colors: ').concat(t.join(", "))), !1;
      if (!r[a].match(/^#[0-9a-f]{6}|#[0-9a-f]{3}$/i))
        return console.error("".concat(a, ' theme color should be provided in valid hex color format. Received: "').concat(r[a], '"')), !1;
    }
    return !0;
  };
  return Te(e) === "object" && ("light" in e && "dark" in e || "colors" in e) ? "light" in e && "dark" in e ? "colors" in e.light ? "colors" in e.dark ? n(e.light.colors) && n(e.dark.colors) : (console.error('Dark theme is missing "colors" property.', e), !1) : (console.error('Light theme is missing "colors" property.', e), !1) : n(e.colors) : (console.error('Theme must contain either both "light" and "dark" properties, or "colors".', e), !1);
}, help: "unsupported theme configuration. Check error logs for detailed info." }, layoutConfig: { validate: function(e) {
  if ("grid" in e) {
    var t = e.grid;
    if ("maxTilesPerPage" in t) {
      if (!Number.isInteger(t.maxTilesPerPage))
        return console.error("grid.maxTilesPerPage should be an integer. You passed ".concat(t.maxTilesPerPage, ".")), !1;
      if (t.maxTilesPerPage > 49)
        return console.error("grid.maxTilesPerPage can't be larger than 49 without sacrificing browser performance. Please contact us at https://www.daily.co/contact to talk about your use case."), !1;
    }
    if ("minTilesPerPage" in t) {
      if (!Number.isInteger(t.minTilesPerPage))
        return console.error("grid.minTilesPerPage should be an integer. You passed ".concat(t.minTilesPerPage, ".")), !1;
      if (t.minTilesPerPage < 1)
        return console.error("grid.minTilesPerPage can't be lower than 1."), !1;
      if ("maxTilesPerPage" in t && t.minTilesPerPage > t.maxTilesPerPage)
        return console.error("grid.minTilesPerPage can't be higher than grid.maxTilesPerPage."), !1;
    }
  }
  return !0;
}, help: "unsupported layoutConfig. Check error logs for detailed info." }, receiveSettings: { validate: function(e) {
  return Ql(e, { allowAllParticipantsKey: !1 });
}, help: ed({ allowAllParticipantsKey: !1 }) }, sendSettings: { validate: function(e, t) {
  return !!function(n, r) {
    try {
      return r.validateUpdateSendSettings(n), !0;
    } catch (i) {
      return console.error("Failed to validate send settings", i), !1;
    }
  }(e, t) && (t._preloadCache.sendSettings = e, !0);
}, help: "Invalid sendSettings provided. Check error logs for detailed info." }, inputSettings: { validate: function(e, t) {
  var n;
  return !!Zl(e) && (t._inputSettings || (t._inputSettings = {}), Xl(e, (n = t.properties) === null || n === void 0 ? void 0 : n.dailyConfig, t._sharedTracks), t._updatePreloadCacheInputSettings(e, !0), !0);
}, help: Oa() }, layout: { validate: function(e) {
  return e === "custom-v1" || e === "browser" || e === "none";
}, help: 'layout may only be set to "custom-v1"', queryString: "layout" }, emb: { queryString: "emb" }, embHref: { queryString: "embHref" }, dailyJsVersion: { queryString: "dailyJsVersion" }, proxy: { queryString: "proxy" }, strictMode: !0, allowMultipleCallInstances: !0 }, ni = { styles: { validate: function(e) {
  for (var t in e)
    if (t !== "cam" && t !== "screen")
      return !1;
  if (e.cam) {
    for (var n in e.cam)
      if (n !== "div" && n !== "video")
        return !1;
  }
  if (e.screen) {
    for (var r in e.screen)
      if (r !== "div" && r !== "video")
        return !1;
  }
  return !0;
}, help: "styles format should be a subset of: { cam: {div: {}, video: {}}, screen: {div: {}, video: {}} }" }, setSubscribedTracks: { validate: function(e, t) {
  if (t._preloadCache.subscribeToTracksAutomatically)
    return !1;
  var n = [!0, !1, "staged"];
  if (n.includes(e) || !we() && e === "avatar")
    return !0;
  var r = ["audio", "video", "screenAudio", "screenVideo", "rmpAudio", "rmpVideo"], i = function(o) {
    var a = arguments.length > 1 && arguments[1] !== void 0 && arguments[1];
    for (var u in o)
      if (u === "custom") {
        if (!n.includes(o[u]) && !i(o[u], !0))
          return !1;
      } else {
        var c = !a && !r.includes(u), l = !n.includes(o[u]);
        if (c || l)
          return !1;
      }
    return !0;
  };
  return i(e);
}, help: "setSubscribedTracks cannot be used when setSubscribeToTracksAutomatically is enabled, and should be of the form: " + "true".concat(we() ? "" : " | 'avatar'", " | false | 'staged' | { [audio: true|false|'staged'], [video: true|false|'staged'], [screenAudio: true|false|'staged'], [screenVideo: true|false|'staged'] }") }, setAudio: !0, setVideo: !0, setScreenShare: { validate: function(e) {
  return e === !1;
}, help: "setScreenShare must be false, as it's only meant for stopping remote participants' screen shares" }, eject: !0, updatePermissions: { validate: function(e) {
  for (var t = 0, n = Object.entries(e); t < n.length; t++) {
    var r = rt(n[t], 2), i = r[0], o = r[1];
    switch (i) {
      case "hasPresence":
        if (typeof o != "boolean")
          return !1;
        break;
      case "canSend":
        if (o instanceof Set || o instanceof Array || Array.isArray(o)) {
          var a, u = ["video", "audio", "screenVideo", "screenAudio", "customVideo", "customAudio"], c = yu(o);
          try {
            for (c.s(); !(a = c.n()).done; ) {
              var l = a.value;
              if (!u.includes(l))
                return !1;
            }
          } catch (w) {
            c.e(w);
          } finally {
            c.f();
          }
        } else if (typeof o != "boolean")
          return !1;
        (o instanceof Array || Array.isArray(o)) && (e.canSend = new Set(o));
        break;
      case "canReceive":
        var d = rt(Hl.validateJSONObject(o), 2), h = d[0], g = d[1];
        if (!h)
          return console.error(g), !1;
        break;
      case "canAdmin":
        if (o instanceof Set || o instanceof Array || Array.isArray(o)) {
          var b, y = ["participants", "streaming", "transcription"], v = yu(o);
          try {
            for (v.s(); !(b = v.n()).done; ) {
              var _ = b.value;
              if (!y.includes(_))
                return !1;
            }
          } catch (w) {
            v.e(w);
          } finally {
            v.f();
          }
        } else if (typeof o != "boolean")
          return !1;
        (o instanceof Array || Array.isArray(o)) && (e.canAdmin = new Set(o));
        break;
      default:
        return !1;
    }
  }
  return !0;
}, help: "updatePermissions can take hasPresence, canSend, canReceive, and canAdmin permissions. hasPresence must be a boolean. canSend can be a boolean or an Array or Set of media types (video, audio, screenVideo, screenAudio, customVideo, customAudio). canReceive must be an object specifying base, byUserId, and/or byParticipantId fields (see documentation for more details). canAdmin can be a boolean or an Array or Set of admin types (participants, streaming, transcription)." } };
Promise.any || (Promise.any = function() {
  var e = ue(function* (t) {
    return new Promise(function(n, r) {
      var i = [];
      t.forEach(function(o) {
        return Promise.resolve(o).then(function(a) {
          n(a);
        }).catch(function(a) {
          i.push(a), i.length === t.length && r(i);
        });
      });
    });
  });
  return function(t) {
    return e.apply(this, arguments);
  };
}());
var Ut = function() {
  function e(s) {
    var p, f, m, S, C, A, x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (gt(this, e), m = this, S = Lt(S = e), Ft(f = Vi(m, Gl() ? Reflect.construct(S, [], Lt(m).constructor) : S.apply(m, C)), "startListeningForDeviceChanges", function() {
      Bv(f.handleDeviceChange);
    }), Ft(f, "stopListeningForDeviceChanges", function() {
      Fv(f.handleDeviceChange);
    }), Ft(f, "handleDeviceChange", function(W) {
      W = W.map(function(H) {
        return JSON.parse(JSON.stringify(H));
      }), f.emitDailyJSEvent({ action: "available-devices-updated", availableDevices: W });
    }), Ft(f, "handleNativeAppStateChange", function() {
      var W = ue(function* (H) {
        if (H === "destroyed")
          return console.warn("App has been destroyed before leaving the meeting. Cleaning up all the resources!"), void (yield f.destroy());
        var ve = H === "active";
        f.disableReactNativeAutoDeviceManagement("video") || (ve ? f.camUnmutedBeforeLosingNativeActiveState && f.setLocalVideo(!0) : (f.camUnmutedBeforeLosingNativeActiveState = f.localVideo(), f.camUnmutedBeforeLosingNativeActiveState && f.setLocalVideo(!1)));
      });
      return function(H) {
        return W.apply(this, arguments);
      };
    }()), Ft(f, "handleNativeAudioFocusChange", function(W) {
      f.disableReactNativeAutoDeviceManagement("audio") || (f._hasNativeAudioFocus = W, f.toggleParticipantAudioBasedOnNativeAudioFocus(), f._hasNativeAudioFocus ? f.micUnmutedBeforeLosingNativeAudioFocus && f.setLocalAudio(!0) : (f.micUnmutedBeforeLosingNativeAudioFocus = f.localAudio(), f.setLocalAudio(!1)));
    }), Ft(f, "handleNativeSystemScreenCaptureStop", function() {
      f.stopScreenShare();
    }), f.strictMode = x.strictMode === void 0 || x.strictMode, f.allowMultipleCallInstances = (p = x.allowMultipleCallInstances) !== null && p !== void 0 && p, Object.keys(hn).length && (f._logDuplicateInstanceAttempt(), !f.allowMultipleCallInstances)) {
      if (f.strictMode)
        throw new Error("Duplicate DailyIframe instances are not allowed");
      console.warn("Using strictMode: false to allow multiple call instances is now deprecated. Set `allowMultipleCallInstances: true`");
    }
    if (window._daily || (window._daily = { pendings: [], instances: {} }), f.callClientId = Bi(), hn[(A = f).callClientId] = A, window._daily.instances[f.callClientId] = {}, f._sharedTracks = {}, window._daily.instances[f.callClientId].tracks = f._sharedTracks, x.dailyJsVersion = e.version(), f._iframe = s, f._callObjectMode = x.layout === "none" && !f._iframe, f._preloadCache = { subscribeToTracksAutomatically: !0, outputDeviceId: null, inputSettings: null, sendSettings: null, videoTrackForNetworkConnectivityTest: null, videoTrackForConnectionQualityTest: null }, x.showLocalVideo !== void 0 ? f._callObjectMode ? console.error("showLocalVideo is not available in call object mode") : f._showLocalVideo = !!x.showLocalVideo : f._showLocalVideo = !0, x.showParticipantsBar !== void 0 ? f._callObjectMode ? console.error("showParticipantsBar is not available in call object mode") : f._showParticipantsBar = !!x.showParticipantsBar : f._showParticipantsBar = !0, x.customIntegrations !== void 0 ? f._callObjectMode ? console.error("customIntegrations is not available in call object mode") : f._customIntegrations = x.customIntegrations : f._customIntegrations = {}, x.customTrayButtons !== void 0 ? f._callObjectMode ? console.error("customTrayButtons is not available in call object mode") : f._customTrayButtons = x.customTrayButtons : f._customTrayButtons = {}, x.activeSpeakerMode !== void 0 ? f._callObjectMode ? console.error("activeSpeakerMode is not available in call object mode") : f._activeSpeakerMode = !!x.activeSpeakerMode : f._activeSpeakerMode = !1, x.receiveSettings ? f._callObjectMode ? f._receiveSettings = x.receiveSettings : console.error("receiveSettings is only available in call object mode") : f._receiveSettings = {}, f.validateProperties(x), f.properties = ee({}, x), f._inputSettings || (f._inputSettings = {}), f._callObjectLoader = f._callObjectMode ? new Av(f.callClientId) : null, f._callState = Bc, f._isPreparingToJoin = !1, f._accessState = { access: $o }, f._meetingSessionSummary = {}, f._finalSummaryOfPrevSession = {}, f._meetingSessionState = Go(Su, f._callObjectMode), f._nativeInCallAudioMode = bu, f._participants = {}, f._isScreenSharing = !1, f._participantCounts = wu, f._rmpPlayerState = {}, f._waitingParticipants = {}, f._network = { threshold: "good", quality: 100, networkState: "unknown", stats: {} }, f._activeSpeaker = {}, f._localAudioLevel = 0, f._isLocalAudioLevelObserverRunning = !1, f._remoteParticipantsAudioLevel = {}, f._isRemoteParticipantsAudioLevelObserverRunning = !1, f._maxAppMessageSize = Bo, f._messageChannel = we() ? new Cv() : new Rv(), f._iframe && (f._iframe.requestFullscreen ? f._iframe.addEventListener("fullscreenchange", function() {
      document.fullscreenElement === f._iframe ? (f.emitDailyJSEvent({ action: Zr }), f.sendMessageToCallMachine({ action: Zr })) : (f.emitDailyJSEvent({ action: Xr }), f.sendMessageToCallMachine({ action: Xr }));
    }) : f._iframe.webkitRequestFullscreen && f._iframe.addEventListener("webkitfullscreenchange", function() {
      document.webkitFullscreenElement === f._iframe ? (f.emitDailyJSEvent({ action: Zr }), f.sendMessageToCallMachine({ action: Zr })) : (f.emitDailyJSEvent({ action: Xr }), f.sendMessageToCallMachine({ action: Xr }));
    })), we()) {
      var F = f.nativeUtils();
      F.addAudioFocusChangeListener && F.removeAudioFocusChangeListener && F.addAppStateChangeListener && F.removeAppStateChangeListener && F.addSystemScreenCaptureStopListener && F.removeSystemScreenCaptureStopListener || console.warn("expected (add|remove)(AudioFocusChange|AppActiveStateChange|SystemScreenCaptureStop)Listener to be available in React Native"), f._hasNativeAudioFocus = !0, F.addAudioFocusChangeListener(f.handleNativeAudioFocusChange), F.addAppStateChangeListener(f.handleNativeAppStateChange), F.addSystemScreenCaptureStopListener(f.handleNativeSystemScreenCaptureStop);
    }
    return f._callObjectMode && f.startListeningForDeviceChanges(), f._messageChannel.addListenerForMessagesFromCallMachine(f.handleMessageFromCallMachine, f.callClientId, f), f;
  }
  return $i(e, Wr), yt(e, [{ key: "destroy", value: (M = ue(function* () {
    var s;
    try {
      yield this.leave();
    } catch {
    }
    var p = this._iframe;
    if (p) {
      var f = p.parentElement;
      f && f.removeChild(p);
    }
    if (this._messageChannel.removeListener(this.handleMessageFromCallMachine), we()) {
      var m = this.nativeUtils();
      m.removeAudioFocusChangeListener(this.handleNativeAudioFocusChange), m.removeAppStateChangeListener(this.handleNativeAppStateChange), m.removeSystemScreenCaptureStopListener(this.handleNativeSystemScreenCaptureStop);
    }
    this._callObjectMode && this.stopListeningForDeviceChanges(), this.resetMeetingDependentVars(), this._destroyed = !0, this.emitDailyJSEvent({ action: "call-instance-destroyed" }), delete hn[this.callClientId], !((s = window) === null || s === void 0 || (s = s._daily) === null || s === void 0) && s.instances && delete window._daily.instances[this.callClientId], this.strictMode && (this.callClientId = void 0);
  }), function() {
    return M.apply(this, arguments);
  }) }, { key: "isDestroyed", value: function() {
    return !!this._destroyed;
  } }, { key: "loadCss", value: function(s) {
    var p = s.bodyClass, f = s.cssFile, m = s.cssText;
    return Se(), this.sendMessageToCallMachine({ action: "load-css", cssFile: this.absoluteUrl(f), bodyClass: p, cssText: m }), this;
  } }, { key: "iframe", value: function() {
    return Se(), this._iframe;
  } }, { key: "meetingState", value: function() {
    return this._callState;
  } }, { key: "accessState", value: function() {
    return Mt(this._callObjectMode, "accessState()"), this._accessState;
  } }, { key: "participants", value: function() {
    return this._participants;
  } }, { key: "participantCounts", value: function() {
    return this._participantCounts;
  } }, { key: "waitingParticipants", value: function() {
    return Mt(this._callObjectMode, "waitingParticipants()"), this._waitingParticipants;
  } }, { key: "validateParticipantProperties", value: function(s, p) {
    for (var f in p) {
      if (!ni[f])
        throw new Error("unrecognized updateParticipant property ".concat(f));
      if (ni[f].validate && !ni[f].validate(p[f], this, this._participants[s]))
        throw new Error(ni[f].help);
    }
  } }, { key: "updateParticipant", value: function(s, p) {
    return this._participants.local && this._participants.local.session_id === s && (s = "local"), s && p && (this.validateParticipantProperties(s, p), this.sendMessageToCallMachine({ action: "update-participant", id: s, properties: p })), this;
  } }, { key: "updateParticipants", value: function(s) {
    var p = this._participants.local && this._participants.local.session_id;
    for (var f in s)
      f === p && (f = "local"), f && s[f] && this.validateParticipantProperties(f, s[f]);
    return this.sendMessageToCallMachine({ action: "update-participants", participants: s }), this;
  } }, { key: "updateWaitingParticipant", value: (Y = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Mt(this._callObjectMode, "updateWaitingParticipant()"), Ie(this._callState, "updateWaitingParticipant()"), typeof p != "string" || Te(f) !== "object")
      throw new Error("updateWaitingParticipant() must take an id string and a updates object");
    return new Promise(function(m, S) {
      s.sendMessageToCallMachine({ action: "daily-method-update-waiting-participant", id: p, updates: f }, function(C) {
        C.error && S(C.error), C.id || S(new Error("unknown error in updateWaitingParticipant()")), m({ id: C.id });
      });
    });
  }), function() {
    return Y.apply(this, arguments);
  }) }, { key: "updateWaitingParticipants", value: (K = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Mt(this._callObjectMode, "updateWaitingParticipants()"), Ie(this._callState, "updateWaitingParticipants()"), Te(p) !== "object")
      throw new Error("updateWaitingParticipants() must take a mapping between ids and update objects");
    return new Promise(function(f, m) {
      s.sendMessageToCallMachine({ action: "daily-method-update-waiting-participants", updatesById: p }, function(S) {
        S.error && m(S.error), S.ids || m(new Error("unknown error in updateWaitingParticipants()")), f({ ids: S.ids });
      });
    });
  }), function() {
    return K.apply(this, arguments);
  }) }, { key: "requestAccess", value: (Ae = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, f = p.access, m = f === void 0 ? { level: Sh } : f, S = p.name, C = S === void 0 ? "" : S;
    return Mt(this._callObjectMode, "requestAccess()"), Ie(this._callState, "requestAccess()"), new Promise(function(A, x) {
      s.sendMessageToCallMachine({ action: "daily-method-request-access", access: m, name: C }, function(F) {
        F.error && x(F.error), F.access || x(new Error("unknown error in requestAccess()")), A({ access: F.access, granted: F.granted });
      });
    });
  }), function() {
    return Ae.apply(this, arguments);
  }) }, { key: "localAudio", value: function() {
    return this._participants.local ? !["blocked", "off"].includes(this._participants.local.tracks.audio.state) : null;
  } }, { key: "localVideo", value: function() {
    return this._participants.local ? !["blocked", "off"].includes(this._participants.local.tracks.video.state) : null;
  } }, { key: "setLocalAudio", value: function(s) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return "forceDiscardTrack" in p && (we() ? (console.warn("forceDiscardTrack option not supported in React Native; ignoring"), p = {}) : s && (console.warn("forceDiscardTrack option only supported when calling setLocalAudio(false); ignoring"), p = {})), this.sendMessageToCallMachine({ action: "local-audio", state: s, options: p }), this;
  } }, { key: "localScreenAudio", value: function() {
    return this._participants.local ? !["blocked", "off"].includes(this._participants.local.tracks.screenAudio.state) : null;
  } }, { key: "localScreenVideo", value: function() {
    return this._participants.local ? !["blocked", "off"].includes(this._participants.local.tracks.screenVideo.state) : null;
  } }, { key: "updateScreenShare", value: function(s) {
    if (this._isScreenSharing)
      return this.sendMessageToCallMachine({ action: "local-screen-update", options: s }), this;
    console.warn("There is no screen share in progress. Try calling startScreenShare first.");
  } }, { key: "setLocalVideo", value: function(s) {
    return this.sendMessageToCallMachine({ action: "local-video", state: s }), this;
  } }, { key: "_setAllowLocalAudio", value: function(s) {
    if (this._preloadCache.allowLocalAudio = s, this._callMachineInitialized)
      return this.sendMessageToCallMachine({ action: "set-allow-local-audio", state: s }), this;
  } }, { key: "_setAllowLocalVideo", value: function(s) {
    if (this._preloadCache.allowLocalVideo = s, this._callMachineInitialized)
      return this.sendMessageToCallMachine({ action: "set-allow-local-video", state: s }), this;
  } }, { key: "getReceiveSettings", value: (ke = ue(function* (s) {
    var p = this, f = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).showInheritedValues, m = f !== void 0 && f;
    if (Mt(this._callObjectMode, "getReceiveSettings()"), !this._callMachineInitialized)
      return this._receiveSettings;
    switch (Te(s)) {
      case "string":
        return new Promise(function(S) {
          p.sendMessageToCallMachine({ action: "get-single-participant-receive-settings", id: s, showInheritedValues: m }, function(C) {
            S(C.receiveSettings);
          });
        });
      case "undefined":
        return this._receiveSettings;
      default:
        throw new Error('first argument to getReceiveSettings() must be a participant id (or "base"), or there should be no arguments');
    }
  }), function(s) {
    return ke.apply(this, arguments);
  }) }, { key: "updateReceiveSettings", value: (Re = ue(function* (s) {
    var p = this;
    if (Mt(this._callObjectMode, "updateReceiveSettings()"), !Ql(s, { allowAllParticipantsKey: !0 }))
      throw new Error(ed({ allowAllParticipantsKey: !0 }));
    return Ie(this._callState, "updateReceiveSettings()", "To specify receive settings earlier, use the receiveSettings config property."), new Promise(function(f) {
      p.sendMessageToCallMachine({ action: "update-receive-settings", receiveSettings: s }, function(m) {
        f({ receiveSettings: m.receiveSettings });
      });
    });
  }), function(s) {
    return Re.apply(this, arguments);
  }) }, { key: "_prepInputSettingsForSharing", value: function(s, p) {
    if (s) {
      var f = {};
      if (s.audio) {
        var m, S, C;
        s.audio.settings && (!Object.keys(s.audio.settings).length && p || (f.audio = { settings: ee({}, s.audio.settings) })), p && (m = f.audio) !== null && m !== void 0 && (m = m.settings) !== null && m !== void 0 && m.customTrack && (f.audio.settings = { customTrack: this._sharedTracks.audioTrack });
        var A = ((S = s.audio.processor) === null || S === void 0 ? void 0 : S.type) === "none" && ((C = s.audio.processor) === null || C === void 0 ? void 0 : C._isDefaultWhenNone);
        if (s.audio.processor && !A) {
          var x = ee({}, s.audio.processor);
          delete x._isDefaultWhenNone, f.audio = ee(ee({}, f.audio), {}, { processor: x });
        }
      }
      if (s.video) {
        var F, W, H;
        s.video.settings && (!Object.keys(s.video.settings).length && p || (f.video = { settings: ee({}, s.video.settings) })), p && (F = f.video) !== null && F !== void 0 && (F = F.settings) !== null && F !== void 0 && F.customTrack && (f.video.settings = { customTrack: this._sharedTracks.videoTrack });
        var ve = ((W = s.video.processor) === null || W === void 0 ? void 0 : W.type) === "none" && ((H = s.video.processor) === null || H === void 0 ? void 0 : H._isDefaultWhenNone);
        if (s.video.processor && !ve) {
          var Ee = ee({}, s.video.processor);
          delete Ee._isDefaultWhenNone, f.video = ee(ee({}, f.video), {}, { processor: Ee });
        }
      }
      return f;
    }
  } }, { key: "getInputSettings", value: function() {
    var s = this;
    return Se(), new Promise(function(p) {
      p(s._getInputSettings());
    });
  } }, { key: "_getInputSettings", value: function() {
    var s, p, f, m, S, C, A = { processor: { type: "none", _isDefaultWhenNone: !0 } };
    this._inputSettings ? (s = ((f = this._inputSettings) === null || f === void 0 ? void 0 : f.video) || A, p = ((m = this._inputSettings) === null || m === void 0 ? void 0 : m.audio) || A) : (s = ((S = this._preloadCache) === null || S === void 0 || (S = S.inputSettings) === null || S === void 0 ? void 0 : S.video) || A, p = ((C = this._preloadCache) === null || C === void 0 || (C = C.inputSettings) === null || C === void 0 ? void 0 : C.audio) || A);
    var x = { audio: p, video: s };
    return this._prepInputSettingsForSharing(x, !0);
  } }, { key: "_updatePreloadCacheInputSettings", value: function(s, p) {
    var f = this._inputSettings || {}, m = {};
    if (s.video) {
      var S, C, A;
      m.video = {}, s.video.settings ? (m.video.settings = {}, p || s.video.settings.customTrack || (A = f.video) === null || A === void 0 || !A.settings ? m.video.settings = s.video.settings : m.video.settings = ee(ee({}, f.video.settings), s.video.settings), Object.keys(m.video.settings).length || delete m.video.settings) : (S = f.video) !== null && S !== void 0 && S.settings && (m.video.settings = f.video.settings), s.video.processor ? m.video.processor = s.video.processor : (C = f.video) !== null && C !== void 0 && C.processor && (m.video.processor = f.video.processor);
    } else
      f.video && (m.video = f.video);
    if (s.audio) {
      var x, F, W;
      m.audio = {}, s.audio.settings ? (m.audio.settings = {}, p || s.audio.settings.customTrack || (W = f.audio) === null || W === void 0 || !W.settings ? m.audio.settings = s.audio.settings : m.audio.settings = ee(ee({}, f.audio.settings), s.audio.settings), Object.keys(m.audio.settings).length || delete m.audio.settings) : (x = f.audio) !== null && x !== void 0 && x.settings && (m.audio.settings = f.audio.settings), s.audio.processor ? m.audio.processor = s.audio.processor : (F = f.audio) !== null && F !== void 0 && F.processor && (m.audio.processor = f.audio.processor);
    } else
      f.audio && (m.audio = f.audio);
    this._maybeUpdateInputSettings(m);
  } }, { key: "_devicesFromInputSettings", value: function(s) {
    var p, f, m = (s == null || (p = s.video) === null || p === void 0 || (p = p.settings) === null || p === void 0 ? void 0 : p.deviceId) || null, S = (s == null || (f = s.audio) === null || f === void 0 || (f = f.settings) === null || f === void 0 ? void 0 : f.deviceId) || null, C = this._preloadCache.outputDeviceId || null;
    return { camera: m ? { deviceId: m } : {}, mic: S ? { deviceId: S } : {}, speaker: C ? { deviceId: C } : {} };
  } }, { key: "updateInputSettings", value: (se = ue(function* (s) {
    var p = this;
    return Se(), Zl(s) ? s.video || s.audio ? (Xl(s, this.properties.dailyConfig, this._sharedTracks), this._callObjectMode && !this._callMachineInitialized ? (this._updatePreloadCacheInputSettings(s, !0), this._getInputSettings()) : new Promise(function(f, m) {
      p.sendMessageToCallMachine({ action: "update-input-settings", inputSettings: s }, function(S) {
        if (S.error)
          m(S.error);
        else {
          if (S.returnPreloadCache)
            return p._updatePreloadCacheInputSettings(s, !0), void f(p._getInputSettings());
          p._maybeUpdateInputSettings(S.inputSettings), f(p._prepInputSettingsForSharing(S.inputSettings, !0));
        }
      });
    })) : this._getInputSettings() : (console.error(Oa()), Promise.reject(Oa()));
  }), function(s) {
    return se.apply(this, arguments);
  }) }, { key: "setBandwidth", value: function(s) {
    var p = s.kbs, f = s.trackConstraints;
    if (Se(), this._callMachineInitialized)
      return this.sendMessageToCallMachine({ action: "set-bandwidth", kbs: p, trackConstraints: f }), this;
  } }, { key: "getDailyLang", value: function() {
    var s = this;
    if (Se(), this._callMachineInitialized)
      return new Promise(function(p) {
        s.sendMessageToCallMachine({ action: "get-daily-lang" }, function(f) {
          delete f.action, delete f.callbackStamp, p(f);
        });
      });
  } }, { key: "setDailyLang", value: function(s) {
    return Se(), this.sendMessageToCallMachine({ action: "set-daily-lang", lang: s }), this;
  } }, { key: "setProxyUrl", value: function(s) {
    return this.sendMessageToCallMachine({ action: "set-proxy-url", proxyUrl: s }), this;
  } }, { key: "setIceConfig", value: function(s) {
    return this.sendMessageToCallMachine({ action: "set-ice-config", iceConfig: s }), this;
  } }, { key: "meetingSessionSummary", value: function() {
    return [pn, en].includes(this._callState) ? this._finalSummaryOfPrevSession : this._meetingSessionSummary;
  } }, { key: "getMeetingSession", value: (Me = ue(function* () {
    var s = this;
    return console.warn("getMeetingSession() is deprecated: use meetingSessionSummary(), which will return immediately"), Ie(this._callState, "getMeetingSession()"), new Promise(function(p) {
      s.sendMessageToCallMachine({ action: "get-meeting-session" }, function(f) {
        delete f.action, delete f.callbackStamp, p(f);
      });
    });
  }), function() {
    return Me.apply(this, arguments);
  }) }, { key: "meetingSessionState", value: function() {
    return Ie(this._callState, "meetingSessionState"), this._meetingSessionState;
  } }, { key: "setMeetingSessionData", value: function(s) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "replace";
    Mt(this._callObjectMode, "setMeetingSessionData()"), Ie(this._callState, "setMeetingSessionData");
    try {
      (function(f, m) {
        new Mv({ data: f, mergeStrategy: m });
      })(s, p);
    } catch (f) {
      throw console.error(f), f;
    }
    try {
      this.sendMessageToCallMachine({ action: "set-session-data", data: s, mergeStrategy: p });
    } catch (f) {
      throw new Error("Error setting meeting session data: ".concat(f));
    }
  } }, { key: "setUserName", value: function(s, p) {
    var f = this;
    return this.properties.userName = s, new Promise(function(m) {
      f.sendMessageToCallMachine({ action: "set-user-name", name: s ?? "", thisMeetingOnly: we() || !!p && !!p.thisMeetingOnly }, function(S) {
        delete S.action, delete S.callbackStamp, m(S);
      });
    });
  } }, { key: "setUserData", value: (ce = ue(function* (s) {
    var p = this;
    try {
      Yl(s);
    } catch (f) {
      throw console.error(f), f;
    }
    if (this.properties.userData = s, this._callMachineInitialized)
      return new Promise(function(f) {
        try {
          p.sendMessageToCallMachine({ action: "set-user-data", userData: s }, function(m) {
            delete m.action, delete m.callbackStamp, f(m);
          });
        } catch (m) {
          throw new Error("Error setting user data: ".concat(m));
        }
      });
  }), function(s) {
    return ce.apply(this, arguments);
  }) }, { key: "validateAudioLevelInterval", value: function(s) {
    if (s && (s < 100 || typeof s != "number"))
      throw new Error("The interval must be a number greater than or equal to 100 milliseconds.");
  } }, { key: "startLocalAudioLevelObserver", value: function(s) {
    var p = this;
    if (typeof AudioWorkletNode > "u" && !we())
      throw new Error("startLocalAudioLevelObserver() is not supported on this browser");
    if (this.validateAudioLevelInterval(s), this._callMachineInitialized)
      return this._isLocalAudioLevelObserverRunning = !0, new Promise(function(f, m) {
        p.sendMessageToCallMachine({ action: "start-local-audio-level-observer", interval: s }, function(S) {
          p._isLocalAudioLevelObserverRunning = !S.error, S.error ? m({ error: S.error }) : f();
        });
      });
    this._preloadCache.localAudioLevelObserver = { enabled: !0, interval: s };
  } }, { key: "isLocalAudioLevelObserverRunning", value: function() {
    return this._isLocalAudioLevelObserverRunning;
  } }, { key: "stopLocalAudioLevelObserver", value: function() {
    this._preloadCache.localAudioLevelObserver = null, this._localAudioLevel = 0, this._isLocalAudioLevelObserverRunning = !1, this.sendMessageToCallMachine({ action: "stop-local-audio-level-observer" });
  } }, { key: "startRemoteParticipantsAudioLevelObserver", value: function(s) {
    var p = this;
    if (this.validateAudioLevelInterval(s), this._callMachineInitialized)
      return this._isRemoteParticipantsAudioLevelObserverRunning = !0, new Promise(function(f, m) {
        p.sendMessageToCallMachine({ action: "start-remote-participants-audio-level-observer", interval: s }, function(S) {
          p._isRemoteParticipantsAudioLevelObserverRunning = !S.error, S.error ? m({ error: S.error }) : f();
        });
      });
    this._preloadCache.remoteParticipantsAudioLevelObserver = { enabled: !0, interval: s };
  } }, { key: "isRemoteParticipantsAudioLevelObserverRunning", value: function() {
    return this._isRemoteParticipantsAudioLevelObserverRunning;
  } }, { key: "stopRemoteParticipantsAudioLevelObserver", value: function() {
    this._preloadCache.remoteParticipantsAudioLevelObserver = null, this._remoteParticipantsAudioLevel = {}, this._isRemoteParticipantsAudioLevelObserverRunning = !1, this.sendMessageToCallMachine({ action: "stop-remote-participants-audio-level-observer" });
  } }, { key: "startCamera", value: (J = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Mt(this._callObjectMode, "startCamera()"), Jo(this._callState, this._isPreparingToJoin, "startCamera()", "Did you mean to use setLocalAudio() and/or setLocalVideo() instead?"), this.needsLoad())
      try {
        yield this.load(p);
      } catch (f) {
        return Promise.reject(f);
      }
    else {
      if (this._didPreAuth) {
        if (p.url && p.url !== this.properties.url)
          return console.error("url in startCamera() is different than the one used in preAuth()"), Promise.reject();
        if (p.token && p.token !== this.properties.token)
          return console.error("token in startCamera() is different than the one used in preAuth()"), Promise.reject();
      }
      this.validateProperties(p), this.properties = ee(ee({}, this.properties), p);
    }
    return new Promise(function(f) {
      s._preloadCache.inputSettings = s._prepInputSettingsForSharing(s._inputSettings, !1), s.sendMessageToCallMachine({ action: "start-camera", properties: jn(s.properties, s.callClientId), preloadCache: jn(s._preloadCache, s.callClientId) }, function(m) {
        f({ camera: m.camera, mic: m.mic, speaker: m.speaker });
      });
    });
  }), function() {
    return J.apply(this, arguments);
  }) }, { key: "validateCustomTrack", value: function(s, p, f) {
    if (f && f.length > 50)
      throw new Error("Custom track `trackName` must not be more than 50 characters");
    if (p && p !== "music" && p !== "speech" && !(p instanceof Object))
      throw new Error("Custom track `mode` must be either `music` | `speech` | `DailyMicAudioModeSettings` or `undefined`");
    if (f && ["cam-audio", "cam-video", "screen-video", "screen-audio", "rmpAudio", "rmpVideo", "customVideoDefaults"].includes(f))
      throw new Error("Custom track `trackName` must not match a track name already used by daily: cam-audio, cam-video, customVideoDefaults, screen-video, screen-audio, rmpAudio, rmpVideo");
    if (!(s instanceof MediaStreamTrack))
      throw new Error("Custom tracks provided must be instances of MediaStreamTrack");
  } }, { key: "startCustomTrack", value: function() {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : { track, mode, trackName, ignoreAudioLevel };
    return Se(), Ie(this._callState, "startCustomTrack()"), this.validateCustomTrack(p.track, p.mode, p.trackName), new Promise(function(f, m) {
      s._sharedTracks.customTrack = p.track, p.track = Kt, s.sendMessageToCallMachine({ action: "start-custom-track", properties: p }, function(S) {
        S.error ? m({ error: S.error }) : f(S.mediaTag);
      });
    });
  } }, { key: "stopCustomTrack", value: function(s) {
    var p = this;
    return Se(), Ie(this._callState, "stopCustomTrack()"), new Promise(function(f) {
      p.sendMessageToCallMachine({ action: "stop-custom-track", mediaTag: s }, function(m) {
        f(m.mediaTag);
      });
    });
  } }, { key: "setCamera", value: function(s) {
    var p = this;
    return dr(), ri(this._callMachineInitialized, "setCamera()"), new Promise(function(f) {
      p.sendMessageToCallMachine({ action: "set-camera", cameraDeviceId: s }, function(m) {
        f({ device: m.device });
      });
    });
  } }, { key: "setAudioDevice", value: (ie = ue(function* (s) {
    return dr(), this.nativeUtils().setAudioDevice(s), { deviceId: yield this.nativeUtils().getAudioDevice() };
  }), function(s) {
    return ie.apply(this, arguments);
  }) }, { key: "cycleCamera", value: function() {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return new Promise(function(f) {
      s.sendMessageToCallMachine({ action: "cycle-camera", properties: p }, function(m) {
        f({ device: m.device });
      });
    });
  } }, { key: "cycleMic", value: function() {
    var s = this;
    return Se(), new Promise(function(p) {
      s.sendMessageToCallMachine({ action: "cycle-mic" }, function(f) {
        p({ device: f.device });
      });
    });
  } }, { key: "getCameraFacingMode", value: function() {
    var s = this;
    return dr(), new Promise(function(p) {
      s.sendMessageToCallMachine({ action: "get-camera-facing-mode" }, function(f) {
        p(f.facingMode);
      });
    });
  } }, { key: "setInputDevicesAsync", value: (te = ue(function* (s) {
    var p = this, f = s.audioDeviceId, m = s.videoDeviceId, S = s.audioSource, C = s.videoSource;
    if (Se(), S !== void 0 && (f = S), C !== void 0 && (m = C), typeof f == "boolean" && (this._setAllowLocalAudio(f), f = void 0), typeof m == "boolean" && (this._setAllowLocalVideo(m), m = void 0), !f && !m)
      return yield this.getInputDevices();
    var A = {};
    return f && (f instanceof MediaStreamTrack ? (this._sharedTracks.audioTrack = f, f = Kt, A.audio = { settings: { customTrack: f } }) : (delete this._sharedTracks.audioTrack, A.audio = { settings: { deviceId: f } })), m && (m instanceof MediaStreamTrack ? (this._sharedTracks.videoTrack = m, m = Kt, A.video = { settings: { customTrack: m } }) : (delete this._sharedTracks.videoTrack, A.video = { settings: { deviceId: m } })), this._callObjectMode && this.needsLoad() ? (this._updatePreloadCacheInputSettings(A, !1), this._devicesFromInputSettings(this._inputSettings)) : new Promise(function(x) {
      p.sendMessageToCallMachine({ action: "set-input-devices", audioDeviceId: f, videoDeviceId: m }, function(F) {
        if (delete F.action, delete F.callbackStamp, F.returnPreloadCache)
          return p._updatePreloadCacheInputSettings(A, !1), void x(p._devicesFromInputSettings(p._inputSettings));
        x(F);
      });
    });
  }), function(s) {
    return te.apply(this, arguments);
  }) }, { key: "setOutputDeviceAsync", value: (G = ue(function* (s) {
    var p = this, f = s.outputDeviceId;
    if (Se(), !f || typeof f != "string")
      throw new Error("outputDeviceId must be provided and must be a valid device id");
    return this._preloadCache.outputDeviceId = f, this._callObjectMode && this.needsLoad() ? this._devicesFromInputSettings(this._inputSettings) : new Promise(function(m, S) {
      p.sendMessageToCallMachine({ action: "set-output-device", outputDeviceId: f }, function(C) {
        if (delete C.action, delete C.callbackStamp, C.error) {
          var A = new Error(C.error.message);
          return A.type = C.error.type, void S(A);
        }
        C.returnPreloadCache ? m(p._devicesFromInputSettings(p._inputSettings)) : m(C);
      });
    });
  }), function(s) {
    return G.apply(this, arguments);
  }) }, { key: "getInputDevices", value: (Q = ue(function* () {
    var s = this;
    return this._callObjectMode && this.needsLoad() ? this._devicesFromInputSettings(this._inputSettings) : new Promise(function(p) {
      s.sendMessageToCallMachine({ action: "get-input-devices" }, function(f) {
        f.returnPreloadCache ? p(s._devicesFromInputSettings(s._inputSettings)) : p({ camera: f.camera, mic: f.mic, speaker: f.speaker });
      });
    });
  }), function() {
    return Q.apply(this, arguments);
  }) }, { key: "nativeInCallAudioMode", value: function() {
    return dr(), this._nativeInCallAudioMode;
  } }, { key: "setNativeInCallAudioMode", value: function(s) {
    if (dr(), [bu, Gv].includes(s)) {
      if (s !== this._nativeInCallAudioMode)
        return this._nativeInCallAudioMode = s, !this.disableReactNativeAutoDeviceManagement("audio") && vi(this._callState, this._isPreparingToJoin) && this.nativeUtils().setAudioMode(this._nativeInCallAudioMode), this;
    } else
      console.error("invalid in-call audio mode specified: ", s);
  } }, { key: "preAuth", value: (B = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (Mt(this._callObjectMode, "preAuth()"), Jo(this._callState, this._isPreparingToJoin, "preAuth()"), this.needsLoad() && (yield this.load(p)), !p.url)
      throw new Error("preAuth() requires at least a url to be provided");
    return this.validateProperties(p), this.properties = ee(ee({}, this.properties), p), new Promise(function(f, m) {
      s._preloadCache.inputSettings = s._prepInputSettingsForSharing(s._inputSettings, !1), s.sendMessageToCallMachine({ action: "daily-method-preauth", properties: jn(s.properties, s.callClientId), preloadCache: jn(s._preloadCache, s.callClientId) }, function(S) {
        return S.error ? m(S.error) : S.access ? (s._didPreAuth = !0, void f({ access: S.access })) : m(new Error("unknown error in preAuth()"));
      });
    });
  }), function() {
    return B.apply(this, arguments);
  }) }, { key: "load", value: (L = ue(function* (s) {
    var p = this;
    if (this.needsLoad()) {
      if (this._destroyed && (this._logUseAfterDestroy(), this.strictMode))
        throw new Error("Use after destroy");
      if (s && (this.validateProperties(s), this.properties = ee(ee({}, this.properties), s)), !this._callObjectMode && !this.properties.url)
        throw new Error("can't load iframe meeting because url property isn't set");
      return this._updateCallState(Fc), this.emitDailyJSEvent({ action: Mh }), this._callObjectMode ? new Promise(function(f, m) {
        p._callObjectLoader.cancel();
        var S = Date.now();
        p._callObjectLoader.load(p.properties.dailyConfig, function(C) {
          p._bundleLoadTime = C ? "no-op" : Date.now() - S, p._updateCallState(Uc), C && p.emitDailyJSEvent({ action: Wc }), f();
        }, function(C, A) {
          if (p.emitDailyJSEvent({ action: Ah }), !A) {
            p._updateCallState(en), p.resetMeetingDependentVars();
            var x = { action: Kc, errorMsg: C.msg, error: { type: "connection-error", msg: "Failed to load call object bundle.", details: { on: "load", sourceError: C, bundleUrl: ki(p.properties.dailyConfig) } } };
            p._maybeSendToSentry(x), p.emitDailyJSEvent(x), m(C.msg);
          }
        });
      }) : (this._iframe.src = yl(this.assembleMeetingUrl(), this.properties.dailyConfig), new Promise(function(f, m) {
        p._loadedCallback = function(S) {
          p._callState !== en ? (p._updateCallState(Uc), (p.properties.cssFile || p.properties.cssText) && p.loadCss(p.properties), f()) : m(S);
        };
      }));
    }
  }), function(s) {
    return L.apply(this, arguments);
  }) }, { key: "join", value: (E = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this._testCallInProgress && this.stopTestCallQuality();
    var f = !1;
    if (this.needsLoad()) {
      this.updateIsPreparingToJoin(!0);
      try {
        yield this.load(p);
      } catch (m) {
        return this.updateIsPreparingToJoin(!1), Promise.reject(m);
      }
    } else {
      if (f = !(!this.properties.cssFile && !this.properties.cssText), this._didPreAuth) {
        if (p.url && p.url !== this.properties.url)
          return console.error("url in join() is different than the one used in preAuth()"), this.updateIsPreparingToJoin(!1), Promise.reject();
        if (p.token && p.token !== this.properties.token)
          return console.error("token in join() is different than the one used in preAuth()"), this.updateIsPreparingToJoin(!1), Promise.reject();
      }
      if (p.url && !this._callObjectMode && p.url && p.url !== this.properties.url)
        return console.error("url in join() is different than the one used in load() (".concat(this.properties.url, " -> ").concat(p.url, ")")), this.updateIsPreparingToJoin(!1), Promise.reject();
      this.validateProperties(p), this.properties = ee(ee({}, this.properties), p);
    }
    return p.showLocalVideo !== void 0 && (this._callObjectMode ? console.error("showLocalVideo is not available in callObject mode") : this._showLocalVideo = !!p.showLocalVideo), p.showParticipantsBar !== void 0 && (this._callObjectMode ? console.error("showParticipantsBar is not available in callObject mode") : this._showParticipantsBar = !!p.showParticipantsBar), this._callState === gn || this._callState === Ea ? (console.warn("already joined meeting, call leave() before joining again"), void this.updateIsPreparingToJoin(!1)) : (this._updateCallState(Ea, !1), this.emitDailyJSEvent({ action: Nh }), this._preloadCache.inputSettings = this._prepInputSettingsForSharing(this._inputSettings || {}, !1), this.sendMessageToCallMachine({ action: "join-meeting", properties: jn(this.properties, this.callClientId), preloadCache: jn(this._preloadCache, this.callClientId) }), new Promise(function(m, S) {
      s._joinedCallback = function(C, A) {
        if (s._callState !== en) {
          if (s._updateCallState(gn), C)
            for (var x in C) {
              if (s._callObjectMode) {
                var F = s._callMachine().store;
                cu(C[x], F), uu(C[x], F), lu(C[x], s._participants[x], F);
              }
              s._participants[x] = ee({}, C[x]), s.toggleParticipantAudioBasedOnNativeAudioFocus();
            }
          f && s.loadCss(s.properties), m(C);
        } else
          S(A);
      };
    }));
  }), function() {
    return E.apply(this, arguments);
  }) }, { key: "leave", value: (N = ue(function* () {
    var s = this;
    return this._testCallInProgress && this.stopTestCallQuality(), new Promise(function(p) {
      s._callState === pn || s._callState === en ? p() : s._callObjectLoader && !s._callObjectLoader.loaded ? (s._callObjectLoader.cancel(), s._updateCallState(pn), s.resetMeetingDependentVars(), s.emitDailyJSEvent({ action: pn }), p()) : (s._resolveLeave = p, s.sendMessageToCallMachine({ action: "leave-meeting" }));
    });
  }), function() {
    return N.apply(this, arguments);
  }) }, { key: "startScreenShare", value: (I = ue(function* () {
    var s = this, p = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (ri(this._callMachineInitialized, "startScreenShare()"), p.screenVideoSendSettings && this._validateVideoSendSettings("screenVideo", p.screenVideoSendSettings), p.mediaStream && (this._sharedTracks.screenMediaStream = p.mediaStream, p.mediaStream = Kt), typeof DailyNativeUtils < "u" && DailyNativeUtils.isIOS !== void 0 && DailyNativeUtils.isIOS) {
      var f = this.nativeUtils();
      if (yield f.isScreenBeingCaptured())
        return void this.emitDailyJSEvent({ action: Gc, type: "screen-share-error", errorMsg: "Could not start the screen sharing. The screen is already been captured!" });
      f.setSystemScreenCaptureStartCallback(function() {
        f.setSystemScreenCaptureStartCallback(null), s.sendMessageToCallMachine({ action: Qc, captureOptions: p });
      }), f.presentSystemScreenCapturePrompt();
    } else
      this.sendMessageToCallMachine({ action: Qc, captureOptions: p });
  }), function() {
    return I.apply(this, arguments);
  }) }, { key: "stopScreenShare", value: function() {
    ri(this._callMachineInitialized, "stopScreenShare()"), this.sendMessageToCallMachine({ action: "local-screen-stop" });
  } }, { key: "startRecording", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, p = s.type;
    if (p && p !== "cloud" && p !== "raw-tracks" && p !== "local")
      throw new Error("invalid type: ".concat(p, ", allowed values 'cloud', 'raw-tracks', or 'local'"));
    this.sendMessageToCallMachine(ee({ action: "local-recording-start" }, s));
  } }, { key: "updateRecording", value: function(s) {
    var p = s.layout, f = p === void 0 ? { preset: "default" } : p, m = s.instanceId;
    this.sendMessageToCallMachine({ action: "daily-method-update-recording", layout: f, instanceId: m });
  } }, { key: "stopRecording", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.sendMessageToCallMachine(ee({ action: "local-recording-stop" }, s));
  } }, { key: "startLiveStreaming", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.sendMessageToCallMachine(ee({ action: "daily-method-start-live-streaming" }, s));
  } }, { key: "updateLiveStreaming", value: function(s) {
    var p = s.layout, f = p === void 0 ? { preset: "default" } : p, m = s.instanceId;
    this.sendMessageToCallMachine({ action: "daily-method-update-live-streaming", layout: f, instanceId: m });
  } }, { key: "addLiveStreamingEndpoints", value: function(s) {
    var p = s.endpoints, f = s.instanceId;
    this.sendMessageToCallMachine({ action: Zc, endpointsOp: bv, endpoints: p, instanceId: f });
  } }, { key: "removeLiveStreamingEndpoints", value: function(s) {
    var p = s.endpoints, f = s.instanceId;
    this.sendMessageToCallMachine({ action: Zc, endpointsOp: Sv, endpoints: p, instanceId: f });
  } }, { key: "stopLiveStreaming", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.sendMessageToCallMachine(ee({ action: "daily-method-stop-live-streaming" }, s));
  } }, { key: "validateDailyConfig", value: function(s) {
    s.camSimulcastEncodings && (console.warn("camSimulcastEncodings is deprecated. Use sendSettings, found in DailyCallOptions, to provide camera simulcast settings."), this.validateSimulcastEncodings(s.camSimulcastEncodings)), s.screenSimulcastEncodings && console.warn("screenSimulcastEncodings is deprecated. Use sendSettings, found in DailyCallOptions, to provide screen simulcast settings."), Vl() && s.noAutoDefaultDeviceChange && console.warn("noAutoDefaultDeviceChange is not supported on Android, and will be ignored.");
  } }, { key: "validateSimulcastEncodings", value: function(s) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, f = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
    if (s) {
      if (!(s instanceof Array || Array.isArray(s)))
        throw new Error("encodings must be an Array");
      if (!Mu(s.length, 1, 3))
        throw new Error("encodings must be an Array with between 1 to ".concat(3, " layers"));
      for (var m = 0; m < s.length; m++) {
        var S = s[m];
        for (var C in this._validateEncodingLayerHasValidProperties(S), S)
          if (qo.includes(C)) {
            if (typeof S[C] != "number")
              throw new Error("".concat(C, " must be a number"));
            if (p) {
              var A = p[C], x = A.min, F = A.max;
              if (!Mu(S[C], x, F))
                throw new Error("".concat(C, " value not in range. valid range: ").concat(x, " to ").concat(F));
            }
          } else if (!["active", "scalabilityMode"].includes(C))
            throw new Error("Invalid key ".concat(C, ", valid keys are:") + Object.values(qo));
        if (f && !S.hasOwnProperty("maxBitrate"))
          throw new Error("maxBitrate is not specified");
      }
    }
  } }, { key: "startRemoteMediaPlayer", value: (O = ue(function* (s) {
    var p = this, f = s.url, m = s.settings, S = m === void 0 ? { state: Ta.PLAY } : m;
    try {
      (function(C) {
        if (typeof C != "string")
          throw new Error('url parameter must be "string" type');
      })(f), Cu(S), function(C) {
        for (var A in C)
          if (!ku.includes(A))
            throw new Error("Invalid key ".concat(A, ", valid keys are: ").concat(ku));
        C.simulcastEncodings && this.validateSimulcastEncodings(C.simulcastEncodings, Kl, !0);
      }(S);
    } catch (C) {
      throw console.error("invalid argument Error: ".concat(C)), console.error(`startRemoteMediaPlayer arguments must be of the form:
  { url: "playback url",
  settings?:
  {state: "play"|"pause", simulcastEncodings?: [{}] } }`), C;
    }
    return new Promise(function(C, A) {
      p.sendMessageToCallMachine({ action: "daily-method-start-remote-media-player", url: f, settings: S }, function(x) {
        x.error ? A({ error: x.error, errorMsg: x.errorMsg }) : C({ session_id: x.session_id, remoteMediaPlayerState: { state: x.state, settings: x.settings } });
      });
    });
  }), function(s) {
    return O.apply(this, arguments);
  }) }, { key: "stopRemoteMediaPlayer", value: (k = ue(function* (s) {
    var p = this;
    if (typeof s != "string")
      throw new Error(" remotePlayerID must be of type string");
    return new Promise(function(f, m) {
      p.sendMessageToCallMachine({ action: "daily-method-stop-remote-media-player", session_id: s }, function(S) {
        S.error ? m({ error: S.error, errorMsg: S.errorMsg }) : f();
      });
    });
  }), function(s) {
    return k.apply(this, arguments);
  }) }, { key: "updateRemoteMediaPlayer", value: (w = ue(function* (s) {
    var p = this, f = s.session_id, m = s.settings;
    try {
      Cu(m);
    } catch (S) {
      throw console.error("invalid argument Error: ".concat(S)), console.error(`updateRemoteMediaPlayer arguments must be of the form:
  session_id: "participant session",
  { settings?: {state: "play"|"pause"} }`), S;
    }
    return new Promise(function(S, C) {
      p.sendMessageToCallMachine({ action: "daily-method-update-remote-media-player", session_id: f, settings: m }, function(A) {
        A.error ? C({ error: A.error, errorMsg: A.errorMsg }) : S({ session_id: A.session_id, remoteMediaPlayerState: { state: A.state, settings: A.settings } });
      });
    });
  }), function(s) {
    return w.apply(this, arguments);
  }) }, { key: "startTranscription", value: function(s) {
    Ie(this._callState, "startTranscription()"), this.sendMessageToCallMachine(ee({ action: "daily-method-start-transcription" }, s));
  } }, { key: "updateTranscription", value: function(s) {
    if (Ie(this._callState, "updateTranscription()"), !s)
      throw new Error("updateTranscription Error: options is mandatory");
    if (Te(s) !== "object")
      throw new Error("updateTranscription Error: options must be object type");
    if (s.participants && !Array.isArray(s.participants))
      throw new Error("updateTranscription Error: participants must be an array");
    this.sendMessageToCallMachine(ee({ action: "daily-method-update-transcription" }, s));
  } }, { key: "stopTranscription", value: function(s) {
    if (Ie(this._callState, "stopTranscription()"), s && Te(s) !== "object")
      throw new Error("stopTranscription Error: options must be object type");
    if (s && !s.instanceId)
      throw new Error('"instanceId" not provided');
    this.sendMessageToCallMachine(ee({ action: "daily-method-stop-transcription" }, s));
  } }, { key: "startDialOut", value: (_ = ue(function* (s) {
    var p = this;
    Ie(this._callState, "startDialOut()");
    var f = function(A) {
      if (A) {
        if (!Array.isArray(A))
          throw new Error("Error starting dial out: audio codec must be an array");
        if (A.length <= 0)
          throw new Error("Error starting dial out: audio codec array specified but empty");
        A.forEach(function(x) {
          if (typeof x != "string")
            throw new Error("Error starting dial out: audio codec must be a string");
          if (x !== "OPUS" && x !== "PCMU" && x !== "PCMA" && x !== "G722")
            throw new Error("Error starting dial out: audio codec must be one of OPUS, PCMU, PCMA, G722");
        });
      }
    };
    if (!s.sipUri && !s.phoneNumber)
      throw new Error("Error starting dial out: either a sip uri or phone number must be provided");
    if (s.sipUri && s.phoneNumber)
      throw new Error("Error starting dial out: only one of sip uri or phone number must be provided");
    if (s.sipUri) {
      if (typeof s.sipUri != "string")
        throw new Error("Error starting dial out: sipUri must be a string");
      if (!s.sipUri.startsWith("sip:"))
        throw new Error("Error starting dial out: Invalid SIP URI, must start with 'sip:'");
      if (s.video && typeof s.video != "boolean")
        throw new Error("Error starting dial out: video must be a boolean value");
      (function(A) {
        if (A && (f(A.audio), A.video)) {
          if (!Array.isArray(A.video))
            throw new Error("Error starting dial out: video codec must be an array");
          if (A.video.length <= 0)
            throw new Error("Error starting dial out: video codec array specified but empty");
          A.video.forEach(function(x) {
            if (typeof x != "string")
              throw new Error("Error starting dial out: video codec must be a string");
            if (x !== "H264" && x !== "VP8")
              throw new Error("Error starting dial out: video codec must be H264 or VP8");
          });
        }
      })(s.codecs);
    }
    if (s.phoneNumber) {
      if (typeof s.phoneNumber != "string")
        throw new Error("Error starting dial out: phoneNumber must be a string");
      if (!/^\+\d{1,}$/.test(s.phoneNumber))
        throw new Error("Error starting dial out: Invalid phone number, must be valid phone number as per E.164");
      s.codecs && f(s.codecs.audio);
    }
    if (s.callerId) {
      if (typeof s.callerId != "string")
        throw new Error("Error starting dial out: callerId must be a string");
      if (s.sipUri)
        throw new Error("Error starting dial out: callerId not allowed with sipUri");
    }
    if (s.displayName) {
      if (typeof s.displayName != "string")
        throw new Error("Error starting dial out: displayName must be a string");
      if (s.displayName.length >= 200)
        throw new Error("Error starting dial out: displayName length must be less than 200");
    }
    if (s.userId) {
      if (typeof s.userId != "string")
        throw new Error("Error starting dial out: userId must be a string");
      if (s.userId.length > 36)
        throw new Error("Error starting dial out: userId length must be less than or equal to 36");
    }
    if (s.permissions && s.permissions.canReceive) {
      var m = rt(Hl.validateJSONObject(s.permissions.canReceive), 2), S = m[0], C = m[1];
      if (!S)
        throw new Error(C);
    }
    return new Promise(function(A, x) {
      p.sendMessageToCallMachine(ee({ action: "dialout-start" }, s), function(F) {
        F.error ? x(F.error) : A(F);
      });
    });
  }), function(s) {
    return _.apply(this, arguments);
  }) }, { key: "stopDialOut", value: function(s) {
    var p = this;
    return Ie(this._callState, "stopDialOut()"), new Promise(function(f, m) {
      p.sendMessageToCallMachine(ee({ action: "dialout-stop" }, s), function(S) {
        S.error ? m(S.error) : f(S);
      });
    });
  } }, { key: "sipCallTransfer", value: (v = ue(function* (s) {
    var p = this;
    if (Ie(this._callState, "sipCallTransfer()"), !s)
      throw new Error("sipCallTransfer() requires a sessionId and toEndPoint");
    return s.useSipRefer = !1, Ru(s, "sipCallTransfer"), new Promise(function(f, m) {
      p.sendMessageToCallMachine(ee({ action: Xc }, s), function(S) {
        S.error ? m(S.error) : f(S);
      });
    });
  }), function(s) {
    return v.apply(this, arguments);
  }) }, { key: "sipRefer", value: (y = ue(function* (s) {
    var p = this;
    if (Ie(this._callState, "sipRefer()"), !s)
      throw new Error("sessionId and toEndPoint are mandatory parameter");
    return s.useSipRefer = !0, Ru(s, "sipRefer"), new Promise(function(f, m) {
      p.sendMessageToCallMachine(ee({ action: Xc }, s), function(S) {
        S.error ? m(S.error) : f(S);
      });
    });
  }), function(s) {
    return y.apply(this, arguments);
  }) }, { key: "sendDTMF", value: (b = ue(function* (s) {
    var p = this;
    return Ie(this._callState, "sendDTMF()"), function(f) {
      var m = f.sessionId, S = f.tones;
      if (!m || !S)
        throw new Error("sessionId and tones are mandatory parameter");
      if (typeof m != "string" || typeof S != "string")
        throw new Error("sessionId and tones should be of string type");
      if (S.length > 20)
        throw new Error("tones string must be upto 20 characters");
      var C = /[^0-9A-D*#]/g, A = S.match(C);
      if (A && A[0])
        throw new Error("".concat(A[0], " is not valid DTMF tone"));
    }(s), new Promise(function(f, m) {
      p.sendMessageToCallMachine(ee({ action: "send-dtmf" }, s), function(S) {
        S.error ? m(S.error) : f(S);
      });
    });
  }), function(s) {
    return b.apply(this, arguments);
  }) }, { key: "getNetworkStats", value: function() {
    var s = this;
    return this._callState !== gn ? Promise.resolve(ee({ stats: { latest: {} } }, this._network)) : new Promise(function(p) {
      s.sendMessageToCallMachine({ action: "get-calc-stats" }, function(f) {
        p(ee(ee({}, s._network), {}, { stats: f.stats }));
      });
    });
  } }, { key: "testWebsocketConnectivity", value: (g = ue(function* () {
    var s = this;
    if (Ho(this._testCallInProgress, "testWebsocketConnectivity()"), this.needsLoad())
      try {
        yield this.load();
      } catch (p) {
        return Promise.reject(p);
      }
    return new Promise(function(p, f) {
      s.sendMessageToCallMachine({ action: "test-websocket-connectivity" }, function(m) {
        m.error ? f(m.error) : p(m.results);
      });
    });
  }), function() {
    return g.apply(this, arguments);
  }) }, { key: "abortTestWebsocketConnectivity", value: function() {
    this.sendMessageToCallMachine({ action: "abort-test-websocket-connectivity" });
  } }, { key: "_validateVideoTrackForNetworkTests", value: function(s) {
    return s ? s instanceof MediaStreamTrack ? !!zv(s, { isLocalScreenVideo: !1 }) || (console.error("Video track is not playable. This test needs a live video track."), !1) : (console.error("Video track needs to be of type `MediaStreamTrack`."), !1) : (console.error("Missing video track. You must provide a video track in order to run this test."), !1);
  } }, { key: "testCallQuality", value: (h = ue(function* () {
    var s = this;
    Se(), Mt(this._callObjectMode, "testCallQuality()"), ri(this._callMachineInitialized, "testCallQuality()", null, !0), Jo(this._callState, this._isPreparingToJoin, "testCallQuality()");
    var p = this._testCallAlreadyInProgress, f = function(S) {
      p || (s._testCallInProgress = S);
    };
    if (f(!0), this.needsLoad())
      try {
        var m = this._callState;
        yield this.load(), this._callState = m;
      } catch (S) {
        return f(!1), Promise.reject(S);
      }
    return new Promise(function(S) {
      s.sendMessageToCallMachine({ action: "test-call-quality", dailyJsVersion: s.properties.dailyJsVersion }, function(C) {
        var A = C.results, x = A.result, F = xs(A, Jv);
        if (x === "failed") {
          var W, H = ee({}, F);
          (W = F.error) !== null && W !== void 0 && W.details ? (F.error.details = JSON.parse(F.error.details), H.error = ee(ee({}, H.error), {}, { details: ee({}, H.error.details) }), H.error.details.duringTest = "testCallQuality") : (H.error = H.error ? ee({}, H.error) : {}, H.error.details = { duringTest: "testCallQuality" }), s._maybeSendToSentry(H);
        }
        f(!1), S(ee({ result: x }, F));
      });
    });
  }), function() {
    return h.apply(this, arguments);
  }) }, { key: "stopTestCallQuality", value: function() {
    this.sendMessageToCallMachine({ action: "stop-test-call-quality" });
  } }, { key: "testConnectionQuality", value: (d = ue(function* (s) {
    var p;
    we() ? (console.warn("testConnectionQuality() is deprecated: use testPeerToPeerCallQuality() instead"), p = yield this.testPeerToPeerCallQuality(s)) : (console.warn("testConnectionQuality() is deprecated: use testCallQuality() instead"), p = yield this.testCallQuality());
    var f = { result: p.result, secondsElapsed: p.secondsElapsed };
    return p.data && (f.data = { maxRTT: p.data.maxRoundTripTime, packetLoss: p.data.avgRecvPacketLoss }), f;
  }), function(s) {
    return d.apply(this, arguments);
  }) }, { key: "testPeerToPeerCallQuality", value: (l = ue(function* (s) {
    var p = this;
    if (Ho(this._testCallInProgress, "testPeerToPeerCallQuality()"), this.needsLoad())
      try {
        yield this.load();
      } catch (S) {
        return Promise.reject(S);
      }
    var f = s.videoTrack, m = s.duration;
    if (!this._validateVideoTrackForNetworkTests(f))
      throw new Error("Video track error");
    return this._sharedTracks.videoTrackForConnectionQualityTest = f, new Promise(function(S, C) {
      p.sendMessageToCallMachine({ action: "test-p2p-call-quality", duration: m }, function(A) {
        A.error ? C(A.error) : S(A.results);
      });
    });
  }), function(s) {
    return l.apply(this, arguments);
  }) }, { key: "stopTestConnectionQuality", value: function() {
    we() ? (console.warn("stopTestConnectionQuality() is deprecated: use testPeerToPeerCallQuality() and stopTestPeerToPeerCallQuality() instead"), this.stopTestPeerToPeerCallQuality()) : (console.warn("stopTestConnectionQuality() is deprecated: use testCallQuality() and stopTestCallQuality() instead"), this.stopTestCallQuality());
  } }, { key: "stopTestPeerToPeerCallQuality", value: function() {
    this.sendMessageToCallMachine({ action: "stop-test-p2p-call-quality" });
  } }, { key: "testNetworkConnectivity", value: (c = ue(function* (s) {
    var p = this;
    if (Ho(this._testCallInProgress, "testNetworkConnectivity()"), this.needsLoad())
      try {
        yield this.load();
      } catch (f) {
        return Promise.reject(f);
      }
    if (!this._validateVideoTrackForNetworkTests(s))
      throw new Error("Video track error");
    return this._sharedTracks.videoTrackForNetworkConnectivityTest = s, new Promise(function(f, m) {
      p.sendMessageToCallMachine({ action: "test-network-connectivity" }, function(S) {
        S.error ? m(S.error) : f(S.results);
      });
    });
  }), function(s) {
    return c.apply(this, arguments);
  }) }, { key: "abortTestNetworkConnectivity", value: function() {
    this.sendMessageToCallMachine({ action: "abort-test-network-connectivity" });
  } }, { key: "getCpuLoadStats", value: function() {
    var s = this;
    return new Promise(function(p) {
      s._callState === gn ? s.sendMessageToCallMachine({ action: "get-cpu-load-stats" }, function(f) {
        p(f.cpuStats);
      }) : p({ cpuLoadState: void 0, cpuLoadStateReason: void 0, stats: {} });
    });
  } }, { key: "_validateEncodingLayerHasValidProperties", value: function(s) {
    var p;
    if (!(((p = Object.keys(s)) === null || p === void 0 ? void 0 : p.length) > 0))
      throw new Error("Empty encoding is not allowed. At least one of these valid keys should be specified:" + Object.values(qo));
  } }, { key: "_validateVideoSendSettings", value: function(s, p) {
    var f = s === "screenVideo" ? ["default-screen-video", "detail-optimized", "motion-optimized", "motion-and-detail-balanced"] : ["default-video", "bandwidth-optimized", "bandwidth-and-quality-balanced", "quality-optimized", "adaptive-2-layers", "adaptive-3-layers"], m = "Video send settings should be either an object or one of the supported presets: ".concat(f.join());
    if (typeof p == "string") {
      if (!f.includes(p))
        throw new Error(m);
    } else {
      if (Te(p) !== "object")
        throw new Error(m);
      if (!p.maxQuality && !p.encodings && p.allowAdaptiveLayers === void 0)
        throw new Error("Video send settings must contain at least maxQuality, allowAdaptiveLayers or encodings attribute");
      if (p.maxQuality && ["low", "medium", "high"].indexOf(p.maxQuality) === -1)
        throw new Error("maxQuality must be either low, medium or high");
      if (p.encodings) {
        var S = !1;
        switch (Object.keys(p.encodings).length) {
          case 1:
            S = !p.encodings.low;
            break;
          case 2:
            S = !p.encodings.low || !p.encodings.medium;
            break;
          case 3:
            S = !p.encodings.low || !p.encodings.medium || !p.encodings.high;
            break;
          default:
            S = !0;
        }
        if (S)
          throw new Error("Encodings must be defined as: low, low and medium, or low, medium and high.");
        p.encodings.low && this._validateEncodingLayerHasValidProperties(p.encodings.low), p.encodings.medium && this._validateEncodingLayerHasValidProperties(p.encodings.medium), p.encodings.high && this._validateEncodingLayerHasValidProperties(p.encodings.high);
      }
    }
  } }, { key: "validateUpdateSendSettings", value: function(s) {
    var p = this;
    if (!s || Object.keys(s).length === 0)
      throw new Error("Send settings must contain at least information for one track!");
    Object.entries(s).forEach(function(f) {
      var m = rt(f, 2), S = m[0], C = m[1];
      p._validateVideoSendSettings(S, C);
    });
  } }, { key: "updateSendSettings", value: function(s) {
    var p = this;
    return this.validateUpdateSendSettings(s), this.needsLoad() ? (this._preloadCache.sendSettings = s, { sendSettings: this._preloadCache.sendSettings }) : new Promise(function(f, m) {
      p.sendMessageToCallMachine({ action: "update-send-settings", sendSettings: s }, function(S) {
        S.error ? m(S.error) : f(S.sendSettings);
      });
    });
  } }, { key: "getSendSettings", value: function() {
    return this._sendSettings || this._preloadCache.sendSettings;
  } }, { key: "getLocalAudioLevel", value: function() {
    return this._localAudioLevel;
  } }, { key: "getRemoteParticipantsAudioLevel", value: function() {
    return this._remoteParticipantsAudioLevel;
  } }, { key: "getActiveSpeaker", value: function() {
    return Se(), this._activeSpeaker;
  } }, { key: "setActiveSpeakerMode", value: function(s) {
    return Se(), this.sendMessageToCallMachine({ action: "set-active-speaker-mode", enabled: s }), this;
  } }, { key: "activeSpeakerMode", value: function() {
    return Se(), this._activeSpeakerMode;
  } }, { key: "subscribeToTracksAutomatically", value: function() {
    return this._preloadCache.subscribeToTracksAutomatically;
  } }, { key: "setSubscribeToTracksAutomatically", value: function(s) {
    return Ie(this._callState, "setSubscribeToTracksAutomatically()", "Use the subscribeToTracksAutomatically configuration property."), this._preloadCache.subscribeToTracksAutomatically = s, this.sendMessageToCallMachine({ action: "daily-method-subscribe-to-tracks-automatically", enabled: s }), this;
  } }, { key: "enumerateDevices", value: (u = ue(function* () {
    var s = this;
    if (this._callObjectMode) {
      var p = yield navigator.mediaDevices.enumerateDevices();
      return cn() === "Firefox" && Ai().major > 115 && Ai().major < 123 && (p = p.filter(function(f) {
        return f.kind !== "audiooutput";
      })), { devices: p.map(function(f) {
        var m = JSON.parse(JSON.stringify(f));
        if (!we() && f.kind === "videoinput" && f.getCapabilities) {
          var S, C = f.getCapabilities();
          m.facing = (C == null || (S = C.facingMode) === null || S === void 0 ? void 0 : S.length) >= 1 ? C.facingMode[0] : void 0;
        }
        return m;
      }) };
    }
    return new Promise(function(f) {
      s.sendMessageToCallMachine({ action: "enumerate-devices" }, function(m) {
        f({ devices: m.devices });
      });
    });
  }), function() {
    return u.apply(this, arguments);
  }) }, { key: "sendAppMessage", value: function(s) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "*";
    if (Ie(this._callState, "sendAppMessage()"), JSON.stringify(s).length > this._maxAppMessageSize)
      throw new Error("Message data too large. Max size is " + this._maxAppMessageSize);
    return this.sendMessageToCallMachine({ action: "app-msg", data: s, to: p }), this;
  } }, { key: "addFakeParticipant", value: function(s) {
    return Se(), Ie(this._callState, "addFakeParticipant()"), this.sendMessageToCallMachine(ee({ action: "add-fake-participant" }, s)), this;
  } }, { key: "setShowNamesMode", value: function(s) {
    return vt(this._callObjectMode, "setShowNamesMode()"), Se(), s && s !== "always" && s !== "never" ? (console.error('setShowNamesMode argument should be "always", "never", or false'), this) : (this.sendMessageToCallMachine({ action: "set-show-names", mode: s }), this);
  } }, { key: "setShowLocalVideo", value: function() {
    var s = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return vt(this._callObjectMode, "setShowLocalVideo()"), Se(), Ie(this._callState, "setShowLocalVideo()"), typeof s != "boolean" ? (console.error("setShowLocalVideo only accepts a boolean value"), this) : (this.sendMessageToCallMachine({ action: "set-show-local-video", show: s }), this._showLocalVideo = s, this);
  } }, { key: "showLocalVideo", value: function() {
    return vt(this._callObjectMode, "showLocalVideo()"), Se(), this._showLocalVideo;
  } }, { key: "setShowParticipantsBar", value: function() {
    var s = !(arguments.length > 0 && arguments[0] !== void 0) || arguments[0];
    return vt(this._callObjectMode, "setShowParticipantsBar()"), Se(), Ie(this._callState, "setShowParticipantsBar()"), typeof s != "boolean" ? (console.error("setShowParticipantsBar only accepts a boolean value"), this) : (this.sendMessageToCallMachine({ action: "set-show-participants-bar", show: s }), this._showParticipantsBar = s, this);
  } }, { key: "showParticipantsBar", value: function() {
    return vt(this._callObjectMode, "showParticipantsBar()"), Se(), this._showParticipantsBar;
  } }, { key: "customIntegrations", value: function() {
    return Se(), vt(this._callObjectMode, "customIntegrations()"), this._customIntegrations;
  } }, { key: "setCustomIntegrations", value: function(s) {
    return Se(), vt(this._callObjectMode, "setCustomIntegrations()"), Ie(this._callState, "setCustomIntegrations()"), rd(s) ? (this.sendMessageToCallMachine({ action: "set-custom-integrations", integrations: s }), this._customIntegrations = s, this) : this;
  } }, { key: "startCustomIntegrations", value: function(s) {
    var p = this;
    if (Se(), vt(this._callObjectMode, "startCustomIntegrations()"), Ie(this._callState, "startCustomIntegrations()"), Array.isArray(s) && s.some(function(S) {
      return typeof S != "string";
    }) || !Array.isArray(s) && typeof s != "string")
      return console.error("startCustomIntegrations() only accepts string | string[]"), this;
    var f = typeof s == "string" ? [s] : s, m = f.filter(function(S) {
      return !(S in p._customIntegrations);
    });
    return m.length ? (console.error(`Can't find custom integration(s): "`.concat(m.join(", "), '"')), this) : (this.sendMessageToCallMachine({ action: "start-custom-integrations", ids: f }), this);
  } }, { key: "stopCustomIntegrations", value: function(s) {
    var p = this;
    if (Se(), vt(this._callObjectMode, "stopCustomIntegrations()"), Ie(this._callState, "stopCustomIntegrations()"), Array.isArray(s) && s.some(function(S) {
      return typeof S != "string";
    }) || !Array.isArray(s) && typeof s != "string")
      return console.error("stopCustomIntegrations() only accepts string | string[]"), this;
    var f = typeof s == "string" ? [s] : s, m = f.filter(function(S) {
      return !(S in p._customIntegrations);
    });
    return m.length ? (console.error(`Can't find custom integration(s): "`.concat(m.join(", "), '"')), this) : (this.sendMessageToCallMachine({ action: "stop-custom-integrations", ids: f }), this);
  } }, { key: "customTrayButtons", value: function() {
    return vt(this._callObjectMode, "customTrayButtons()"), Se(), this._customTrayButtons;
  } }, { key: "updateCustomTrayButtons", value: function(s) {
    return vt(this._callObjectMode, "updateCustomTrayButtons()"), Se(), Ie(this._callState, "updateCustomTrayButtons()"), nd(s) ? (this.sendMessageToCallMachine({ action: "update-custom-tray-buttons", btns: s }), this._customTrayButtons = s, this) : (console.error("updateCustomTrayButtons only accepts a dictionary of the type ".concat(JSON.stringify(Oi))), this);
  } }, { key: "theme", value: function() {
    return vt(this._callObjectMode, "theme()"), this.properties.theme;
  } }, { key: "setTheme", value: function(s) {
    var p = this;
    return vt(this._callObjectMode, "setTheme()"), new Promise(function(f, m) {
      try {
        p.validateProperties({ theme: s }), p.properties.theme = ee({}, s), p.sendMessageToCallMachine({ action: "set-theme", theme: p.properties.theme });
        try {
          p.emitDailyJSEvent({ action: Ch, theme: p.properties.theme });
        } catch (S) {
          console.log("could not emit 'theme-updated'", S);
        }
        f(p.properties.theme);
      } catch (S) {
        m(S);
      }
    });
  } }, { key: "requestFullscreen", value: (a = ue(function* () {
    if (Se(), this._iframe && !document.fullscreenElement && eu())
      try {
        (yield this._iframe.requestFullscreen) ? this._iframe.requestFullscreen() : this._iframe.webkitRequestFullscreen();
      } catch (s) {
        console.log("could not make video call fullscreen", s);
      }
  }), function() {
    return a.apply(this, arguments);
  }) }, { key: "exitFullscreen", value: function() {
    Se(), document.fullscreenElement ? document.exitFullscreen() : document.webkitFullscreenElement && document.webkitExitFullscreen();
  } }, { key: "getSidebarView", value: (o = ue(function* () {
    var s = this;
    return this._callObjectMode ? (console.error("getSidebarView is not available in callObject mode"), Promise.resolve(null)) : new Promise(function(p) {
      s.sendMessageToCallMachine({ action: "get-sidebar-view" }, function(f) {
        p(f.view);
      });
    });
  }), function() {
    return o.apply(this, arguments);
  }) }, { key: "setSidebarView", value: function(s) {
    return this._callObjectMode ? (console.error("setSidebarView is not available in callObject mode"), this) : (this.sendMessageToCallMachine({ action: "set-sidebar-view", view: s }), this);
  } }, { key: "room", value: (i = ue(function* () {
    var s = this, p = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).includeRoomConfigDefaults, f = p === void 0 || p;
    return this._accessState.access === $o || this.needsLoad() ? this.properties.url ? { roomUrlPendingJoin: this.properties.url } : null : new Promise(function(m) {
      s.sendMessageToCallMachine({ action: "lib-room-info", includeRoomConfigDefaults: f }, function(S) {
        delete S.action, delete S.callbackStamp, m(S);
      });
    });
  }), function() {
    return i.apply(this, arguments);
  }) }, { key: "geo", value: (r = ue(function* () {
    try {
      var s = yield fetch("https://gs.daily.co/_ks_/x-swsl/:");
      return { current: (yield s.json()).geo };
    } catch (p) {
      return console.error("geo lookup failed", p), { current: "" };
    }
  }), function() {
    return r.apply(this, arguments);
  }) }, { key: "setNetworkTopology", value: (n = ue(function* (s) {
    var p = this;
    return Se(), Ie(this._callState, "setNetworkTopology()"), new Promise(function(f, m) {
      p.sendMessageToCallMachine({ action: "set-network-topology", opts: s }, function(S) {
        S.error ? m({ error: S.error }) : f({ workerId: S.workerId });
      });
    });
  }), function(s) {
    return n.apply(this, arguments);
  }) }, { key: "getNetworkTopology", value: (t = ue(function* () {
    var s = this;
    return new Promise(function(p, f) {
      s.needsLoad() && p({ topology: "none" }), s.sendMessageToCallMachine({ action: "get-network-topology" }, function(m) {
        m.error ? f({ error: m.error }) : p({ topology: m.topology });
      });
    });
  }), function() {
    return t.apply(this, arguments);
  }) }, { key: "setPlayNewParticipantSound", value: function(s) {
    if (Se(), typeof s != "number" && s !== !0 && s !== !1)
      throw new Error("argument to setShouldPlayNewParticipantSound should be true, false, or a number, but is ".concat(s));
    this.sendMessageToCallMachine({ action: "daily-method-set-play-ding", arg: s });
  } }, { key: "on", value: function(s, p) {
    return Wr.prototype.on.call(this, s, p);
  } }, { key: "once", value: function(s, p) {
    return Wr.prototype.once.call(this, s, p);
  } }, { key: "off", value: function(s, p) {
    return Wr.prototype.off.call(this, s, p);
  } }, { key: "validateProperties", value: function(s) {
    var p, f;
    if (s != null && (p = s.dailyConfig) !== null && p !== void 0 && p.userMediaAudioConstraints) {
      var m, S;
      we() || console.warn("userMediaAudioConstraints is deprecated. You can override constraints with inputSettings.audio.settings, found in DailyCallOptions.");
      var C = s.inputSettings || {};
      C.audio = ((m = s.inputSettings) === null || m === void 0 ? void 0 : m.audio) || {}, C.audio.settings = ((S = s.inputSettings) === null || S === void 0 || (S = S.audio) === null || S === void 0 ? void 0 : S.settings) || {}, C.audio.settings = ee(ee({}, C.audio.settings), s.dailyConfig.userMediaAudioConstraints), s.inputSettings = C, delete s.dailyConfig.userMediaAudioConstraints;
    }
    if (s != null && (f = s.dailyConfig) !== null && f !== void 0 && f.userMediaVideoConstraints) {
      var A, x;
      we() || console.warn("userMediaVideoConstraints is deprecated. You can override constraints with inputSettings.video.settings, found in DailyCallOptions.");
      var F = s.inputSettings || {};
      F.video = ((A = s.inputSettings) === null || A === void 0 ? void 0 : A.video) || {}, F.video.settings = ((x = s.inputSettings) === null || x === void 0 || (x = x.video) === null || x === void 0 ? void 0 : x.settings) || {}, F.video.settings = ee(ee({}, F.video.settings), s.dailyConfig.userMediaVideoConstraints), s.inputSettings = F, delete s.dailyConfig.userMediaVideoConstraints;
    }
    for (var W in s) {
      if (!vn[W])
        throw new Error("unrecognized property '".concat(W, "'"));
      if (vn[W].validate && !vn[W].validate(s[W], this))
        throw new Error("property '".concat(W, "': ").concat(vn[W].help));
    }
  } }, { key: "assembleMeetingUrl", value: function() {
    var s, p, f = ee(ee({}, this.properties), {}, { emb: this.callClientId, embHref: encodeURIComponent(window.location.href), proxy: (s = this.properties.dailyConfig) !== null && s !== void 0 && s.proxyUrl ? encodeURIComponent((p = this.properties.dailyConfig) === null || p === void 0 ? void 0 : p.proxyUrl) : void 0 }), m = f.url.match(/\?/) ? "&" : "?";
    return f.url + m + Object.keys(vn).filter(function(S) {
      return vn[S].queryString && f[S] !== void 0;
    }).map(function(S) {
      return "".concat(vn[S].queryString, "=").concat(f[S]);
    }).join("&");
  } }, { key: "needsLoad", value: function() {
    return [Bc, Fc, pn, en].includes(this._callState);
  } }, { key: "sendMessageToCallMachine", value: function(s, p) {
    if (this._destroyed && (this._logUseAfterDestroy(), this.strictMode))
      throw new Error("Use after destroy");
    this._messageChannel.sendMessageToCallMachine(s, p, this.callClientId, this._iframe);
  } }, { key: "forwardPackagedMessageToCallMachine", value: function(s) {
    this._messageChannel.forwardPackagedMessageToCallMachine(s, this._iframe, this.callClientId);
  } }, { key: "addListenerForPackagedMessagesFromCallMachine", value: function(s) {
    return this._messageChannel.addListenerForPackagedMessagesFromCallMachine(s, this.callClientId);
  } }, { key: "removeListenerForPackagedMessagesFromCallMachine", value: function(s) {
    this._messageChannel.removeListenerForPackagedMessagesFromCallMachine(s);
  } }, { key: "handleMessageFromCallMachine", value: function(s) {
    switch (s.action) {
      case Th:
        this.sendMessageToCallMachine(ee({ action: Rh }, this.properties));
        break;
      case "call-machine-initialized":
        this._callMachineInitialized = !0;
        var p = { action: ei, level: "log", code: 1011, stats: { event: "bundle load", time: this._bundleLoadTime === "no-op" ? 0 : this._bundleLoadTime, preLoaded: this._bundleLoadTime === "no-op", url: ki(this.properties.dailyConfig) } };
        this.sendMessageToCallMachine(p), this._delayDuplicateInstanceLog && this._logDuplicateInstanceAttempt();
        break;
      case Wc:
        this._loadedCallback && (this._loadedCallback(), this._loadedCallback = null), this.emitDailyJSEvent(s);
        break;
      case Lh:
        var f, m = ee({}, s);
        delete m.internal, this._maxAppMessageSize = ((f = s.internal) === null || f === void 0 ? void 0 : f._maxAppMessageSize) || Bo, this._joinedCallback && (this._joinedCallback(s.participants), this._joinedCallback = null), this.emitDailyJSEvent(m);
        break;
      case xh:
      case jh:
        if (this._callState === pn)
          return;
        if (s.participant && s.participant.session_id) {
          var S = s.participant.local ? "local" : s.participant.session_id;
          if (this._callObjectMode) {
            var C = this._callMachine().store;
            cu(s.participant, C), uu(s.participant, C), lu(s.participant, this._participants[S], C);
          }
          try {
            this.maybeParticipantTracksStopped(this._participants[S], s.participant), this.maybeParticipantTracksStarted(this._participants[S], s.participant), this.maybeEventRecordingStopped(this._participants[S], s.participant), this.maybeEventRecordingStarted(this._participants[S], s.participant);
          } catch (Dt) {
            console.error("track events error", Dt);
          }
          this.compareEqualForParticipantUpdateEvent(s.participant, this._participants[S]) || (this._participants[S] = ee({}, s.participant), this.toggleParticipantAudioBasedOnNativeAudioFocus(), this.emitDailyJSEvent(s));
        }
        break;
      case Dh:
        if (s.participant && s.participant.session_id) {
          var A = this._participants[s.participant.session_id];
          A && this.maybeParticipantTracksStopped(A, null), delete this._participants[s.participant.session_id], this.emitDailyJSEvent(s);
        }
        break;
      case Vh:
        at(this._participantCounts, s.participantCounts) || (this._participantCounts = s.participantCounts, this.emitDailyJSEvent(s));
        break;
      case $h:
        var x = { access: s.access };
        s.awaitingAccess && (x.awaitingAccess = s.awaitingAccess), at(this._accessState, x) || (this._accessState = x, this.emitDailyJSEvent(s));
        break;
      case Bh:
        if (s.meetingSession) {
          this._meetingSessionSummary = s.meetingSession, this.emitDailyJSEvent(s);
          var F = ee(ee({}, s), {}, { action: "meeting-session-updated" });
          this.emitDailyJSEvent(F);
        }
        break;
      case Kc:
        var W;
        this._iframe && !s.preserveIframe && (this._iframe.src = ""), this._updateCallState(en), this.resetMeetingDependentVars(), this._loadedCallback && (this._loadedCallback(s.errorMsg), this._loadedCallback = null), s.preserveIframe;
        var H = xs(s, Hv);
        H != null && (W = H.error) !== null && W !== void 0 && W.details && (H.error.details = JSON.parse(H.error.details)), this._maybeSendToSentry(s), this._joinedCallback && (this._joinedCallback(null, H), this._joinedCallback = null), this.emitDailyJSEvent(H);
        break;
      case Ih:
        this._callState !== en && this._updateCallState(pn), this.resetMeetingDependentVars(), this._resolveLeave && (this._resolveLeave(), this._resolveLeave = null), this.emitDailyJSEvent(s);
        break;
      case "selected-devices-updated":
        s.devices && this.emitDailyJSEvent(s);
        break;
      case lv:
        var ve = s.state, Ee = s.threshold, me = s.quality, oe = ve.state, Ne = ve.reasons;
        oe === this._network.networkState && at(Ne, this._network.networkStateReasons) && Ee === this._network.threshold && me === this._network.quality || (this._network.networkState = oe, this._network.networkStateReasons = Ne, this._network.quality = me, this._network.threshold = Ee, s.networkState = oe, Ne.length && (s.networkStateReasons = Ne), delete s.state, this.emitDailyJSEvent(s));
        break;
      case fv:
        s && s.cpuLoadState && this.emitDailyJSEvent(s);
        break;
      case pv:
        s && s.faceCounts !== void 0 && this.emitDailyJSEvent(s);
        break;
      case cv:
        var tt = s.activeSpeaker;
        this._activeSpeaker.peerId !== tt.peerId && (this._activeSpeaker.peerId = tt.peerId, this.emitDailyJSEvent({ action: s.action, activeSpeaker: this._activeSpeaker }));
        break;
      case "show-local-video-changed":
        if (this._callObjectMode)
          return;
        var Ue = s.show;
        this._showLocalVideo = Ue, this.emitDailyJSEvent({ action: s.action, show: Ue });
        break;
      case uv:
        var he = s.enabled;
        this._activeSpeakerMode !== he && (this._activeSpeakerMode = he, this.emitDailyJSEvent({ action: s.action, enabled: this._activeSpeakerMode }));
        break;
      case Uh:
      case zh:
      case Wh:
        this._waitingParticipants = s.allWaitingParticipants, this.emitDailyJSEvent({ action: s.action, participant: s.participant });
        break;
      case _v:
        at(this._receiveSettings, s.receiveSettings) || (this._receiveSettings = s.receiveSettings, this.emitDailyJSEvent({ action: s.action, receiveSettings: s.receiveSettings }));
        break;
      case Hc:
        this._maybeUpdateInputSettings(s.inputSettings);
        break;
      case "send-settings-updated":
        at(this._sendSettings, s.sendSettings) || (this._sendSettings = s.sendSettings, this._preloadCache.sendSettings = null, this.emitDailyJSEvent({ action: s.action, sendSettings: s.sendSettings }));
        break;
      case "local-audio-level":
        this._localAudioLevel = s.audioLevel, this._preloadCache.localAudioLevelObserver = null, this.emitDailyJSEvent(s);
        break;
      case "remote-participants-audio-level":
        this._remoteParticipantsAudioLevel = s.participantsAudioLevel, this._preloadCache.remoteParticipantsAudioLevelObserver = null, this.emitDailyJSEvent(s);
        break;
      case nv:
        var We = s.session_id;
        this._rmpPlayerState[We] = s.playerState, this.emitDailyJSEvent(s);
        break;
      case iv:
        delete this._rmpPlayerState[s.session_id], this.emitDailyJSEvent(s);
        break;
      case rv:
        var Ke = s.session_id, _t = this._rmpPlayerState[Ke];
        _t && this.compareEqualForRMPUpdateEvent(_t, s.remoteMediaPlayerState) || (this._rmpPlayerState[Ke] = s.remoteMediaPlayerState, this.emitDailyJSEvent(s));
        break;
      case "custom-button-click":
      case "sidebar-view-changed":
        this.emitDailyJSEvent(s);
        break;
      case Fh:
        var jt = this._meetingSessionState.topology !== (s.meetingSessionState && s.meetingSessionState.topology);
        this._meetingSessionState = Go(s.meetingSessionState, this._callObjectMode), (this._callObjectMode || jt) && this.emitDailyJSEvent(s);
        break;
      case ov:
        this._isScreenSharing = !0, this.emitDailyJSEvent(s);
        break;
      case av:
      case sv:
        this._isScreenSharing = !1, this.emitDailyJSEvent(s);
        break;
      case qc:
      case Jc:
      case Yh:
      case Qh:
      case Zh:
      case Hh:
      case Gh:
      case Kh:
      case Ph:
      case Oh:
      case ev:
      case tv:
      case "test-completed":
      case dv:
      case Xh:
      case hv:
      case vv:
      case mv:
      case gv:
      case Gc:
      case yv:
      case "dialin-ready":
      case "dialin-connected":
      case "dialin-error":
      case "dialin-stopped":
      case "dialin-warning":
      case "dialout-connected":
      case "dialout-answered":
      case "dialout-error":
      case "dialout-stopped":
      case "dialout-warning":
        this.emitDailyJSEvent(s);
        break;
      case "request-fullscreen":
        this.requestFullscreen();
        break;
      case "request-exit-fullscreen":
        this.exitFullscreen();
    }
  } }, { key: "maybeEventRecordingStopped", value: function(s, p) {
    var f = "record";
    s && (p.local || p[f] !== !1 || s[f] === p[f] || this.emitDailyJSEvent({ action: Jc }));
  } }, { key: "maybeEventRecordingStarted", value: function(s, p) {
    var f = "record";
    s && (p.local || p[f] !== !0 || s[f] === p[f] || this.emitDailyJSEvent({ action: qc }));
  } }, { key: "_trackStatePlayable", value: function(s) {
    return !(!s || s.state !== bh);
  } }, { key: "_trackChanged", value: function(s, p) {
    return (s == null ? void 0 : s.id) !== (p == null ? void 0 : p.id);
  } }, { key: "maybeEventTrackStopped", value: function(s, p, f) {
    var m, S, C = (m = p == null ? void 0 : p.tracks[s]) !== null && m !== void 0 ? m : null, A = (S = f == null ? void 0 : f.tracks[s]) !== null && S !== void 0 ? S : null, x = C == null ? void 0 : C.track;
    if (x) {
      var F = this._trackStatePlayable(C), W = this._trackStatePlayable(A), H = this._trackChanged(x, A == null ? void 0 : A.track);
      F && (W && !H || this.emitDailyJSEvent({ action: Jh, track: x, participant: f ?? p, type: s }));
    }
  } }, { key: "maybeEventTrackStarted", value: function(s, p, f) {
    var m, S, C = (m = p == null ? void 0 : p.tracks[s]) !== null && m !== void 0 ? m : null, A = (S = f == null ? void 0 : f.tracks[s]) !== null && S !== void 0 ? S : null, x = A == null ? void 0 : A.track;
    if (x) {
      var F = this._trackStatePlayable(C), W = this._trackStatePlayable(A), H = this._trackChanged(C == null ? void 0 : C.track, x);
      W && (F && !H || this.emitDailyJSEvent({ action: qh, track: x, participant: f, type: s }));
    }
  } }, { key: "maybeParticipantTracksStopped", value: function(s, p) {
    if (s)
      for (var f in s.tracks)
        this.maybeEventTrackStopped(f, s, p);
  } }, { key: "maybeParticipantTracksStarted", value: function(s, p) {
    if (p)
      for (var f in p.tracks)
        this.maybeEventTrackStarted(f, s, p);
  } }, { key: "compareEqualForRMPUpdateEvent", value: function(s, p) {
    var f, m;
    return s.state === p.state && ((f = s.settings) === null || f === void 0 ? void 0 : f.volume) === ((m = p.settings) === null || m === void 0 ? void 0 : m.volume);
  } }, { key: "emitDailyJSEvent", value: function(s) {
    try {
      s.callClientId = this.callClientId, this.emit(s.action, s);
    } catch (p) {
      console.log("could not emit", s, p);
    }
  } }, { key: "compareEqualForParticipantUpdateEvent", value: function(s, p) {
    return !!at(s, p) && (!s.videoTrack || !p.videoTrack || s.videoTrack.id === p.videoTrack.id && s.videoTrack.muted === p.videoTrack.muted && s.videoTrack.enabled === p.videoTrack.enabled) && (!s.audioTrack || !p.audioTrack || s.audioTrack.id === p.audioTrack.id && s.audioTrack.muted === p.audioTrack.muted && s.audioTrack.enabled === p.audioTrack.enabled);
  } }, { key: "nativeUtils", value: function() {
    return we() ? typeof DailyNativeUtils > "u" ? (console.warn("in React Native, DailyNativeUtils is expected to be available"), null) : DailyNativeUtils : null;
  } }, { key: "updateIsPreparingToJoin", value: function(s) {
    this._updateCallState(this._callState, s);
  } }, { key: "_updateCallState", value: function(s) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this._isPreparingToJoin;
    if (s !== this._callState || p !== this._isPreparingToJoin) {
      var f = this._callState, m = this._isPreparingToJoin;
      this._callState = s, this._isPreparingToJoin = p;
      var S = this._callState === gn;
      this.updateShowAndroidOngoingMeetingNotification(S);
      var C = vi(f, m), A = vi(this._callState, this._isPreparingToJoin);
      C !== A && (this.updateKeepDeviceAwake(A), this.updateDeviceAudioMode(A), this.updateNoOpRecordingEnsuringBackgroundContinuity(A));
    }
  } }, { key: "resetMeetingDependentVars", value: function() {
    this._participants = {}, this._participantCounts = wu, this._waitingParticipants = {}, this._activeSpeaker = {}, this._activeSpeakerMode = !1, this._didPreAuth = !1, this._accessState = { access: $o }, this._finalSummaryOfPrevSession = this._meetingSessionSummary, this._meetingSessionSummary = {}, this._meetingSessionState = Go(Su, this._callObjectMode), this._isScreenSharing = !1, this._receiveSettings = {}, this._inputSettings = void 0, this._sendSettings = {}, this._localAudioLevel = 0, this._isLocalAudioLevelObserverRunning = !1, this._remoteParticipantsAudioLevel = {}, this._isRemoteParticipantsAudioLevelObserverRunning = !1, this._maxAppMessageSize = Bo, this._callMachineInitialized = !1, this._bundleLoadTime = void 0, this._preloadCache;
  } }, { key: "updateKeepDeviceAwake", value: function(s) {
    we() && this.nativeUtils().setKeepDeviceAwake(s, this.callClientId);
  } }, { key: "updateDeviceAudioMode", value: function(s) {
    if (we() && !this.disableReactNativeAutoDeviceManagement("audio")) {
      var p = s ? this._nativeInCallAudioMode : "idle";
      this.nativeUtils().setAudioMode(p);
    }
  } }, { key: "updateShowAndroidOngoingMeetingNotification", value: function(s) {
    if (we() && this.nativeUtils().setShowOngoingMeetingNotification) {
      var p, f, m, S;
      if (this.properties.reactNativeConfig && this.properties.reactNativeConfig.androidInCallNotification) {
        var C = this.properties.reactNativeConfig.androidInCallNotification;
        p = C.title, f = C.subtitle, m = C.iconName, S = C.disableForCustomOverride;
      }
      S && (s = !1), this.nativeUtils().setShowOngoingMeetingNotification(s, p, f, m, this.callClientId);
    }
  } }, { key: "updateNoOpRecordingEnsuringBackgroundContinuity", value: function(s) {
    we() && this.nativeUtils().enableNoOpRecordingEnsuringBackgroundContinuity && this.nativeUtils().enableNoOpRecordingEnsuringBackgroundContinuity(s);
  } }, { key: "toggleParticipantAudioBasedOnNativeAudioFocus", value: function() {
    var s;
    if (we()) {
      var p = (s = this._callMachine()) === null || s === void 0 || (s = s.store) === null || s === void 0 ? void 0 : s.getState();
      for (var f in p == null ? void 0 : p.streams) {
        var m = p.streams[f];
        m && m.pendingTrack && m.pendingTrack.kind === "audio" && (m.pendingTrack.enabled = this._hasNativeAudioFocus);
      }
    }
  } }, { key: "disableReactNativeAutoDeviceManagement", value: function(s) {
    return this.properties.reactNativeConfig && this.properties.reactNativeConfig.disableAutoDeviceManagement && this.properties.reactNativeConfig.disableAutoDeviceManagement[s];
  } }, { key: "absoluteUrl", value: function(s) {
    if (s !== void 0) {
      var p = document.createElement("a");
      return p.href = s, p.href;
    }
  } }, { key: "sayHello", value: function() {
    var s = "hello, world.";
    return console.log(s), s;
  } }, { key: "_logUseAfterDestroy", value: function() {
    var s = Object.values(hn)[0];
    if (this.needsLoad())
      if (s && !s.needsLoad()) {
        var p = { action: ei, level: "error", code: this.strictMode ? 9995 : 9997 };
        s.sendMessageToCallMachine(p);
      } else
        this.strictMode || console.error("You are are attempting to use a call instance that was previously destroyed, which is unsupported. Please remove `strictMode: false` from your constructor properties to enable strict mode to track down and fix this unsupported usage.");
    else {
      var f = { action: ei, level: "error", code: this.strictMode ? 9995 : 9997 };
      this._messageChannel.sendMessageToCallMachine(f, null, this.callClientId, this._iframe);
    }
  } }, { key: "_logDuplicateInstanceAttempt", value: function() {
    for (var s = 0, p = Object.values(hn); s < p.length; s++) {
      var f = p[s];
      f._callMachineInitialized ? (f.sendMessageToCallMachine({ action: ei, level: "warn", code: this.allowMultipleCallInstances ? 9993 : 9992 }), f._delayDuplicateInstanceLog = !1) : f._delayDuplicateInstanceLog = !0;
    }
  } }, { key: "_maybeSendToSentry", value: function(s) {
    var p, f, m, S;
    if (!((p = s.error) !== null && p !== void 0 && p.type && (![Eh, kh, zc].includes(s.error.type) || s.error.type === zc && s.error.msg.includes("deleted")))) {
      var C = (f = this.properties) !== null && f !== void 0 && f.url ? new URL(this.properties.url) : void 0, A = "production";
      C && C.host.includes(".staging.daily") && (A = "staging");
      var x, F, W, H, ve, Ee = function(We) {
        const Ke = [Bp(), Vp(), fh(), lh(), gh(), _h(), Wp(), yh()];
        return We.autoSessionTracking !== !1 && Ke.push(mh()), Ke;
      }({}).filter(function(We) {
        return !["BrowserApiErrors", "Breadcrumbs", "GlobalHandlers"].includes(We.name);
      }), me = new Zp({ dsn: "https://f10f1c81e5d44a4098416c0867a8b740@o77906.ingest.sentry.io/168844", transport: rh, stackParser: uh, integrations: Ee, environment: A }), oe = new Zt();
      if (oe.setClient(me), me.init(), this.session_id && oe.setExtra("sessionId", this.session_id), this.properties) {
        var Ne = ee({}, this.properties);
        Ne.userName = Ne.userName ? "[Filtered]" : void 0, Ne.userData = Ne.userData ? "[Filtered]" : void 0, Ne.token = Ne.token ? "[Filtered]" : void 0, oe.setExtra("properties", Ne);
      }
      if (C) {
        var tt = C.searchParams.get("domain");
        if (!tt) {
          var Ue = C.host.match(/(.*?)\./);
          tt = Ue && Ue[1] || "";
        }
        tt && oe.setTag("domain", tt);
      }
      s.error && (oe.setTag("fatalErrorType", s.error.type), oe.setExtra("errorDetails", s.error.details), !((x = s.error.details) === null || x === void 0) && x.uri && oe.setTag("serverAddress", s.error.details.uri), !((F = s.error.details) === null || F === void 0) && F.workerGroup && oe.setTag("workerGroup", s.error.details.workerGroup), !((W = s.error.details) === null || W === void 0) && W.geoGroup && oe.setTag("geoGroup", s.error.details.geoGroup), !((H = s.error.details) === null || H === void 0) && H.on && oe.setTag("connectionAttempt", s.error.details.on), (ve = s.error.details) !== null && ve !== void 0 && ve.bundleUrl && (oe.setTag("bundleUrl", s.error.details.bundleUrl), oe.setTag("bundleError", s.error.details.sourceError.type))), oe.setTags({ callMode: this._callObjectMode ? we() ? "reactNative" : (m = this.properties) !== null && m !== void 0 && (m = m.dailyConfig) !== null && m !== void 0 && (m = m.callMode) !== null && m !== void 0 && m.includes("prebuilt") ? this.properties.dailyConfig.callMode : "custom" : "prebuilt-frame", version: e.version() });
      var he = ((S = s.error) === null || S === void 0 ? void 0 : S.msg) || s.errorMsg;
      oe.captureException(new Error(he));
    }
  } }, { key: "_callMachine", value: function() {
    var s;
    return (s = window._daily) === null || s === void 0 || (s = s.instances) === null || s === void 0 || (s = s[this.callClientId]) === null || s === void 0 ? void 0 : s.callMachine;
  } }, { key: "_maybeUpdateInputSettings", value: function(s) {
    if (!at(this._inputSettings, s)) {
      var p = this._getInputSettings();
      this._inputSettings = s;
      var f = this._getInputSettings();
      at(p, f) || this.emitDailyJSEvent({ action: Hc, inputSettings: f });
    }
  } }], [{ key: "supportedBrowser", value: function() {
    if (we())
      return { supported: !0, mobile: !0, name: "React Native", version: null, supportsScreenShare: !0, supportsSfu: !0, supportsVideoProcessing: !1, supportsAudioProcessing: !1 };
    var s = ip.getParser(Rt());
    return { supported: !!tu(), mobile: s.getPlatformType() === "mobile", name: s.getBrowserName(), version: s.getBrowserVersion(), supportsFullscreen: !!eu(), supportsScreenShare: !!wv(), supportsSfu: !!tu(), supportsVideoProcessing: jl(), supportsAudioProcessing: Dl() };
  } }, { key: "version", value: function() {
    return "0.83.1";
  } }, { key: "createCallObject", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return s.layout = "none", new e(null, s);
  } }, { key: "wrap", value: function(s) {
    var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (Se(), !s || !s.contentWindow || typeof s.src != "string")
      throw new Error("DailyIframe::Wrap needs an iframe-like first argument");
    return p.layout || (p.customLayout ? p.layout = "custom-v1" : p.layout = "browser"), new e(s, p);
  } }, { key: "createFrame", value: function(s, p) {
    var f, m;
    Se(), s && p ? (f = s, m = p) : s && s.append ? (f = s, m = {}) : (f = document.body, m = s || {});
    var S = m.iframeStyle;
    S || (S = f === document.body ? { position: "fixed", border: "1px solid black", backgroundColor: "white", width: "375px", height: "450px", right: "1em", bottom: "1em" } : { border: 0, width: "100%", height: "100%" });
    var C = document.createElement("iframe");
    window.navigator && window.navigator.userAgent.match(/Chrome\/61\./) ? C.allow = "microphone, camera" : C.allow = "microphone; camera; autoplay; display-capture; screen-wake-lock", C.style.visibility = "hidden", f.appendChild(C), C.style.visibility = null, Object.keys(S).forEach(function(A) {
      return C.style[A] = S[A];
    }), m.layout || (m.customLayout ? m.layout = "custom-v1" : m.layout = "browser");
    try {
      return new e(C, m);
    } catch (A) {
      throw f.removeChild(C), A;
    }
  } }, { key: "createTransparentFrame", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Se();
    var p = document.createElement("iframe");
    return p.allow = "microphone; camera; autoplay", p.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
      pointer-events: none;
    `, document.body.appendChild(p), s.layout || (s.layout = "custom-v1"), e.wrap(p, s);
  } }, { key: "getCallInstance", value: function() {
    var s = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
    return s ? hn[s] : Object.values(hn)[0];
  } }]);
  var t, n, r, i, o, a, u, c, l, d, h, g, b, y, v, _, w, k, O, I, N, E, L, B, Q, G, te, ie, J, ce, Me, se, Re, ke, Ae, K, Y, M;
}();
function jn(e, t) {
  var n = {};
  for (var r in e)
    if (e[r] instanceof MediaStreamTrack)
      console.warn("MediaStreamTrack found in props or cache.", r), n[r] = Kt;
    else if (r === "dailyConfig") {
      if (e[r].modifyLocalSdpHook) {
        var i = window._daily.instances[t].customCallbacks || {};
        i.modifyLocalSdpHook = e[r].modifyLocalSdpHook, window._daily.instances[t].customCallbacks = i, delete e[r].modifyLocalSdpHook;
      }
      if (e[r].modifyRemoteSdpHook) {
        var o = window._daily.instances[t].customCallbacks || {};
        o.modifyRemoteSdpHook = e[r].modifyRemoteSdpHook, window._daily.instances[t].customCallbacks = o, delete e[r].modifyRemoteSdpHook;
      }
      n[r] = e[r];
    } else
      n[r] = e[r];
  return n;
}
function Ie(e) {
  var t = arguments.length > 2 ? arguments[2] : void 0;
  if (e !== gn) {
    var n = "".concat(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "This daily-js method", " only supported after join.");
    throw t && (n += " ".concat(t)), console.error(n), new Error(n);
  }
}
function vi(e, t) {
  return [Ea, gn].includes(e) || t;
}
function Jo(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "This daily-js method", r = arguments.length > 3 ? arguments[3] : void 0;
  if (vi(e, t)) {
    var i = "".concat(n, " not supported after joining a meeting.");
    throw r && (i += " ".concat(r)), console.error(i), new Error(i);
  }
}
function ri(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "This daily-js method", n = arguments.length > 2 ? arguments[2] : void 0;
  if (!e) {
    var r = "".concat(t, arguments.length > 3 && arguments[3] !== void 0 && arguments[3] ? " requires preAuth() or startCamera() to initialize call state." : " requires preAuth(), startCamera(), or join() to initialize call state.");
    throw n && (r += " ".concat(n)), console.error(r), new Error(r);
  }
}
function Ho(e) {
  if (e) {
    var t = "A pre-call quality test is in progress. Please try ".concat(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "This daily-js method", " again once testing has completed. Use stopTestCallQuality() to end it early.");
    throw console.error(t), new Error(t);
  }
}
function Mt(e) {
  if (!e) {
    var t = "".concat(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "This daily-js method", " is only supported on custom callObject instances");
    throw console.error(t), new Error(t);
  }
}
function vt(e) {
  if (e) {
    var t = "".concat(arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "This daily-js method", " is only supported as part of Daily's Prebuilt");
    throw console.error(t), new Error(t);
  }
}
function Se() {
  if (we())
    throw new Error("This daily-js method is not currently supported in React Native");
}
function dr() {
  if (!we())
    throw new Error("This daily-js method is only supported in React Native");
}
function Yl(e) {
  if (e === void 0)
    return !0;
  var t;
  if (typeof e == "string")
    t = e;
  else
    try {
      t = JSON.stringify(e), at(JSON.parse(t), e) || console.warn("The userData provided will be modified when serialized.");
    } catch (n) {
      throw Error("userData must be serializable to JSON: ".concat(n));
    }
  if (t.length > 4096)
    throw Error("userData is too large (".concat(t.length, " characters). Maximum size suppported is ").concat(4096, "."));
  return !0;
}
function Ql(e, t) {
  for (var n = t.allowAllParticipantsKey, r = function(h) {
    var g = ["local"];
    return n || g.push("*"), h && !g.includes(h);
  }, i = function(h) {
    return !!(h.layer === void 0 || Number.isInteger(h.layer) && h.layer >= 0 || h.layer === "inherit");
  }, o = function(h) {
    return !!h && !(h.video && !i(h.video)) && !(h.screenVideo && !i(h.screenVideo));
  }, a = 0, u = Object.entries(e); a < u.length; a++) {
    var c = rt(u[a], 2), l = c[0], d = c[1];
    if (!r(l) || !o(d))
      return !1;
  }
  return !0;
}
function Zl(e) {
  if (Te(e) !== "object")
    return !1;
  for (var t = 0, n = Object.entries(e); t < n.length; t++) {
    var r = rt(n[t], 2), i = r[0], o = r[1];
    switch (i) {
      case "video":
        if (Te(o) !== "object")
          return !1;
        for (var a = 0, u = Object.entries(o); a < u.length; a++) {
          var c = rt(u[a], 2), l = c[0], d = c[1];
          switch (l) {
            case "processor":
              if (!Yv(d))
                return !1;
              break;
            case "settings":
              if (!Tu(d))
                return !1;
              break;
            default:
              return !1;
          }
        }
        break;
      case "audio":
        if (Te(o) !== "object")
          return !1;
        for (var h = 0, g = Object.entries(o); h < g.length; h++) {
          var b = rt(g[h], 2), y = b[0], v = b[1];
          switch (y) {
            case "processor":
              if (!Kv(v))
                return !1;
              break;
            case "settings":
              if (!Tu(v))
                return !1;
              break;
            default:
              return !1;
          }
        }
        break;
      default:
        return !1;
    }
  }
  return !0;
}
function Xl(e, t, n) {
  var r, i = [];
  e.video && e.video.processor && (jl((r = t == null ? void 0 : t.useLegacyVideoProcessor) !== null && r !== void 0 && r) || (e.video.settings ? delete e.video.processor : delete e.video, i.push("video"))), e.audio && e.audio.processor && (Dl() || (e.audio.settings ? delete e.audio.processor : delete e.audio, i.push("audio"))), i.length > 0 && console.error("Ignoring settings for browser- or platform-unsupported input processor(s): ".concat(i.join(", "))), e.audio && e.audio.settings && (e.audio.settings.customTrack ? (n.audioTrack = e.audio.settings.customTrack, e.audio.settings = { customTrack: Kt }) : delete n.audioTrack), e.video && e.video.settings && (e.video.settings.customTrack ? (n.videoTrack = e.video.settings.customTrack, e.video.settings = { customTrack: Kt }) : delete n.videoTrack);
}
function Kv(e) {
  if (we())
    return console.warn("Video processing is not yet supported in React Native"), !1;
  var t = ["type"];
  return !!e && Te(e) === "object" && (Object.keys(e).filter(function(n) {
    return !t.includes(n);
  }).forEach(function(n) {
    console.warn("invalid key inputSettings -> audio -> processor : ".concat(n)), delete e[n];
  }), !!function(n) {
    return typeof n != "string" ? !1 : Object.values(Il).includes(n) ? !0 : (console.error("inputSettings audio processor type invalid"), !1);
  }(e.type));
}
function Yv(e) {
  if (we())
    return console.warn("Video processing is not yet supported in React Native"), !1;
  var t = ["type", "config"];
  return !e || Te(e) !== "object" || !function(n) {
    return typeof n != "string" ? !1 : Object.values(hi).includes(n) ? !0 : (console.error("inputSettings video processor type invalid"), !1);
  }(e.type) || e.config && (Te(e.config) !== "object" || !function(n, r) {
    var i = Object.keys(r);
    if (i.length === 0)
      return !0;
    var o = "invalid object in inputSettings -> video -> processor -> config";
    switch (n) {
      case hi.BGBLUR:
        return i.length > 1 || i[0] !== "strength" ? (console.error(o), !1) : !(typeof r.strength != "number" || r.strength <= 0 || r.strength > 1 || isNaN(r.strength)) || (console.error("".concat(o, "; expected: {0 < strength <= 1}, got: ").concat(r.strength)), !1);
      case hi.BGIMAGE:
        return !(r.source !== void 0 && !function(a) {
          if (a.source === "default")
            return a.type = "default", !0;
          if (a.source instanceof ArrayBuffer)
            return !0;
          if (Ei(a.source))
            return a.type = "url", !!function(l) {
              var d = new URL(l), h = d.pathname;
              if (d.protocol === "data:")
                try {
                  var g = h.substring(h.indexOf(":") + 1, h.indexOf(";")).split("/")[1];
                  return Uo.includes(g);
                } catch (y) {
                  return console.error("failed to deduce blob content type", y), !1;
                }
              var b = h.split(".").at(-1).toLowerCase().trim();
              return Uo.includes(b);
            }(a.source) || (console.error("invalid image type; supported types: [".concat(Uo.join(", "), "]")), !1);
          return u = a.source, c = Number(u), isNaN(c) || !Number.isInteger(c) || c <= 0 || c > 10 ? (console.error("invalid image selection; must be an int, > 0, <= ".concat(10)), !1) : (a.type = "daily-preselect", !0);
          var u, c;
        }(r));
      default:
        return !0;
    }
  }(e.type, e.config)) ? !1 : (Object.keys(e).filter(function(n) {
    return !t.includes(n);
  }).forEach(function(n) {
    console.warn("invalid key inputSettings -> video -> processor : ".concat(n)), delete e[n];
  }), !0);
}
function Tu(e) {
  return Te(e) === "object" && (!e.customTrack || e.customTrack instanceof MediaStreamTrack);
}
function Oa() {
  var e = Object.values(hi).join(" | "), t = Object.values(Il).join(" | ");
  return "inputSettings must be of the form: { video?: { processor?: { type: [ ".concat(e, " ], config?: {} } }, audio?: { processor: {type: [ ").concat(t, " ] } } }");
}
function ed(e) {
  var t = e.allowAllParticipantsKey;
  return "receiveSettings must be of the form { [<remote participant id> | ".concat(wh).concat(t ? ' | "'.concat("*", '"') : "", "]: ") + '{ [video: [{ layer: [<non-negative integer> | "inherit"] } | "inherit"]], [screenVideo: [{ layer: [<non-negative integer> | "inherit"] } | "inherit"]] }}}';
}
function td() {
  return "customIntegrations should be an object of type ".concat(JSON.stringify(Pa), ".");
}
function nd(e) {
  if (e && Te(e) !== "object" || Array.isArray(e))
    return console.error("customTrayButtons should be an Object of the type ".concat(JSON.stringify(Oi), ".")), !1;
  if (e)
    for (var t = 0, n = Object.entries(e); t < n.length; t++)
      for (var r = rt(n[t], 1)[0], i = 0, o = Object.entries(e[r]); i < o.length; i++) {
        var a = rt(o[i], 2), u = a[0], c = a[1], l = Oi.id[u];
        if (!l)
          return console.error("customTrayButton does not support key ".concat(u)), !1;
        switch (u) {
          case "iconPath":
          case "iconPathDarkMode":
            if (!Ei(c))
              return console.error("customTrayButton ".concat(u, " should be a url.")), !1;
            break;
          case "visualState":
            if (!["default", "sidebar-open", "active"].includes(c))
              return console.error("customTrayButton ".concat(u, " should be ").concat(l, ". Got: ").concat(c)), !1;
            break;
          default:
            if (Te(c) !== l)
              return console.error("customTrayButton ".concat(u, " should be a ").concat(l, ".")), !1;
        }
      }
  return !0;
}
function rd(e) {
  if (!e || e && Te(e) !== "object" || Array.isArray(e))
    return console.error(td()), !1;
  for (var t = function(h) {
    return "".concat(h, " should be ").concat(Pa.id[h]);
  }, n = function(h, g) {
    return console.error("customIntegration ".concat(h, ": ").concat(g));
  }, r = 0, i = Object.entries(e); r < i.length; r++) {
    var o = rt(i[r], 1)[0];
    if (!("label" in e[o]))
      return n(o, "label is required"), !1;
    if (!("location" in e[o]))
      return n(o, "location is required"), !1;
    if (!("src" in e[o]) && !("srcdoc" in e[o]))
      return n(o, "src or srcdoc is required"), !1;
    for (var a = 0, u = Object.entries(e[o]); a < u.length; a++) {
      var c = rt(u[a], 2), l = c[0], d = c[1];
      switch (l) {
        case "allow":
        case "csp":
        case "name":
        case "referrerPolicy":
        case "sandbox":
          if (typeof d != "string")
            return n(o, t(l)), !1;
          break;
        case "iconURL":
          if (!Ei(d))
            return n(o, "".concat(l, " should be a url")), !1;
          break;
        case "src":
          if ("srcdoc" in e[o])
            return n(o, "cannot have both src and srcdoc"), !1;
          if (!Ei(d))
            return n(o, 'src "'.concat(d, '" is not a valid URL')), !1;
          break;
        case "srcdoc":
          if ("src" in e[o])
            return n(o, "cannot have both src and srcdoc"), !1;
          if (typeof d != "string")
            return n(o, t(l)), !1;
          break;
        case "location":
          if (!["main", "sidebar"].includes(d))
            return n(o, t(l)), !1;
          break;
        case "controlledBy":
          if (d !== "*" && d !== "owners" && (!Array.isArray(d) || d.some(function(h) {
            return typeof h != "string";
          })))
            return n(o, t(l)), !1;
          break;
        case "shared":
          if ((!Array.isArray(d) || d.some(function(h) {
            return typeof h != "string";
          })) && d !== "owners" && typeof d != "boolean")
            return n(o, t(l)), !1;
          break;
        default:
          if (!Pa.id[l])
            return console.error("customIntegration does not support key ".concat(l)), !1;
      }
    }
  }
  return !0;
}
function id(e, t) {
  if (t === void 0)
    return !1;
  switch (Te(t)) {
    case "string":
      return Te(e) === t;
    case "object":
      if (Te(e) !== "object")
        return !1;
      for (var n in e)
        if (!id(e[n], t[n]))
          return !1;
      return !0;
    default:
      return !1;
  }
}
function Ru(e, t) {
  var n = e.sessionId, r = e.toEndPoint, i = e.callerId, o = e.useSipRefer;
  if (!n || !r)
    throw new Error("".concat(t, "() requires a sessionId and toEndPoint"));
  if (typeof n != "string" || typeof r != "string")
    throw new Error("Invalid paramater: sessionId and toEndPoint must be of type string");
  if (o && !r.startsWith("sip:"))
    throw new Error('"toEndPoint" must be a "sip" address');
  if (!r.startsWith("sip:") && !r.startsWith("+"))
    throw new Error("toEndPoint: ".concat(r, ' must starts with either "sip:" or "+"'));
  if (i && typeof i != "string")
    throw new Error("callerId must be of type string");
  if (i && !r.startsWith("+"))
    throw new Error("callerId is only valid when transferring to a PSTN number");
}
function Cu(e) {
  if (Te(e) !== "object")
    throw new Error('RemoteMediaPlayerSettings: must be "object" type');
  if (e.state && !Object.values(Ta).includes(e.state))
    throw new Error("Invalid value for RemoteMediaPlayerSettings.state, valid values are: " + JSON.stringify(Ta));
  if (e.volume) {
    if (typeof e.volume != "number")
      throw new Error('RemoteMediaPlayerSettings.volume: must be "number" type');
    if (e.volume < 0 || e.volume > 2)
      throw new Error("RemoteMediaPlayerSettings.volume: must be between 0.0 - 2.0");
  }
}
function Mu(e, t, n) {
  return !(typeof e != "number" || e < t || e > n);
}
function Go(e, t) {
  return e && !t && delete e.data, e;
}
function Qv(e) {
  const t = new Error(e);
  if (t.stack === void 0)
    try {
      throw t;
    } catch {
    }
  return t;
}
var Zv = Qv, de = Zv;
function Xv(e) {
  return !!e && typeof e.then == "function";
}
var xe = Xv;
function em(e, t) {
  if (e != null)
    return e;
  throw de(t ?? "Got unexpected null or undefined");
}
var $e = em;
function pe(e, t, n) {
  return t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
class Ji {
  getValue() {
    throw de("BaseLoadable");
  }
  toPromise() {
    throw de("BaseLoadable");
  }
  valueMaybe() {
    throw de("BaseLoadable");
  }
  valueOrThrow() {
    throw de(`Loadable expected value, but in "${this.state}" state`);
  }
  promiseMaybe() {
    throw de("BaseLoadable");
  }
  promiseOrThrow() {
    throw de(`Loadable expected promise, but in "${this.state}" state`);
  }
  errorMaybe() {
    throw de("BaseLoadable");
  }
  errorOrThrow() {
    throw de(`Loadable expected error, but in "${this.state}" state`);
  }
  is(t) {
    return t.state === this.state && t.contents === this.contents;
  }
  map(t) {
    throw de("BaseLoadable");
  }
}
class tm extends Ji {
  constructor(t) {
    super(), pe(this, "state", "hasValue"), pe(this, "contents", void 0), this.contents = t;
  }
  getValue() {
    return this.contents;
  }
  toPromise() {
    return Promise.resolve(this.contents);
  }
  valueMaybe() {
    return this.contents;
  }
  valueOrThrow() {
    return this.contents;
  }
  promiseMaybe() {
  }
  errorMaybe() {
  }
  map(t) {
    try {
      const n = t(this.contents);
      return xe(n) ? Rn(n) : Zn(n) ? n : Lr(n);
    } catch (n) {
      return xe(n) ? (
        // If we "suspended", then try again.
        // errors and subsequent retries will be handled in 'loading' case
        // $FlowFixMe[prop-missing]
        Rn(n.next(() => this.map(t)))
      ) : Hi(n);
    }
  }
}
class nm extends Ji {
  constructor(t) {
    super(), pe(this, "state", "hasError"), pe(this, "contents", void 0), this.contents = t;
  }
  getValue() {
    throw this.contents;
  }
  toPromise() {
    return Promise.reject(this.contents);
  }
  valueMaybe() {
  }
  promiseMaybe() {
  }
  errorMaybe() {
    return this.contents;
  }
  errorOrThrow() {
    return this.contents;
  }
  map(t) {
    return this;
  }
}
class od extends Ji {
  constructor(t) {
    super(), pe(this, "state", "loading"), pe(this, "contents", void 0), this.contents = t;
  }
  getValue() {
    throw this.contents;
  }
  toPromise() {
    return this.contents;
  }
  valueMaybe() {
  }
  promiseMaybe() {
    return this.contents;
  }
  promiseOrThrow() {
    return this.contents;
  }
  errorMaybe() {
  }
  map(t) {
    return Rn(this.contents.then((n) => {
      const r = t(n);
      if (Zn(r)) {
        const i = r;
        switch (i.state) {
          case "hasValue":
            return i.contents;
          case "hasError":
            throw i.contents;
          case "loading":
            return i.contents;
        }
      }
      return r;
    }).catch((n) => {
      if (xe(n))
        return n.then(() => this.map(t).contents);
      throw n;
    }));
  }
}
function Lr(e) {
  return Object.freeze(new tm(e));
}
function Hi(e) {
  return Object.freeze(new nm(e));
}
function Rn(e) {
  return Object.freeze(new od(e));
}
function ad() {
  return Object.freeze(new od(new Promise(() => {
  })));
}
function rm(e) {
  return e.every((t) => t.state === "hasValue") ? Lr(e.map((t) => t.contents)) : e.some((t) => t.state === "hasError") ? Hi($e(e.find((t) => t.state === "hasError"), "Invalid loadable passed to loadableAll").contents) : Rn(Promise.all(e.map((t) => t.contents)));
}
function sd(e) {
  const n = (Array.isArray(e) ? e : Object.getOwnPropertyNames(e).map((i) => e[i])).map((i) => Zn(i) ? i : xe(i) ? Rn(i) : Lr(i)), r = rm(n);
  return Array.isArray(e) ? (
    // $FlowIssue[incompatible-return]
    r
  ) : (
    // Object.getOwnPropertyNames() has consistent key ordering with ES6
    // $FlowIssue[incompatible-call]
    r.map((i) => Object.getOwnPropertyNames(e).reduce(
      // $FlowFixMe[invalid-computed-prop]
      (o, a, u) => ({
        ...o,
        [a]: i[u]
      }),
      {}
    ))
  );
}
function Zn(e) {
  return e instanceof Ji;
}
const im = {
  of: (e) => xe(e) ? Rn(e) : Zn(e) ? e : Lr(e),
  error: (e) => Hi(e),
  // $FlowIssue[incompatible-return]
  loading: () => ad(),
  // $FlowIssue[unclear-type]
  all: sd,
  isLoadable: Zn
};
var On = {
  loadableWithValue: Lr,
  loadableWithError: Hi,
  loadableWithPromise: Rn,
  loadableLoading: ad,
  loadableAll: sd,
  isLoadable: Zn,
  RecoilLoadable: im
}, om = On.loadableWithValue, am = On.loadableWithError, sm = On.loadableWithPromise, cm = On.loadableLoading, um = On.loadableAll, lm = On.isLoadable, dm = On.RecoilLoadable, Ir = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  loadableWithValue: om,
  loadableWithError: am,
  loadableWithPromise: sm,
  loadableLoading: cm,
  loadableAll: um,
  isLoadable: lm,
  RecoilLoadable: dm
});
const Na = {
  RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED: !0,
  // Note: RECOIL_GKS_ENABLED settings will only be honored in OSS builds of Recoil
  RECOIL_GKS_ENABLED: /* @__PURE__ */ new Set(["recoil_hamt_2020", "recoil_sync_external_store", "recoil_suppress_rerender_in_callback", "recoil_memory_managament_2020"])
};
function fm(e, t) {
  var n, r;
  const i = (n = process.env[e]) === null || n === void 0 || (r = n.toLowerCase()) === null || r === void 0 ? void 0 : r.trim();
  if (i == null || i === "")
    return;
  if (!["true", "false"].includes(i))
    throw de(`process.env.${e} value must be 'true', 'false', or empty: ${i}`);
  t(i === "true");
}
function pm(e, t) {
  var n;
  const r = (n = process.env[e]) === null || n === void 0 ? void 0 : n.trim();
  r == null || r === "" || t(r.split(/\s*,\s*|\s+/));
}
function hm() {
  var e;
  typeof process > "u" || ((e = process) === null || e === void 0 ? void 0 : e.env) != null && (fm("RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED", (t) => {
    Na.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED = t;
  }), pm("RECOIL_GKS_ENABLED", (t) => {
    t.forEach((n) => {
      Na.RECOIL_GKS_ENABLED.add(n);
    });
  }));
}
hm();
var or = Na;
function Gi(e) {
  return or.RECOIL_GKS_ENABLED.has(e);
}
Gi.setPass = (e) => {
  or.RECOIL_GKS_ENABLED.add(e);
};
Gi.setFail = (e) => {
  or.RECOIL_GKS_ENABLED.delete(e);
};
Gi.clear = () => {
  or.RECOIL_GKS_ENABLED.clear();
};
var je = Gi;
function vm(e, t, {
  error: n
} = {}) {
  return process.env.NODE_ENV !== "production" && console.error(e, n), null;
}
var mm = vm, Ze = mm, Ko, Yo, Qo;
const gm = (
  // flowlint-next-line unclear-type:off
  (Ko = Z.createMutableSource) !== null && Ko !== void 0 ? Ko : Z.unstable_createMutableSource
), cd = (
  // flowlint-next-line unclear-type:off
  (Yo = Z.useMutableSource) !== null && Yo !== void 0 ? Yo : Z.unstable_useMutableSource
), fs = (
  // flowlint-next-line unclear-type:off
  (Qo = Z.useSyncExternalStore) !== null && Qo !== void 0 ? Qo : (
    // flowlint-next-line unclear-type:off
    Z.unstable_useSyncExternalStore
  )
);
let Au = !1;
function ym() {
  var e;
  const {
    ReactCurrentDispatcher: t,
    ReactCurrentOwner: n
  } = (
    /* $FlowFixMe[prop-missing] This workaround was approved as a safer mechanism
     * to detect if the current renderer supports useSyncExternalStore()
     * https://fb.workplace.com/groups/reactjs/posts/9558682330846963/ */
    Z.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
  ), i = ((e = t == null ? void 0 : t.current) !== null && e !== void 0 ? e : n.currentDispatcher).useSyncExternalStore != null;
  return fs && !i && !Au && (Au = !0, Ze("A React renderer without React 18+ API support is being used with React 18+.")), i;
}
function _m() {
  return je("recoil_transition_support") ? {
    mode: "TRANSITION_SUPPORT",
    early: !0,
    concurrent: !0
  } : je("recoil_sync_external_store") && fs != null ? {
    mode: "SYNC_EXTERNAL_STORE",
    early: !0,
    concurrent: !1
  } : je("recoil_mutable_source") && cd != null && typeof window < "u" && !window.$disableRecoilValueMutableSource_TEMP_HACK_DO_NOT_USE ? je("recoil_suppress_rerender_in_callback") ? {
    mode: "MUTABLE_SOURCE",
    early: !0,
    concurrent: !0
  } : {
    mode: "MUTABLE_SOURCE",
    early: !1,
    concurrent: !1
  } : je("recoil_suppress_rerender_in_callback") ? {
    mode: "LEGACY",
    early: !0,
    concurrent: !1
  } : {
    mode: "LEGACY",
    early: !1,
    concurrent: !1
  };
}
function bm() {
  return !1;
}
var ar = {
  createMutableSource: gm,
  useMutableSource: cd,
  useSyncExternalStore: fs,
  currentRendererSupportsUseSyncExternalStore: ym,
  reactMode: _m,
  isFastRefreshEnabled: bm
};
class ps {
  constructor(t) {
    pe(this, "key", void 0), this.key = t;
  }
  toJSON() {
    return {
      key: this.key
    };
  }
}
class ud extends ps {
}
class ld extends ps {
}
function Sm(e) {
  return e instanceof ud || e instanceof ld;
}
var Ki = {
  AbstractRecoilValue: ps,
  RecoilState: ud,
  RecoilValueReadOnly: ld,
  isRecoilValue: Sm
}, wm = Ki.AbstractRecoilValue, km = Ki.RecoilState, Em = Ki.RecoilValueReadOnly, Tm = Ki.isRecoilValue, Cn = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  AbstractRecoilValue: wm,
  RecoilState: km,
  RecoilValueReadOnly: Em,
  isRecoilValue: Tm
});
function Rm(e, ...t) {
  let n = 0;
  return e.replace(/%s/g, () => String(t[n++]));
}
var Cm = Rm;
function Mm(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = Cm.call(null, e, ...t), r = new Error(n);
    r.name = "Expectation Violation", console.error(r);
  }
}
var Am = Mm, Yi = Am;
function Pm(e, t) {
  return function* () {
    let n = 0;
    for (const r of e)
      yield t(r, n++);
  }();
}
var Qi = Pm;
const {
  isFastRefreshEnabled: Om
} = ar;
class dd {
}
const Nm = new dd(), Mn = /* @__PURE__ */ new Map(), hs = /* @__PURE__ */ new Map();
function Lm(e) {
  return Qi(e, (t) => $e(hs.get(t)));
}
function Im(e) {
  if (Mn.has(e)) {
    const t = `Duplicate atom key "${e}". This is a FATAL ERROR in
      production. But it is safe to ignore this warning if it occurred because of
      hot module replacement.`;
    process.env.NODE_ENV !== "production" ? Om() || Yi(t, "recoil") : console.warn(t);
  }
}
function xm(e) {
  or.RECOIL_DUPLICATE_ATOM_KEY_CHECKING_ENABLED && Im(e.key), Mn.set(e.key, e);
  const t = e.set == null ? new Cn.RecoilValueReadOnly(e.key) : new Cn.RecoilState(e.key);
  return hs.set(e.key, t), t;
}
class fd extends Error {
}
function jm(e) {
  const t = Mn.get(e);
  if (t == null)
    throw new fd(`Missing definition for RecoilValue: "${e}""`);
  return t;
}
function Dm(e) {
  return Mn.get(e);
}
const Ni = /* @__PURE__ */ new Map();
function Vm(e) {
  var t;
  if (!je("recoil_memory_managament_2020"))
    return;
  const n = Mn.get(e);
  if (n != null && (t = n.shouldDeleteConfigOnRelease) !== null && t !== void 0 && t.call(n)) {
    var r;
    Mn.delete(e), (r = pd(e)) === null || r === void 0 || r(), Ni.delete(e);
  }
}
function $m(e, t) {
  je("recoil_memory_managament_2020") && (t === void 0 ? Ni.delete(e) : Ni.set(e, t));
}
function pd(e) {
  return Ni.get(e);
}
var ht = {
  nodes: Mn,
  recoilValues: hs,
  registerNode: xm,
  getNode: jm,
  getNodeMaybe: Dm,
  deleteNodeConfigIfPossible: Vm,
  setConfigDeletionHandler: $m,
  getConfigDeletionHandler: pd,
  recoilValuesForKeys: Lm,
  NodeMissingError: fd,
  DefaultValue: dd,
  DEFAULT_VALUE: Nm
};
function Bm(e, t) {
  t();
}
var Fm = {
  enqueueExecution: Bm
};
function Um(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
var zm = Um(function(e) {
  var t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(R) {
    return typeof R;
  } : function(R) {
    return R && typeof Symbol == "function" && R.constructor === Symbol && R !== Symbol.prototype ? "symbol" : typeof R;
  }, n = {}, r = 5, i = Math.pow(2, r), o = i - 1, a = i / 2, u = i / 4, c = {}, l = function(T) {
    return function() {
      return T;
    };
  }, d = n.hash = function(R) {
    var T = typeof R > "u" ? "undefined" : t(R);
    if (T === "number")
      return R;
    T !== "string" && (R += "");
    for (var j = 0, V = 0, U = R.length; V < U; ++V) {
      var q = R.charCodeAt(V);
      j = (j << 5) - j + q | 0;
    }
    return j;
  }, h = function(T) {
    return T -= T >> 1 & 1431655765, T = (T & 858993459) + (T >> 2 & 858993459), T = T + (T >> 4) & 252645135, T += T >> 8, T += T >> 16, T & 127;
  }, g = function(T, j) {
    return j >>> T & o;
  }, b = function(T) {
    return 1 << T;
  }, y = function(T, j) {
    return h(T & j - 1);
  }, v = function(T, j, V, U) {
    var q = U;
    if (!T) {
      var ne = U.length;
      q = new Array(ne);
      for (var re = 0; re < ne; ++re)
        q[re] = U[re];
    }
    return q[j] = V, q;
  }, _ = function(T, j, V) {
    var U = V.length - 1, q = 0, ne = 0, re = V;
    if (T)
      q = ne = j;
    else
      for (re = new Array(U); q < j; )
        re[ne++] = V[q++];
    for (++q; q <= U; )
      re[ne++] = V[q++];
    return T && (re.length = U), re;
  }, w = function(T, j, V, U) {
    var q = U.length;
    if (T) {
      for (var ne = q; ne >= j; )
        U[ne--] = U[ne];
      return U[j] = V, U;
    }
    for (var re = 0, ae = 0, ye = new Array(q + 1); re < j; )
      ye[ae++] = U[re++];
    for (ye[j] = V; re < q; )
      ye[++ae] = U[re++];
    return ye;
  }, k = 1, O = 2, I = 3, N = 4, E = {
    __hamt_isEmpty: !0
  }, L = function(T) {
    return T === E || T && T.__hamt_isEmpty;
  }, B = function(T, j, V, U) {
    return {
      type: k,
      edit: T,
      hash: j,
      key: V,
      value: U,
      _modify: ke
    };
  }, Q = function(T, j, V) {
    return {
      type: O,
      edit: T,
      hash: j,
      children: V,
      _modify: Ae
    };
  }, G = function(T, j, V) {
    return {
      type: I,
      edit: T,
      mask: j,
      children: V,
      _modify: K
    };
  }, te = function(T, j, V) {
    return {
      type: N,
      edit: T,
      size: j,
      children: V,
      _modify: Y
    };
  }, ie = function(T) {
    return T === E || T.type === k || T.type === O;
  }, J = function(T, j, V, U, q) {
    for (var ne = [], re = U, ae = 0, ye = 0; re; ++ye)
      re & 1 && (ne[ye] = q[ae++]), re >>>= 1;
    return ne[j] = V, te(T, ae + 1, ne);
  }, ce = function(T, j, V, U) {
    for (var q = new Array(j - 1), ne = 0, re = 0, ae = 0, ye = U.length; ae < ye; ++ae)
      if (ae !== V) {
        var Ve = U[ae];
        Ve && !L(Ve) && (q[ne++] = Ve, re |= 1 << ae);
      }
    return G(T, re, q);
  }, Me = function R(T, j, V, U, q, ne) {
    if (V === q)
      return Q(T, V, [ne, U]);
    var re = g(j, V), ae = g(j, q);
    return G(T, b(re) | b(ae), re === ae ? [R(T, j + r, V, U, q, ne)] : re < ae ? [U, ne] : [ne, U]);
  }, se = function(T, j, V, U, q, ne, re, ae) {
    for (var ye = q.length, Ve = 0; Ve < ye; ++Ve) {
      var lt = q[Ve];
      if (V(re, lt.key)) {
        var Ye = lt.value, bt = ne(Ye);
        return bt === Ye ? q : bt === c ? (--ae.value, _(T, Ve, q)) : v(T, Ve, B(j, U, re, bt), q);
      }
    }
    var Ct = ne();
    return Ct === c ? q : (++ae.value, v(T, ye, B(j, U, re, Ct), q));
  }, Re = function(T, j) {
    return T === j.edit;
  }, ke = function(T, j, V, U, q, ne, re) {
    if (j(ne, this.key)) {
      var ae = U(this.value);
      return ae === this.value ? this : ae === c ? (--re.value, E) : Re(T, this) ? (this.value = ae, this) : B(T, q, ne, ae);
    }
    var ye = U();
    return ye === c ? this : (++re.value, Me(T, V, this.hash, this, q, B(T, q, ne, ye)));
  }, Ae = function(T, j, V, U, q, ne, re) {
    if (q === this.hash) {
      var ae = Re(T, this), ye = se(ae, T, j, this.hash, this.children, U, ne, re);
      return ye === this.children ? this : ye.length > 1 ? Q(T, this.hash, ye) : ye[0];
    }
    var Ve = U();
    return Ve === c ? this : (++re.value, Me(T, V, this.hash, this, q, B(T, q, ne, Ve)));
  }, K = function(T, j, V, U, q, ne, re) {
    var ae = this.mask, ye = this.children, Ve = g(V, q), lt = b(Ve), Ye = y(ae, lt), bt = ae & lt, Ct = bt ? ye[Ye] : E, In = Ct._modify(T, j, V + r, U, q, ne, re);
    if (Ct === In)
      return this;
    var Ur = Re(T, this), cr = ae, ur = void 0;
    if (bt && L(In)) {
      if (cr &= ~lt, !cr)
        return E;
      if (ye.length <= 2 && ie(ye[Ye ^ 1]))
        return ye[Ye ^ 1];
      ur = _(Ur, Ye, ye);
    } else if (!bt && !L(In)) {
      if (ye.length >= a)
        return J(T, Ve, In, ae, ye);
      cr |= lt, ur = w(Ur, Ye, In, ye);
    } else
      ur = v(Ur, Ye, In, ye);
    return Ur ? (this.mask = cr, this.children = ur, this) : G(T, cr, ur);
  }, Y = function(T, j, V, U, q, ne, re) {
    var ae = this.size, ye = this.children, Ve = g(V, q), lt = ye[Ve], Ye = (lt || E)._modify(T, j, V + r, U, q, ne, re);
    if (lt === Ye)
      return this;
    var bt = Re(T, this), Ct = void 0;
    if (L(lt) && !L(Ye))
      ++ae, Ct = v(bt, Ve, Ye, ye);
    else if (!L(lt) && L(Ye)) {
      if (--ae, ae <= u)
        return ce(T, ae, Ve, ye);
      Ct = v(bt, Ve, E, ye);
    } else
      Ct = v(bt, Ve, Ye, ye);
    return bt ? (this.size = ae, this.children = Ct, this) : te(T, ae, Ct);
  };
  E._modify = function(R, T, j, V, U, q, ne) {
    var re = V();
    return re === c ? E : (++ne.value, B(R, U, q, re));
  };
  function M(R, T, j, V, U) {
    this._editable = R, this._edit = T, this._config = j, this._root = V, this._size = U;
  }
  M.prototype.setTree = function(R, T) {
    return this._editable ? (this._root = R, this._size = T, this) : R === this._root ? this : new M(this._editable, this._edit, this._config, R, T);
  };
  var s = n.tryGetHash = function(R, T, j, V) {
    for (var U = V._root, q = 0, ne = V._config.keyEq; ; )
      switch (U.type) {
        case k:
          return ne(j, U.key) ? U.value : R;
        case O: {
          if (T === U.hash)
            for (var re = U.children, ae = 0, ye = re.length; ae < ye; ++ae) {
              var Ve = re[ae];
              if (ne(j, Ve.key))
                return Ve.value;
            }
          return R;
        }
        case I: {
          var lt = g(q, T), Ye = b(lt);
          if (U.mask & Ye) {
            U = U.children[y(U.mask, Ye)], q += r;
            break;
          }
          return R;
        }
        case N: {
          if (U = U.children[g(q, T)], U) {
            q += r;
            break;
          }
          return R;
        }
        default:
          return R;
      }
  };
  M.prototype.tryGetHash = function(R, T, j) {
    return s(R, T, j, this);
  };
  var p = n.tryGet = function(R, T, j) {
    return s(R, j._config.hash(T), T, j);
  };
  M.prototype.tryGet = function(R, T) {
    return p(R, T, this);
  };
  var f = n.getHash = function(R, T, j) {
    return s(void 0, R, T, j);
  };
  M.prototype.getHash = function(R, T) {
    return f(R, T, this);
  }, n.get = function(R, T) {
    return s(void 0, T._config.hash(R), R, T);
  }, M.prototype.get = function(R, T) {
    return p(T, R, this);
  };
  var m = n.has = function(R, T, j) {
    return s(c, R, T, j) !== c;
  };
  M.prototype.hasHash = function(R, T) {
    return m(R, T, this);
  };
  var S = n.has = function(R, T) {
    return m(T._config.hash(R), R, T);
  };
  M.prototype.has = function(R) {
    return S(R, this);
  };
  var C = function(T, j) {
    return T === j;
  };
  n.make = function(R) {
    return new M(0, 0, {
      keyEq: R && R.keyEq || C,
      hash: R && R.hash || d
    }, E, 0);
  }, n.empty = n.make();
  var A = n.isEmpty = function(R) {
    return R && !!L(R._root);
  };
  M.prototype.isEmpty = function() {
    return A(this);
  };
  var x = n.modifyHash = function(R, T, j, V) {
    var U = {
      value: V._size
    }, q = V._root._modify(V._editable ? V._edit : NaN, V._config.keyEq, 0, R, T, j, U);
    return V.setTree(q, U.value);
  };
  M.prototype.modifyHash = function(R, T, j) {
    return x(j, R, T, this);
  };
  var F = n.modify = function(R, T, j) {
    return x(R, j._config.hash(T), T, j);
  };
  M.prototype.modify = function(R, T) {
    return F(T, R, this);
  };
  var W = n.setHash = function(R, T, j, V) {
    return x(l(j), R, T, V);
  };
  M.prototype.setHash = function(R, T, j) {
    return W(R, T, j, this);
  };
  var H = n.set = function(R, T, j) {
    return W(j._config.hash(R), R, T, j);
  };
  M.prototype.set = function(R, T) {
    return H(R, T, this);
  };
  var ve = l(c), Ee = n.removeHash = function(R, T, j) {
    return x(ve, R, T, j);
  };
  M.prototype.removeHash = M.prototype.deleteHash = function(R, T) {
    return Ee(R, T, this);
  };
  var me = n.remove = function(R, T) {
    return Ee(T._config.hash(R), R, T);
  };
  M.prototype.remove = M.prototype.delete = function(R) {
    return me(R, this);
  };
  var oe = n.beginMutation = function(R) {
    return new M(R._editable + 1, R._edit + 1, R._config, R._root, R._size);
  };
  M.prototype.beginMutation = function() {
    return oe(this);
  };
  var Ne = n.endMutation = function(R) {
    return R._editable = R._editable && R._editable - 1, R;
  };
  M.prototype.endMutation = function() {
    return Ne(this);
  };
  var tt = n.mutate = function(R, T) {
    var j = oe(T);
    return R(j), Ne(j);
  };
  M.prototype.mutate = function(R) {
    return tt(R, this);
  };
  var Ue = function(T) {
    return T && he(T[0], T[1], T[2], T[3], T[4]);
  }, he = function(T, j, V, U, q) {
    for (; V < T; ) {
      var ne = j[V++];
      if (ne && !L(ne))
        return We(ne, U, [T, j, V, U, q]);
    }
    return Ue(q);
  }, We = function(T, j, V) {
    switch (T.type) {
      case k:
        return {
          value: j(T),
          rest: V
        };
      case O:
      case N:
      case I:
        var U = T.children;
        return he(U.length, U, 0, j, V);
      default:
        return Ue(V);
    }
  }, Ke = {
    done: !0
  };
  function _t(R) {
    this.v = R;
  }
  _t.prototype.next = function() {
    if (!this.v)
      return Ke;
    var R = this.v;
    return this.v = Ue(R.rest), R;
  }, _t.prototype[Symbol.iterator] = function() {
    return this;
  };
  var jt = function(T, j) {
    return new _t(We(T._root, j));
  }, Dt = function(T) {
    return [T.key, T.value];
  }, To = n.entries = function(R) {
    return jt(R, Dt);
  };
  M.prototype.entries = M.prototype[Symbol.iterator] = function() {
    return To(this);
  };
  var Ro = function(T) {
    return T.key;
  }, Co = n.keys = function(R) {
    return jt(R, Ro);
  };
  M.prototype.keys = function() {
    return Co(this);
  };
  var Mo = function(T) {
    return T.value;
  }, P = n.values = M.prototype.values = function(R) {
    return jt(R, Mo);
  };
  M.prototype.values = function() {
    return P(this);
  };
  var z = n.fold = function(R, T, j) {
    var V = j._root;
    if (V.type === k)
      return R(T, V.value, V.key);
    for (var U = [V.children], q = void 0; q = U.pop(); )
      for (var ne = 0, re = q.length; ne < re; ) {
        var ae = q[ne++];
        ae && ae.type && (ae.type === k ? T = R(T, ae.value, ae.key) : U.push(ae.children));
      }
    return T;
  };
  M.prototype.fold = function(R, T) {
    return z(R, T, this);
  };
  var X = n.forEach = function(R, T) {
    return z(function(j, V, U) {
      return R(V, U, T);
    }, null, T);
  };
  M.prototype.forEach = function(R) {
    return X(R, this);
  };
  var _e = n.count = function(R) {
    return R._size;
  };
  M.prototype.count = function() {
    return _e(this);
  }, Object.defineProperty(M.prototype, "size", {
    get: M.prototype.count
  }), e.exports ? e.exports = n : (void 0).hamt = n;
});
class Wm {
  constructor(t) {
    pe(this, "_map", void 0), this._map = new Map(t == null ? void 0 : t.entries());
  }
  keys() {
    return this._map.keys();
  }
  entries() {
    return this._map.entries();
  }
  get(t) {
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
  set(t, n) {
    return this._map.set(t, n), this;
  }
  delete(t) {
    return this._map.delete(t), this;
  }
  clone() {
    return ms(this);
  }
  toMap() {
    return new Map(this._map);
  }
}
class vs {
  // Because hamt.empty is not a function there is no way to introduce type
  // parameters on it, so empty is typed as HAMTPlusMap<string, mixed>.
  // $FlowIssue
  constructor(t) {
    if (pe(this, "_hamt", zm.empty.beginMutation()), t instanceof vs) {
      const n = t._hamt.endMutation();
      t._hamt = n.beginMutation(), this._hamt = n.beginMutation();
    } else if (t)
      for (const [n, r] of t.entries())
        this._hamt.set(n, r);
  }
  keys() {
    return this._hamt.keys();
  }
  entries() {
    return this._hamt.entries();
  }
  get(t) {
    return this._hamt.get(t);
  }
  has(t) {
    return this._hamt.has(t);
  }
  set(t, n) {
    return this._hamt.set(t, n), this;
  }
  delete(t) {
    return this._hamt.delete(t), this;
  }
  clone() {
    return ms(this);
  }
  toMap() {
    return new Map(this._hamt);
  }
}
function ms(e) {
  return je("recoil_hamt_2020") ? new vs(e) : new Wm(e);
}
var qm = {
  persistentMap: ms
}, Jm = qm.persistentMap, Hm = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  persistentMap: Jm
});
function Gm(e, ...t) {
  const n = /* @__PURE__ */ new Set();
  e:
    for (const r of e) {
      for (const i of t)
        if (i.has(r))
          continue e;
      n.add(r);
    }
  return n;
}
var kr = Gm;
function Km(e, t) {
  const n = /* @__PURE__ */ new Map();
  return e.forEach((r, i) => {
    n.set(i, t(r, i));
  }), n;
}
var Li = Km;
function Ym() {
  return {
    nodeDeps: /* @__PURE__ */ new Map(),
    nodeToNodeSubscriptions: /* @__PURE__ */ new Map()
  };
}
function Qm(e) {
  return {
    nodeDeps: Li(e.nodeDeps, (t) => new Set(t)),
    nodeToNodeSubscriptions: Li(e.nodeToNodeSubscriptions, (t) => new Set(t))
  };
}
function Zo(e, t, n, r) {
  const {
    nodeDeps: i,
    nodeToNodeSubscriptions: o
  } = n, a = i.get(e);
  if (a && r && a !== r.nodeDeps.get(e))
    return;
  i.set(e, t);
  const u = a == null ? t : kr(t, a);
  for (const c of u)
    o.has(c) || o.set(c, /* @__PURE__ */ new Set()), $e(o.get(c)).add(e);
  if (a) {
    const c = kr(a, t);
    for (const l of c) {
      if (!o.has(l))
        return;
      const d = $e(o.get(l));
      d.delete(e), d.size === 0 && o.delete(l);
    }
  }
}
function Zm(e, t, n, r) {
  var i, o, a, u;
  const c = n.getState();
  r === c.currentTree.version || r === ((i = c.nextTree) === null || i === void 0 ? void 0 : i.version) || r === ((o = c.previousTree) === null || o === void 0 ? void 0 : o.version) || Ze("Tried to save dependencies to a discarded tree");
  const l = n.getGraph(r);
  if (Zo(e, t, l), r === ((a = c.previousTree) === null || a === void 0 ? void 0 : a.version)) {
    const h = n.getGraph(c.currentTree.version);
    Zo(e, t, h, l);
  }
  if (r === ((u = c.previousTree) === null || u === void 0 ? void 0 : u.version) || r === c.currentTree.version) {
    var d;
    const h = (d = c.nextTree) === null || d === void 0 ? void 0 : d.version;
    if (h !== void 0) {
      const g = n.getGraph(h);
      Zo(e, t, g, l);
    }
  }
}
var xr = {
  cloneGraph: Qm,
  graph: Ym,
  saveDepsToStore: Zm
};
let Xm = 0;
const eg = () => Xm++;
let tg = 0;
const ng = () => tg++;
let rg = 0;
const ig = () => rg++;
var Zi = {
  getNextTreeStateVersion: eg,
  getNextStoreID: ng,
  getNextComponentID: ig
};
const {
  persistentMap: Pu
} = Hm, {
  graph: og
} = xr, {
  getNextTreeStateVersion: hd
} = Zi;
function vd() {
  const e = hd();
  return {
    version: e,
    stateID: e,
    transactionMetadata: {},
    dirtyAtoms: /* @__PURE__ */ new Set(),
    atomValues: Pu(),
    nonvalidatedAtoms: Pu()
  };
}
function ag() {
  const e = vd();
  return {
    currentTree: e,
    nextTree: null,
    previousTree: null,
    commitDepth: 0,
    knownAtoms: /* @__PURE__ */ new Set(),
    knownSelectors: /* @__PURE__ */ new Set(),
    transactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeTransactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeToComponentSubscriptions: /* @__PURE__ */ new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: /* @__PURE__ */ new Set(),
    graphsByVersion: (/* @__PURE__ */ new Map()).set(e.version, og()),
    retention: {
      referenceCounts: /* @__PURE__ */ new Map(),
      nodesRetainedByZone: /* @__PURE__ */ new Map(),
      retainablesToCheckForRelease: /* @__PURE__ */ new Set()
    },
    nodeCleanupFunctions: /* @__PURE__ */ new Map()
  };
}
var md = {
  makeEmptyTreeState: vd,
  makeEmptyStoreState: ag,
  getNextTreeStateVersion: hd
};
class gd {
}
function sg() {
  return new gd();
}
var Xi = {
  RetentionZone: gd,
  retentionZone: sg
};
function cg(e, t) {
  const n = new Set(e);
  return n.add(t), n;
}
function ug(e, t) {
  const n = new Set(e);
  return n.delete(t), n;
}
function lg(e, t, n) {
  const r = new Map(e);
  return r.set(t, n), r;
}
function dg(e, t, n) {
  const r = new Map(e);
  return r.set(t, n(r.get(t))), r;
}
function fg(e, t) {
  const n = new Map(e);
  return n.delete(t), n;
}
function pg(e, t) {
  const n = new Map(e);
  return t.forEach((r) => n.delete(r)), n;
}
var yd = {
  setByAddingToSet: cg,
  setByDeletingFromSet: ug,
  mapBySettingInMap: lg,
  mapByUpdatingInMap: dg,
  mapByDeletingFromMap: fg,
  mapByDeletingMultipleFromMap: pg
};
function* hg(e, t) {
  let n = 0;
  for (const r of e)
    t(r, n++) && (yield r);
}
var gs = hg;
function vg(e, t) {
  return new Proxy(e, {
    // Compute and cache lazy property if not already done.
    get: (r, i) => (!(i in r) && i in t && (r[i] = t[i]()), r[i]),
    // This method allows user to iterate keys as normal
    ownKeys: (r) => Object.keys(r)
  });
}
var _d = vg;
const {
  getNode: jr,
  getNodeMaybe: mg,
  recoilValuesForKeys: Ou
} = ht, {
  RetentionZone: Nu
} = Xi, {
  setByAddingToSet: gg
} = yd, yg = Object.freeze(/* @__PURE__ */ new Set());
class _g extends Error {
}
function bg(e, t, n) {
  if (!je("recoil_memory_managament_2020"))
    return () => {
    };
  const {
    nodesRetainedByZone: r
  } = e.getState().retention;
  function i(o) {
    let a = r.get(o);
    a || r.set(o, a = /* @__PURE__ */ new Set()), a.add(t);
  }
  if (n instanceof Nu)
    i(n);
  else if (Array.isArray(n))
    for (const o of n)
      i(o);
  return () => {
    if (!je("recoil_memory_managament_2020"))
      return;
    const {
      retention: o
    } = e.getState();
    function a(u) {
      const c = o.nodesRetainedByZone.get(u);
      c == null || c.delete(t), c && c.size === 0 && o.nodesRetainedByZone.delete(u);
    }
    if (n instanceof Nu)
      a(n);
    else if (Array.isArray(n))
      for (const u of n)
        a(u);
  };
}
function ys(e, t, n, r) {
  const i = e.getState();
  if (i.nodeCleanupFunctions.has(n))
    return;
  const o = jr(n), a = bg(e, n, o.retainedBy), u = o.init(e, t, r);
  i.nodeCleanupFunctions.set(n, () => {
    u(), a();
  });
}
function Sg(e, t, n) {
  ys(e, e.getState().currentTree, t, n);
}
function wg(e, t) {
  var n;
  const r = e.getState();
  (n = r.nodeCleanupFunctions.get(t)) === null || n === void 0 || n(), r.nodeCleanupFunctions.delete(t);
}
function kg(e, t, n) {
  return ys(e, t, n, "get"), jr(n).get(e, t);
}
function bd(e, t, n) {
  return jr(n).peek(e, t);
}
function Eg(e, t, n) {
  var r;
  const i = mg(t);
  return i == null || (r = i.invalidate) === null || r === void 0 || r.call(i, e), {
    ...e,
    atomValues: e.atomValues.clone().delete(t),
    nonvalidatedAtoms: e.nonvalidatedAtoms.clone().set(t, n),
    dirtyAtoms: gg(e.dirtyAtoms, t)
  };
}
function Tg(e, t, n, r) {
  const i = jr(n);
  if (i.set == null)
    throw new _g(`Attempt to set read-only RecoilValue: ${n}`);
  const o = i.set;
  return ys(e, t, n, "set"), o(e, t, r);
}
function Rg(e, t, n) {
  const r = e.getState(), i = e.getGraph(t.version), o = jr(n).nodeType;
  return _d({
    type: o
  }, {
    // $FlowFixMe[underconstrained-implicit-instantiation]
    loadable: () => bd(e, t, n),
    isActive: () => r.knownAtoms.has(n) || r.knownSelectors.has(n),
    isSet: () => o === "selector" ? !1 : t.atomValues.has(n),
    isModified: () => t.dirtyAtoms.has(n),
    // Report current dependencies.  If the node hasn't been evaluated, then
    // dependencies may be missing based on the current state.
    deps: () => {
      var a;
      return Ou((a = i.nodeDeps.get(n)) !== null && a !== void 0 ? a : []);
    },
    // Reports all "current" subscribers.  Evaluating other nodes or
    // previous in-progress async evaluations may introduce new subscribers.
    subscribers: () => {
      var a, u;
      return {
        nodes: Ou(gs(Sd(e, t, /* @__PURE__ */ new Set([n])), (c) => c !== n)),
        components: Qi((a = (u = r.nodeToComponentSubscriptions.get(n)) === null || u === void 0 ? void 0 : u.values()) !== null && a !== void 0 ? a : [], ([c]) => ({
          name: c
        }))
      };
    }
  });
}
function Sd(e, t, n) {
  const r = /* @__PURE__ */ new Set(), i = Array.from(n), o = e.getGraph(t.version);
  for (let u = i.pop(); u; u = i.pop()) {
    var a;
    r.add(u);
    const c = (a = o.nodeToNodeSubscriptions.get(u)) !== null && a !== void 0 ? a : yg;
    for (const l of c)
      r.has(l) || i.push(l);
  }
  return r;
}
var un = {
  getNodeLoadable: kg,
  peekNodeLoadable: bd,
  setNodeValue: Tg,
  initializeNode: Sg,
  cleanUpNode: wg,
  setUnvalidatedAtomValue_DEPRECATED: Eg,
  peekNodeInfo: Rg,
  getDownstreamNodes: Sd
};
let wd = null;
function Cg(e) {
  wd = e;
}
function Mg() {
  var e;
  (e = wd) === null || e === void 0 || e();
}
var kd = {
  setInvalidateMemoizedSnapshot: Cg,
  invalidateMemoizedSnapshot: Mg
};
const {
  getDownstreamNodes: Ag,
  getNodeLoadable: Ed,
  setNodeValue: Pg
} = un, {
  getNextComponentID: Og
} = Zi, {
  getNode: Ng,
  getNodeMaybe: Td
} = ht, {
  DefaultValue: _s
} = ht, {
  reactMode: Lg
} = ar, {
  AbstractRecoilValue: Ig,
  RecoilState: xg,
  RecoilValueReadOnly: jg,
  isRecoilValue: Dg
} = Cn, {
  invalidateMemoizedSnapshot: Vg
} = kd;
function $g(e, {
  key: t
}, n = e.getState().currentTree) {
  var r, i;
  const o = e.getState();
  n.version === o.currentTree.version || n.version === ((r = o.nextTree) === null || r === void 0 ? void 0 : r.version) || n.version === ((i = o.previousTree) === null || i === void 0 ? void 0 : i.version) || Ze("Tried to read from a discarded tree");
  const a = Ed(e, n, t);
  return a.state === "loading" && a.contents.catch(() => {
  }), a;
}
function Bg(e, t) {
  const n = e.clone();
  return t.forEach((r, i) => {
    r.state === "hasValue" && r.contents instanceof _s ? n.delete(i) : n.set(i, r);
  }), n;
}
function Fg(e, t, {
  key: n
}, r) {
  if (typeof r == "function") {
    const i = Ed(e, t, n);
    if (i.state === "loading") {
      const o = `Tried to set atom or selector "${n}" using an updater function while the current state is pending, this is not currently supported.`;
      throw Ze(o), de(o);
    } else if (i.state === "hasError")
      throw i.contents;
    return r(i.contents);
  } else
    return r;
}
function Ug(e, t, n) {
  if (n.type === "set") {
    const {
      recoilValue: i,
      valueOrUpdater: o
    } = n, a = Fg(e, t, i, o), u = Pg(e, t, i.key, a);
    for (const [c, l] of u.entries())
      La(t, c, l);
  } else if (n.type === "setLoadable") {
    const {
      recoilValue: {
        key: i
      },
      loadable: o
    } = n;
    La(t, i, o);
  } else if (n.type === "markModified") {
    const {
      recoilValue: {
        key: i
      }
    } = n;
    t.dirtyAtoms.add(i);
  } else if (n.type === "setUnvalidated") {
    var r;
    const {
      recoilValue: {
        key: i
      },
      unvalidatedValue: o
    } = n, a = Td(i);
    a == null || (r = a.invalidate) === null || r === void 0 || r.call(a, t), t.atomValues.delete(i), t.nonvalidatedAtoms.set(i, o), t.dirtyAtoms.add(i);
  } else
    Ze(`Unknown action ${n.type}`);
}
function La(e, t, n) {
  n.state === "hasValue" && n.contents instanceof _s ? e.atomValues.delete(t) : e.atomValues.set(t, n), e.dirtyAtoms.add(t), e.nonvalidatedAtoms.delete(t);
}
function Rd(e, t) {
  e.replaceState((n) => {
    const r = Cd(n);
    for (const i of t)
      Ug(e, r, i);
    return Md(e, r), Vg(), r;
  });
}
function eo(e, t) {
  if (Er.length) {
    const n = Er[Er.length - 1];
    let r = n.get(e);
    r || n.set(e, r = []), r.push(t);
  } else
    Rd(e, [t]);
}
const Er = [];
function zg() {
  const e = /* @__PURE__ */ new Map();
  return Er.push(e), () => {
    for (const [n, r] of e)
      Rd(n, r);
    Er.pop() !== e && Ze("Incorrect order of batch popping");
  };
}
function Cd(e) {
  return {
    ...e,
    atomValues: e.atomValues.clone(),
    nonvalidatedAtoms: e.nonvalidatedAtoms.clone(),
    dirtyAtoms: new Set(e.dirtyAtoms)
  };
}
function Md(e, t) {
  const n = Ag(e, t, t.dirtyAtoms);
  for (const o of n) {
    var r, i;
    (r = Td(o)) === null || r === void 0 || (i = r.invalidate) === null || i === void 0 || i.call(r, t);
  }
}
function Ad(e, t, n) {
  eo(e, {
    type: "set",
    recoilValue: t,
    valueOrUpdater: n
  });
}
function Wg(e, t, n) {
  if (n instanceof _s)
    return Ad(e, t, n);
  eo(e, {
    type: "setLoadable",
    recoilValue: t,
    loadable: n
  });
}
function qg(e, t) {
  eo(e, {
    type: "markModified",
    recoilValue: t
  });
}
function Jg(e, t, n) {
  eo(e, {
    type: "setUnvalidated",
    recoilValue: t,
    unvalidatedValue: n
  });
}
function Hg(e, {
  key: t
}, n, r = null) {
  const i = Og(), o = e.getState();
  o.nodeToComponentSubscriptions.has(t) || o.nodeToComponentSubscriptions.set(t, /* @__PURE__ */ new Map()), $e(o.nodeToComponentSubscriptions.get(t)).set(i, [r ?? "<not captured>", n]);
  const a = Lg();
  if (a.early && (a.mode === "LEGACY" || a.mode === "MUTABLE_SOURCE")) {
    const u = e.getState().nextTree;
    u && u.dirtyAtoms.has(t) && n(u);
  }
  return {
    release: () => {
      const u = e.getState(), c = u.nodeToComponentSubscriptions.get(t);
      if (c === void 0 || !c.has(i)) {
        Ze(`Subscription missing at release time for atom ${t}. This is a bug in Recoil.`);
        return;
      }
      c.delete(i), c.size === 0 && u.nodeToComponentSubscriptions.delete(t);
    }
  };
}
function Gg(e, t) {
  var n;
  const {
    currentTree: r
  } = e.getState(), i = Ng(t.key);
  (n = i.clearCache) === null || n === void 0 || n.call(i, e, r);
}
var Wt = {
  RecoilValueReadOnly: jg,
  AbstractRecoilValue: Ig,
  RecoilState: xg,
  getRecoilValueAsLoadable: $g,
  setRecoilValue: Ad,
  setRecoilValueLoadable: Wg,
  markRecoilValueModified: qg,
  setUnvalidatedRecoilValue: Jg,
  subscribeToRecoilValue: Hg,
  isRecoilValue: Dg,
  applyAtomValueWrites: Bg,
  // TODO Remove export when deprecating initialStoreState_DEPRECATED in RecoilRoot
  batchStart: zg,
  writeLoadableToTreeState: La,
  invalidateDownstreams: Md,
  copyTreeState: Cd,
  refreshRecoilValue: Gg
};
function Kg(e, t, n) {
  const r = e.entries();
  let i = r.next();
  for (; !i.done; ) {
    const o = i.value;
    if (t.call(n, o[1], o[0], e))
      return !0;
    i = r.next();
  }
  return !1;
}
var Yg = Kg;
const {
  cleanUpNode: Qg
} = un, {
  deleteNodeConfigIfPossible: Zg,
  getNode: Pd
} = ht, {
  RetentionZone: Od
} = Xi, Xg = 12e4, Nd = /* @__PURE__ */ new Set();
function Ld(e, t) {
  const n = e.getState(), r = n.currentTree;
  if (n.nextTree) {
    Ze("releaseNodesNowOnCurrentTree should only be called at the end of a batch");
    return;
  }
  const i = /* @__PURE__ */ new Set();
  for (const a of t)
    if (a instanceof Od)
      for (const u of ry(n, a))
        i.add(u);
    else
      i.add(a);
  const o = ey(e, i);
  for (const a of o)
    ny(e, r, a);
}
function ey(e, t) {
  const n = e.getState(), r = n.currentTree, i = e.getGraph(r.version), o = /* @__PURE__ */ new Set(), a = /* @__PURE__ */ new Set();
  return u(t), o;
  function u(c) {
    const l = /* @__PURE__ */ new Set(), d = ty(
      e,
      r,
      c,
      o,
      // don't descend into these
      a
      // don't descend into these
    );
    for (const y of d) {
      var h;
      if (Pd(y).retainedBy === "recoilRoot") {
        a.add(y);
        continue;
      }
      if (((h = n.retention.referenceCounts.get(y)) !== null && h !== void 0 ? h : 0) > 0) {
        a.add(y);
        continue;
      }
      if (Id(y).some((_) => n.retention.referenceCounts.get(_))) {
        a.add(y);
        continue;
      }
      const v = i.nodeToNodeSubscriptions.get(y);
      if (v && Yg(v, (_) => a.has(_))) {
        a.add(y);
        continue;
      }
      o.add(y), l.add(y);
    }
    const g = /* @__PURE__ */ new Set();
    for (const y of l)
      for (const v of (b = i.nodeDeps.get(y)) !== null && b !== void 0 ? b : Nd) {
        var b;
        o.has(v) || g.add(v);
      }
    g.size && u(g);
  }
}
function ty(e, t, n, r, i) {
  const o = e.getGraph(t.version), a = [], u = /* @__PURE__ */ new Set();
  for (; n.size > 0; )
    c($e(n.values().next().value));
  return a;
  function c(l) {
    if (r.has(l) || i.has(l)) {
      n.delete(l);
      return;
    }
    if (u.has(l))
      return;
    const d = o.nodeToNodeSubscriptions.get(l);
    if (d)
      for (const h of d)
        c(h);
    u.add(l), n.delete(l), a.push(l);
  }
}
function ny(e, t, n) {
  if (!je("recoil_memory_managament_2020"))
    return;
  Qg(e, n);
  const r = e.getState();
  r.knownAtoms.delete(n), r.knownSelectors.delete(n), r.nodeTransactionSubscriptions.delete(n), r.retention.referenceCounts.delete(n);
  const i = Id(n);
  for (const c of i) {
    var o;
    (o = r.retention.nodesRetainedByZone.get(c)) === null || o === void 0 || o.delete(n);
  }
  t.atomValues.delete(n), t.dirtyAtoms.delete(n), t.nonvalidatedAtoms.delete(n);
  const a = r.graphsByVersion.get(t.version);
  if (a) {
    const c = a.nodeDeps.get(n);
    if (c !== void 0) {
      a.nodeDeps.delete(n);
      for (const l of c) {
        var u;
        (u = a.nodeToNodeSubscriptions.get(l)) === null || u === void 0 || u.delete(n);
      }
    }
    a.nodeToNodeSubscriptions.delete(n);
  }
  Zg(n);
}
function ry(e, t) {
  var n;
  return (n = e.retention.nodesRetainedByZone.get(t)) !== null && n !== void 0 ? n : Nd;
}
function Id(e) {
  const t = Pd(e).retainedBy;
  return t === void 0 || t === "components" || t === "recoilRoot" ? [] : t instanceof Od ? [t] : t;
}
function iy(e, t) {
  const n = e.getState();
  n.nextTree ? n.retention.retainablesToCheckForRelease.add(t) : Ld(e, /* @__PURE__ */ new Set([t]));
}
function oy(e, t, n) {
  var r;
  if (!je("recoil_memory_managament_2020"))
    return;
  const i = e.getState().retention.referenceCounts, o = ((r = i.get(t)) !== null && r !== void 0 ? r : 0) + n;
  o === 0 ? xd(e, t) : i.set(t, o);
}
function xd(e, t) {
  if (!je("recoil_memory_managament_2020"))
    return;
  e.getState().retention.referenceCounts.delete(t), iy(e, t);
}
function ay(e) {
  if (!je("recoil_memory_managament_2020"))
    return;
  const t = e.getState();
  Ld(e, t.retention.retainablesToCheckForRelease), t.retention.retainablesToCheckForRelease.clear();
}
function sy(e) {
  return e === void 0 ? "recoilRoot" : e;
}
var Nn = {
  SUSPENSE_TIMEOUT_MS: Xg,
  updateRetainCount: oy,
  updateRetainCountToZero: xd,
  releaseScheduledRetainablesNow: ay,
  retainedByOptionWithDefault: sy
};
const {
  unstable_batchedUpdates: cy
} = hl;
var uy = {
  unstable_batchedUpdates: cy
};
const {
  unstable_batchedUpdates: ly
} = uy;
var dy = {
  unstable_batchedUpdates: ly
};
const {
  batchStart: fy
} = Wt, {
  unstable_batchedUpdates: py
} = dy;
let bs = py || ((e) => e());
const hy = (e) => {
  bs = e;
}, vy = () => bs, my = (e) => {
  bs(() => {
    let t = () => {
    };
    try {
      t = fy(), e();
    } finally {
      t();
    }
  });
};
var to = {
  getBatcher: vy,
  setBatcher: hy,
  batchUpdates: my
};
function* gy(e) {
  for (const t of e)
    for (const n of t)
      yield n;
}
var jd = gy;
const Dd = (
  // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
  typeof Window > "u" || typeof window > "u"
), yy = (e) => !Dd && // $FlowFixMe(site=recoil) Window does not have a FlowType definition https://github.com/facebook/flow/issues/6709
(e === window || e instanceof Window), _y = typeof navigator < "u" && navigator.product === "ReactNative";
var Dr = {
  isSSR: Dd,
  isReactNative: _y,
  isWindow: yy
};
function by(e, t) {
  let n;
  return (...r) => {
    n || (n = {});
    const i = t(...r);
    return Object.hasOwnProperty.call(n, i) || (n[i] = e(...r)), n[i];
  };
}
function Sy(e, t) {
  let n, r;
  return (...i) => {
    const o = t(...i);
    return n === o || (n = o, r = e(...i)), r;
  };
}
function wy(e, t) {
  let n, r;
  return [(...a) => {
    const u = t(...a);
    return n === u || (n = u, r = e(...a)), r;
  }, () => {
    n = null;
  }];
}
var ky = {
  memoizeWithArgsHash: by,
  memoizeOneWithArgsHash: Sy,
  memoizeOneWithArgsHashAndInvalidation: wy
};
const {
  batchUpdates: Ia
} = to, {
  initializeNode: Ey,
  peekNodeInfo: Ty
} = un, {
  graph: Ry
} = xr, {
  getNextStoreID: Cy
} = Zi, {
  DEFAULT_VALUE: My,
  recoilValues: Lu,
  recoilValuesForKeys: Iu
} = ht, {
  AbstractRecoilValue: Ay,
  getRecoilValueAsLoadable: Py,
  setRecoilValue: xu,
  setUnvalidatedRecoilValue: Oy
} = Wt, {
  updateRetainCount: mi
} = Nn, {
  setInvalidateMemoizedSnapshot: Ny
} = kd, {
  getNextTreeStateVersion: Ly,
  makeEmptyStoreState: Iy
} = md, {
  isSSR: xy
} = Dr, {
  memoizeOneWithArgsHashAndInvalidation: jy
} = ky, Dy = `
Recoil Snapshots only last for the duration of the callback they are provided to. To keep a Snapshot longer, do this:

  const release = snapshot.retain();
  try {
    await doSomethingWithSnapshot(snapshot);
  } finally {
    release();
  }

This is currently a DEV-only warning but will become a thrown exception in the next release of Recoil.
`;
class no {
  // eslint-disable-next-line fb-www/no-uninitialized-properties
  constructor(t, n) {
    pe(this, "_store", void 0), pe(this, "_refCount", 1), pe(this, "getLoadable", (r) => (this.checkRefCount_INTERNAL(), Py(this._store, r))), pe(this, "getPromise", (r) => (this.checkRefCount_INTERNAL(), this.getLoadable(r).toPromise())), pe(this, "getNodes_UNSTABLE", (r) => {
      if (this.checkRefCount_INTERNAL(), (r == null ? void 0 : r.isModified) === !0) {
        if ((r == null ? void 0 : r.isInitialized) === !1)
          return [];
        const a = this._store.getState().currentTree;
        return Iu(a.dirtyAtoms);
      }
      const i = this._store.getState().knownAtoms, o = this._store.getState().knownSelectors;
      return (r == null ? void 0 : r.isInitialized) == null ? Lu.values() : r.isInitialized === !0 ? Iu(jd([i, o])) : gs(Lu.values(), ({
        key: a
      }) => !i.has(a) && !o.has(a));
    }), pe(this, "getInfo_UNSTABLE", ({
      key: r
    }) => (this.checkRefCount_INTERNAL(), Ty(this._store, this._store.getState().currentTree, r))), pe(this, "map", (r) => {
      this.checkRefCount_INTERNAL();
      const i = new xa(this, Ia);
      return r(i), i;
    }), pe(this, "asyncMap", async (r) => {
      this.checkRefCount_INTERNAL();
      const i = new xa(this, Ia);
      return i.retain(), await r(i), i.autoRelease_INTERNAL(), i;
    }), this._store = {
      storeID: Cy(),
      parentStoreID: n,
      getState: () => t,
      replaceState: (r) => {
        t.currentTree = r(t.currentTree);
      },
      getGraph: (r) => {
        const i = t.graphsByVersion;
        if (i.has(r))
          return $e(i.get(r));
        const o = Ry();
        return i.set(r, o), o;
      },
      subscribeToTransactions: () => ({
        release: () => {
        }
      }),
      addTransactionMetadata: () => {
        throw de("Cannot subscribe to Snapshots");
      }
    };
    for (const r of this._store.getState().knownAtoms)
      Ey(this._store, r, "get"), mi(this._store, r, 1);
    this.autoRelease_INTERNAL();
  }
  retain() {
    if (this._refCount <= 0) {
      if (process.env.NODE_ENV !== "production")
        throw de("Snapshot has already been released.");
      Ze("Attempt to retain() Snapshot that was already released.");
    }
    this._refCount++;
    let t = !1;
    return () => {
      t || (t = !0, this._release());
    };
  }
  /**
   * Release the snapshot on the next tick.  This means the snapshot is retained
   * during the execution of the current function using it.
   */
  autoRelease_INTERNAL() {
    xy || window.setTimeout(() => this._release(), 10);
  }
  _release() {
    if (this._refCount--, this._refCount === 0) {
      if (this._store.getState().nodeCleanupFunctions.forEach((t) => t()), this._store.getState().nodeCleanupFunctions.clear(), !je("recoil_memory_managament_2020"))
        return;
    } else
      this._refCount < 0 && process.env.NODE_ENV !== "production" && Ze("Snapshot released an extra time.");
  }
  isRetained() {
    return this._refCount > 0;
  }
  checkRefCount_INTERNAL() {
    je("recoil_memory_managament_2020") && this._refCount <= 0 && process.env.NODE_ENV !== "production" && Ze(Dy);
  }
  getStore_INTERNAL() {
    return this.checkRefCount_INTERNAL(), this._store;
  }
  getID() {
    return this.checkRefCount_INTERNAL(), this._store.getState().currentTree.stateID;
  }
  getStoreID() {
    return this.checkRefCount_INTERNAL(), this._store.storeID;
  }
  // We want to allow the methods to be destructured and used as accessors
  /* eslint-disable fb-www/extra-arrow-initializer */
  /* eslint-enable fb-www/extra-arrow-initializer */
}
function Vd(e, t, n = !1) {
  const r = e.getState(), i = n ? Ly() : t.version;
  return {
    // Always clone the TreeState to isolate stores from accidental mutations.
    // For example, reading a selector from a cloned snapshot shouldn't cache
    // in the original treestate which may cause the original to skip
    // initialization of upstream atoms.
    currentTree: {
      // TODO snapshots shouldn't really have versions because a new version number
      // is always assigned when the snapshot is gone to.
      version: n ? i : t.version,
      stateID: n ? i : t.stateID,
      transactionMetadata: {
        ...t.transactionMetadata
      },
      dirtyAtoms: new Set(t.dirtyAtoms),
      atomValues: t.atomValues.clone(),
      nonvalidatedAtoms: t.nonvalidatedAtoms.clone()
    },
    commitDepth: 0,
    nextTree: null,
    previousTree: null,
    knownAtoms: new Set(r.knownAtoms),
    // FIXME here's a copy
    knownSelectors: new Set(r.knownSelectors),
    // FIXME here's a copy
    transactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeTransactionSubscriptions: /* @__PURE__ */ new Map(),
    nodeToComponentSubscriptions: /* @__PURE__ */ new Map(),
    queuedComponentCallbacks_DEPRECATED: [],
    suspendedComponentResolvers: /* @__PURE__ */ new Set(),
    graphsByVersion: (/* @__PURE__ */ new Map()).set(i, e.getGraph(t.version)),
    retention: {
      referenceCounts: /* @__PURE__ */ new Map(),
      nodesRetainedByZone: /* @__PURE__ */ new Map(),
      retainablesToCheckForRelease: /* @__PURE__ */ new Set()
    },
    // FIXME here's a copy
    // Create blank cleanup handlers for atoms so snapshots don't re-run
    // atom effects.
    nodeCleanupFunctions: new Map(Qi(r.nodeCleanupFunctions.entries(), ([o]) => [o, () => {
    }]))
  };
}
function Vy(e) {
  const t = new no(Iy());
  return e != null ? t.map(e) : t;
}
const [ju, $d] = jy(
  // $FlowFixMe[missing-local-annot]
  (e, t) => {
    var n;
    const r = e.getState(), i = t === "latest" ? (n = r.nextTree) !== null && n !== void 0 ? n : r.currentTree : $e(r.previousTree);
    return new no(Vd(e, i), e.storeID);
  },
  (e, t) => {
    var n, r;
    return String(t) + String(e.storeID) + String((n = e.getState().nextTree) === null || n === void 0 ? void 0 : n.version) + String(e.getState().currentTree.version) + String((r = e.getState().previousTree) === null || r === void 0 ? void 0 : r.version);
  }
);
Ny($d);
function $y(e, t = "latest") {
  const n = ju(e, t);
  return n.isRetained() ? n : ($d(), ju(e, t));
}
class xa extends no {
  constructor(t, n) {
    super(Vd(t.getStore_INTERNAL(), t.getStore_INTERNAL().getState().currentTree, !0), t.getStoreID()), pe(this, "_batch", void 0), pe(this, "set", (r, i) => {
      this.checkRefCount_INTERNAL();
      const o = this.getStore_INTERNAL();
      this._batch(() => {
        mi(o, r.key, 1), xu(this.getStore_INTERNAL(), r, i);
      });
    }), pe(this, "reset", (r) => {
      this.checkRefCount_INTERNAL();
      const i = this.getStore_INTERNAL();
      this._batch(() => {
        mi(i, r.key, 1), xu(this.getStore_INTERNAL(), r, My);
      });
    }), pe(this, "setUnvalidatedAtomValues_DEPRECATED", (r) => {
      this.checkRefCount_INTERNAL();
      const i = this.getStore_INTERNAL();
      Ia(() => {
        for (const [o, a] of r.entries())
          mi(i, o, 1), Oy(i, new Ay(o), a);
      });
    }), this._batch = n;
  }
}
var ro = {
  Snapshot: no,
  MutableSnapshot: xa,
  freshSnapshot: Vy,
  cloneSnapshot: $y
}, By = ro.Snapshot, Fy = ro.MutableSnapshot, Uy = ro.freshSnapshot, zy = ro.cloneSnapshot, io = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  Snapshot: By,
  MutableSnapshot: Fy,
  freshSnapshot: Uy,
  cloneSnapshot: zy
});
function Wy(...e) {
  const t = /* @__PURE__ */ new Set();
  for (const n of e)
    for (const r of n)
      t.add(r);
  return t;
}
var qy = Wy;
const {
  useRef: Jy
} = Z;
function Hy(e) {
  const t = Jy(e);
  return t.current === e && typeof e == "function" && (t.current = e()), t;
}
var Du = Hy;
const {
  getNextTreeStateVersion: Gy,
  makeEmptyStoreState: Bd
} = md, {
  cleanUpNode: Ky,
  getDownstreamNodes: Yy,
  initializeNode: Qy,
  setNodeValue: Zy,
  setUnvalidatedAtomValue_DEPRECATED: Xy
} = un, {
  graph: e_
} = xr, {
  cloneGraph: t_
} = xr, {
  getNextStoreID: Fd
} = Zi, {
  createMutableSource: Xo,
  reactMode: Ud
} = ar, {
  applyAtomValueWrites: n_
} = Wt, {
  releaseScheduledRetainablesNow: zd
} = Nn, {
  freshSnapshot: r_
} = io, {
  useCallback: i_,
  useContext: Wd,
  useEffect: ja,
  useMemo: o_,
  useRef: a_,
  useState: s_
} = Z;
function fr() {
  throw de("This component must be used inside a <RecoilRoot> component.");
}
const qd = Object.freeze({
  storeID: Fd(),
  getState: fr,
  replaceState: fr,
  getGraph: fr,
  subscribeToTransactions: fr,
  addTransactionMetadata: fr
});
let Da = !1;
function Vu(e) {
  if (Da)
    throw de("An atom update was triggered within the execution of a state updater function. State updater functions provided to Recoil must be pure functions.");
  const t = e.getState();
  if (t.nextTree === null) {
    je("recoil_memory_managament_2020") && je("recoil_release_on_cascading_update_killswitch_2021") && t.commitDepth > 0 && zd(e);
    const n = t.currentTree.version, r = Gy();
    t.nextTree = {
      ...t.currentTree,
      version: r,
      stateID: r,
      dirtyAtoms: /* @__PURE__ */ new Set(),
      transactionMetadata: {}
    }, t.graphsByVersion.set(r, t_($e(t.graphsByVersion.get(n))));
  }
}
const Jd = Z.createContext({
  current: qd
}), oo = () => Wd(Jd), Hd = Z.createContext(null);
function c_() {
  const e = Wd(Hd);
  return e == null && Yi("Attempted to use a Recoil hook outside of a <RecoilRoot>. <RecoilRoot> must be an ancestor of any component that uses Recoil hooks."), e;
}
function Ss(e, t, n) {
  const r = Yy(e, n, n.dirtyAtoms);
  for (const i of r) {
    const o = t.nodeToComponentSubscriptions.get(i);
    if (o)
      for (const [a, [u, c]] of o)
        c(n);
  }
}
function Gd(e) {
  const t = e.getState(), n = t.currentTree, r = n.dirtyAtoms;
  if (r.size) {
    for (const [i, o] of t.nodeTransactionSubscriptions)
      if (r.has(i))
        for (const [a, u] of o)
          u(e);
    for (const [i, o] of t.transactionSubscriptions)
      o(e);
    (!Ud().early || t.suspendedComponentResolvers.size > 0) && (Ss(e, t, n), t.suspendedComponentResolvers.forEach((i) => i()), t.suspendedComponentResolvers.clear());
  }
  t.queuedComponentCallbacks_DEPRECATED.forEach((i) => i(n)), t.queuedComponentCallbacks_DEPRECATED.splice(0, t.queuedComponentCallbacks_DEPRECATED.length);
}
function u_(e) {
  const t = e.getState();
  t.commitDepth++;
  try {
    const {
      nextTree: n
    } = t;
    if (n == null)
      return;
    t.previousTree = t.currentTree, t.currentTree = n, t.nextTree = null, Gd(e), t.previousTree != null ? t.graphsByVersion.delete(t.previousTree.version) : Ze("Ended batch with no previous state, which is unexpected", "recoil"), t.previousTree = null, je("recoil_memory_managament_2020") && n == null && zd(e);
  } finally {
    t.commitDepth--;
  }
}
function l_({
  setNotifyBatcherOfChange: e
}) {
  const t = oo(), [, n] = s_([]);
  return e(() => n({})), ja(() => (e(() => n({})), () => {
    e(() => {
    });
  }), [e]), ja(() => {
    Fm.enqueueExecution("Batcher", () => {
      u_(t.current);
    });
  }), null;
}
process.env.NODE_ENV !== "production" && typeof window < "u" && !window.$recoilDebugStates && (window.$recoilDebugStates = []);
function d_(e, t) {
  const n = Bd();
  return t({
    set: (r, i) => {
      const o = n.currentTree, a = Zy(e, o, r.key, i), u = new Set(a.keys()), c = o.nonvalidatedAtoms.clone();
      for (const l of u)
        c.delete(l);
      n.currentTree = {
        ...o,
        dirtyAtoms: qy(o.dirtyAtoms, u),
        atomValues: n_(o.atomValues, a),
        // NB: PLEASE un-export applyAtomValueWrites when deleting this code
        nonvalidatedAtoms: c
      };
    },
    setUnvalidatedAtomValues: (r) => {
      r.forEach((i, o) => {
        n.currentTree = Xy(n.currentTree, o, i);
      });
    }
  }), n;
}
function f_(e) {
  const t = r_(e), n = t.getStore_INTERNAL().getState();
  return t.retain(), n.nodeCleanupFunctions.forEach((r) => r()), n.nodeCleanupFunctions.clear(), n;
}
let $u = 0;
function p_({
  initializeState_DEPRECATED: e,
  initializeState: t,
  store_INTERNAL: n,
  // For use with React "context bridging"
  children: r
}) {
  let i;
  const o = (b) => {
    const y = i.current.graphsByVersion;
    if (y.has(b))
      return $e(y.get(b));
    const v = e_();
    return y.set(b, v), v;
  }, a = (b, y) => {
    if (y == null) {
      const {
        transactionSubscriptions: v
      } = h.current.getState(), _ = $u++;
      return v.set(_, b), {
        release: () => {
          v.delete(_);
        }
      };
    } else {
      const {
        nodeTransactionSubscriptions: v
      } = h.current.getState();
      v.has(y) || v.set(y, /* @__PURE__ */ new Map());
      const _ = $u++;
      return $e(v.get(y)).set(_, b), {
        release: () => {
          const w = v.get(y);
          w && (w.delete(_), w.size === 0 && v.delete(y));
        }
      };
    }
  }, u = (b) => {
    Vu(h.current);
    for (const y of Object.keys(b))
      $e(h.current.getState().nextTree).transactionMetadata[y] = b[y];
  }, c = (b) => {
    Vu(h.current);
    const y = $e(i.current.nextTree);
    let v;
    try {
      Da = !0, v = b(y);
    } finally {
      Da = !1;
    }
    v !== y && (process.env.NODE_ENV !== "production" && typeof window < "u" && window.$recoilDebugStates.push(v), i.current.nextTree = v, Ud().early && Ss(h.current, i.current, v), $e(l.current)());
  }, l = a_(null), d = i_((b) => {
    l.current = b;
  }, [l]), h = Du(() => n ?? {
    storeID: Fd(),
    getState: () => i.current,
    replaceState: c,
    getGraph: o,
    subscribeToTransactions: a,
    addTransactionMetadata: u
  });
  n != null && (h.current = n), i = Du(() => e != null ? d_(h.current, e) : t != null ? f_(t) : Bd());
  const g = o_(() => Xo == null ? void 0 : Xo(i, () => i.current.currentTree.version), [i]);
  return ja(() => {
    const b = h.current;
    for (const y of new Set(b.getState().knownAtoms))
      Qy(b, y, "get");
    return () => {
      for (const y of b.getState().knownAtoms)
        Ky(b, y);
    };
  }, [h]), /* @__PURE__ */ Z.createElement(Jd.Provider, {
    value: h
  }, /* @__PURE__ */ Z.createElement(Hd.Provider, {
    value: g
  }, /* @__PURE__ */ Z.createElement(l_, {
    setNotifyBatcherOfChange: d
  }), r));
}
function h_(e) {
  const {
    override: t,
    ...n
  } = e, r = oo();
  return t === !1 && r.current !== qd ? e.children : /* @__PURE__ */ Z.createElement(p_, n);
}
function v_() {
  return oo().current.storeID;
}
var Xt = {
  RecoilRoot: h_,
  useStoreRef: oo,
  useRecoilMutableSource: c_,
  useRecoilStoreID: v_,
  notifyComponents_FOR_TESTING: Ss,
  sendEndOfBatchNotifications_FOR_TESTING: Gd
};
function m_(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let n = 0, r = e.length; n < r; n++)
    if (e[n] !== t[n])
      return !1;
  return !0;
}
var g_ = m_;
const {
  useEffect: y_,
  useRef: __
} = Z;
function b_(e) {
  const t = __();
  return y_(() => {
    t.current = e;
  }), t.current;
}
var Kd = b_;
const {
  useStoreRef: S_
} = Xt, {
  SUSPENSE_TIMEOUT_MS: w_
} = Nn, {
  updateRetainCount: pr
} = Nn, {
  RetentionZone: k_
} = Xi, {
  useEffect: E_,
  useRef: T_
} = Z, {
  isSSR: Bu
} = Dr;
function R_(e) {
  if (je("recoil_memory_managament_2020"))
    return C_(e);
}
function C_(e) {
  const n = (Array.isArray(e) ? e : [e]).map((a) => a instanceof k_ ? a : a.key), r = S_();
  E_(() => {
    if (!je("recoil_memory_managament_2020"))
      return;
    const a = r.current;
    if (i.current && !Bu)
      window.clearTimeout(i.current), i.current = null;
    else
      for (const u of n)
        pr(a, u, 1);
    return () => {
      for (const u of n)
        pr(a, u, -1);
    };
  }, [r, ...n]);
  const i = T_(), o = Kd(n);
  if (!Bu && (o === void 0 || !g_(o, n))) {
    const a = r.current;
    for (const u of n)
      pr(a, u, 1);
    if (o)
      for (const u of o)
        pr(a, u, -1);
    i.current && window.clearTimeout(i.current), i.current = window.setTimeout(() => {
      i.current = null;
      for (const u of n)
        pr(a, u, -1);
    }, w_);
  }
}
var ws = R_;
function M_() {
  return "<component name not available>";
}
var Vr = M_;
const {
  batchUpdates: A_
} = to, {
  DEFAULT_VALUE: Yd
} = ht, {
  currentRendererSupportsUseSyncExternalStore: P_,
  reactMode: Ln,
  useMutableSource: O_,
  useSyncExternalStore: N_
} = ar, {
  useRecoilMutableSource: L_,
  useStoreRef: qt
} = Xt, {
  isRecoilValue: I_
} = Cn, {
  AbstractRecoilValue: Va,
  getRecoilValueAsLoadable: $r,
  setRecoilValue: Ii,
  setUnvalidatedRecoilValue: x_,
  subscribeToRecoilValue: Xn
} = Wt, {
  useCallback: ft,
  useEffect: er,
  useMemo: Qd,
  useRef: Tr,
  useState: ks
} = Z, {
  setByAddingToSet: j_
} = yd, {
  isSSR: D_
} = Dr;
function Es(e, t, n) {
  if (e.state === "hasValue")
    return e.contents;
  throw e.state === "loading" ? new Promise((i) => {
    const o = n.current.getState().suspendedComponentResolvers;
    o.add(i), D_ && xe(e.contents) && e.contents.finally(() => {
      o.delete(i);
    });
  }) : e.state === "hasError" ? e.contents : de(`Invalid value of loadable atom "${t.key}"`);
}
function st(e, t) {
  if (!I_(e))
    throw de(`Invalid argument to ${t}: expected an atom or selector but got ${String(e)}`);
}
function V_() {
  const e = Vr(), t = qt(), [, n] = ks([]), r = Tr(/* @__PURE__ */ new Set());
  r.current = /* @__PURE__ */ new Set();
  const i = Tr(/* @__PURE__ */ new Set()), o = Tr(/* @__PURE__ */ new Map()), a = ft((c) => {
    const l = o.current.get(c);
    l && (l.release(), o.current.delete(c));
  }, [o]), u = ft((c, l) => {
    o.current.has(l) && n([]);
  }, []);
  return er(() => {
    const c = t.current;
    kr(r.current, i.current).forEach((l) => {
      if (o.current.has(l)) {
        Yi(`Double subscription to RecoilValue "${l}"`);
        return;
      }
      const d = Xn(c, new Va(l), (g) => u(g, l), e);
      o.current.set(l, d), c.getState().nextTree ? c.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        u(c.getState(), l);
      }) : u(c.getState(), l);
    }), kr(i.current, r.current).forEach((l) => {
      a(l);
    }), i.current = r.current;
  }), er(() => {
    const c = o.current;
    return kr(r.current, new Set(c.keys())).forEach((l) => {
      const d = Xn(t.current, new Va(l), (h) => u(h, l), e);
      c.set(l, d);
    }), () => c.forEach((l, d) => a(d));
  }, [e, t, a, u]), Qd(() => {
    function c(y) {
      return process.env.NODE_ENV !== "production" && st(y, "useSetRecoilState"), (v) => {
        Ii(t.current, y, v);
      };
    }
    function l(y) {
      return process.env.NODE_ENV !== "production" && st(y, "useResetRecoilState"), () => Ii(t.current, y, Yd);
    }
    function d(y) {
      var v;
      process.env.NODE_ENV !== "production" && st(y, "useRecoilValueLoadable"), r.current.has(y.key) || (r.current = j_(r.current, y.key));
      const _ = t.current.getState();
      return $r(t.current, y, Ln().early && (v = _.nextTree) !== null && v !== void 0 ? v : _.currentTree);
    }
    function h(y) {
      process.env.NODE_ENV !== "production" && st(y, "useRecoilValue");
      const v = d(y);
      return Es(v, y, t);
    }
    function g(y) {
      return process.env.NODE_ENV !== "production" && st(y, "useRecoilState"), [h(y), c(y)];
    }
    function b(y) {
      return process.env.NODE_ENV !== "production" && st(y, "useRecoilStateLoadable"), [d(y), c(y)];
    }
    return {
      getRecoilValue: h,
      getRecoilValueLoadable: d,
      getRecoilState: g,
      getRecoilStateLoadable: b,
      getSetRecoilState: c,
      getResetRecoilState: l
    };
  }, [r, t]);
}
const Br = {
  current: 0
};
function $_(e) {
  const t = qt(), n = Vr(), r = ft(() => {
    var u;
    process.env.NODE_ENV !== "production" && Br.current++;
    const c = t.current, l = c.getState(), d = Ln().early && (u = l.nextTree) !== null && u !== void 0 ? u : l.currentTree;
    return {
      loadable: $r(c, e, d),
      key: e.key
    };
  }, [t, e]), i = ft((u) => {
    let c;
    return () => {
      var l, d;
      const h = u();
      return (l = c) !== null && l !== void 0 && l.loadable.is(h.loadable) && ((d = c) === null || d === void 0 ? void 0 : d.key) === h.key ? c : (c = h, h);
    };
  }, []), o = Qd(() => i(r), [r, i]), a = ft((u) => {
    const c = t.current;
    return Xn(c, e, u, n).release;
  }, [t, e, n]);
  return N_(
    a,
    o,
    // getSnapshot()
    o
    // getServerSnapshot() for SSR support
  ).loadable;
}
function B_(e) {
  const t = qt(), n = ft(() => {
    var l;
    const d = t.current, h = d.getState(), g = Ln().early && (l = h.nextTree) !== null && l !== void 0 ? l : h.currentTree;
    return $r(d, e, g);
  }, [t, e]), r = ft(() => (process.env.NODE_ENV !== "production" && Br.current++, n()), [n]), i = Vr(), o = ft((l, d) => {
    const h = t.current;
    return Xn(h, e, () => {
      if (!je("recoil_suppress_rerender_in_callback"))
        return d();
      const b = n();
      c.current.is(b) || d(), c.current = b;
    }, i).release;
  }, [t, e, i, n]), a = L_();
  if (a == null)
    throw de("Recoil hooks must be used in components contained within a <RecoilRoot> component.");
  const u = O_(a, r, o), c = Tr(u);
  return er(() => {
    c.current = u;
  }), u;
}
function $a(e) {
  const t = qt(), n = Vr(), r = ft(() => {
    var c;
    process.env.NODE_ENV !== "production" && Br.current++;
    const l = t.current, d = l.getState(), h = Ln().early && (c = d.nextTree) !== null && c !== void 0 ? c : d.currentTree;
    return $r(l, e, h);
  }, [t, e]), i = ft(() => ({
    loadable: r(),
    key: e.key
  }), [r, e.key]), o = ft((c) => {
    const l = i();
    return c.loadable.is(l.loadable) && c.key === l.key ? c : l;
  }, [i]);
  er(() => {
    const c = Xn(t.current, e, (l) => {
      u(o);
    }, n);
    return u(o), c.release;
  }, [n, e, t, o]);
  const [a, u] = ks(i);
  return a.key !== e.key ? i().loadable : a.loadable;
}
function F_(e) {
  const t = qt(), [, n] = ks([]), r = Vr(), i = ft(() => {
    var u;
    process.env.NODE_ENV !== "production" && Br.current++;
    const c = t.current, l = c.getState(), d = Ln().early && (u = l.nextTree) !== null && u !== void 0 ? u : l.currentTree;
    return $r(c, e, d);
  }, [t, e]), o = i(), a = Tr(o);
  return er(() => {
    a.current = o;
  }), er(() => {
    const u = t.current, c = u.getState(), l = Xn(u, e, (h) => {
      var g;
      if (!je("recoil_suppress_rerender_in_callback"))
        return n([]);
      const b = i();
      (g = a.current) !== null && g !== void 0 && g.is(b) || n(b), a.current = b;
    }, r);
    if (c.nextTree)
      u.getState().queuedComponentCallbacks_DEPRECATED.push(() => {
        a.current = null, n([]);
      });
    else {
      var d;
      if (!je("recoil_suppress_rerender_in_callback"))
        return n([]);
      const h = i();
      (d = a.current) !== null && d !== void 0 && d.is(h) || n(h), a.current = h;
    }
    return l.release;
  }, [r, i, e, t]), o;
}
function Ts(e) {
  return process.env.NODE_ENV !== "production" && st(e, "useRecoilValueLoadable"), je("recoil_memory_managament_2020") && ws(e), {
    TRANSITION_SUPPORT: $a,
    // Recoil will attemp to detect if `useSyncExternalStore()` is supported with
    // `reactMode()` before calling it.  However, sometimes the host React
    // environment supports it but uses additional React renderers (such as with
    // `react-three-fiber`) which do not.  While this is technically a user issue
    // by using a renderer with React 18+ that doesn't fully support React 18 we
    // don't want to break users if it can be avoided. As the current renderer can
    // change at runtime, we need to dynamically check and fallback if necessary.
    SYNC_EXTERNAL_STORE: P_() ? $_ : $a,
    MUTABLE_SOURCE: B_,
    LEGACY: F_
  }[Ln().mode](e);
}
function Zd(e) {
  process.env.NODE_ENV !== "production" && st(e, "useRecoilValue");
  const t = qt(), n = Ts(e);
  return Es(n, e, t);
}
function ao(e) {
  process.env.NODE_ENV !== "production" && st(e, "useSetRecoilState");
  const t = qt();
  return ft((n) => {
    Ii(t.current, e, n);
  }, [t, e]);
}
function U_(e) {
  process.env.NODE_ENV !== "production" && st(e, "useResetRecoilState");
  const t = qt();
  return ft(() => {
    Ii(t.current, e, Yd);
  }, [t, e]);
}
function z_(e) {
  return process.env.NODE_ENV !== "production" && st(e, "useRecoilState"), [Zd(e), ao(e)];
}
function W_(e) {
  return process.env.NODE_ENV !== "production" && st(e, "useRecoilStateLoadable"), [Ts(e), ao(e)];
}
function q_() {
  const e = qt();
  return (t, n = {}) => {
    A_(() => {
      e.current.addTransactionMetadata(n), t.forEach((r, i) => x_(e.current, new Va(i), r));
    });
  };
}
function Xd(e) {
  return process.env.NODE_ENV !== "production" && (st(e, "useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE"), Ln().early || Ze("Attepmt to use a hook with UNSTABLE_TRANSITION_SUPPORT in a rendering mode incompatible with concurrent rendering.  Try enabling the recoil_sync_external_store or recoil_transition_support GKs.")), je("recoil_memory_managament_2020") && ws(e), $a(e);
}
function ef(e) {
  process.env.NODE_ENV !== "production" && st(e, "useRecoilValue_TRANSITION_SUPPORT_UNSTABLE");
  const t = qt(), n = Xd(e);
  return Es(n, e, t);
}
function J_(e) {
  return process.env.NODE_ENV !== "production" && st(e, "useRecoilState_TRANSITION_SUPPORT_UNSTABLE"), [ef(e), ao(e)];
}
var H_ = {
  recoilComponentGetRecoilValueCount_FOR_TESTING: Br,
  useRecoilInterface: V_,
  useRecoilState: z_,
  useRecoilStateLoadable: W_,
  useRecoilValue: Zd,
  useRecoilValueLoadable: Ts,
  useResetRecoilState: U_,
  useSetRecoilState: ao,
  useSetUnvalidatedAtomValues: q_,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: Xd,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: ef,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: J_
};
function G_(e, t) {
  const n = /* @__PURE__ */ new Map();
  for (const [r, i] of e)
    t(i, r) && n.set(r, i);
  return n;
}
var K_ = G_;
function Y_(e, t) {
  const n = /* @__PURE__ */ new Set();
  for (const r of e)
    t(r) && n.add(r);
  return n;
}
var Q_ = Y_;
function Z_(...e) {
  const t = /* @__PURE__ */ new Map();
  for (let n = 0; n < e.length; n++) {
    const r = e[n].keys();
    let i;
    for (; !(i = r.next()).done; )
      t.set(i.value, e[n].get(i.value));
  }
  return t;
}
var X_ = Z_;
const {
  batchUpdates: eb
} = to, {
  DEFAULT_VALUE: tb,
  getNode: tf,
  nodes: nb
} = ht, {
  useStoreRef: Rs
} = Xt, {
  AbstractRecoilValue: rb,
  setRecoilValueLoadable: ib
} = Wt, {
  SUSPENSE_TIMEOUT_MS: ob
} = Nn, {
  cloneSnapshot: xi
} = io, {
  useCallback: so,
  useEffect: nf,
  useRef: Fu,
  useState: ab
} = Z, {
  isSSR: Uu
} = Dr;
function co(e) {
  const t = Rs();
  nf(() => t.current.subscribeToTransactions(e).release, [e, t]);
}
function zu(e) {
  const t = e.atomValues.toMap(), n = Li(K_(t, (r, i) => {
    const a = tf(i).persistence_UNSTABLE;
    return a != null && a.type !== "none" && r.state === "hasValue";
  }), (r) => r.contents);
  return X_(e.nonvalidatedAtoms.toMap(), n);
}
function sb(e) {
  co(so((t) => {
    let n = t.getState().previousTree;
    const r = t.getState().currentTree;
    n || (Ze("Transaction subscribers notified without a previous tree being present -- this is a bug in Recoil"), n = t.getState().currentTree);
    const i = zu(r), o = zu(n), a = Li(nb, (c) => {
      var l, d, h, g;
      return {
        persistence_UNSTABLE: {
          type: (l = (d = c.persistence_UNSTABLE) === null || d === void 0 ? void 0 : d.type) !== null && l !== void 0 ? l : "none",
          backButton: (h = (g = c.persistence_UNSTABLE) === null || g === void 0 ? void 0 : g.backButton) !== null && h !== void 0 ? h : !1
        }
      };
    }), u = Q_(r.dirtyAtoms, (c) => i.has(c) || o.has(c));
    e({
      atomValues: i,
      previousAtomValues: o,
      atomInfo: a,
      modifiedAtoms: u,
      transactionMetadata: {
        ...r.transactionMetadata
      }
    });
  }, [e]));
}
function cb(e) {
  co(so((t) => {
    const n = xi(t, "latest"), r = xi(t, "previous");
    e({
      snapshot: n,
      previousSnapshot: r
    });
  }, [e]));
}
function ub() {
  const e = Rs(), [t, n] = ab(() => xi(e.current)), r = Kd(t), i = Fu(), o = Fu();
  if (co(so((u) => n(xi(u)), [])), nf(() => {
    const u = t.retain();
    if (i.current && !Uu) {
      var c;
      window.clearTimeout(i.current), i.current = null, (c = o.current) === null || c === void 0 || c.call(o), o.current = null;
    }
    return () => {
      window.setTimeout(u, 10);
    };
  }, [t]), r !== t && !Uu) {
    if (i.current) {
      var a;
      window.clearTimeout(i.current), i.current = null, (a = o.current) === null || a === void 0 || a.call(o), o.current = null;
    }
    o.current = t.retain(), i.current = window.setTimeout(() => {
      var u;
      i.current = null, (u = o.current) === null || u === void 0 || u.call(o), o.current = null;
    }, ob);
  }
  return t;
}
function rf(e, t) {
  var n;
  const r = e.getState(), i = (n = r.nextTree) !== null && n !== void 0 ? n : r.currentTree, o = t.getStore_INTERNAL().getState().currentTree;
  eb(() => {
    const a = /* @__PURE__ */ new Set();
    for (const l of [i.atomValues.keys(), o.atomValues.keys()])
      for (const d of l) {
        var u, c;
        ((u = i.atomValues.get(d)) === null || u === void 0 ? void 0 : u.contents) !== ((c = o.atomValues.get(d)) === null || c === void 0 ? void 0 : c.contents) && tf(d).shouldRestoreFromSnapshots && a.add(d);
      }
    a.forEach((l) => {
      ib(e, new rb(l), o.atomValues.has(l) ? $e(o.atomValues.get(l)) : tb);
    }), e.replaceState((l) => ({
      ...l,
      stateID: t.getID()
    }));
  });
}
function lb() {
  const e = Rs();
  return so((t) => rf(e.current, t), [e]);
}
var of = {
  useRecoilSnapshot: ub,
  gotoSnapshot: rf,
  useGotoRecoilSnapshot: lb,
  useRecoilTransactionObserver: cb,
  useTransactionObservation_DEPRECATED: sb,
  useTransactionSubscription_DEPRECATED: co
};
const {
  peekNodeInfo: db
} = un, {
  useStoreRef: fb
} = Xt;
function pb() {
  const e = fb();
  return ({
    key: t
  }) => db(e.current, e.current.getState().currentTree, t);
}
var hb = pb;
const {
  reactMode: vb
} = ar, {
  RecoilRoot: mb,
  useStoreRef: gb
} = Xt, {
  useMemo: yb
} = Z;
function _b() {
  vb().mode === "MUTABLE_SOURCE" && console.warn("Warning: There are known issues using useRecoilBridgeAcrossReactRoots() in recoil_mutable_source rendering mode.  Please consider upgrading to recoil_sync_external_store mode.");
  const e = gb().current;
  return yb(() => {
    function t({
      children: n
    }) {
      return /* @__PURE__ */ Z.createElement(mb, {
        store_INTERNAL: e
      }, n);
    }
    return t;
  }, [e]);
}
var bb = _b;
const {
  loadableWithValue: Sb
} = Ir, {
  initializeNode: wb
} = un, {
  DEFAULT_VALUE: kb,
  getNode: Eb
} = ht, {
  copyTreeState: Tb,
  getRecoilValueAsLoadable: Rb,
  invalidateDownstreams: Cb,
  writeLoadableToTreeState: Mb
} = Wt;
function Wu(e) {
  return Eb(e.key).nodeType === "atom";
}
class Ab {
  constructor(t, n) {
    pe(this, "_store", void 0), pe(this, "_treeState", void 0), pe(this, "_changes", void 0), pe(this, "get", (r) => {
      if (this._changes.has(r.key))
        return this._changes.get(r.key);
      if (!Wu(r))
        throw de("Reading selectors within atomicUpdate is not supported");
      const i = Rb(this._store, r, this._treeState);
      if (i.state === "hasValue")
        return i.contents;
      throw i.state === "hasError" ? i.contents : de(`Expected Recoil atom ${r.key} to have a value, but it is in a loading state.`);
    }), pe(this, "set", (r, i) => {
      if (!Wu(r))
        throw de("Setting selectors within atomicUpdate is not supported");
      if (typeof i == "function") {
        const o = this.get(r);
        this._changes.set(r.key, i(o));
      } else
        wb(this._store, r.key, "set"), this._changes.set(r.key, i);
    }), pe(this, "reset", (r) => {
      this.set(r, kb);
    }), this._store = t, this._treeState = n, this._changes = /* @__PURE__ */ new Map();
  }
  // Allow destructing
  // eslint-disable-next-line fb-www/extra-arrow-initializer
  newTreeState_INTERNAL() {
    if (this._changes.size === 0)
      return this._treeState;
    const t = Tb(this._treeState);
    for (const [n, r] of this._changes)
      Mb(t, n, Sb(r));
    return Cb(this._store, t), t;
  }
}
function Pb(e) {
  return (t) => {
    e.replaceState((n) => {
      const r = new Ab(e, n);
      return t(r), r.newTreeState_INTERNAL();
    });
  };
}
var Ob = {
  atomicUpdater: Pb
}, Nb = Ob.atomicUpdater, af = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  atomicUpdater: Nb
});
function Lb(e, t) {
  if (!e)
    throw new Error(t);
}
var Ib = Lb, Vt = Ib;
const {
  atomicUpdater: xb
} = af, {
  batchUpdates: jb
} = to, {
  DEFAULT_VALUE: Db
} = ht, {
  useStoreRef: Vb
} = Xt, {
  refreshRecoilValue: $b,
  setRecoilValue: qu
} = Wt, {
  cloneSnapshot: Bb
} = io, {
  gotoSnapshot: Fb
} = of, {
  useCallback: Ub
} = Z;
class sf {
}
const zb = new sf();
function cf(e, t, n, r) {
  let i = zb, o;
  if (jb(() => {
    const u = "useRecoilCallback() expects a function that returns a function: it accepts a function of the type (RecoilInterface) => (Args) => ReturnType and returns a callback function (Args) => ReturnType, where RecoilInterface is an object {snapshot, set, ...} and Args and ReturnType are the argument and return types of the callback you want to create.  Please see the docs at recoiljs.org for details.";
    if (typeof t != "function")
      throw de(u);
    const c = _d({
      ...r ?? {},
      // flowlint-line unclear-type:off
      // $FlowFixMe[missing-local-annot]
      set: (d, h) => qu(e, d, h),
      // $FlowFixMe[missing-local-annot]
      reset: (d) => qu(e, d, Db),
      // $FlowFixMe[missing-local-annot]
      refresh: (d) => $b(e, d),
      gotoSnapshot: (d) => Fb(e, d),
      transact_UNSTABLE: (d) => xb(e)(d)
    }, {
      snapshot: () => {
        const d = Bb(e);
        return o = d.retain(), d;
      }
    }), l = t(c);
    if (typeof l != "function")
      throw de(u);
    i = l(...n);
  }), i instanceof sf && (process.env.NODE_ENV !== "production" ? Vt(!1, "batchUpdates should return immediately") : Vt(!1)), xe(i))
    i = i.finally(() => {
      var u;
      (u = o) === null || u === void 0 || u();
    });
  else {
    var a;
    (a = o) === null || a === void 0 || a();
  }
  return i;
}
function Wb(e, t) {
  const n = Vb();
  return Ub(
    // $FlowIssue[incompatible-call]
    (...r) => cf(n.current, e, r),
    t != null ? [...t, n] : void 0
    // eslint-disable-line fb-www/react-hooks-deps
  );
}
var uf = {
  recoilCallback: cf,
  useRecoilCallback: Wb
};
const {
  useStoreRef: qb
} = Xt, {
  refreshRecoilValue: Jb
} = Wt, {
  useCallback: Hb
} = Z;
function Gb(e) {
  const t = qb();
  return Hb(() => {
    const n = t.current;
    Jb(n, e);
  }, [e, t]);
}
var Kb = Gb;
const {
  atomicUpdater: Yb
} = af, {
  useStoreRef: Qb
} = Xt, {
  useMemo: Zb
} = Z;
function Xb(e, t) {
  const n = Qb();
  return Zb(
    () => (...r) => {
      Yb(n.current)((o) => {
        e(o)(...r);
      });
    },
    t != null ? [...t, n] : void 0
    // eslint-disable-line fb-www/react-hooks-deps
  );
}
var eS = Xb;
class tS {
  constructor(t) {
    pe(this, "value", void 0), this.value = t;
  }
}
var nS = {
  WrappedValue: tS
}, rS = nS.WrappedValue, lf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WrappedValue: rS
});
const {
  isFastRefreshEnabled: iS
} = ar;
class Ju extends Error {
}
class oS {
  // $FlowIssue[unclear-type]
  constructor(t) {
    var n, r, i;
    pe(this, "_name", void 0), pe(this, "_numLeafs", void 0), pe(this, "_root", void 0), pe(this, "_onHit", void 0), pe(this, "_onSet", void 0), pe(this, "_mapNodeValue", void 0), this._name = t == null ? void 0 : t.name, this._numLeafs = 0, this._root = null, this._onHit = (n = t == null ? void 0 : t.onHit) !== null && n !== void 0 ? n : () => {
    }, this._onSet = (r = t == null ? void 0 : t.onSet) !== null && r !== void 0 ? r : () => {
    }, this._mapNodeValue = (i = t == null ? void 0 : t.mapNodeValue) !== null && i !== void 0 ? i : (o) => o;
  }
  size() {
    return this._numLeafs;
  }
  // $FlowIssue[unclear-type]
  root() {
    return this._root;
  }
  get(t, n) {
    var r;
    return (r = this.getLeafNode(t, n)) === null || r === void 0 ? void 0 : r.value;
  }
  getLeafNode(t, n) {
    if (this._root == null)
      return;
    let r = this._root;
    for (; r; ) {
      if (n == null || n.onNodeVisit(r), r.type === "leaf")
        return this._onHit(r), r;
      const i = this._mapNodeValue(t(r.nodeKey));
      r = r.branches.get(i);
    }
  }
  set(t, n, r) {
    const i = () => {
      var o, a, u, c;
      let l, d;
      for (const [_, w] of t) {
        var h, g, b;
        const k = this._root;
        if ((k == null ? void 0 : k.type) === "leaf")
          throw this.invalidCacheError();
        const O = l;
        if (l = O ? O.branches.get(d) : k, l = (h = l) !== null && h !== void 0 ? h : {
          type: "branch",
          nodeKey: _,
          parent: O,
          branches: /* @__PURE__ */ new Map(),
          branchKey: d
        }, l.type !== "branch" || l.nodeKey !== _)
          throw this.invalidCacheError();
        O == null || O.branches.set(d, l), r == null || (g = r.onNodeVisit) === null || g === void 0 || g.call(r, l), d = this._mapNodeValue(w), this._root = (b = this._root) !== null && b !== void 0 ? b : l;
      }
      const y = l ? (o = l) === null || o === void 0 ? void 0 : o.branches.get(d) : this._root;
      if (y != null && (y.type !== "leaf" || y.branchKey !== d))
        throw this.invalidCacheError();
      const v = {
        type: "leaf",
        value: n,
        parent: l,
        branchKey: d
      };
      (a = l) === null || a === void 0 || a.branches.set(d, v), this._root = (u = this._root) !== null && u !== void 0 ? u : v, this._numLeafs++, this._onSet(v), r == null || (c = r.onNodeVisit) === null || c === void 0 || c.call(r, v);
    };
    try {
      i();
    } catch (o) {
      if (o instanceof Ju)
        this.clear(), i();
      else
        throw o;
    }
  }
  // Returns true if leaf was actually deleted from the tree
  delete(t) {
    const n = this.root();
    if (!n)
      return !1;
    if (t === n)
      return this._root = null, this._numLeafs = 0, !0;
    let r = t.parent, i = t.branchKey;
    for (; r; ) {
      var o;
      if (r.branches.delete(i), r === n)
        return r.branches.size === 0 ? (this._root = null, this._numLeafs = 0) : this._numLeafs--, !0;
      if (r.branches.size > 0)
        break;
      i = (o = r) === null || o === void 0 ? void 0 : o.branchKey, r = r.parent;
    }
    for (; r !== n; r = r.parent)
      if (r == null)
        return !1;
    return this._numLeafs--, !0;
  }
  clear() {
    this._numLeafs = 0, this._root = null;
  }
  invalidCacheError() {
    const t = iS() ? "Possible Fast Refresh module reload detected.  This may also be caused by an selector returning inconsistent values. Resetting cache." : "Invalid cache values.  This happens when selectors do not return consistent values for the same input dependency values.  That may also be caused when using Fast Refresh to change a selector implementation.  Resetting cache.";
    throw Ze(t + (this._name != null ? ` - ${this._name}` : "")), new Ju();
  }
}
var aS = {
  TreeCache: oS
}, sS = aS.TreeCache, df = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  TreeCache: sS
});
class cS {
  constructor(t) {
    var n;
    pe(this, "_maxSize", void 0), pe(this, "_size", void 0), pe(this, "_head", void 0), pe(this, "_tail", void 0), pe(this, "_map", void 0), pe(this, "_keyMapper", void 0), this._maxSize = t.maxSize, this._size = 0, this._head = null, this._tail = null, this._map = /* @__PURE__ */ new Map(), this._keyMapper = (n = t.mapKey) !== null && n !== void 0 ? n : (r) => r;
  }
  head() {
    return this._head;
  }
  tail() {
    return this._tail;
  }
  size() {
    return this._size;
  }
  maxSize() {
    return this._maxSize;
  }
  has(t) {
    return this._map.has(this._keyMapper(t));
  }
  get(t) {
    const n = this._keyMapper(t), r = this._map.get(n);
    if (r)
      return this.set(t, r.value), r.value;
  }
  set(t, n) {
    const r = this._keyMapper(t);
    this._map.get(r) && this.delete(t);
    const o = this.head(), a = {
      key: t,
      right: o,
      left: null,
      value: n
    };
    o ? o.left = a : this._tail = a, this._map.set(r, a), this._head = a, this._size++, this._maybeDeleteLRU();
  }
  _maybeDeleteLRU() {
    this.size() > this.maxSize() && this.deleteLru();
  }
  deleteLru() {
    const t = this.tail();
    t && this.delete(t.key);
  }
  delete(t) {
    const n = this._keyMapper(t);
    if (!this._size || !this._map.has(n))
      return;
    const r = $e(this._map.get(n)), i = r.right, o = r.left;
    i && (i.left = r.left), o && (o.right = r.right), r === this.head() && (this._head = i), r === this.tail() && (this._tail = o), this._map.delete(n), this._size--;
  }
  clear() {
    this._size = 0, this._head = null, this._tail = null, this._map = /* @__PURE__ */ new Map();
  }
}
var uS = {
  LRUCache: cS
}, lS = uS.LRUCache, ff = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  LRUCache: lS
});
const {
  LRUCache: dS
} = ff, {
  TreeCache: fS
} = df;
function pS({
  name: e,
  maxSize: t,
  mapNodeValue: n = (r) => r
}) {
  const r = new dS({
    maxSize: t
  }), i = new fS({
    name: e,
    mapNodeValue: n,
    onHit: (o) => {
      r.set(o, !0);
    },
    onSet: (o) => {
      const a = r.tail();
      r.set(o, !0), a && i.size() > t && i.delete(a.key);
    }
  });
  return i;
}
var Hu = pS;
const hS = 15;
function St(e, t, n) {
  if (typeof e == "string" && !e.includes('"') && !e.includes("\\"))
    return `"${e}"`;
  switch (typeof e) {
    case "undefined":
      return "";
    case "boolean":
      return e ? "true" : "false";
    case "number":
    case "symbol":
      return String(e);
    case "string":
      return JSON.stringify(e);
    case "function":
      if ((t == null ? void 0 : t.allowFunctions) !== !0)
        throw de("Attempt to serialize function in a Recoil cache key");
      return `__FUNCTION(${e.name})__`;
  }
  if (e === null)
    return "null";
  if (typeof e != "object") {
    var r;
    return (r = JSON.stringify(e)) !== null && r !== void 0 ? r : "";
  }
  if (xe(e))
    return "__PROMISE__";
  if (Array.isArray(e))
    return `[${e.map((i, o) => St(i, t, o.toString()))}]`;
  if (typeof e.toJSON == "function")
    return St(e.toJSON(n), t, n);
  if (e instanceof Map) {
    const i = {};
    for (const [o, a] of e)
      i[typeof o == "string" ? o : St(o, t)] = a;
    return St(i, t, n);
  }
  return e instanceof Set ? St(
    // $FlowFixMe[missing-local-annot]
    Array.from(e).sort((i, o) => St(i, t).localeCompare(St(o, t))),
    t,
    n
  ) : Symbol !== void 0 && e[Symbol.iterator] != null && typeof e[Symbol.iterator] == "function" ? St(Array.from(e), t, n) : `{${Object.keys(e).filter((i) => e[i] !== void 0).sort().map((i) => `${St(i, t)}:${St(e[i], t, i)}`).join(",")}}`;
}
function vS(e, t = {
  allowFunctions: !1
}) {
  if (process.env.NODE_ENV !== "production" && typeof window < "u") {
    const n = window.performance ? window.performance.now() : 0, r = St(e, t), i = window.performance ? window.performance.now() : 0;
    return i - n > hS && (console.groupCollapsed(`Recoil: Spent ${i - n}ms computing a cache key`), console.warn(e, r), console.groupEnd()), r;
  }
  return St(e, t);
}
var uo = vS;
const {
  TreeCache: mS
} = df, ii = {
  equality: "reference",
  eviction: "keep-all",
  maxSize: 1 / 0
};
function gS({
  equality: e = ii.equality,
  eviction: t = ii.eviction,
  maxSize: n = ii.maxSize
} = ii, r) {
  const i = yS(e);
  return _S(t, n, i, r);
}
function yS(e) {
  switch (e) {
    case "reference":
      return (t) => t;
    case "value":
      return (t) => uo(t);
  }
  throw de(`Unrecognized equality policy ${e}`);
}
function _S(e, t, n, r) {
  switch (e) {
    case "keep-all":
      return new mS({
        name: r,
        mapNodeValue: n
      });
    case "lru":
      return Hu({
        name: r,
        maxSize: $e(t),
        mapNodeValue: n
      });
    case "most-recent":
      return Hu({
        name: r,
        maxSize: 1,
        mapNodeValue: n
      });
  }
  throw de(`Unrecognized eviction policy ${e}`);
}
var bS = gS;
function SS(e) {
  var t, n;
  if (typeof window > "u")
    return !1;
  const i = (n = (e != null ? (t = e.ownerDocument) !== null && t !== void 0 ? t : e : document).defaultView) !== null && n !== void 0 ? n : window;
  return e != null && (typeof i.Node == "function" ? e instanceof i.Node : typeof e == "object" && typeof e.nodeType == "number" && typeof e.nodeName == "string");
}
var wS = SS;
const {
  isReactNative: kS,
  isWindow: ES
} = Dr;
function TS(e) {
  if (e === null || typeof e != "object")
    return !0;
  switch (typeof e.$$typeof) {
    case "symbol":
      return !0;
    case "number":
      return !0;
  }
  return !!(e["@@__IMMUTABLE_ITERABLE__@@"] != null || e["@@__IMMUTABLE_KEYED__@@"] != null || e["@@__IMMUTABLE_INDEXED__@@"] != null || e["@@__IMMUTABLE_ORDERED__@@"] != null || e["@@__IMMUTABLE_RECORD__@@"] != null || wS(e) || xe(e) || e instanceof Error || ArrayBuffer.isView(e) || !kS && ES(e));
}
function pf(e) {
  if (!(typeof e != "object" || TS(e))) {
    Object.freeze(e);
    for (const t in e)
      if (Object.prototype.hasOwnProperty.call(e, t)) {
        const n = e[t];
        typeof n == "object" && n != null && !Object.isFrozen(n) && pf(n);
      }
    Object.seal(e);
  }
}
var Ba = pf;
function RS(e) {
  return () => null;
}
var CS = {
  startPerfBlock: RS
};
const {
  isLoadable: MS,
  loadableWithError: oi,
  loadableWithPromise: AS,
  loadableWithValue: ea
} = Ir, {
  WrappedValue: hf
} = lf, {
  getNodeLoadable: ai,
  peekNodeLoadable: PS,
  setNodeValue: OS
} = un, {
  saveDepsToStore: NS
} = xr, {
  DEFAULT_VALUE: LS,
  getConfigDeletionHandler: IS,
  getNode: xS,
  registerNode: Gu
} = ht, {
  isRecoilValue: jS
} = Cn, {
  markRecoilValueModified: Ku
} = Wt, {
  retainedByOptionWithDefault: DS
} = Nn, {
  recoilCallback: VS
} = uf, {
  startPerfBlock: $S
} = CS;
class vf {
}
const hr = new vf(), vr = [], si = /* @__PURE__ */ new Map(), BS = /* @__PURE__ */ (() => {
  let e = 0;
  return () => e++;
})();
function mf(e) {
  let t = null;
  const {
    key: n,
    get: r,
    cachePolicy_UNSTABLE: i
  } = e, o = e.set != null ? e.set : void 0;
  if (process.env.NODE_ENV !== "production") {
    if (typeof n != "string")
      throw de("A key option with a unique string value must be provided when creating a selector.");
    if (typeof r != "function")
      throw de("Selectors must specify a get callback option to get the selector value.");
  }
  const a = /* @__PURE__ */ new Set(), u = bS(i ?? {
    equality: "reference",
    eviction: "keep-all"
  }, n), c = DS(e.retainedBy_UNSTABLE), l = /* @__PURE__ */ new Map();
  let d = 0;
  function h() {
    return !je("recoil_memory_managament_2020") || d > 0;
  }
  function g(M) {
    return M.getState().knownSelectors.add(n), d++, () => {
      d--;
    };
  }
  function b() {
    return IS(n) !== void 0 && !h();
  }
  function y(M, s, p, f, m) {
    se(s, f, m), v(M, p);
  }
  function v(M, s) {
    ce(M, s) && J(M), w(s, !0);
  }
  function _(M, s) {
    ce(M, s) && ($e(G(M)).stateVersions.clear(), w(s, !1));
  }
  function w(M, s) {
    const p = si.get(M);
    if (p != null) {
      for (const f of p)
        Ku(f, $e(t));
      s && si.delete(M);
    }
  }
  function k(M, s) {
    let p = si.get(s);
    p == null && si.set(s, p = /* @__PURE__ */ new Set()), p.add(M);
  }
  function O(M, s, p, f, m, S) {
    return s.then((C) => {
      if (!h())
        throw J(M), hr;
      const A = ea(C);
      return y(M, p, m, A, f), C;
    }).catch((C) => {
      if (!h())
        throw J(M), hr;
      if (xe(C))
        return I(M, C, p, f, m, S);
      const A = oi(C);
      throw y(M, p, m, A, f), C;
    });
  }
  function I(M, s, p, f, m, S) {
    return s.then((C) => {
      if (!h())
        throw J(M), hr;
      S.loadingDepKey != null && S.loadingDepPromise === s ? p.atomValues.set(S.loadingDepKey, ea(C)) : M.getState().knownSelectors.forEach((W) => {
        p.atomValues.delete(W);
      });
      const A = L(M, p);
      if (A && A.state !== "loading") {
        if ((ce(M, m) || G(M) == null) && v(M, m), A.state === "hasValue")
          return A.contents;
        throw A.contents;
      }
      if (!ce(M, m)) {
        const W = Q(M, p);
        if (W != null)
          return W.loadingLoadable.contents;
      }
      const [x, F] = E(M, p, m);
      if (x.state !== "loading" && y(M, p, m, x, F), x.state === "hasError")
        throw x.contents;
      return x.contents;
    }).catch((C) => {
      if (C instanceof vf)
        throw hr;
      if (!h())
        throw J(M), hr;
      const A = oi(C);
      throw y(M, p, m, A, f), C;
    });
  }
  function N(M, s, p, f) {
    var m, S, C, A;
    if (ce(M, f) || s.version === ((m = M.getState()) === null || m === void 0 || (S = m.currentTree) === null || S === void 0 ? void 0 : S.version) || s.version === ((C = M.getState()) === null || C === void 0 || (A = C.nextTree) === null || A === void 0 ? void 0 : A.version)) {
      var x, F, W;
      NS(n, p, M, (x = (F = M.getState()) === null || F === void 0 || (W = F.nextTree) === null || W === void 0 ? void 0 : W.version) !== null && x !== void 0 ? x : M.getState().currentTree.version);
    }
    for (const H of p)
      a.add(H);
  }
  function E(M, s, p) {
    const f = $S(n);
    let m = !0, S = !0;
    const C = () => {
      f(), S = !1;
    };
    let A, x = !1, F;
    const W = {
      loadingDepKey: null,
      loadingDepPromise: null
    }, H = /* @__PURE__ */ new Map();
    function ve({
      key: me
    }) {
      const oe = ai(M, s, me);
      switch (H.set(me, oe), m || (N(M, s, new Set(H.keys()), p), _(M, p)), oe.state) {
        case "hasValue":
          return oe.contents;
        case "hasError":
          throw oe.contents;
        case "loading":
          throw W.loadingDepKey = me, W.loadingDepPromise = oe.contents, oe.contents;
      }
      throw de("Invalid Loadable state");
    }
    const Ee = (me) => (...oe) => {
      if (S)
        throw de("Callbacks from getCallback() should only be called asynchronously after the selector is evalutated.  It can be used for selectors to return objects with callbacks that can work with Recoil state without a subscription.");
      return t == null && (process.env.NODE_ENV !== "production" ? Vt(!1, "Recoil Value can never be null") : Vt(!1)), VS(
        M,
        me,
        oe,
        {
          node: t
        }
        // flowlint-line unclear-type:off
      );
    };
    try {
      A = r({
        get: ve,
        getCallback: Ee
      }), A = jS(A) ? ve(A) : A, MS(A) && (A.state === "hasError" && (x = !0), A = A.contents), xe(A) ? A = O(M, A, s, H, p, W).finally(C) : C(), A = A instanceof hf ? A.value : A;
    } catch (me) {
      A = me, xe(A) ? A = I(M, A, s, H, p, W).finally(C) : (x = !0, C());
    }
    return x ? F = oi(A) : xe(A) ? F = AS(A) : F = ea(A), m = !1, ie(M, p, H), N(M, s, new Set(H.keys()), p), [F, H];
  }
  function L(M, s) {
    let p = s.atomValues.get(n);
    if (p != null)
      return p;
    const f = /* @__PURE__ */ new Set();
    try {
      p = u.get((S) => (typeof S != "string" && (process.env.NODE_ENV !== "production" ? Vt(!1, "Cache nodeKey is type string") : Vt(!1)), ai(M, s, S).contents), {
        onNodeVisit: (S) => {
          S.type === "branch" && S.nodeKey !== n && f.add(S.nodeKey);
        }
      });
    } catch (S) {
      throw de(`Problem with cache lookup for selector "${n}": ${S.message}`);
    }
    if (p) {
      var m;
      s.atomValues.set(n, p), N(M, s, f, (m = G(M)) === null || m === void 0 ? void 0 : m.executionID);
    }
    return p;
  }
  function B(M, s) {
    const p = L(M, s);
    if (p != null)
      return J(M), p;
    const f = Q(M, s);
    if (f != null) {
      var m;
      return ((m = f.loadingLoadable) === null || m === void 0 ? void 0 : m.state) === "loading" && k(M, f.executionID), f.loadingLoadable;
    }
    const S = BS(), [C, A] = E(M, s, S);
    return C.state === "loading" ? (te(M, S, C, A, s), k(M, S)) : (J(M), se(s, C, A)), C;
  }
  function Q(M, s) {
    const p = jd([l.has(M) ? [$e(l.get(M))] : [], Qi(gs(l, ([m]) => m !== M), ([, m]) => m)]);
    function f(m) {
      for (const [S, C] of m)
        if (!ai(M, s, S).is(C))
          return !0;
      return !1;
    }
    for (const m of p) {
      if (
        // If this execution was already checked to be valid with this version
        // of state, then let's use it!
        m.stateVersions.get(s.version) || // If the deps for the execution match our current state, then it's valid
        !f(m.depValuesDiscoveredSoFarDuringAsyncWork)
      )
        return m.stateVersions.set(s.version, !0), m;
      m.stateVersions.set(s.version, !1);
    }
  }
  function G(M) {
    return l.get(M);
  }
  function te(M, s, p, f, m) {
    l.set(M, {
      depValuesDiscoveredSoFarDuringAsyncWork: f,
      executionID: s,
      loadingLoadable: p,
      stateVersions: /* @__PURE__ */ new Map([[m.version, !0]])
    });
  }
  function ie(M, s, p) {
    if (ce(M, s)) {
      const f = G(M);
      f != null && (f.depValuesDiscoveredSoFarDuringAsyncWork = p);
    }
  }
  function J(M) {
    l.delete(M);
  }
  function ce(M, s) {
    var p;
    return s === ((p = G(M)) === null || p === void 0 ? void 0 : p.executionID);
  }
  function Me(M) {
    return Array.from(M.entries()).map(([s, p]) => [s, p.contents]);
  }
  function se(M, s, p) {
    process.env.NODE_ENV !== "production" && s.state !== "loading" && !e.dangerouslyAllowMutability && Ba(s.contents), M.atomValues.set(n, s);
    try {
      u.set(Me(p), s);
    } catch (f) {
      throw de(`Problem with setting cache for selector "${n}": ${f.message}`);
    }
  }
  function Re(M) {
    if (vr.includes(n)) {
      const s = `Recoil selector has circular dependencies: ${vr.slice(vr.indexOf(n)).join(" → ")}`;
      return oi(de(s));
    }
    vr.push(n);
    try {
      return M();
    } finally {
      vr.pop();
    }
  }
  function ke(M, s) {
    const p = s.atomValues.get(n);
    return p ?? u.get((f) => {
      var m;
      return typeof f != "string" && (process.env.NODE_ENV !== "production" ? Vt(!1, "Cache nodeKey is type string") : Vt(!1)), (m = PS(M, s, f)) === null || m === void 0 ? void 0 : m.contents;
    });
  }
  function Ae(M, s) {
    return Re(() => B(M, s));
  }
  function K(M) {
    M.atomValues.delete(n);
  }
  function Y(M, s) {
    t == null && (process.env.NODE_ENV !== "production" ? Vt(!1, "Recoil Value can never be null") : Vt(!1));
    for (const f of a) {
      var p;
      const m = xS(f);
      (p = m.clearCache) === null || p === void 0 || p.call(m, M, s);
    }
    a.clear(), K(s), u.clear(), Ku(M, t);
  }
  return o != null ? t = Gu({
    key: n,
    nodeType: "selector",
    peek: ke,
    get: Ae,
    set: (s, p, f) => {
      let m = !1;
      const S = /* @__PURE__ */ new Map();
      function C({
        key: W
      }) {
        if (m)
          throw de("Recoil: Async selector sets are not currently supported.");
        const H = ai(s, p, W);
        if (H.state === "hasValue")
          return H.contents;
        if (H.state === "loading") {
          const ve = `Getting value of asynchronous atom or selector "${W}" in a pending state while setting selector "${n}" is not yet supported.`;
          throw Ze(ve), de(ve);
        } else
          throw H.contents;
      }
      function A(W, H) {
        if (m) {
          const me = "Recoil: Async selector sets are not currently supported.";
          throw Ze(me), de(me);
        }
        const ve = typeof H == "function" ? (
          // cast to any because we can't restrict type S from being a function itself without losing support for opaque types
          // flowlint-next-line unclear-type:off
          H(C(W))
        ) : H;
        OS(s, p, W.key, ve).forEach((me, oe) => S.set(oe, me));
      }
      function x(W) {
        A(W, LS);
      }
      const F = o({
        set: A,
        get: C,
        reset: x
      }, f);
      if (F !== void 0)
        throw xe(F) ? de("Recoil: Async selector sets are not currently supported.") : de("Recoil: selector set should be a void function.");
      return m = !0, S;
    },
    init: g,
    invalidate: K,
    clearCache: Y,
    shouldDeleteConfigOnRelease: b,
    dangerouslyAllowMutability: e.dangerouslyAllowMutability,
    shouldRestoreFromSnapshots: !1,
    retainedBy: c
  }) : t = Gu({
    key: n,
    nodeType: "selector",
    peek: ke,
    get: Ae,
    init: g,
    invalidate: K,
    clearCache: Y,
    shouldDeleteConfigOnRelease: b,
    dangerouslyAllowMutability: e.dangerouslyAllowMutability,
    shouldRestoreFromSnapshots: !1,
    retainedBy: c
  });
}
mf.value = (e) => new hf(e);
var tr = mf;
const {
  isLoadable: FS,
  loadableWithError: ta,
  loadableWithPromise: na,
  loadableWithValue: Dn
} = Ir, {
  WrappedValue: gf
} = lf, {
  peekNodeInfo: US
} = un, {
  DEFAULT_VALUE: yn,
  DefaultValue: on,
  getConfigDeletionHandler: yf,
  registerNode: zS,
  setConfigDeletionHandler: WS
} = ht, {
  isRecoilValue: qS
} = Cn, {
  getRecoilValueAsLoadable: JS,
  markRecoilValueModified: HS,
  setRecoilValue: Yu,
  setRecoilValueLoadable: GS
} = Wt, {
  retainedByOptionWithDefault: KS
} = Nn, mr = (e) => e instanceof gf ? e.value : e;
function YS(e) {
  const {
    key: t,
    persistence_UNSTABLE: n
  } = e, r = KS(e.retainedBy_UNSTABLE);
  let i = 0;
  function o(k) {
    return na(k.then((O) => (a = Dn(O), O)).catch((O) => {
      throw a = ta(O), O;
    }));
  }
  let a = xe(e.default) ? o(e.default) : FS(e.default) ? e.default.state === "loading" ? o(e.default.contents) : e.default : (
    // $FlowFixMe[incompatible-call]
    Dn(mr(e.default))
  );
  l(a.contents);
  let u;
  const c = /* @__PURE__ */ new Map();
  function l(k) {
    return process.env.NODE_ENV !== "production" && e.dangerouslyAllowMutability !== !0 ? xe(k) ? k.then((O) => (Ba(O), O)) : (Ba(k), k) : k;
  }
  function d(k, O) {
    const I = O.then((N) => {
      var E, L;
      return ((L = ((E = k.getState().nextTree) !== null && E !== void 0 ? E : k.getState().currentTree).atomValues.get(t)) === null || L === void 0 ? void 0 : L.contents) === I && Yu(k, w, N), N;
    }).catch((N) => {
      var E, L;
      throw ((L = ((E = k.getState().nextTree) !== null && E !== void 0 ? E : k.getState().currentTree).atomValues.get(t)) === null || L === void 0 ? void 0 : L.contents) === I && GS(k, w, ta(N)), N;
    });
    return I;
  }
  function h(k, O, I) {
    var N;
    i++;
    const E = () => {
      var G;
      i--, (G = c.get(k)) === null || G === void 0 || G.forEach((te) => te()), c.delete(k);
    };
    if (k.getState().knownAtoms.add(t), a.state === "loading") {
      const G = () => {
        var te;
        ((te = k.getState().nextTree) !== null && te !== void 0 ? te : k.getState().currentTree).atomValues.has(t) || HS(k, w);
      };
      a.contents.finally(G);
    }
    const L = (N = e.effects) !== null && N !== void 0 ? N : e.effects_UNSTABLE;
    if (L != null) {
      let ce = function(K) {
        if (te && K.key === t) {
          const Y = G;
          return Y instanceof on ? g(k, O) : xe(Y) ? na(Y.then((M) => M instanceof on ? (
            // Cast T to S
            a.toPromise()
          ) : M)) : (
            // $FlowFixMe[incompatible-call]
            Dn(Y)
          );
        }
        return JS(k, K);
      }, Me = function(K) {
        return ce(K).toPromise();
      }, se = function(K) {
        var Y;
        const M = US(k, (Y = k.getState().nextTree) !== null && Y !== void 0 ? Y : k.getState().currentTree, K.key);
        return te && K.key === t && !(G instanceof on) ? {
          ...M,
          isSet: !0,
          loadable: ce(K)
        } : M;
      }, G = yn, te = !0, ie = !1, J = null;
      const Re = (K) => (Y) => {
        if (te) {
          const M = ce(w), s = M.state === "hasValue" ? M.contents : yn;
          G = typeof Y == "function" ? (
            // cast to any because we can't restrict T from being a function without losing support for opaque types
            Y(s)
          ) : Y, xe(G) && (G = G.then((p) => (J = {
            effect: K,
            value: p
          }, p)));
        } else {
          if (xe(Y))
            throw de("Setting atoms to async values is not implemented.");
          typeof Y != "function" && (J = {
            effect: K,
            value: mr(Y)
          }), Yu(k, w, typeof Y == "function" ? (M) => {
            const s = mr(
              // cast to any because we can't restrict T from being a function without losing support for opaque types
              Y(M)
              // flowlint-line unclear-type:off
            );
            return J = {
              effect: K,
              value: s
            }, s;
          } : mr(Y));
        }
      }, ke = (K) => () => Re(K)(yn), Ae = (K) => (Y) => {
        var M;
        const {
          release: s
        } = k.subscribeToTransactions((p) => {
          var f;
          let {
            currentTree: m,
            previousTree: S
          } = p.getState();
          S || (Ze("Transaction subscribers notified without a next tree being present -- this is a bug in Recoil"), S = m);
          const C = (f = m.atomValues.get(t)) !== null && f !== void 0 ? f : a;
          if (C.state === "hasValue") {
            var A, x, F, W;
            const H = C.contents, ve = (A = S.atomValues.get(t)) !== null && A !== void 0 ? A : a, Ee = ve.state === "hasValue" ? ve.contents : yn;
            ((x = J) === null || x === void 0 ? void 0 : x.effect) !== K || ((F = J) === null || F === void 0 ? void 0 : F.value) !== H ? Y(H, Ee, !m.atomValues.has(t)) : ((W = J) === null || W === void 0 ? void 0 : W.effect) === K && (J = null);
          }
        }, t);
        c.set(k, [...(M = c.get(k)) !== null && M !== void 0 ? M : [], s]);
      };
      for (const K of L)
        try {
          const Y = K({
            node: w,
            storeID: k.storeID,
            parentStoreID_UNSTABLE: k.parentStoreID,
            trigger: I,
            setSelf: Re(K),
            resetSelf: ke(K),
            onSet: Ae(K),
            getPromise: Me,
            getLoadable: ce,
            getInfo_UNSTABLE: se
          });
          if (Y != null) {
            var B;
            c.set(k, [...(B = c.get(k)) !== null && B !== void 0 ? B : [], Y]);
          }
        } catch (Y) {
          G = Y, ie = !0;
        }
      if (te = !1, !(G instanceof on)) {
        var Q;
        const K = ie ? ta(G) : xe(G) ? na(d(k, G)) : Dn(mr(G));
        l(K.contents), O.atomValues.set(t, K), (Q = k.getState().nextTree) === null || Q === void 0 || Q.atomValues.set(t, K);
      }
    }
    return E;
  }
  function g(k, O) {
    var I, N;
    return (I = (N = O.atomValues.get(t)) !== null && N !== void 0 ? N : u) !== null && I !== void 0 ? I : a;
  }
  function b(k, O) {
    if (O.atomValues.has(t))
      return $e(O.atomValues.get(t));
    if (O.nonvalidatedAtoms.has(t)) {
      if (u != null)
        return u;
      if (n == null)
        return Yi(`Tried to restore a persisted value for atom ${t} but it has no persistence settings.`), a;
      const I = O.nonvalidatedAtoms.get(t), N = n.validator(I, yn);
      return u = N instanceof on ? a : Dn(N), u;
    } else
      return a;
  }
  function y() {
    u = void 0;
  }
  function v(k, O, I) {
    if (O.atomValues.has(t)) {
      const N = $e(O.atomValues.get(t));
      if (N.state === "hasValue" && I === N.contents)
        return /* @__PURE__ */ new Map();
    } else if (!O.nonvalidatedAtoms.has(t) && I instanceof on)
      return /* @__PURE__ */ new Map();
    return l(I), u = void 0, (/* @__PURE__ */ new Map()).set(t, Dn(I));
  }
  function _() {
    return yf(t) !== void 0 && i <= 0;
  }
  const w = zS({
    key: t,
    nodeType: "atom",
    peek: g,
    get: b,
    set: v,
    init: h,
    invalidate: y,
    shouldDeleteConfigOnRelease: _,
    dangerouslyAllowMutability: e.dangerouslyAllowMutability,
    persistence_UNSTABLE: e.persistence_UNSTABLE ? {
      type: e.persistence_UNSTABLE.type,
      backButton: e.persistence_UNSTABLE.backButton
    } : void 0,
    shouldRestoreFromSnapshots: !0,
    retainedBy: r
  });
  return w;
}
function Cs(e) {
  if (process.env.NODE_ENV !== "production" && typeof e.key != "string")
    throw de("A key option with a unique string value must be provided when creating an atom.");
  const {
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
    ...t
  } = e, n = "default" in e ? (
    // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
    e.default
  ) : new Promise(() => {
  });
  return qS(n) ? QS({
    ...t,
    default: n
    // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS,
  }) : YS({
    ...t,
    default: n
  });
}
function QS(e) {
  const t = Cs({
    ...e,
    default: yn,
    persistence_UNSTABLE: e.persistence_UNSTABLE === void 0 ? void 0 : {
      ...e.persistence_UNSTABLE,
      validator: (r) => r instanceof on ? r : $e(e.persistence_UNSTABLE).validator(r, yn)
    },
    // TODO Hack for now.
    effects: e.effects,
    // flowlint-line unclear-type: off
    effects_UNSTABLE: e.effects_UNSTABLE
    // flowlint-line unclear-type: off
  }), n = tr({
    key: `${e.key}__withFallback`,
    get: ({
      get: r
    }) => {
      const i = r(t);
      return i instanceof on ? e.default : i;
    },
    // $FlowFixMe[incompatible-call]
    set: ({
      set: r
    }, i) => r(t, i),
    // This selector does not need to cache as it is a wrapper selector
    // and the selector within the wrapper selector will have a cache
    // option by default
    cachePolicy_UNSTABLE: {
      eviction: "most-recent"
    },
    dangerouslyAllowMutability: e.dangerouslyAllowMutability
  });
  return WS(n.key, yf(e.key)), n;
}
Cs.value = (e) => new gf(e);
var _f = Cs;
class ZS {
  constructor(t) {
    var n;
    pe(this, "_map", void 0), pe(this, "_keyMapper", void 0), this._map = /* @__PURE__ */ new Map(), this._keyMapper = (n = t == null ? void 0 : t.mapKey) !== null && n !== void 0 ? n : (r) => r;
  }
  size() {
    return this._map.size;
  }
  has(t) {
    return this._map.has(this._keyMapper(t));
  }
  get(t) {
    return this._map.get(this._keyMapper(t));
  }
  set(t, n) {
    this._map.set(this._keyMapper(t), n);
  }
  delete(t) {
    this._map.delete(this._keyMapper(t));
  }
  clear() {
    this._map.clear();
  }
}
var XS = {
  MapCache: ZS
}, ew = XS.MapCache, tw = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MapCache: ew
});
const {
  LRUCache: Qu
} = ff, {
  MapCache: nw
} = tw, ci = {
  equality: "reference",
  eviction: "none",
  maxSize: 1 / 0
};
function rw({
  equality: e = ci.equality,
  eviction: t = ci.eviction,
  maxSize: n = ci.maxSize
} = ci) {
  const r = iw(e);
  return ow(t, n, r);
}
function iw(e) {
  switch (e) {
    case "reference":
      return (t) => t;
    case "value":
      return (t) => uo(t);
  }
  throw de(`Unrecognized equality policy ${e}`);
}
function ow(e, t, n) {
  switch (e) {
    case "keep-all":
      return new nw({
        mapKey: n
      });
    case "lru":
      return new Qu({
        mapKey: n,
        maxSize: $e(t)
      });
    case "most-recent":
      return new Qu({
        mapKey: n,
        maxSize: 1
      });
  }
  throw de(`Unrecognized eviction policy ${e}`);
}
var bf = rw;
const {
  setConfigDeletionHandler: aw
} = ht;
function sw(e) {
  var t, n;
  const r = bf({
    equality: (t = (n = e.cachePolicyForParams_UNSTABLE) === null || n === void 0 ? void 0 : n.equality) !== null && t !== void 0 ? t : "value",
    eviction: "keep-all"
  });
  return (i) => {
    var o, a;
    const u = r.get(i);
    if (u != null)
      return u;
    const {
      cachePolicyForParams_UNSTABLE: c,
      ...l
    } = e, d = "default" in e ? (
      // $FlowIssue[incompatible-type] No way to refine in Flow that property is not defined
      e.default
    ) : new Promise(() => {
    }), h = _f({
      ...l,
      key: `${e.key}__${(o = uo(i)) !== null && o !== void 0 ? o : "void"}`,
      default: typeof d == "function" ? (
        // The default was parameterized
        // Flow doesn't know that T isn't a function, so we need to case to any
        // $FlowIssue[incompatible-use]
        d(i)
      ) : (
        // Default may be a static value, promise, or RecoilValue
        d
      ),
      retainedBy_UNSTABLE: typeof e.retainedBy_UNSTABLE == "function" ? e.retainedBy_UNSTABLE(i) : e.retainedBy_UNSTABLE,
      effects: typeof e.effects == "function" ? e.effects(i) : typeof e.effects_UNSTABLE == "function" ? e.effects_UNSTABLE(i) : (a = e.effects) !== null && a !== void 0 ? a : e.effects_UNSTABLE
      // prettier-ignore
      // @fb-only: scopeRules_APPEND_ONLY_READ_THE_DOCS: mapScopeRules(
      // @fb-only: options.scopeRules_APPEND_ONLY_READ_THE_DOCS,
      // @fb-only: params,
      // @fb-only: ),
    });
    return r.set(i, h), aw(h.key, () => {
      r.delete(i);
    }), h;
  };
}
var cw = sw;
const {
  setConfigDeletionHandler: uw
} = ht;
let lw = 0;
function dw(e) {
  var t, n;
  const r = bf({
    equality: (t = (n = e.cachePolicyForParams_UNSTABLE) === null || n === void 0 ? void 0 : n.equality) !== null && t !== void 0 ? t : "value",
    eviction: "keep-all"
  });
  return (i) => {
    var o;
    let a;
    try {
      a = r.get(i);
    } catch (g) {
      throw de(`Problem with cache lookup for selector ${e.key}: ${g.message}`);
    }
    if (a != null)
      return a;
    const u = `${e.key}__selectorFamily/${(o = uo(i, {
      // It is possible to use functions in parameters if the user uses
      // a cache with reference equality thanks to the incrementing index.
      allowFunctions: !0
    })) !== null && o !== void 0 ? o : "void"}/${lw++}`, c = (g) => e.get(i)(g), l = e.cachePolicy_UNSTABLE, d = typeof e.retainedBy_UNSTABLE == "function" ? e.retainedBy_UNSTABLE(i) : e.retainedBy_UNSTABLE;
    let h;
    if (e.set != null) {
      const g = e.set;
      h = tr({
        key: u,
        get: c,
        set: (y, v) => g(i)(y, v),
        cachePolicy_UNSTABLE: l,
        dangerouslyAllowMutability: e.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: d
      });
    } else
      h = tr({
        key: u,
        get: c,
        cachePolicy_UNSTABLE: l,
        dangerouslyAllowMutability: e.dangerouslyAllowMutability,
        retainedBy_UNSTABLE: d
      });
    return r.set(i, h), uw(h.key, () => {
      r.delete(i);
    }), h;
  };
}
var ln = dw;
const fw = ln({
  key: "__constant",
  get: (e) => () => e,
  cachePolicyForParams_UNSTABLE: {
    equality: "reference"
  }
});
function pw(e) {
  return fw(e);
}
var hw = pw;
const vw = ln({
  key: "__error",
  get: (e) => () => {
    throw de(e);
  },
  // TODO Why?
  cachePolicyForParams_UNSTABLE: {
    equality: "reference"
  }
});
function mw(e) {
  return vw(e);
}
var gw = mw;
function yw(e) {
  return e;
}
var _w = yw;
const {
  loadableWithError: Sf,
  loadableWithPromise: wf,
  loadableWithValue: kf
} = Ir;
function lo(e, t) {
  const n = Array(t.length).fill(void 0), r = Array(t.length).fill(void 0);
  for (const [i, o] of t.entries())
    try {
      n[i] = e(o);
    } catch (a) {
      r[i] = a;
    }
  return [n, r];
}
function bw(e) {
  return e != null && !xe(e);
}
function fo(e) {
  return Array.isArray(e) ? e : Object.getOwnPropertyNames(e).map((t) => e[t]);
}
function Fa(e, t) {
  return Array.isArray(e) ? t : (
    // Object.getOwnPropertyNames() has consistent key ordering with ES6
    Object.getOwnPropertyNames(e).reduce((n, r, i) => ({
      ...n,
      [r]: t[i]
    }), {})
  );
}
function Jn(e, t, n) {
  const r = n.map((i, o) => i == null ? kf(t[o]) : xe(i) ? wf(i) : Sf(i));
  return Fa(e, r);
}
function Sw(e, t) {
  return t.map((n, r) => (
    /**
     * it's important we use === undefined as opposed to == null, because the
     * resolved value of the async promise could be `null`, in which case we
     * don't want to use syncResults[idx], which would be undefined. If async
     * promise resolves to `undefined`, that's ok because `syncResults[idx]`
     * will also be `undefined`. That's a little hacky, but it works.
     */
    n === void 0 ? e[r] : n
  ));
}
const ww = ln({
  key: "__waitForNone",
  get: (e) => ({
    get: t
  }) => {
    const n = fo(e), [r, i] = lo(t, n);
    return Jn(e, r, i);
  },
  dangerouslyAllowMutability: !0
}), kw = ln({
  key: "__waitForAny",
  get: (e) => ({
    get: t
  }) => {
    const n = fo(e), [r, i] = lo(t, n);
    return i.some((o) => !xe(o)) ? Jn(e, r, i) : new Promise((o) => {
      for (const [a, u] of i.entries())
        xe(u) && u.then((c) => {
          r[a] = c, i[a] = void 0, o(Jn(e, r, i));
        }).catch((c) => {
          i[a] = c, o(Jn(e, r, i));
        });
    });
  },
  dangerouslyAllowMutability: !0
}), Ew = ln({
  key: "__waitForAll",
  get: (e) => ({
    get: t
  }) => {
    const n = fo(e), [r, i] = lo(t, n);
    if (i.every((a) => a == null))
      return Fa(e, r);
    const o = i.find(bw);
    if (o != null)
      throw o;
    return Promise.all(i).then((a) => Fa(e, Sw(r, a)));
  },
  dangerouslyAllowMutability: !0
}), Tw = ln({
  key: "__waitForAllSettled",
  get: (e) => ({
    get: t
  }) => {
    const n = fo(e), [r, i] = lo(t, n);
    return i.every((o) => !xe(o)) ? Jn(e, r, i) : Promise.all(i.map((o, a) => xe(o) ? o.then((u) => {
      r[a] = u, i[a] = void 0;
    }).catch((u) => {
      r[a] = void 0, i[a] = u;
    }) : null)).then(() => Jn(e, r, i));
  },
  dangerouslyAllowMutability: !0
}), Rw = ln({
  key: "__noWait",
  get: (e) => ({
    get: t
  }) => {
    try {
      return tr.value(kf(t(e)));
    } catch (n) {
      return tr.value(xe(n) ? wf(n) : Sf(n));
    }
  },
  dangerouslyAllowMutability: !0
});
var Cw = {
  waitForNone: ww,
  waitForAny: kw,
  waitForAll: Ew,
  waitForAllSettled: Tw,
  noWait: Rw
};
const {
  RecoilLoadable: Mw
} = Ir, {
  DefaultValue: Aw
} = ht, {
  RecoilRoot: Pw,
  useRecoilStoreID: Ow
} = Xt, {
  isRecoilValue: Nw
} = Cn, {
  retentionZone: Lw
} = Xi, {
  freshSnapshot: Iw
} = io, {
  useRecoilState: xw,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: jw,
  useRecoilStateLoadable: Dw,
  useRecoilValue: Vw,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $w,
  useRecoilValueLoadable: Bw,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: Fw,
  useResetRecoilState: Uw,
  useSetRecoilState: zw
} = H_, {
  useGotoRecoilSnapshot: Ww,
  useRecoilSnapshot: qw,
  useRecoilTransactionObserver: Jw
} = of, {
  useRecoilCallback: Hw
} = uf, {
  noWait: Gw,
  waitForAll: Kw,
  waitForAllSettled: Yw,
  waitForAny: Qw,
  waitForNone: Zw
} = Cw;
var dn = {
  // Types
  DefaultValue: Aw,
  isRecoilValue: Nw,
  RecoilLoadable: Mw,
  // Global Recoil environment settiongs
  RecoilEnv: or,
  // Recoil Root
  RecoilRoot: Pw,
  useRecoilStoreID: Ow,
  useRecoilBridgeAcrossReactRoots_UNSTABLE: bb,
  // Atoms/Selectors
  atom: _f,
  selector: tr,
  // Convenience Atoms/Selectors
  atomFamily: cw,
  selectorFamily: ln,
  constSelector: hw,
  errorSelector: gw,
  readOnlySelector: _w,
  // Concurrency Helpers for Atoms/Selectors
  noWait: Gw,
  waitForNone: Zw,
  waitForAny: Qw,
  waitForAll: Kw,
  waitForAllSettled: Yw,
  // Hooks for Atoms/Selectors
  useRecoilValue: Vw,
  useRecoilValueLoadable: Bw,
  useRecoilState: xw,
  useRecoilStateLoadable: Dw,
  useSetRecoilState: zw,
  useResetRecoilState: Uw,
  useGetRecoilValueInfo_UNSTABLE: hb,
  useRecoilRefresher_UNSTABLE: Kb,
  useRecoilValueLoadable_TRANSITION_SUPPORT_UNSTABLE: Fw,
  useRecoilValue_TRANSITION_SUPPORT_UNSTABLE: $w,
  useRecoilState_TRANSITION_SUPPORT_UNSTABLE: jw,
  // Hooks for complex operations
  useRecoilCallback: Hw,
  useRecoilTransaction_UNSTABLE: eS,
  // Snapshots
  useGotoRecoilSnapshot: Ww,
  useRecoilSnapshot: qw,
  useRecoilTransactionObserver_UNSTABLE: Jw,
  snapshot_UNSTABLE: Iw,
  // Memory Management
  useRetain: ws,
  retentionZone: Lw
}, Xw = dn.RecoilRoot, Fe = dn.atom, Zu = dn.selector, po = dn.atomFamily, Ua = dn.selectorFamily, Ge = dn.useRecoilValue, e0 = dn.useSetRecoilState, be = dn.useRecoilCallback, Ef = "Expected a function", Xu = NaN, t0 = "[object Symbol]", n0 = /^\s+|\s+$/g, r0 = /^[-+]0x[0-9a-f]+$/i, i0 = /^0b[01]+$/i, o0 = /^0o[0-7]+$/i, a0 = parseInt, s0 = typeof kt == "object" && kt && kt.Object === Object && kt, c0 = typeof self == "object" && self && self.Object === Object && self, u0 = s0 || c0 || Function("return this")(), l0 = Object.prototype, d0 = l0.toString, f0 = Math.max, p0 = Math.min, ra = function() {
  return u0.Date.now();
};
function h0(e, t, n) {
  var r, i, o, a, u, c, l = 0, d = !1, h = !1, g = !0;
  if (typeof e != "function")
    throw new TypeError(Ef);
  t = el(t) || 0, ji(n) && (d = !!n.leading, h = "maxWait" in n, o = h ? f0(el(n.maxWait) || 0, t) : o, g = "trailing" in n ? !!n.trailing : g);
  function b(E) {
    var L = r, B = i;
    return r = i = void 0, l = E, a = e.apply(B, L), a;
  }
  function y(E) {
    return l = E, u = setTimeout(w, t), d ? b(E) : a;
  }
  function v(E) {
    var L = E - c, B = E - l, Q = t - L;
    return h ? p0(Q, o - B) : Q;
  }
  function _(E) {
    var L = E - c, B = E - l;
    return c === void 0 || L >= t || L < 0 || h && B >= o;
  }
  function w() {
    var E = ra();
    if (_(E))
      return k(E);
    u = setTimeout(w, v(E));
  }
  function k(E) {
    return u = void 0, g && r ? b(E) : (r = i = void 0, a);
  }
  function O() {
    u !== void 0 && clearTimeout(u), l = 0, r = c = i = u = void 0;
  }
  function I() {
    return u === void 0 ? a : k(ra());
  }
  function N() {
    var E = ra(), L = _(E);
    if (r = arguments, i = this, c = E, L) {
      if (u === void 0)
        return y(c);
      if (h)
        return u = setTimeout(w, t), b(c);
    }
    return u === void 0 && (u = setTimeout(w, t)), a;
  }
  return N.cancel = O, N.flush = I, N;
}
function v0(e, t, n) {
  var r = !0, i = !0;
  if (typeof e != "function")
    throw new TypeError(Ef);
  return ji(n) && (r = "leading" in n ? !!n.leading : r, i = "trailing" in n ? !!n.trailing : i), h0(e, t, {
    leading: r,
    maxWait: t,
    trailing: i
  });
}
function ji(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function m0(e) {
  return !!e && typeof e == "object";
}
function g0(e) {
  return typeof e == "symbol" || m0(e) && d0.call(e) == t0;
}
function el(e) {
  if (typeof e == "number")
    return e;
  if (g0(e))
    return Xu;
  if (ji(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = ji(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(n0, "");
  var n = i0.test(e);
  return n || o0.test(e) ? a0(e.slice(2), n ? 2 : 8) : r0.test(e) ? Xu : +e;
}
var y0 = v0;
const Ms = /* @__PURE__ */ Gf(y0);
function tl(e, t, n, r, i, o, a) {
  try {
    var u = e[o](a), c = u.value;
  } catch (l) {
    n(l);
    return;
  }
  u.done ? t(c) : Promise.resolve(c).then(r, i);
}
function Nt(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(c) {
        tl(o, r, i, a, u, "next", c);
      }
      function u(c) {
        tl(o, r, i, a, u, "throw", c);
      }
      a(void 0);
    });
  };
}
function Be() {
  return Be = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Be.apply(this, arguments);
}
function As(e, t) {
  if (e == null)
    return {};
  var n = {}, r = Object.keys(e), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
  return n;
}
function _0(e, t) {
  if (e) {
    if (typeof e == "string")
      return nl(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return nl(e, t);
  }
}
function nl(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function za(e, t) {
  var n = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n)
    return (n = n.call(e)).next.bind(n);
  if (Array.isArray(e) || (n = _0(e)) || t && e && typeof e.length == "number") {
    n && (e = n);
    var r = 0;
    return function() {
      return r >= e.length ? {
        done: !0
      } : {
        done: !1,
        value: e[r++]
      };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Tf = /* @__PURE__ */ Ar(null), Xe = function() {
  var t = nr(Tf);
  return pt(t), t;
}, Ps = /* @__PURE__ */ Ar({
  on: function() {
  },
  off: function() {
  }
}), b0 = 0, Wa = function() {
  return b0++;
}, le = function(t, n) {
  var r = nr(Ps), i = r.off, o = r.on, a = ut(!1), u = a[0], c = a[1], l = it(0), d = Pt(function() {
    return Wa();
  }, []);
  Oe(function() {
    if (!(!t || u)) {
      if (l.current > 1e5) {
        console.error(`useDailyEvent called with potentially non-memoized event callback or due to too many re-renders.
        Memoize using useCallback to avoid re-render loop or reduce the amount of state transitions the callback depends on.
        Passed callback for '` + t + "' event is NOT registered.", n), c(!0);
        return;
      }
      l.current++;
      var h = setTimeout(function() {
        l.current = 0;
      }, 50);
      return o(t, n, d), function() {
        clearTimeout(h), i(t, d);
      };
    }
  }, [n, t, d, u, i, o]), pt({
    event: t,
    eventId: d,
    isBlocked: u,
    callback: n
  });
}, Pe = "daily-react-", Vn = /* @__PURE__ */ po({
  key: Pe + "participant-property-paths",
  default: []
}), dt = /* @__PURE__ */ po({
  key: Pe + "participant-property",
  default: null,
  dangerouslyAllowMutability: !0
}), gi = /* @__PURE__ */ Ua({
  key: Pe + "participant-properties",
  get: function(t) {
    var n = t.id, r = t.properties;
    return function(i) {
      var o = i.get;
      return r.map(function(a) {
        return o(dt({
          id: n,
          property: a
        }));
      });
    };
  },
  dangerouslyAllowMutability: !0
}), ho = function(t, n) {
  var r, i = Ge(Array.isArray(n) ? gi({
    id: t,
    properties: n
  }) : dt({
    id: t,
    property: n
  }));
  return pt(Array.isArray(n) ? n.reduce(function(o, a, u) {
    return o[a] = i[u], o;
  }, {}) : (r = {}, r[n] = i, r)), i;
}, Mr = function(t, n, r) {
  r === void 0 && (r = 500);
  var i = nr(Ps), o = i.off, a = i.on, u = Pt(function() {
    var d;
    return Array.isArray(t) ? t.reduce(function(h, g) {
      return h[g] = Wa(), h;
    }, {}) : (d = {}, d[t] = Wa(), d);
  }, [t]), c = it([]);
  le("call-instance-destroyed", ge(function() {
    c.current.length = 0;
  }, []));
  var l = Pt(function() {
    return Ms(function() {
      c.current.length !== 0 && (n(c.current), c.current.length = 0);
    }, r, {
      trailing: !0
    });
  }, [n, r]);
  Oe(function() {
    if (t) {
      var d = function(g) {
        c.current.push(g), l();
      };
      return Array.isArray(t) ? t.forEach(function(h) {
        return a(h, d, u[h]);
      }) : a(t, d, u[t]), function() {
        Array.isArray(t) ? t.forEach(function(h) {
          return o(h, u[h]);
        }) : o(t, u[t]);
      };
    }
  }, [l, t, u, o, a]), pt({
    event: t,
    eventId: u
  });
};
function Qt(e, t) {
  if (e === t)
    return !0;
  if (e instanceof MediaStream && t instanceof MediaStream)
    return e.id === t.id && e.active === t.active && e.getTracks().length === t.getTracks().length && e.getTracks().every(function(v, _) {
      return Qt(v, t.getTracks()[_]);
    });
  if (e instanceof MediaStreamTrack && t instanceof MediaStreamTrack)
    return e.id === t.id && e.kind === t.kind && e.readyState === t.readyState;
  if (e instanceof Date && t instanceof Date)
    return e.getTime() === t.getTime();
  if (e instanceof RegExp && t instanceof RegExp)
    return e.source === t.source && e.flags === t.flags;
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size)
      return !1;
    for (var n = za(e.values()), r; !(r = n()).done; ) {
      var i = r.value;
      if (!t.has(i))
        return !1;
    }
    return !0;
  }
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size)
      return !1;
    for (var o = za(e.entries()), a; !(a = o()).done; ) {
      var u = a.value, c = u[0], l = u[1];
      if (!t.has(c) || !Qt(l, t.get(c)))
        return !1;
    }
    return !0;
  }
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  var d = Object.keys(e), h = Object.keys(t);
  if (d.length !== h.length)
    return !1;
  for (var g = 0, b = d; g < b.length; g++) {
    var y = b[g];
    if (
      // If key exists in a, but not in b -> not equal
      !(y in t) || // Both keys exist in both object -> run nested equality check
      !Qt(e[y], t[y])
    )
      return !1;
  }
  return !0;
}
function S0(e) {
  var t = Zu({
    key: e.key + "_inner",
    get: e.get
  }), n;
  return Zu({
    key: e.key,
    get: function(i) {
      var o = i.get, a = o(t);
      return n != null && e.equals(a, n) ? n : (n = a, a);
    }
  });
}
function w0(e) {
  var t = Ua({
    key: e.key + "_inner",
    get: e.get
  }), n = /* @__PURE__ */ new Map();
  return Ua(Be({}, e, {
    key: e.key,
    get: function(i) {
      return function(o) {
        var a = o.get, u = a(t(i)), c = n.get(i);
        return c != null && e.equals(u, c) ? c : (n.set(i, u), u);
      };
    }
  }));
}
var k0 = function e(t, n) {
  if (n === void 0 && (n = ""), typeof t != "object" || t === null)
    return [n];
  var r = [];
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      var o = n ? n + "." + i : i;
      r.push.apply(r, [o].concat(e(t[i], o)));
    }
  return r;
}, ia = function(t) {
  return k0(t);
}, E0 = function(t, n) {
  return String(n).split(".").filter(function(r) {
    return r.length;
  }).reduce(function(r, i) {
    return r && r[i];
  }, t);
}, oa = function(t, n) {
  return n.map(function(r) {
    return E0(t, r);
  });
}, Rf = /* @__PURE__ */ Fe({
  key: Pe + "active-id",
  default: null
}), yi = /* @__PURE__ */ Fe({
  key: Pe + "local-id",
  default: ""
}), T0 = /* @__PURE__ */ Fe({
  key: Pe + "local-joined-date",
  default: null
}), Bn = /* @__PURE__ */ Fe({
  key: Pe + "participant-ids",
  default: []
}), mn = /* @__PURE__ */ po({
  key: Pe + "participant-state",
  default: null,
  dangerouslyAllowMutability: !0
}), rl = /* @__PURE__ */ Fe({
  key: Pe + "waiting-participants",
  default: []
}), aa = /* @__PURE__ */ po({
  key: Pe + "waiting-participant",
  default: {
    awaitingAccess: {
      level: "full"
    },
    id: "",
    name: ""
  }
}), R0 = function(t) {
  var n = t.children, r = Xe(), i = ut(!1), o = i[0], a = i[1], u = be(function(l) {
    var d = l.transact_UNSTABLE;
    return function(h) {
      d(function(g) {
        var b = g.set;
        b(yi, h.local.session_id);
        var y = Object.values(h), v = y.map(function(_) {
          return _.session_id;
        });
        b(Bn, v), y.forEach(function(_) {
          b(mn(_.session_id), _);
          var w = ia(_);
          b(Vn(_.session_id), w), w.forEach(function(k) {
            var O = oa(_, [k]), I = O[0];
            b(dt({
              id: _.session_id,
              property: k
            }), I);
          });
        }), a(!0);
      });
    };
  }, []);
  Oe(function() {
    if (!(!r || o)) {
      var l = setInterval(function() {
        var d = r.participants();
        "local" in d && (u(d), clearInterval(l));
      }, 100);
      return function() {
        clearInterval(l);
      };
    }
  }, [r, o, u]);
  var c = ge(function() {
    if (r) {
      var l = r == null ? void 0 : r.participants();
      l.local && u(l);
    }
  }, [r, u]);
  return le("started-camera", c), le("access-state-updated", c), le("joining-meeting", be(function(l) {
    var d = l.set;
    return function() {
      d(T0, /* @__PURE__ */ new Date()), c();
    };
  }, [c])), le("joined-meeting", ge(function(l) {
    u(l.participants);
  }, [u])), Mr(["active-speaker-change", "call-instance-destroyed", "left-meeting", "participant-joined", "participant-updated", "participant-left"], be(function(l) {
    var d = l.transact_UNSTABLE;
    return function(h) {
      d(function(g) {
        var b = g.get, y = g.reset, v = g.set;
        h.forEach(function(_) {
          switch (_.action) {
            case "active-speaker-change": {
              v(Rf, _.activeSpeaker.peerId), v(mn(_.activeSpeaker.peerId), function(E) {
                return E ? Be({}, E, {
                  last_active: /* @__PURE__ */ new Date()
                }) : null;
              });
              break;
            }
            case "participant-joined": {
              v(Bn, function(E) {
                return E.includes(_.participant.session_id) ? E : [].concat(E, [_.participant.session_id]);
              }), v(mn(_.participant.session_id), _.participant);
              var w = ia(_.participant);
              v(Vn(_.participant.session_id), w), w.forEach(function(E) {
                var L = oa(_.participant, [E]), B = L[0];
                v(dt({
                  id: _.participant.session_id,
                  property: E
                }), B);
              });
              break;
            }
            case "participant-updated": {
              v(mn(_.participant.session_id), function(E) {
                return Be({}, E, _.participant);
              }), _.participant.local && v(yi, function(E) {
                return E !== _.participant.session_id ? _.participant.session_id : E;
              });
              var k = ia(_.participant), O = b(Vn(_.participant.session_id));
              v(Vn(_.participant.session_id), function(E) {
                return Qt(E, k) ? E : k;
              }), O.filter(function(E) {
                return !k.includes(E);
              }).forEach(function(E) {
                y(dt({
                  id: _.participant.session_id,
                  property: E
                }));
              }), k.forEach(function(E) {
                var L = oa(_.participant, [E]), B = L[0];
                v(dt({
                  id: _.participant.session_id,
                  property: E
                }), function(Q) {
                  return Qt(Q, B) ? Q : B;
                });
              });
              break;
            }
            case "participant-left": {
              v(Bn, function(E) {
                return E.includes(_.participant.session_id) ? [].concat(E.filter(function(L) {
                  return L !== _.participant.session_id;
                })) : E;
              }), y(mn(_.participant.session_id));
              var I = b(Vn(_.participant.session_id));
              I.forEach(function(E) {
                y(dt({
                  id: _.participant.session_id,
                  property: E
                }));
              }), y(Vn(_.participant.session_id));
              break;
            }
            case "call-instance-destroyed":
            case "left-meeting": {
              y(yi);
              var N = b(Bn);
              Array.isArray(N) && N.forEach(function(E) {
                return y(mn(E));
              }), y(Bn);
              break;
            }
          }
        });
      });
    };
  }, [])), Mr(["waiting-participant-added", "waiting-participant-updated", "waiting-participant-removed"], be(function(l) {
    var d = l.transact_UNSTABLE;
    return function(h) {
      d(function(g) {
        var b = g.reset, y = g.set;
        h.forEach(function(v) {
          switch (v.action) {
            case "waiting-participant-added":
              y(rl, function(_) {
                return _.includes(v.participant.id) ? _ : [].concat(_, [v.participant.id]);
              }), y(aa(v.participant.id), v.participant);
              break;
            case "waiting-participant-updated":
              y(aa(v.participant.id), v.participant);
              break;
            case "waiting-participant-removed":
              y(rl, function(_) {
                return _.filter(function(w) {
                  return w !== v.participant.id;
                });
              }), b(aa(v.participant.id));
              break;
          }
        });
      });
    };
  }, [])), Z.createElement(Z.Fragment, null, n);
}, It = function() {
  var t = Ge(yi);
  return pt(t), t;
}, C0 = function() {
  return !0;
}, M0 = function(t) {
  var n = t === void 0 ? {} : t, r = n.filter, i = r === void 0 ? C0 : r, o = n.ignoreLocal, a = o === void 0 ? !1 : o, u = It(), c = Ge(Rf), l = a && c === u, d = !(i != null && i(c)), h = !l && !d, g = ut(h ? c : null), b = g[0], y = g[1];
  return Oe(function() {
    l || d || y(c);
  }, [d, l, c]), pt(b), b;
}, Di = function(t) {
  return ["blocked", "off"].includes(t);
}, Cf = /* @__PURE__ */ w0({
  key: Pe + "participant-ids-filtered-sorted",
  equals: Qt,
  get: function(t) {
    var n = t.filter, r = t.sort;
    return function(i) {
      var o = i.get, a = o(Bn);
      return a.filter(function(u) {
        switch (n) {
          case "local":
          case "owner":
          case "record":
            return o(dt({
              id: u,
              property: n
            }));
          case "remote":
            return !o(dt({
              id: u,
              property: "local"
            }));
          case "screen": {
            var c = o(gi({
              id: u,
              properties: ["tracks.screenAudio.state", "tracks.screenVideo.state"]
            })), l = c[0], d = c[1];
            return !Di(l) || !Di(d);
          }
          default:
            return !0;
        }
      }).sort(function(u, c) {
        switch (r) {
          case "joined_at":
          case "session_id":
          case "user_id":
          case "user_name": {
            var l = o(gi({
              id: u,
              properties: [r]
            })), d = l[0], h = o(gi({
              id: c,
              properties: [r]
            })), g = h[0];
            if (d !== void 0 || g !== void 0) {
              if (d === void 0)
                return -1;
              if (g === void 0 || d > g)
                return 1;
              if (d < g)
                return -1;
            }
            return 0;
          }
          default:
            return 0;
        }
      });
    };
  }
}), Os = function(t) {
  var n = t === void 0 ? {} : t, r = n.filter, i = n.onActiveSpeakerChange, o = n.onParticipantJoined, a = n.onParticipantLeft, u = n.onParticipantUpdated, c = n.sort, l = Ge(Cf({
    filter: typeof r == "string" ? r : null,
    sort: typeof c == "string" ? c : null
  })), d = be(function(_) {
    var w = _.snapshot;
    return function() {
      if (
        // Ignore if both filter and sort are not functions.
        typeof r != "function" && typeof c != "function"
      )
        return [];
      var k = l.map(function(O) {
        return w.getLoadable(mn(O)).contents;
      });
      return k.filter(Boolean).filter(typeof r == "function" ? r : function() {
        return !0;
      }).sort(typeof c == "function" ? c : function() {
        return 0;
      }).map(function(O) {
        return O.session_id;
      }).filter(Boolean);
    };
  }, [r, l, c]), h = ut([]), g = h[0], b = h[1], y = ge(function() {
    var _ = d();
    Qt(_, g) || b(_);
  }, [g, d]);
  Oe(function() {
    y();
  }, [y]), Mr(["participant-joined", "participant-updated", "active-speaker-change", "participant-left"], ge(function(_) {
    _.length && (_.forEach(function(w) {
      switch (w.action) {
        case "participant-joined":
          o == null || o(w);
          break;
        case "participant-updated":
          u == null || u(w);
          break;
        case "active-speaker-change":
          i == null || i(w);
          break;
        case "participant-left":
          a == null || a(w);
          break;
      }
    }), y());
  }, [y, i, o, a, u]));
  var v = typeof r == "function" || typeof c == "function" ? g : l;
  return pt(v), v;
}, A0 = /* @__PURE__ */ S0({
  key: Pe + "screen-shares",
  equals: Qt,
  get: function(t) {
    var n = t.get, r = n(Cf({
      filter: "screen",
      sort: null
    }));
    return r.map(function(i) {
      return {
        local: n(dt({
          id: i,
          property: "local"
        })),
        screenAudio: n(dt({
          id: i,
          property: "tracks.screenAudio"
        })),
        screenVideo: n(dt({
          id: i,
          property: "tracks.screenVideo"
        })),
        screenId: i + "-screen",
        session_id: i
      };
    });
  }
}), vo = function(t) {
  var n = t === void 0 ? {} : t, r = n.onError, i = n.onLocalScreenShareStarted, o = n.onLocalScreenShareStopped, a = Xe(), u = ge(function() {
    for (var h = arguments.length, g = new Array(h), b = 0; b < h; b++)
      g[b] = arguments[b];
    a == null || a.startScreenShare.apply(a, g);
  }, [a]), c = ge(function() {
    for (var h = arguments.length, g = new Array(h), b = 0; b < h; b++)
      g[b] = arguments[b];
    a == null || a.stopScreenShare.apply(a, g);
  }, [a]);
  le("local-screen-share-started", ge(function() {
    return i == null ? void 0 : i();
  }, [i])), le("local-screen-share-stopped", ge(function() {
    return o == null ? void 0 : o();
  }, [o])), le("nonfatal-error", ge(function(h) {
    h.type === "screen-share-error" && (r == null || r(h));
  }, [r]));
  var l = Ge(A0), d = {
    isSharingScreen: l.some(function(h) {
      return h.local;
    }),
    screens: l,
    startScreenShare: u,
    stopScreenShare: c
  };
  return pt(d), d;
}, mo = function(t, n) {
  n === void 0 && (n = "video");
  var r = ho(t, "tracks." + n), i = r ? Be({}, r, {
    isOff: Di(r.state)
  }) : {
    isOff: !0,
    persistentTrack: void 0,
    state: "off",
    subscribed: !1
  };
  return pt(i), i;
};
function Mf() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return ge(
    function(r) {
      for (var i = 0; i < t.length; i++) {
        var o = t[i];
        typeof o == "function" ? o(r) : o && typeof o == "object" && (o.current = r);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  );
}
var P0 = ["onPlayFailed", "sessionId", "type"], _i = /* @__PURE__ */ pl(/* @__PURE__ */ Qa(function(e, t) {
  var n = e.onPlayFailed, r = e.sessionId, i = e.type, o = i === void 0 ? "audio" : i, a = As(e, P0), u = it(null), c = mo(r, o), l = Mf(u, t), d = c == null ? void 0 : c.subscribed;
  return Oe(function() {
    var h = u.current;
    if (!(!h || !(c != null && c.persistentTrack))) {
      var g, b = function() {
        h.play().catch(function(_) {
          n == null || n({
            sessionId: r,
            target: h,
            type: o,
            message: _.message,
            name: _.name
          });
        });
      }, y = function() {
        clearTimeout(g);
      };
      return h.addEventListener("canplay", b), h.addEventListener("play", y), h.srcObject = new MediaStream([c == null ? void 0 : c.persistentTrack]), function() {
        h == null || h.removeEventListener("canplay", b), h == null || h.removeEventListener("play", y);
      };
    }
  }, [c == null ? void 0 : c.persistentTrack, n, r, o]), Z.createElement("audio", Object.assign({
    autoPlay: !0,
    playsInline: !0,
    ref: l
  }, a, {
    "data-session-id": r,
    "data-audio-type": o,
    "data-subscribed": d
  }));
}));
_i.displayName = "DailyAudioTrack";
var Af = /* @__PURE__ */ pl(/* @__PURE__ */ Qa(function(e, t) {
  var n = e.autoSubscribeActiveSpeaker, r = n === void 0 ? !1 : n, i = e.maxSpeakers, o = i === void 0 ? 5 : i, a = e.onPlayFailed, u = e.playLocalScreenAudio, c = u === void 0 ? !1 : u, l = Xe(), d = ut(new Array(o).fill("")), h = d[0], g = d[1], b = vo(), y = b.screens, v = It(), _ = M0({
    ignoreLocal: !0
  }), w = it(null);
  Jf(t, function() {
    return {
      getActiveSpeakerAudio: function() {
        var E, L;
        return (E = (L = w.current) == null ? void 0 : L.querySelector('audio[data-session-id="' + _ + '"][data-audio-type="audio"]')) != null ? E : null;
      },
      getAllAudio: function() {
        var E, L;
        return Array.from((E = (L = w.current) == null ? void 0 : L.querySelectorAll("audio")) != null ? E : []);
      },
      getAudioBySessionId: function(E) {
        var L, B;
        return (L = (B = w.current) == null ? void 0 : B.querySelector('audio[data-session-id="' + E + '"][data-audio-type="audio"]')) != null ? L : null;
      },
      getRmpAudio: function() {
        var E, L;
        return Array.from((E = (L = w.current) == null ? void 0 : L.querySelectorAll('audio[data-audio-type="rmpAudio"]')) != null ? E : []);
      },
      getScreenAudio: function() {
        var E, L;
        return Array.from((E = (L = w.current) == null ? void 0 : L.querySelectorAll('audio[data-audio-type="screenAudio"]')) != null ? E : []);
      },
      getRmpAudioBySessionId: function(E) {
        var L, B;
        return (L = (B = w.current) == null ? void 0 : B.querySelector('audio[data-session-id="' + E + '"][data-audio-type="rmpAudio"]')) != null ? L : null;
      },
      getScreenAudioBySessionId: function(E) {
        var L, B;
        return (L = (B = w.current) == null ? void 0 : B.querySelector('audio[data-session-id="' + E + '"][data-audio-type="screenAudio"]')) != null ? L : null;
      }
    };
  }, [_]);
  var k = be(function(N) {
    var E = N.snapshot;
    return /* @__PURE__ */ function() {
      var L = Nt(function* (B) {
        var Q, G = Object.values((Q = l == null ? void 0 : l.participants()) != null ? Q : {}).filter(function(ie) {
          return !ie.local && !!ie.tracks.audio.subscribed;
        }), te = function(J) {
          return G.some(function(ce) {
            return ce.session_id === J;
          });
        };
        if (!te(B))
          if (l && !l.isDestroyed() && r && !l.subscribeToTracksAutomatically())
            l.updateParticipant(B, {
              setSubscribedTracks: {
                audio: !0
              }
            });
          else
            return;
        g(function(ie) {
          var J;
          if (ie.includes(B))
            return ie;
          var ce = function(Y) {
            return !Y || !te(Y);
          };
          if (ie.some(ce)) {
            var Me = ie.findIndex(ce);
            return ie[Me] = B, [].concat(ie);
          }
          var se = ie.findIndex(function(K) {
            return G.some(function(Y) {
              return Y.session_id === K && Di(Y.tracks.audio.state);
            });
          });
          if (se >= 0)
            return ie[se] = B, [].concat(ie);
          var Re = G.filter(function(K) {
            return (
              // Only consider participants currently assigned to speaker slots
              ie.includes(K.session_id) && // Don't replace current active participant, to avoid audio drop-outs
              K.session_id !== _
            );
          }).sort(function(K, Y) {
            var M, s, p = (M = E.getLoadable(dt({
              id: K.session_id,
              property: "last_active"
            })).contents) != null ? M : /* @__PURE__ */ new Date("1970-01-01"), f = (s = E.getLoadable(dt({
              id: Y.session_id,
              property: "last_active"
            })).contents) != null ? s : /* @__PURE__ */ new Date("1970-01-01");
            return p > f ? 1 : p < f ? -1 : 0;
          });
          if (!Re.length) {
            var ke = ie.findIndex(function(K) {
              return K !== _;
            });
            return ie[ke] = B, [].concat(ie);
          }
          var Ae = ie.indexOf((J = Re[0]) == null ? void 0 : J.session_id);
          return ie[Ae] = B, [].concat(ie);
        });
      });
      return function(B) {
        return L.apply(this, arguments);
      };
    }();
  }, [_, r, l]), O = ge(function(N) {
    g(function(E) {
      if (!E.includes(N))
        return E;
      var L = [].concat(E), B = L.indexOf(N);
      return L[B] = "", L;
    });
  }, []);
  Mr(["active-speaker-change", "track-started", "participant-left"], ge(function(N) {
    N.forEach(function(E) {
      switch (E.action) {
        case "active-speaker-change":
          if (E.activeSpeaker.peerId === v)
            return;
          k(E.activeSpeaker.peerId);
          break;
        case "track-started":
          E.track.kind === "audio" && E.participant && !E.participant.local && k(E.participant.session_id);
          break;
        case "participant-left":
          O(E.participant.session_id);
          break;
      }
    });
  }, [k, v, O]), 200);
  var I = Os({
    filter: ge(function(N) {
      var E;
      return !!(!(N == null || (E = N.tracks) == null) && E.rmpAudio);
    }, [])
  });
  return Z.createElement("div", {
    ref: w
  }, h.map(function(N, E) {
    return Z.createElement(_i, {
      key: "speaker-slot-" + E,
      onPlayFailed: a,
      sessionId: N,
      type: "audio"
    });
  }), y.filter(function(N) {
    return c ? !0 : !N.local;
  }).map(function(N) {
    return Z.createElement(_i, {
      key: N.screenId,
      onPlayFailed: a,
      sessionId: N.session_id,
      type: "screenAudio"
    });
  }), I.map(function(N) {
    return Z.createElement(_i, {
      key: N + "-rmp",
      onPlayFailed: a,
      sessionId: N,
      type: "rmpAudio"
    });
  }));
}));
Af.displayName = "DailyAudio";
var O0 = ["automirror", "fit", "mirror", "onResize", "playableStyle", "sessionId", "style", "type"], Ns = /* @__PURE__ */ Qa(function(t, n) {
  var r = t.automirror, i = t.fit, o = i === void 0 ? "contain" : i, a = t.mirror, u = t.onResize, c = t.playableStyle, l = c === void 0 ? {} : c, d = t.sessionId, h = t.style, g = h === void 0 ? {} : h, b = t.type, y = b === void 0 ? "video" : b, v = As(t, O0), _ = It(), w = _ === d, k = y === "screenVideo", O = w && !k, I = it(null), N = Mf(I, n), E = mo(d, y), L = E.persistentTrack, B = O || k || !E.isOff, Q = ho(d, "tracks." + y), G = Q == null ? void 0 : Q.subscribed, te = Pt(function() {
    if (typeof a == "boolean")
      return a;
    if (!r)
      return !1;
    if (!L)
      return O;
    var ie = L.getSettings(), J = "facingMode" in ie ? O && ie.facingMode === "user" : O;
    return J;
  }, [r, O, a, L]);
  return Oe(function() {
    var J = I.current;
    if (J) {
      var ce = function() {
        var K = J.play();
        K !== void 0 && K.then(function() {
          J.controls = !1;
        }).catch(function(Y) {
          J.controls = !0, console.warn("Failed to play video", Y);
        });
      }, Me = function() {
        J.paused && ce();
      }, se = function() {
        J.style.transform = "scale(1)";
      }, Re = function() {
        J.style.transform = "", setTimeout(function() {
          J.paused && ce();
        }, 100);
      }, ke = function() {
        document.visibilityState !== "hidden" && J.paused && ce();
      };
      return J.addEventListener("canplay", Me), J.addEventListener("enterpictureinpicture", se), J.addEventListener("leavepictureinpicture", Re), document.addEventListener("visibilitychange", ke), function() {
        J.removeEventListener("canplay", Me), J.removeEventListener("enterpictureinpicture", se), J.removeEventListener("leavepictureinpicture", Re), document.removeEventListener("visibilitychange", ke);
      };
    }
  }, []), Oe(function() {
    var J = I.current;
    if (!(!J || !L))
      return J.srcObject = new MediaStream([L]), J.load(), function() {
        J.srcObject = null, J.load();
      };
  }, [L, L == null ? void 0 : L.id]), Oe(function() {
    var J = I.current;
    if (!u || !J)
      return;
    var ce;
    function Me() {
      ce && cancelAnimationFrame(ce), ce = requestAnimationFrame(function() {
        var se = I.current;
        if (!(!se || document.hidden)) {
          var Re = se.videoWidth, ke = se.videoHeight;
          Re && ke && (u == null || u({
            aspectRatio: Re / ke,
            height: ke,
            width: Re
          }));
        }
      });
    }
    return Me(), J.addEventListener("loadedmetadata", Me), J.addEventListener("resize", Me), function() {
      ce && cancelAnimationFrame(ce), J.removeEventListener("loadedmetadata", Me), J.removeEventListener("resize", Me);
    };
  }, [u]), Z.createElement("video", Object.assign({
    autoPlay: !0,
    muted: !0,
    playsInline: !0,
    ref: N,
    "data-local": w,
    "data-mirrored": te || void 0,
    "data-playable": B || void 0,
    "data-session-id": d,
    "data-subscribed": G,
    "data-video-type": y,
    style: Be({
      objectFit: o,
      transform: te ? "scale(-1, 1)" : ""
    }, g, B ? l : {})
  }, v));
});
Ns.displayName = "DailyVideo";
var Pf = /* @__PURE__ */ Ar({
  refreshDevices: function() {
    return Promise.resolve();
  }
}), Je = /* @__PURE__ */ Fe({
  key: Pe + "general-camera-state",
  default: "idle"
}), He = /* @__PURE__ */ Fe({
  key: Pe + "general-microphone-state",
  default: "idle"
}), bi = /* @__PURE__ */ Fe({
  key: Pe + "camera-devices",
  default: []
}), Si = /* @__PURE__ */ Fe({
  key: Pe + "microphone-devices",
  default: []
}), Of = /* @__PURE__ */ Fe({
  key: Pe + "speaker-devices",
  default: []
}), Nf = /* @__PURE__ */ Fe({
  key: Pe + "last-camera-error",
  default: null
}), N0 = function(t) {
  var n = t.children, r = Xe(), i = be(function(a) {
    var u = a.transact_UNSTABLE;
    return /* @__PURE__ */ Nt(function* () {
      var c, l, d, h;
      if (typeof ((c = navigator) == null || (l = c.mediaDevices) == null ? void 0 : l.getUserMedia) > "u" || typeof ((d = navigator) == null || (h = d.mediaDevices) == null ? void 0 : h.enumerateDevices) > "u") {
        u(function(L) {
          var B = L.set;
          B(Je, "not-supported"), B(He, "not-supported");
        });
        return;
      }
      if (r)
        try {
          var g = yield r.enumerateDevices(), b = g.devices, y = b.filter(function(L) {
            return L.kind === "videoinput" && L.deviceId !== "";
          }), v = b.filter(function(L) {
            return L.kind === "audioinput" && L.deviceId !== "";
          }), _ = b.filter(function(L) {
            return L.kind === "audiooutput" && L.deviceId !== "";
          }), w = yield r.getInputDevices(), k = w.camera, O = w.mic, I = w.speaker, N = function(B, Q, G) {
            var te, ie;
            return {
              device: Q,
              selected: "deviceId" in B && Q.deviceId === B.deviceId,
              state: (te = (ie = G.find(function(J) {
                return J.device.deviceId === Q.deviceId;
              })) == null ? void 0 : ie.state) != null ? te : "granted"
            };
          }, E = function(B, Q) {
            return B.device.deviceId === "default" ? -1 : Q.device.deviceId === "default" ? 1 : B.device.label < Q.device.label ? -1 : B.device.label > Q.device.label ? 1 : 0;
          };
          u(function(L) {
            var B = L.set;
            B(bi, function(Q) {
              return y.filter(Boolean).map(function(G) {
                return N(k, G, Q);
              }).sort(E);
            }), B(Si, function(Q) {
              return v.filter(Boolean).map(function(G) {
                return N(O, G, Q);
              }).sort(E);
            }), B(Of, function(Q) {
              return _.filter(Boolean).map(function(G) {
                return N(I, G, Q);
              }).sort(E);
            });
          });
        } catch {
          u(function(B) {
            var Q = B.set;
            Q(Je, "not-supported"), Q(He, "not-supported");
          });
        }
    });
  }, [r]), o = be(function(a) {
    var u = a.set, c = a.snapshot, l = a.transact_UNSTABLE;
    return /* @__PURE__ */ Nt(function* () {
      var d, h, g, b, y, v, _, w, k, O, I, N, E, L;
      if (r) {
        var B = yield c.getPromise(Je), Q = yield c.getPromise(He), G = r.participants();
        if (G.local) {
          var te = G.local.tracks, ie = "prompt", J = "prompt";
          if (navigator.permissions)
            try {
              var ce = yield navigator.permissions.query({
                // @ts-ignore
                name: "camera"
              });
              ie = ce.state;
              var Me = yield navigator.permissions.query({
                // @ts-ignore
                name: "microphone"
              });
              J = Me.state;
            } catch {
            }
          var se = ie === "prompt" && ["idle", "pending"].includes(B) && te.video.state === "interrupted" && !te.video.persistentTrack, Re = ["idle", "pending"].includes(B) && !te.video.persistentTrack && !!((d = te.video.off) != null && d.byUser), ke = J === "prompt" && ["idle", "pending"].includes(Q) && te.audio.state === "interrupted" && !te.audio.persistentTrack, Ae = ["idle", "pending"].includes(Q) && !te.audio.persistentTrack && !!((h = te.audio.off) != null && h.byUser);
          (g = te.audio) != null && (b = g.blocked) != null && b.byDeviceInUse ? l(function(K) {
            var Y = K.set;
            Y(He, "in-use"), Y(Si, function(M) {
              return M.map(function(s) {
                return s.selected ? Be({}, s, {
                  state: "in-use"
                }) : s;
              });
            });
          }) : (y = te.audio) != null && (v = y.blocked) != null && v.byDeviceMissing ? u(He, "not-found") : (_ = te.audio) != null && (w = _.blocked) != null && w.byPermissions || J === "denied" ? u(He, "blocked") : ke ? u(He, "pending") : Ae ? u(He, "idle") : l(function(K) {
            var Y = K.set;
            Y(He, "granted"), Y(Si, function(M) {
              return M.map(function(s) {
                return s.selected ? Be({}, s, {
                  state: "granted"
                }) : s;
              });
            });
          }), (k = te.video) != null && (O = k.blocked) != null && O.byDeviceInUse ? l(function(K) {
            var Y = K.set;
            Y(Je, "in-use"), Y(bi, function(M) {
              return M.map(function(s) {
                return s.selected ? Be({}, s, {
                  state: "in-use"
                }) : s;
              });
            });
          }) : (I = te.video) != null && (N = I.blocked) != null && N.byDeviceMissing ? u(Je, "not-found") : (E = te.video) != null && (L = E.blocked) != null && L.byPermissions || ie === "denied" ? u(Je, "blocked") : se ? u(Je, "pending") : Re ? u(Je, "idle") : l(function(K) {
            var Y = K.set;
            Y(Je, "granted"), Y(bi, function(M) {
              return M.map(function(s) {
                return s.selected ? Be({}, s, {
                  state: "granted"
                }) : s;
              });
            });
          }), i();
        }
      }
    });
  }, [r, i]);
  return le("participant-updated", ge(function(a) {
    a.participant.local && o();
  }, [o])), le("available-devices-updated", i), le("selected-devices-updated", i), le("camera-error", be(function(a) {
    var u = a.transact_UNSTABLE;
    return function(c) {
      u(function(l) {
        var d, h, g, b, y, v, _, w = l.set;
        switch (w(Nf, c.error), (d = c.error) == null ? void 0 : d.type) {
          case "cam-in-use":
            w(Je, "in-use");
            break;
          case "mic-in-use":
            w(He, "in-use");
            break;
          case "cam-mic-in-use":
            w(Je, "in-use"), w(He, "in-use");
            break;
          case "not-found":
            (h = c.error) != null && h.missingMedia.includes("video") && w(Je, "not-found"), (g = c.error) != null && g.missingMedia.includes("audio") && w(He, "not-found");
            break;
          case "permissions":
            (b = c.error) != null && b.blockedMedia.includes("video") && w(Je, "blocked"), (y = c.error) != null && y.blockedMedia.includes("audio") && w(He, "blocked");
            break;
          case "constraints":
            ((v = c.error) == null ? void 0 : v.reason) === "invalid" ? (w(Je, "constraints-invalid"), w(He, "constraints-invalid")) : ((_ = c.error) == null ? void 0 : _.reason) === "none-specified" && (w(Je, "constraints-none-specified"), w(He, "constraints-none-specified"));
            break;
          case "undefined-mediadevices":
            w(Je, "undefined-mediadevices"), w(He, "undefined-mediadevices");
            break;
          case "unknown":
          default:
            w(Je, "unknown"), w(He, "unknown");
            break;
        }
      });
    };
  }, [])), le("started-camera", be(function(a) {
    var u = a.transact_UNSTABLE;
    return function() {
      u(function(c) {
        var l = c.set;
        l(Je, "granted"), l(He, "granted");
      }), o();
    };
  }, [o])), Z.createElement(Pf.Provider, {
    value: {
      refreshDevices: i
    }
  }, n);
}, ui = /* @__PURE__ */ Fe({
  key: Pe + "live-streaming",
  default: {
    errorMsg: void 0,
    isLiveStreaming: !1,
    layout: void 0
  }
}), L0 = function(t) {
  var n = t.children;
  return le("live-streaming-started", be(function(r) {
    var i = r.set;
    return function(o) {
      i(ui, {
        isLiveStreaming: !0,
        layout: o == null ? void 0 : o.layout
      });
    };
  }, [])), le("live-streaming-stopped", be(function(r) {
    var i = r.set;
    return function() {
      i(ui, function(o) {
        return Be({}, o, {
          isLiveStreaming: !1,
          layout: void 0
        });
      });
    };
  }, [])), le("live-streaming-error", be(function(r) {
    var i = r.set;
    return function(o) {
      i(ui, function(a) {
        return Be({}, a, {
          errorMsg: o.errorMsg
        });
      });
    };
  }, [])), le("left-meeting", be(function(r) {
    var i = r.reset;
    return function() {
      i(ui);
    };
  }, [])), Z.createElement(Z.Fragment, null, n);
}, qa = /* @__PURE__ */ Fe({
  key: Pe + "meeting-state",
  default: "new"
}), Ja = /* @__PURE__ */ Fe({
  key: Pe + "meeting-error",
  default: null
}), Ha = /* @__PURE__ */ Fe({
  key: Pe + "non-fatal-error",
  default: null
}), li = /* @__PURE__ */ Fe({
  key: "meeting-session-data",
  default: {
    data: void 0,
    topology: "none"
  }
}), I0 = function(t) {
  var n = t.children, r = Xe(), i = be(function(a) {
    var u = a.set;
    return function() {
      if (r) {
        var c = r.meetingState();
        return u(qa, c), c;
      }
    };
  }, [r]);
  le("loading", i), le("loaded", i), le("joining-meeting", i), le("joined-meeting", i), le("left-meeting", i), le("error", be(function(a) {
    var u = a.set;
    return function(c) {
      u(Ja, c), i();
    };
  }, [i])), le("nonfatal-error", be(function(a) {
    var u = a.set;
    return function(c) {
      u(Ha, c);
    };
  }, []));
  var o = be(function(a) {
    var u = a.set;
    return function() {
      r && u(li, r.meetingSessionState());
    };
  }, [r]);
  return le("joined-meeting", o), le("meeting-session-state-updated", be(function(a) {
    var u = a.set;
    return function(c) {
      u(li, c.meetingSessionState);
    };
  }, [])), le("left-meeting", be(function(a) {
    var u = a.reset;
    return function() {
      u(li);
    };
  }, [])), le("call-instance-destroyed", be(function(a) {
    var u = a.transact_UNSTABLE;
    return function() {
      u(function(c) {
        var l = c.reset;
        l(qa), l(Ja), l(Ha), l(li);
      });
    };
  }, [])), Z.createElement(Z.Fragment, null, n);
}, Fn = /* @__PURE__ */ Fe({
  key: Pe + "topology",
  default: "none"
}), Ga = /* @__PURE__ */ Fe({
  key: Pe + "networkQuality",
  default: 100
}), Ka = /* @__PURE__ */ Fe({
  key: Pe + "networkThreshold",
  default: "good"
}), x0 = function(t) {
  var n = t.children, r = Xe(), i = Ge(Fn), o = be(function(a) {
    var u = a.set;
    return /* @__PURE__ */ Nt(function* () {
      if (r) {
        var c = yield r.getNetworkTopology();
        !c || (c == null ? void 0 : c.topology) === "none" || u(Fn, c.topology);
      }
    });
  }, [r]);
  return le("joined-meeting", o), le("network-connection", be(function(a) {
    var u = a.set;
    return function(c) {
      switch (c.event) {
        case "connected":
          c.type === "peer-to-peer" && u(Fn, "peer"), c.type === "sfu" && u(Fn, "sfu");
          break;
      }
    };
  }, [])), le("network-quality-change", be(function(a) {
    var u = a.transact_UNSTABLE;
    return function(c) {
      u(function(l) {
        var d = l.set;
        d(Ga, function(h) {
          return h !== c.quality ? c.quality : h;
        }), d(Ka, function(h) {
          return h !== c.threshold ? c.threshold : h;
        });
      });
    };
  }, [])), le("left-meeting", be(function(a) {
    var u = a.transact_UNSTABLE;
    return function() {
      u(function(c) {
        var l = c.reset;
        l(Fn), l(Ga), l(Ka);
      });
    };
  }, [])), Oe(function() {
    !r || i !== "none" || o();
  }, [r, o, i]), Z.createElement(Z.Fragment, null, n);
}, gr = /* @__PURE__ */ Fe({
  key: Pe + "recording",
  default: {
    isLocalParticipantRecorded: !1,
    isRecording: !1
  }
}), j0 = function(t) {
  var n = t.children, r = e0(gr), i = It(), o = Os({
    filter: "record"
  });
  return Oe(function() {
    var a = o.length > 0, u = o.includes(i || "local");
    r(function(c) {
      return Be({}, c, {
        // In case type is local or not set, determine based on recording participants
        isLocalParticipantRecorded: (c == null ? void 0 : c.type) === "local" || !(c != null && c.type) ? a : c.isLocalParticipantRecorded,
        isRecording: (c == null ? void 0 : c.type) === "local" || !(c != null && c.type) ? a : c.isRecording,
        local: ((c == null ? void 0 : c.type) === "local" || !(c != null && c.type)) && a ? u : c == null ? void 0 : c.local,
        /**
         * Set type in case recording participants are detected.
         * We only set `record` on participants, when recording type is 'local'.
         */
        type: a ? "local" : c == null ? void 0 : c.type
      });
    });
  }, [i, o, r]), le("recording-started", be(function(a) {
    var u = a.set;
    return function(c) {
      var l = !0;
      switch (c.type) {
        case "cloud-beta":
        case "cloud": {
          var d;
          i && ((d = c.layout) == null ? void 0 : d.preset) === "single-participant" && c.layout.session_id !== i && (l = !1);
          break;
        }
      }
      u(gr, {
        error: !1,
        isLocalParticipantRecorded: l,
        isRecording: !0,
        layout: c == null ? void 0 : c.layout,
        local: c == null ? void 0 : c.local,
        recordingId: c == null ? void 0 : c.recordingId,
        recordingStartedDate: /* @__PURE__ */ new Date(),
        startedBy: c == null ? void 0 : c.startedBy,
        type: c == null ? void 0 : c.type
      });
    };
  }, [i])), le("recording-stopped", be(function(a) {
    var u = a.set;
    return function() {
      u(gr, function(c) {
        return Be({}, c, {
          isLocalParticipantRecorded: !1,
          isRecording: !1
        });
      });
    };
  }, [])), le("recording-error", be(function(a) {
    var u = a.set;
    return function() {
      u(gr, function(c) {
        return Be({}, c, {
          error: !0,
          isLocalParticipantRecorded: !1,
          isRecording: !1
        });
      });
    };
  }, [])), le("left-meeting", be(function(a) {
    var u = a.reset;
    return function() {
      u(gr);
    };
  }, [])), Z.createElement(Z.Fragment, null, n);
}, Lf = function() {
  var t = Ge(qa);
  return pt(t), t;
}, il = /* @__PURE__ */ Fe({
  key: Pe + "room",
  default: null
}), D0 = function(t) {
  var n = t.children, r = Xe(), i = Lf(), o = be(function(a) {
    var u = a.set;
    return /* @__PURE__ */ Nt(function* () {
      if (!(!r || i === "left-meeting")) {
        var c = yield r.room();
        return c && "id" in c && u(il, c), c;
      }
    });
  }, [r, i]);
  return le("access-state-updated", o), le("left-meeting", be(function(a) {
    var u = a.reset;
    return function() {
      u(il);
    };
  }, [])), Z.createElement(Z.Fragment, null, n);
}, yr = /* @__PURE__ */ Fe({
  key: Pe + "transcription",
  default: {
    isTranscribing: !1,
    model: "general",
    language: "en",
    transcriptions: []
  }
}), V0 = function(t) {
  var n = t.children;
  return le("transcription-started", be(function(r) {
    var i = r.set;
    return function(o) {
      i(yr, Be({
        error: !1,
        isTranscribing: !0,
        transcriptionStartDate: /* @__PURE__ */ new Date(),
        transcriptions: []
      }, o));
    };
  }, [])), le("transcription-stopped", be(function(r) {
    var i = r.set;
    return function(o) {
      i(yr, function(a) {
        return Be({}, a, {
          updatedBy: o == null ? void 0 : o.updatedBy,
          isTranscribing: !1
        });
      });
    };
  }, [])), le("transcription-error", be(function(r) {
    var i = r.set;
    return function() {
      i(yr, function(o) {
        return Be({}, o, {
          error: !0,
          isTranscribing: !1
        });
      });
    };
  }, [])), le("left-meeting", be(function(r) {
    var i = r.set;
    return function() {
      i(yr, function(o) {
        return Be({}, o, {
          isTranscribing: !1
        });
      });
    };
  }, [])), le("app-message", be(function(r) {
    var i = r.set;
    return function(o) {
      (o == null ? void 0 : o.fromId) === "transcription" && i(yr, function(a) {
        return Be({}, a, {
          // setting it to true whenever a new message is received
          // as the participants who joined after the transcription-started event
          // won't be knowing if transcription is started or not
          isTranscribing: !0,
          transcriptions: [].concat(a.transcriptions, [o.data])
        });
      });
    };
  }, [])), Z.createElement(Z.Fragment, null, n);
}, If = {}, xf = function() {
  return !0;
}, $0 = {
  options: If,
  shouldCreateInstance: xf
}, B0 = function(t, n) {
  var r = n === void 0 ? $0 : n, i = r.parentEl, o = r.options, a = o === void 0 ? If : o, u = r.shouldCreateInstance, c = u === void 0 ? xf : u, l = ut(null), d = l[0], h = l[1], g = it();
  return Oe(function() {
    if (t === "callFrame" && i === null || !c())
      return;
    function b(w) {
      return y.apply(this, arguments);
    }
    function y() {
      return y = Nt(function* (w) {
        yield w.destroy();
      }), y.apply(this, arguments);
    }
    var v = function() {
      setTimeout(function() {
        return h(null);
      }, 0);
    }, _ = Ut.getCallInstance();
    if (!d && _ && !_.isDestroyed()) {
      _.once("call-instance-destroyed", v), h(_);
      return;
    }
    if (d) {
      Qt(g.current, a) || b(d);
      return;
    }
    if (!_ || _.isDestroyed()) {
      switch (t) {
        case "callFrame":
          _ = i ? Ut.createFrame(i, Be({}, a)) : Ut.createFrame(Be({}, a));
          break;
        case "callObject":
          _ = Ut.createCallObject(Be({}, a));
          break;
      }
      g.current = a;
    }
    h(_), _.once("call-instance-destroyed", v);
  }, [d, a, i, c, t]), d;
}, F0 = function(t) {
  return B0("callObject", t);
}, U0 = ["children", "recoilRootProps"], z0 = function(t) {
  var n = t.children, r = t.recoilRootProps, i = r === void 0 ? {} : r, o = As(t, U0), a = it({}), u = ge(function(v) {
    if ("action" in v)
      for (var _ = v.action, w = za((O = (I = a.current) == null || (N = I[_]) == null ? void 0 : N.values()) != null ? O : []), k; !(k = w()).done; ) {
        var O, I, N, E = k.value;
        E(v);
      }
  }, []), c = ge(function(v) {
    v && Object.keys(a.current).forEach(function(_) {
      v.off(_, u), v.isDestroyed() || v.on(_, u);
    });
  }, [u]), l = "callObject" in o ? o.callObject : null, d = Pt(function() {
    return "callObject" in o ? {} : o;
  }, [o]), h = F0({
    options: d,
    shouldCreateInstance: ge(function() {
      return !("callObject" in o);
    }, [o])
  }), g = l ?? h;
  Oe(function() {
    g && c(g);
  }, [g, c]);
  var b = ge(function(v, _, w) {
    var k;
    if (a.current[v] || (a.current[v] = /* @__PURE__ */ new Map(), g && (g.off(v, u), g.isDestroyed() || g.on(v, u))), !((k = a.current[v]) != null && k.has(w))) {
      var O;
      (O = a.current[v]) == null || O.set(w, _);
    }
  }, [g, u]), y = ge(function(v, _) {
    var w, k;
    (w = a.current[v]) == null || w.delete(_), ((k = a.current[v]) == null ? void 0 : k.size) === 0 && (g == null || g.off(v, u), delete a.current[v]);
  }, [g, u]);
  return Z.createElement(Xw, Object.assign({}, i), Z.createElement(Tf.Provider, {
    value: g
  }, Z.createElement(Ps.Provider, {
    value: {
      on: b,
      off: y
    }
  }, Z.createElement(D0, null, Z.createElement(I0, null, Z.createElement(x0, null, Z.createElement(R0, null, Z.createElement(j0, null, Z.createElement(L0, null, Z.createElement(V0, null, Z.createElement(N0, null, n)))))))))));
}, W0 = `
    class AudioLevelProcessor extends AudioWorkletProcessor {
    volume;
    interval;
    nextFrame;
    
    constructor() {
      super();
      this.volume = 0;
      this.interval = 25;
      this.nextFrame = this.interval;
    }
    
    get intervalInFrames() {
      // sampleRate is globally defined in AudioWorklets.
      // See https://developer.mozilla.org/en-US/docs/Web/API/AudioWorkletGlobalScope
      // eslint-disable-next-line no-undef
      return (this.interval / 1000) * sampleRate;
    }
    
    process(inputList) {
      const firstInput = inputList[0];
    
      if (firstInput.length > 0) {
        const inputData = firstInput[0];
        let total = 0;
    
        for (let i = 0; i < inputData.length; ++i) {
          total += Math.abs(inputData[i]);
        }
    
        const rms = Math.sqrt(total / inputData.length);
        this.volume = Math.max(0, Math.min(1, rms));
    
        this.nextFrame -= inputData.length;
        if (this.nextFrame < 0) {
          this.nextFrame += this.intervalInFrames;
          this.port.postMessage({ volume: this.volume });
        }
      }
    
      return true;
    }
    }
    
    registerProcessor('audiolevel', AudioLevelProcessor);              
`, q0 = "data:application/javascript;charset=utf8," + /* @__PURE__ */ encodeURIComponent(W0), jf = function(t, n) {
  var r = it();
  Oe(function() {
    if (t) {
      var o = typeof AudioContext < "u" ? AudioContext : typeof window.webkitAudioContext < "u" ? window.webkitAudioContext : null;
      if (o) {
        r.current || (r.current = new o());
        var a = r.current;
        if (a) {
          var u = a.createMediaStreamSource(new MediaStream([t])), c, l, d = /* @__PURE__ */ function() {
            var h = Nt(function* () {
              try {
                c = new AudioWorkletNode(a, "audiolevel"), l = a.createGain();
              } catch {
                try {
                  yield a.audioWorklet.addModule(q0), c = new AudioWorkletNode(a, "audiolevel"), l = a.createGain();
                } catch (b) {
                  console.error(b);
                }
              }
              if (c && l) {
                c.port.onmessage = function(g) {
                  var b = 0;
                  g.data.volume && (b = g.data.volume), c && n(b);
                }, l.gain.value = 0;
                try {
                  u.connect(c).connect(l).connect(a.destination);
                } catch (g) {
                  console.warn(g);
                }
              }
            });
            return function() {
              return h.apply(this, arguments);
            };
          }();
          return d(), function() {
            var h;
            (h = c) == null || h.disconnect(), c = null, u == null || u.disconnect();
          };
        }
      }
    }
  }, [n, t]);
}, go = function(t) {
  return mo(t, "audio");
}, Df = function() {
  var t = Ge(Ja), n = Ge(Ha), r = {
    meetingError: t,
    nonFatalError: n
  };
  return pt(r), r;
}, Uk = function() {
  var t = Xe(), n = Ge(Je), r = Ge(He), i = Ge(bi), o = Ge(Si), a = Ge(Of), u = Ge(Nf), c = nr(Pf), l = c.refreshDevices, d = ge(/* @__PURE__ */ function() {
    var v = Nt(function* (_) {
      yield t == null ? void 0 : t.setInputDevicesAsync({
        audioDeviceId: null,
        videoDeviceId: _
      });
    });
    return function(_) {
      return v.apply(this, arguments);
    };
  }(), [t]), h = ge(/* @__PURE__ */ function() {
    var v = Nt(function* (_) {
      yield t == null ? void 0 : t.setInputDevicesAsync({
        audioDeviceId: _,
        videoDeviceId: null
      });
    });
    return function(_) {
      return v.apply(this, arguments);
    };
  }(), [t]), g = ge(/* @__PURE__ */ function() {
    var v = Nt(function* (_) {
      yield t == null ? void 0 : t.setOutputDeviceAsync({
        outputDeviceId: _
      });
    });
    return function(_) {
      return v.apply(this, arguments);
    };
  }(), [t]), b = ["blocked", "in-use", "not-found", "constraints-invalid", "constraints-none-specified", "undefined-mediadevices", "unknown"], y = {
    /**
     * Most recent error object emitted via [camera-error event](https://docs.daily.co/reference/daily-js/events/meeting-events#camera-error).
     */
    cameraError: u,
    /**
     * A list of the user's camera (videoinput) devices. See [MediaDeviceInfo](https://developer.mozilla.org/en-US/docs/Web/API/MediaDeviceInfo) for more info.
     */
    cameras: i,
    /**
     * The general state for camera access.
     */
    camState: n,
    /**
     * Holds the currently selected camera.
     */
    currentCam: i.find(function(v) {
      return v.selected;
    }),
    /**
     * Holds the currently selected microphone.
     */
    currentMic: o.find(function(v) {
      return v.selected;
    }),
    /**
     * Holds the currently selected speaker.
     */
    currentSpeaker: a.find(function(v) {
      return v.selected;
    }),
    /**
     * Indicates that there's an issue with camera devices.
     */
    hasCamError: b.includes(n),
    /**
     * Indicates that there's an issue with microphone devices.
     */
    hasMicError: b.includes(r),
    /**
     * A list of the user's microphone (audioinput) devices. See [MediaDeviceInfo](https://developer.mozilla.org/en-US/docs/Web/API/MediaDeviceInfo) for more info.
     */
    microphones: o,
    /**
     * The general state for microphone access.
     */
    micState: r,
    /**
     * Refreshes the list of devices using [enumerateDevices](https://docs.daily.co/reference/daily-js/instance-methods/enumerate-devices).
     */
    refreshDevices: l,
    /**
     * Allows to switch to the camera with the specified deviceId. Calls [setInputDevicesAsync](https://docs.daily.co/reference/daily-js/instance-methods/set-input-devices-async) internally.
     */
    setCamera: d,
    /**
     * Allows to switch to the microphone with the specified deviceId. Calls [setInputDevicesAsync](https://docs.daily.co/reference/daily-js/instance-methods/set-input-devices-async) internally.
     */
    setMicrophone: h,
    /**
     * Allows to switch to the speaker with the specified deviceId. Calls [setOutputDevice](https://docs.daily.co/reference/daily-js/instance-methods/set-output-device) internally.
     */
    setSpeaker: g,
    /**
     * A list of the user's speaker (audiooutput) devices. See [MediaDeviceInfo](https://developer.mozilla.org/en-US/docs/Web/API/MediaDeviceInfo) for more info.
     */
    speakers: a
  };
  return pt(y), y;
}, ol = /* @__PURE__ */ Fe({
  key: Pe + "input-settings",
  default: null
}), J0 = function(t) {
  var n = t === void 0 ? {} : t, r = n.onError, i = n.onInputSettingsUpdated, o = Ge(ol), a = Df(), u = a.nonFatalError, c = Xe(), l = be(function(g) {
    var b = g.set;
    return function(y) {
      b(ol, y);
    };
  }, []);
  Oe(function() {
    c && c.getInputSettings().then(l);
  }, [c, l]), le("input-settings-updated", ge(function(g) {
    l(g.inputSettings), i == null || i(g);
  }, [i, l])), le("nonfatal-error", ge(function(g) {
    g.type === "input-settings-error" && (r == null || r(g));
  }, [r]));
  var d = ge(function() {
    for (var g = arguments.length, b = new Array(g), y = 0; y < g; y++)
      b[y] = arguments[y];
    return c == null ? void 0 : c.updateInputSettings.apply(c, b);
  }, [c]), h = {
    errorMsg: (u == null ? void 0 : u.type) === "input-settings-error" ? u.errorMsg : null,
    inputSettings: o,
    updateInputSettings: d
  };
  return pt(h), h;
}, H0 = function(t) {
  var n = t === void 0 ? {} : t, r = n.onNetworkConnection, i = n.onNetworkQualityChange, o = Xe(), a = Ge(Fn), u = Ge(Ga), c = Ge(Ka);
  le("network-connection", ge(function(h) {
    r == null || r(h);
  }, [r])), le("network-quality-change", ge(function(h) {
    i == null || i(h);
  }, [i]));
  var l = ge(/* @__PURE__ */ Nt(function* () {
    var h = yield o == null ? void 0 : o.getNetworkStats();
    return h == null ? void 0 : h.stats;
  }), [o]), d = {
    getStats: l,
    quality: u,
    threshold: c,
    topology: a
  };
  return pt(d), d;
}, sr = function(t) {
  return mo(t, "video");
};
function G0(e) {
  return new Promise((t, n) => {
    fetch(e).then((r) => {
      if (!r.ok)
        throw new Error("failed to fetch image: " + r.status);
      return r.blob();
    }).then((r) => {
      const i = new FileReader();
      i.readAsArrayBuffer(r), i.onloadend = () => {
        const o = i.result;
        t(o);
      };
    }).catch((r) => {
      n(r);
    });
  });
}
const al = [
  "loading",
  "loaded",
  "started-camera",
  "joining-meeting",
  "joined-meeting",
  "left-meeting",
  "call-instance-destroyed",
  "meeting-session-updated",
  "access-state-updated",
  "receive-settings-updated",
  "send-settings-updated",
  "input-settings-updated",
  "local-screen-share-started",
  "local-screen-share-stopped",
  "local-screen-share-canceled",
  "participant-joined",
  "participant-updated",
  "participant-left",
  "track-started",
  "track-stopped",
  "network-connection",
  "cpu-load-change"
];
function K0(e) {
  const { meetingError: t, nonFatalError: n } = Df(), r = Xe();
  function i({ action: a, ...u }) {
    qe.info(a, u);
  }
  function o({ action: a, ...u }) {
    qe.error(a, u);
  }
  Oe(() => {
    if (r)
      return al.forEach((a) => r.on(a, i)), () => {
        al.forEach((a) => r.off(a, i));
      };
  }, [r]), Oe(() => {
    t && (o(t), qe.error("useDailyError", t), e("error", { error: new Error(t.errorMsg) }));
  }, [t]), Oe(() => {
    if (n) {
      const { action: a, ...u } = n;
      qe.warn(a, u);
    }
  }, [n]);
}
const Vf = "#08B273", wi = "#D83A68", Y0 = "#FFFFFF", $f = "#00000028";
function Q0() {
  const { getStats: e, topology: t } = H0(), n = ge((r) => {
    r != null && r.length && qe.info("network quality changed", { events: r.map(({ threshold: i, quality: o }) => ({ threshold: i, quality: o })) });
  }, []);
  Mr("network-quality-change", n, 3e4), Oe(() => {
    qe.info("network topology changed", { topology: t });
  }, [t]), Oe(() => {
    if (e && ["peer", "sfu"].includes(t)) {
      const r = setInterval(() => e().then((i) => qe.info("stats", i)), 3e4);
      return () => {
        clearInterval(r);
      };
    }
  }, [e, t]);
}
function Bf(e) {
  let t = {};
  return e != null && e.maxAudioBitrate && (t.micAudioMode = {
    bitrate: e == null ? void 0 : e.maxAudioBitrate,
    stereo: !1
  }), (e == null ? void 0 : e.audioDeviceId) === !1 && (t.alwaysIncludeMicInPermissionPrompt = !1), t;
}
function Z0(e) {
  var r, i;
  let t = {
    dailyConfig: Bf(e)
  };
  const { mobile: n } = Ut.supportedBrowser();
  return n ? t.sendSettings = {
    video: {
      encodings: {
        low: { maxBitrate: 5e5, maxFramerate: 25, scaleResolutionDownBy: 2 },
        medium: { maxBitrate: 15e5, maxFramerate: 30, scaleResolutionDownBy: 1 }
      }
    }
  } : t.sendSettings = {
    video: {
      encodings: {
        low: { maxBitrate: 75e4, maxFramerate: 30, scaleResolutionDownBy: 2 },
        medium: { maxBitrate: 25e5, maxFramerate: 30, scaleResolutionDownBy: 1 }
      }
    }
  }, (r = e == null ? void 0 : e.sendSettings) != null && r.video && (t.sendSettings.video = (i = e == null ? void 0 : e.sendSettings) == null ? void 0 : i.video), t;
}
const Ff = Ar(null), X0 = {
  ctrlButtonColor: wi,
  ctrlBarRadius: "32px",
  statusMessageRadius: "20px",
  statusMessageBGColor: Vf,
  displayTimer: "visible"
}, ek = {
  showCallTimer: !0,
  enableVideoProcessors: !1,
  preemptLoad: !1,
  enableRecording: !1
};
function tk({
  themeOptions: e,
  options: t = {},
  children: n
}) {
  const r = Xe(), [i, o] = ut(!!r), [a, u] = ut(null), c = Lf(), l = it(null), d = it(new EventTarget()), h = it(/* @__PURE__ */ new Map());
  K0(O), Q0();
  const g = Pt(() => ({ userDefined: Object.assign(X0, e) }), [e]), b = Pt(() => Object.assign({}, ek, t), [t]);
  Oe(() => {
    qe.info("meetingState:", { roomState: c, prevState: l.current }), ["left-meeting", "error"].includes(c) && ["joining-meeting", "joined-meeting"].includes(l.current) && O("disconnected", { error: c === "error" ? new Error("room state in error") : null }), l.current = c;
  }, [c]), Oe(() => {
    if (r && (qe.info("Daily is ready"), o(!0), b.preemptLoad)) {
      const I = ["load-attempt-failed", "loaded", "error"], N = ({ action: E, errorMsg: L }) => {
        E === "load-attempt-failed" ? qe.warn("Load attempt failed", L) : E === "error" ? (qe.error("Load failed", L), I.forEach((B) => r.off(B, N))) : (qe.info("Daily is loaded"), I.forEach((B) => r.off(B, N)));
      };
      return I.forEach((E) => r.on(E, N)), r.load(), () => {
        I.forEach((E) => r.off(E, N));
      };
    }
  }, [r, b.preemptLoad]);
  function y(I, N, E, L, B = null) {
    const Q = {
      url: I,
      token: N,
      userName: E,
      userData: L,
      ...Z0(B)
    };
    return qe.info("join options", Q), r.join(Q);
  }
  function v() {
    return r.leave();
  }
  const _ = (I) => {
    var N;
    return (I == null ? void 0 : I.type) === "background-image" ? G0((N = I.config) == null ? void 0 : N.url).then((E) => (u(E), r.updateInputSettings({
      video: {
        processor: {
          type: I.type,
          config: { source: E }
        }
      }
    }))) : r.updateInputSettings({
      video: {
        processor: I
      }
    });
  };
  function w(I, N) {
    const E = (L) => N(L.detail);
    d.current.addEventListener(I, E), h.current.set(N, E);
  }
  function k(I, N) {
    const E = h.current.get(N);
    E && (d.current.removeEventListener(I, E), h.current.delete(N));
  }
  function O(I, N) {
    const E = new CustomEvent(I, { detail: N });
    d.current.dispatchEvent(E);
  }
  return /* @__PURE__ */ D.jsx(Ff.Provider, { value: {
    isReady: i,
    roomState: c,
    join: y,
    leave: v,
    applyVideoProcessor: _,
    themeOptions: g,
    options: b,
    backgroundImage: a,
    onVideoEvent: w,
    offVideoEvent: k,
    emit: O
  }, children: n });
}
function xt() {
  const e = nr(Ff);
  if (!e)
    throw new Error("useBoutiqVideoRoomContext must be used within a BoutiqVideoRoomProvider");
  return e;
}
function zk({ children: e, ...t }) {
  return /* @__PURE__ */ D.jsx(z0, { children: /* @__PURE__ */ D.jsx(tk, { ...t, children: e }) });
}
function Uf({ initials: e, avatar: t, size: n = 150, fontSize: r = 52 }) {
  const [i, o] = ut(!t), a = () => {
    o(!0);
  };
  return /* @__PURE__ */ D.jsx("div", { className: `profile-avatar__container ${i && "profile-avatar__container__initial-background"}`, style: { width: n, height: n }, children: i ? /* @__PURE__ */ D.jsx("span", { className: "profile-avatar__initials", style: { fontSize: r }, children: e }) : /* @__PURE__ */ D.jsx("img", { className: "profile-avatar__pic", src: t, onError: a }) });
}
function nk() {
  const [e, t] = ut(0);
  Oe(() => {
    const r = setInterval(() => {
      t((i) => i + 1);
    }, 1e3);
    return () => {
      clearInterval(r);
    };
  }, []);
  const n = () => {
    const r = Math.floor(e / 3600), i = Math.floor(e / 60) - r * 60, o = (e % 60).toFixed(0), a = (i < 10 ? "0" : "") + i + ":" + (o < 10 ? "0" : "") + o;
    return r > 0 ? r + ":" + a : a;
  };
  return /* @__PURE__ */ D.jsx("span", { className: "call-time-display", children: n() });
}
function zf(e, t, n, r, i) {
  const o = it([]), { emit: a } = xt(), u = it(!1), c = it(/* @__PURE__ */ new Date()), l = 0.15, d = 3, h = 20;
  Oe(() => () => {
    u.current && a("participant_speaking", { action: "stopped_speaking", participantId: e, participantSid: t, participantName: n, timestamp: Date.now() });
  }, []), Oe(() => {
    i && u.current && (a("participant_speaking", { action: "stopped_speaking", participantId: e, participantSid: t, participantName: n, timestamp: Date.now() }), u.current = !1);
  }, [i]), Oe(() => {
    u.current = !1, o.current = [];
  }, [e]), Oe(() => {
    if (!e)
      return;
    c.current = /* @__PURE__ */ new Date();
    const g = r ?? 0;
    o.current.length > h - 1 && o.current.shift(), o.current.push(g);
    const b = o.current.length >= d && o.current.slice(-d).every((v) => v >= l), y = o.current.length >= h && o.current.every((v) => v < l);
    b && !u.current ? (u.current = !0, a("participant_speaking", { action: "started_speaking", participantId: e, participantSid: t, participantName: n, timestamp: Date.now() })) : y && u.current && (u.current = !1, a("participant_speaking", { action: "stopped_speaking", participantId: e, participantSid: t, participantName: n, timestamp: Date.now() }));
  }, [r, e]);
}
function rk(e) {
  return /* @__PURE__ */ D.jsxs(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: e.width || 20,
      height: e.height || 20,
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ D.jsx("path", { d: "M0 0h24v24H0z", fill: "none" }),
        /* @__PURE__ */ D.jsx("path", { fill: e.fill || "#000000", d: "M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" })
      ]
    }
  );
}
var Wf = {}, yo = {};
Object.defineProperty(yo, "__esModule", { value: !0 });
yo.PopoverPortal = void 0;
var ik = Z, ok = hl, ak = function(e) {
  var t = e.container, n = e.element, r = e.scoutElement, i = e.children;
  return (0, ik.useLayoutEffect)(function() {
    return t.appendChild(n), t.appendChild(r), function() {
      t.removeChild(n), t.removeChild(r);
    };
  }, [t, n, r]), (0, ok.createPortal)(i, n);
};
yo.PopoverPortal = ak;
var _o = {};
(function(e) {
  var t = kt && kt.__assign || function() {
    return t = Object.assign || function(c) {
      for (var l, d = 1, h = arguments.length; d < h; d++) {
        l = arguments[d];
        for (var g in l)
          Object.prototype.hasOwnProperty.call(l, g) && (c[g] = l[g]);
      }
      return c;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.getNudgedPopoverRect = e.getNewPopoverRect = e.popoverRectForPosition = e.createContainer = e.rectsAreEqual = e.createRect = e.EMPTY_RECT = void 0, e.EMPTY_RECT = {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0
  };
  var n = function(c) {
    var l = c.top, d = c.left, h = c.width, g = c.height;
    return {
      top: l,
      left: d,
      width: h,
      height: g,
      right: d + h,
      bottom: l + g
    };
  };
  e.createRect = n;
  var r = function(c, l) {
    return c === l || (c == null ? void 0 : c.bottom) === (l == null ? void 0 : l.bottom) && (c == null ? void 0 : c.height) === (l == null ? void 0 : l.height) && (c == null ? void 0 : c.left) === (l == null ? void 0 : l.left) && (c == null ? void 0 : c.right) === (l == null ? void 0 : l.right) && (c == null ? void 0 : c.top) === (l == null ? void 0 : l.top) && (c == null ? void 0 : c.width) === (l == null ? void 0 : l.width);
  };
  e.rectsAreEqual = r;
  var i = function(c) {
    var l = c.containerStyle, d = c.containerClassName, h = c.id, g = window.document.createElement("div");
    return g.id = h, d && (g.className = d), Object.assign(g.style, l), g;
  };
  e.createContainer = i;
  var o = function(c, l, d, h, g) {
    var b = l.left + l.width / 2, y = l.top + l.height / 2, v = d.width, _ = d.height, w, k;
    switch (c) {
      case "left":
        w = y - _ / 2, k = l.left - h - v, g === "start" && (w = l.top), g === "end" && (w = l.bottom - _);
        break;
      case "bottom":
        w = l.bottom + h, k = b - v / 2, g === "start" && (k = l.left), g === "end" && (k = l.right - v);
        break;
      case "right":
        w = y - _ / 2, k = l.right + h, g === "start" && (w = l.top), g === "end" && (w = l.bottom - _);
        break;
      default:
        w = l.top - _ - h, k = b - v / 2, g === "start" && (k = l.left), g === "end" && (k = l.right - v);
        break;
    }
    return (0, e.createRect)({ left: k, top: w, width: v, height: _ });
  };
  e.popoverRectForPosition = o;
  var a = function(c, l) {
    var d = c.position, h = c.align, g = c.childRect, b = c.popoverRect, y = c.boundaryRect, v = c.padding, _ = c.reposition, w = (0, e.popoverRectForPosition)(d, g, b, v, h), k = _ && (d === "top" && w.top < y.top + l || d === "left" && w.left < y.left + l || d === "right" && w.right > y.right - l || d === "bottom" && w.bottom > y.bottom - l);
    return {
      rect: w,
      boundaryViolation: k
    };
  };
  e.getNewPopoverRect = a;
  var u = function(c, l, d) {
    var h = l.top + d, g = l.left + d, b = l.right - d, y = l.bottom - d, v = c.top < h ? h : c.top;
    v = v + c.height > y ? y - c.height : v;
    var _ = c.left < g ? g : c.left;
    return _ = _ + c.width > b ? b - c.width : _, (0, e.createRect)(t(t({}, c), { top: v, left: _ }));
  };
  e.getNudgedPopoverRect = u;
})(_o);
var bo = {}, So = {};
Object.defineProperty(So, "__esModule", { value: !0 });
So.useElementRef = void 0;
var sl = Z, sk = _o, ck = function(e) {
  var t = e.containerClassName, n = e.containerStyle, r = e.id, i = (0, sl.useRef)(), o = (0, sl.useMemo)(function() {
    return (0, sk.createContainer)({ containerStyle: n, containerClassName: t, id: r });
  }, [t, n, r]);
  return i.current = o, i;
};
So.useElementRef = ck;
Object.defineProperty(bo, "__esModule", { value: !0 });
bo.usePopover = void 0;
var uk = Z, $n = _o, cl = So, lk = {
  position: "fixed",
  overflow: "visible",
  top: "0px",
  left: "0px"
}, dk = {
  position: "fixed",
  top: "0px",
  left: "0px",
  width: "0px",
  height: "0px",
  visibility: "hidden"
}, fk = function(e) {
  var t = e.isOpen, n = e.childRef, r = e.positions, i = e.containerClassName, o = e.parentElement, a = e.transform, u = e.transformMode, c = e.align, l = e.padding, d = e.reposition, h = e.boundaryInset, g = e.boundaryElement, b = e.onPositionPopover, y = (0, cl.useElementRef)({ id: "react-tiny-popover-scout", containerStyle: dk }), v = (0, cl.useElementRef)({
    id: "react-tiny-popover-container",
    containerClassName: i,
    containerStyle: lk
  }), _ = (0, uk.useCallback)(function(w) {
    var k, O, I = w === void 0 ? {} : w, N = I.positionIndex, E = N === void 0 ? 0 : N, L = I.parentRect, B = L === void 0 ? o.getBoundingClientRect() : L, Q = I.childRect, G = Q === void 0 ? (k = n == null ? void 0 : n.current) === null || k === void 0 ? void 0 : k.getBoundingClientRect() : Q, te = I.scoutRect, ie = te === void 0 ? (O = y == null ? void 0 : y.current) === null || O === void 0 ? void 0 : O.getBoundingClientRect() : te, J = I.popoverRect, ce = J === void 0 ? v.current.getBoundingClientRect() : J, Me = I.boundaryRect, se = Me === void 0 ? g === o ? B : g.getBoundingClientRect() : Me;
    if (!(!G || !B || !t)) {
      if (a && u === "absolute") {
        var Re = typeof a == "function" ? a({
          childRect: G,
          popoverRect: ce,
          parentRect: B,
          boundaryRect: se,
          padding: l,
          align: c,
          nudgedTop: 0,
          nudgedLeft: 0,
          boundaryInset: h,
          violations: $n.EMPTY_RECT,
          hasViolations: !1
        }) : a, ke = Re.top, Ae = Re.left, K = Math.round(B.left + Ae - ie.left), Y = Math.round(B.top + ke - ie.top);
        v.current.style.transform = "translate(".concat(K, "px, ").concat(Y, "px)"), b({
          childRect: G,
          popoverRect: (0, $n.createRect)({
            left: K,
            top: Y,
            width: ce.width,
            height: ce.height
          }),
          parentRect: B,
          boundaryRect: se,
          padding: l,
          align: c,
          transform: { top: ke, left: Ae },
          nudgedTop: 0,
          nudgedLeft: 0,
          boundaryInset: h,
          violations: $n.EMPTY_RECT,
          hasViolations: !1
        });
        return;
      }
      var M = E === r.length, s = M ? r[0] : r[E], p = (0, $n.getNewPopoverRect)({
        childRect: G,
        popoverRect: ce,
        boundaryRect: se,
        position: s,
        align: c,
        padding: l,
        reposition: d
      }, h), f = p.rect, m = p.boundaryViolation;
      if (m && d && !M) {
        _({
          positionIndex: E + 1,
          childRect: G,
          popoverRect: ce,
          parentRect: B,
          boundaryRect: se
        });
        return;
      }
      var S = f.top, C = f.left, A = f.width, x = f.height, F = d && !M, W = (0, $n.getNudgedPopoverRect)(f, se, h), H = W.left, ve = W.top, Ee = S, me = C;
      F && (Ee = ve, me = H), Ee = Math.round(Ee - ie.top), me = Math.round(me - ie.left), v.current.style.transform = "translate(".concat(me, "px, ").concat(Ee, "px)");
      var oe = {
        top: se.top + h - Ee,
        left: se.left + h - me,
        right: me + A - se.right + h,
        bottom: Ee + x - se.bottom + h
      }, Ne = {
        childRect: G,
        popoverRect: (0, $n.createRect)({ left: me, top: Ee, width: A, height: x }),
        parentRect: B,
        boundaryRect: se,
        position: s,
        align: c,
        padding: l,
        nudgedTop: ve - S,
        nudgedLeft: H - C,
        boundaryInset: h,
        violations: {
          top: oe.top <= 0 ? 0 : oe.top,
          left: oe.left <= 0 ? 0 : oe.left,
          right: oe.right <= 0 ? 0 : oe.right,
          bottom: oe.bottom <= 0 ? 0 : oe.bottom
        },
        hasViolations: oe.top > 0 || oe.left > 0 || oe.right > 0 || oe.bottom > 0
      };
      if (a) {
        b(Ne);
        var tt = typeof a == "function" ? a(Ne) : a, Ue = tt.top, he = tt.left;
        v.current.style.transform = "translate(".concat(Math.round(me + (he ?? 0)), "px, ").concat(Math.round(Ee + (Ue ?? 0)), "px)"), Ne.nudgedLeft += he ?? 0, Ne.nudgedTop += Ue ?? 0, Ne.transform = { top: Ue, left: he };
      }
      b(Ne);
    }
  }, [
    o,
    n,
    y,
    v,
    g,
    t,
    a,
    u,
    r,
    c,
    l,
    d,
    h,
    b
  ]);
  return { positionPopover: _, popoverRef: v, scoutRef: y };
};
bo.usePopover = fk;
var wo = {};
Object.defineProperty(wo, "__esModule", { value: !0 });
wo.useMemoizedArray = void 0;
var ul = Z, pk = function(e) {
  var t = (0, ul.useRef)(e), n = (0, ul.useMemo)(function() {
    if (t.current === e)
      return t.current;
    if (t.current.length !== e.length)
      return t.current = e, e;
    for (var r = 0; r < e.length; r += 1)
      if (e[r] !== t.current[r])
        return t.current = e, e;
    return t.current;
  }, [e]);
  return n;
};
wo.useMemoizedArray = pk;
var Fr = {}, Ya = kt && kt.__assign || function() {
  return Ya = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, Ya.apply(this, arguments);
};
Object.defineProperty(Fr, "__esModule", { value: !0 });
Fr.useArrowContainer = void 0;
var ll = Z, hk = function(e) {
  var t = e.childRect, n = e.popoverRect, r = e.position, i = e.arrowSize, o = e.arrowColor, a = (0, ll.useMemo)(function() {
    return {
      padding: i
    };
  }, [i]), u = (0, ll.useMemo)(function() {
    return Ya({ position: "absolute" }, function() {
      var c = i * 2, l = t.top - n.top + t.height / 2 - c / 2, d = t.left - n.left + t.width / 2 - c / 2, h = i, g = n.width - i, b = n.height - i;
      switch (d = d < h ? h : d, d = d + c > g ? g - c : d, l = l < h ? h : l, l = l + c > b ? b - c : l, l = Number.isNaN(l) ? 0 : l, d = Number.isNaN(d) ? 0 : d, r) {
        case "right":
          return {
            borderTop: "".concat(i, "px solid transparent"),
            borderBottom: "".concat(i, "px solid transparent"),
            borderRight: "".concat(i, "px solid ").concat(o),
            left: 0,
            top: l
          };
        case "left":
          return {
            borderTop: "".concat(i, "px solid transparent"),
            borderBottom: "".concat(i, "px solid transparent"),
            borderLeft: "".concat(i, "px solid ").concat(o),
            right: 0,
            top: l
          };
        case "bottom":
          return {
            borderLeft: "".concat(i, "px solid transparent"),
            borderRight: "".concat(i, "px solid transparent"),
            borderBottom: "".concat(i, "px solid ").concat(o),
            top: 0,
            left: d
          };
        case "top":
          return {
            borderLeft: "".concat(i, "px solid transparent"),
            borderRight: "".concat(i, "px solid transparent"),
            borderTop: "".concat(i, "px solid ").concat(o),
            bottom: 0,
            left: d
          };
        default:
          return {
            display: "hidden"
          };
      }
    }());
  }, [
    o,
    i,
    t.height,
    t.left,
    t.top,
    t.width,
    n.height,
    n.left,
    n.top,
    n.width,
    r
  ]);
  return {
    arrowContainerStyle: a,
    arrowStyle: u
  };
};
Fr.useArrowContainer = hk;
var ko = {}, zn = kt && kt.__assign || function() {
  return zn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, zn.apply(this, arguments);
};
Object.defineProperty(ko, "__esModule", { value: !0 });
ko.ArrowContainer = void 0;
var dl = D, fl = Z, vk = Fr, mk = function(e) {
  var t = e.childRect, n = e.popoverRect, r = e.position, i = e.arrowColor, o = e.arrowSize, a = e.arrowClassName, u = e.arrowStyle, c = e.className, l = e.children, d = e.style, h = (0, vk.useArrowContainer)({
    childRect: t,
    popoverRect: n,
    position: r,
    arrowColor: i,
    arrowSize: o
  }), g = h.arrowContainerStyle, b = h.arrowStyle, y = (0, fl.useMemo)(function() {
    return zn(zn({}, g), d);
  }, [g, d]), v = (0, fl.useMemo)(function() {
    return zn(zn({}, b), u);
  }, [b, u]);
  return (0, dl.jsxs)("div", { className: c, style: y, children: [(0, dl.jsx)("div", { style: v, className: a }), l] });
};
ko.ArrowContainer = mk;
(function(e) {
  var t = kt && kt.__assign || function() {
    return t = Object.assign || function(g) {
      for (var b, y = 1, v = arguments.length; y < v; y++) {
        b = arguments[y];
        for (var _ in b)
          Object.prototype.hasOwnProperty.call(b, _) && (g[_] = b[_]);
      }
      return g;
    }, t.apply(this, arguments);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Popover = e.usePopover = e.ArrowContainer = e.useArrowContainer = void 0;
  var n = D, r = Z, i = yo, o = _o, a = bo;
  Object.defineProperty(e, "usePopover", { enumerable: !0, get: function() {
    return a.usePopover;
  } });
  var u = wo, c = Fr;
  Object.defineProperty(e, "useArrowContainer", { enumerable: !0, get: function() {
    return c.useArrowContainer;
  } });
  var l = ko;
  Object.defineProperty(e, "ArrowContainer", { enumerable: !0, get: function() {
    return l.ArrowContainer;
  } });
  var d = ["top", "left", "right", "bottom"], h = (0, r.forwardRef)(function(g, b) {
    var y = g.isOpen, v = g.children, _ = g.content, w = g.positions, k = w === void 0 ? d : w, O = g.align, I = O === void 0 ? "center" : O, N = g.padding, E = N === void 0 ? 0 : N, L = g.reposition, B = L === void 0 ? !0 : L, Q = g.parentElement, G = Q === void 0 ? window.document.body : Q, te = g.boundaryElement, ie = te === void 0 ? G : te, J = g.containerClassName, ce = g.containerStyle, Me = g.transform, se = g.transformMode, Re = se === void 0 ? "absolute" : se, ke = g.boundaryInset, Ae = ke === void 0 ? 0 : ke, K = g.onClickOutside, Y = g.clickOutsideCapture, M = Y === void 0 ? !1 : Y, s = (0, u.useMemoizedArray)(Array.isArray(k) ? k : [k]), p = (0, r.useRef)(!1), f = (0, r.useRef)(), m = (0, r.useRef)(B), S = (0, r.useRef)(), C = (0, r.useState)({
      align: I,
      nudgedLeft: 0,
      nudgedTop: 0,
      position: s[0],
      padding: E,
      childRect: o.EMPTY_RECT,
      popoverRect: o.EMPTY_RECT,
      parentRect: o.EMPTY_RECT,
      boundaryRect: o.EMPTY_RECT,
      boundaryInset: Ae,
      violations: o.EMPTY_RECT,
      hasViolations: !1
    }), A = C[0], x = C[1], F = (0, r.useCallback)(function(he) {
      return x(he);
    }, []), W = (0, a.usePopover)({
      isOpen: y,
      childRef: S,
      containerClassName: J,
      parentElement: G,
      boundaryElement: ie,
      transform: Me,
      transformMode: Re,
      positions: s,
      align: I,
      padding: E,
      boundaryInset: Ae,
      reposition: B,
      onPositionPopover: F
    }), H = W.positionPopover, ve = W.popoverRef, Ee = W.scoutRef;
    (0, r.useLayoutEffect)(function() {
      var he = !0, We = function() {
        var Ke, _t;
        if (y && he) {
          var jt = (Ke = S == null ? void 0 : S.current) === null || Ke === void 0 ? void 0 : Ke.getBoundingClientRect(), Dt = (_t = ve == null ? void 0 : ve.current) === null || _t === void 0 ? void 0 : _t.getBoundingClientRect();
          jt != null && Dt != null && (!(0, o.rectsAreEqual)(jt, A.childRect) || Dt.width !== A.popoverRect.width || Dt.height !== A.popoverRect.height || A.padding !== E || A.align !== I || s !== f.current || B !== m.current) && H(), s !== f.current && (f.current = s), B !== m.current && (m.current = B), he && window.requestAnimationFrame(We);
        }
        p.current = y;
      };
      return window.requestAnimationFrame(We), function() {
        he = !1;
      };
    }, [
      I,
      y,
      E,
      ve,
      A.align,
      A.childRect,
      A.padding,
      A.popoverRect.height,
      A.popoverRect.width,
      H,
      s,
      B
    ]), (0, r.useEffect)(function() {
      var he = ve.current;
      return Object.assign(he.style, ce), function() {
        Object.keys(ce ?? {}).forEach(function(We) {
          return delete he.style[We];
        });
      };
    }, [ce, y, ve]);
    var me = (0, r.useCallback)(function(he) {
      var We, Ke;
      y && !(!((We = ve.current) === null || We === void 0) && We.contains(he.target)) && !(!((Ke = S.current) === null || Ke === void 0) && Ke.contains(he.target)) && (K == null || K(he));
    }, [y, K, ve]), oe = (0, r.useCallback)(function() {
      S.current && window.requestAnimationFrame(function() {
        return H();
      });
    }, [H]);
    (0, r.useEffect)(function() {
      var he = G.ownerDocument.body;
      return he.addEventListener("click", me, M), he.addEventListener("contextmenu", me, M), he.addEventListener("resize", oe), function() {
        he.removeEventListener("click", me, M), he.removeEventListener("contextmenu", me, M), he.removeEventListener("resize", oe);
      };
    }, [M, me, oe, G]);
    var Ne = (0, r.useCallback)(function(he) {
      S.current = he, b != null && (typeof b == "object" ? b.current = he : typeof b == "function" && b(he));
    }, [b]), tt = function() {
      return (0, r.cloneElement)(v, { ref: Ne });
    }, Ue = function() {
      return y ? (0, n.jsx)(i.PopoverPortal, { element: ve.current, scoutElement: Ee.current, container: G, children: typeof _ == "function" ? _(A) : _ }) : null;
    };
    return (0, n.jsxs)(n.Fragment, { children: [tt(), Ue()] });
  });
  e.Popover = (0, r.forwardRef)(function(g, b) {
    return typeof window > "u" ? g.children : (0, n.jsx)(h, t({}, g, { ref: b }));
  });
})(Wf);
const an = (e) => {
  let t;
  const [n, r] = ut(!1), i = () => {
    t = setTimeout(() => {
      r(!0);
    }, e.delay || 200);
  }, o = () => {
    clearInterval(t), r(!1);
  };
  return /* @__PURE__ */ D.jsxs("div", { className: "tooltip__wrapper", onMouseEnter: i, onMouseLeave: o, style: e.styles, children: [
    e.children,
    n && /* @__PURE__ */ D.jsx("div", { className: `tooltip__tip ${Ut.supportedBrowser().mobile ? "hidden" : "bottom"}`, children: e.title })
  ] });
}, gk = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: e == null ? void 0 : e.className,
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: e == null ? void 0 : e.fill,
    style: e == null ? void 0 : e.style,
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9A7.902 7.902 0 0 1 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1A7.902 7.902 0 0 1 20 12c0 4.42-3.58 8-8 8z" })
  }
), yk = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: "MuiSvgIcon-root",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: e == null ? void 0 : e.fill,
    style: e == null ? void 0 : e.style,
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z" })
  }
), _k = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: "MuiSvgIcon-root",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    fill: e == null ? void 0 : e.fill,
    style: e == null ? void 0 : e.style,
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M19 7v2.99s-1.99.01-2 0V7h-3s.01-1.99 0-2h3V2h2v3h3v2h-3zm-3 4V8h-3V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-8h-3zM5 19l3-4 2 3 3-4 4 5H5z" })
  }
);
function bk({}) {
  const { backgroundImage: e } = xt(), { errorMsg: t, inputSettings: n, updateInputSettings: r } = J0(), [i, o] = ut(!1), a = it();
  function u() {
    r({
      video: {
        processor: {
          type: "none"
        }
      }
    }).finally(() => o(!1));
  }
  function c() {
    r({
      video: {
        processor: {
          type: "background-blur",
          config: { strength: 0.5 }
        }
      }
    }).finally(() => o(!1));
  }
  function l() {
    r({
      video: {
        processor: {
          type: "background-image",
          config: { source: e }
        }
      }
    }).finally(() => o(!1));
  }
  function d() {
    var h, g, b, y, v, _;
    return /* @__PURE__ */ D.jsxs("ul", { className: "video-processor-button_options", children: [
      ["background-image", "background-blur"].includes((g = (h = n.video) == null ? void 0 : h.processor) == null ? void 0 : g.type) && /* @__PURE__ */ D.jsx("li", { onClick: u, children: /* @__PURE__ */ D.jsx(an, { title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: "Turn off visual effects" }), children: /* @__PURE__ */ D.jsx("div", { className: "video-processor-button_icon", children: /* @__PURE__ */ D.jsx(gk, {}) }) }) }),
      ((y = (b = n.video) == null ? void 0 : b.processor) == null ? void 0 : y.type) !== "background-blur" && /* @__PURE__ */ D.jsx("li", { onClick: c, children: /* @__PURE__ */ D.jsx(an, { title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: "Blur your background" }), children: /* @__PURE__ */ D.jsx("div", { className: "video-processor-button_icon", children: /* @__PURE__ */ D.jsx(yk, {}) }) }) }),
      ((_ = (v = n.video) == null ? void 0 : v.processor) == null ? void 0 : _.type) !== "background-image" && e && /* @__PURE__ */ D.jsx("li", { onClick: l, children: /* @__PURE__ */ D.jsx(an, { title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: "Enable background image" }), children: /* @__PURE__ */ D.jsx("div", { className: "video-processor-button_icon", children: /* @__PURE__ */ D.jsx(_k, {}) }) }) })
    ] });
  }
  return /* @__PURE__ */ D.jsx("div", { ref: a, className: "video-processor-button", children: /* @__PURE__ */ D.jsx(
    Wf.Popover,
    {
      isOpen: i,
      onClickOutside: () => o(!1),
      positions: "right",
      padding: 10,
      reposition: !0,
      parentElement: a.current,
      content: d,
      children: /* @__PURE__ */ D.jsx("div", { className: "video-processor-button_awesome-icon", onClick: () => o(!i), children: /* @__PURE__ */ D.jsx(rk, { fill: "#6e6e6e" }) })
    }
  ) });
}
function Sk({}) {
  const e = It(), t = sr(e), n = go(e), { isSharingScreen: r } = vo(), { options: i } = xt(), [o, a, u] = ho(e, ["user_id", "user_name", "userData"]), [c, l] = ut(null), d = ge(Ms((h) => {
    l(h);
  }, 50), []);
  return jf(n == null ? void 0 : n.persistentTrack, d), zf(o, e, a, c, n == null ? void 0 : n.isOff), e ? /* @__PURE__ */ D.jsxs(
    "div",
    {
      id: "LocalParticipantInfo.container",
      className: "local-video-wrapper",
      children: [
        /* @__PURE__ */ D.jsxs(
          "div",
          {
            className: `local-participant-info__container ${t.isOff ? "local-participant-info--muted" : ""}`,
            children: [
              !t.isOff && /* @__PURE__ */ D.jsx(
                Ns,
                {
                  className: "local-video-element",
                  automirror: !0,
                  sessionId: e,
                  type: r ? "screenVideo" : "video",
                  fit: r ? "contain" : "cover"
                }
              ),
              (i == null ? void 0 : i.enableVideoProcessors) && Ut.supportedBrowser().supportsVideoProcessing && !t.isOff && /* @__PURE__ */ D.jsx(bk, {}),
              t.isOff && /* @__PURE__ */ D.jsx("div", { children: /* @__PURE__ */ D.jsx(
                Uf,
                {
                  initials: (u == null ? void 0 : u.initials) ?? null,
                  avatar: (u == null ? void 0 : u.avatar) ?? null,
                  size: 70,
                  fontSize: 28
                }
              ) })
            ]
          }
        ),
        (i == null ? void 0 : i.showCallTimer) && /* @__PURE__ */ D.jsx(nk, {})
      ]
    }
  ) : null;
}
function wk() {
  const e = It(), t = Os({ filter: "remote" });
  return t.length > 0 ? t[0] : e;
}
function kk({ volume: e }) {
  const t = Pt(() => Math.min(21, Math.max(0, Math.log10(e * 255 / 3) * 14))), n = window.screen.width < 600 ? 8 : 12, r = { backgroundColor: Vf }, i = (a, u = 0) => ({ height: `${a}px`, backgroundColor: $f, ...t > u ? r : "" }), o = (a, u = 0) => /* @__PURE__ */ D.jsx(
    "span",
    {
      className: `audio-level__indicator ${t > 0 ? "audio-level__indicator--full" : ""}`,
      style: i(a, u)
    }
  );
  return /* @__PURE__ */ D.jsxs("div", { className: "audio-level", children: [
    o(n, 0),
    o(n * 1.5, 7),
    o(n * 2, 14)
  ] });
}
function Ek({ name: e }) {
  return /* @__PURE__ */ D.jsx("span", { className: "app-info-display", children: e });
}
const qf = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: e == null ? void 0 : e.className,
    viewBox: "0 0 24 24",
    fill: "#fff",
    "aria-hidden": "true",
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3 3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z" })
  }
);
function Tk({ showOverlays: e }) {
  const { themeOptions: t } = xt(), n = wk(), [r, i, o, a] = ho(n, ["local", "user_id", "user_name", "userData"]), u = sr(n), c = go(n), [l, d] = ut(null), h = it(!0), g = ge(Ms((Q) => {
    h.current && d(Q);
  }, 50), []);
  jf(c == null ? void 0 : c.persistentTrack, g), zf(!r && i, n, o, l, c == null ? void 0 : c.isOff);
  const { screens: b } = vo(), y = Pt(
    () => !!b.find((Q) => Q.session_id === n),
    [b, n]
  ), [v, _] = ut(null), w = Pt(
    () => ((v == null ? void 0 : v.height) ?? 0) > ((v == null ? void 0 : v.width) ?? 0),
    [v]
  ), k = window.innerHeight > window.innerWidth, O = Pt(
    () => w && !k || y ? "contain" : "cover",
    [w, k, y]
  ), I = (o == null ? void 0 : o.split(" ")[0]) ?? "", { format: N } = rr(), E = N(zt.remote_muted_audio, { name: I });
  Oe(() => () => {
    h.current = !1, g.cancel();
  }, [g]);
  const L = () => w && !k ? {
    height: "133%",
    marginTop: window.innerHeight * 0
    //window.innerHeight*0.3,
  } : null, B = () => {
    const Q = { borderRadius: t.userDefined.statusMessageRadius };
    return Q.backgroundColor = t.userDefined.statusMessageBGColor, Q;
  };
  return /* @__PURE__ */ D.jsxs(
    "div",
    {
      id: "MainParticipantInfo.container",
      className: `main-participant-info__container ${u.isOff ? "video-switched--off" : ""}`,
      children: [
        /* @__PURE__ */ D.jsx(
          "div",
          {
            id: "MainParticipantInfo.infoContainer",
            className: "main-participant-info__container__info",
            children: /* @__PURE__ */ D.jsx(
              "span",
              {
                className: `status-messages ${!c.isOff && "status-messages--empty"}`,
                style: B(),
                children: c.isOff && [
                  /* @__PURE__ */ D.jsx("h4", { children: E }, "mute-message"),
                  /* @__PURE__ */ D.jsx(qf, { style: { width: "24px", height: "24px" } }, "mute-icon")
                ]
              }
            )
          }
        ),
        u.isOff ? /* @__PURE__ */ D.jsx("div", { className: "video--off__message", children: /* @__PURE__ */ D.jsx(
          Uf,
          {
            initials: (a == null ? void 0 : a.initials) ?? null,
            avatar: (a == null ? void 0 : a.avatar) ?? null
          }
        ) }) : /* @__PURE__ */ D.jsx(
          Ns,
          {
            className: "remote-video-element",
            style: L(),
            automirror: !0,
            sessionId: n,
            onResize: _,
            type: y ? "screenVideo" : "video",
            fit: O
          }
        ),
        /* @__PURE__ */ D.jsxs("div", { className: `aux-info__container ${e ? "show-overlays" : ""}`, children: [
          o && /* @__PURE__ */ D.jsx(Ek, { name: o }),
          /* @__PURE__ */ D.jsx(kk, { volume: l })
        ] })
      ]
    }
  );
}
function Rk({ showOverlays: e }) {
  return /* @__PURE__ */ D.jsxs("div", { id: "Room", children: [
    /* @__PURE__ */ D.jsx(Tk, { showOverlays: e }),
    /* @__PURE__ */ D.jsx(Sk, {}),
    /* @__PURE__ */ D.jsx(Af, {})
  ] });
}
function Ck() {
  const { leave: e, emit: t } = xt(), { format: n } = rr(), r = () => {
    t("controlEvent", { action: "disconnect" }), e();
  };
  return /* @__PURE__ */ D.jsx(an, { title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: n(zt.end_call) }), children: /* @__PURE__ */ D.jsx(
    "button",
    {
      onClick: r,
      className: "end-call-button",
      id: "end-call-button",
      style: { borderColor: wi, WebkitTextFillColor: wi, color: wi, backgroundColor: Y0 },
      children: n(zt.cta_bye)
    }
  ) });
}
function Eo({ theme: e, onClick: t, disabled: n = !1, size: r = "small", isIconEnabled: i = !1, icon: o = null }) {
  const a = () => i === null ? {
    backgroundColor: $f,
    borderColor: "#565656"
  } : {
    backgroundColor: i ? "transparent" : e.userDefined.ctrlButtonColor,
    borderColor: i ? "#565656" : e.userDefined.ctrlButtonColor
  }, u = i !== null ? i ? "fab--enabled" : "fab--disabled" : "", c = n ? "fab__cursor--disabled" : "fab__cursor--enabled";
  return /* @__PURE__ */ D.jsx(
    "button",
    {
      className: `button-base--root fab--root fab--small fab ${u} ${c}`,
      onClick: t,
      style: a(),
      disabled: n,
      size: r,
      children: /* @__PURE__ */ D.jsx("span", { className: "fab__label", children: o })
    }
  );
}
function Mk({}) {
  const e = Xe(), t = It(), n = go(t), { format: r } = rr(), { themeOptions: i, emit: o } = xt(), a = n.isOff, u = ge(() => {
    o("controlEvent", { action: "toggleAudio", isEnabled: a }), e.setLocalAudio(a);
  }, [e, a]);
  return /* @__PURE__ */ D.jsx(
    an,
    {
      title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: r(a ? zt.cta_unmute_audio : zt.cta_mute_audio) }),
      children: /* @__PURE__ */ D.jsx("span", { id: "audio-button", children: /* @__PURE__ */ D.jsx(
        Eo,
        {
          icon: /* @__PURE__ */ D.jsx(qf, { fill: a ? "white" : "", className: "control-size" }),
          theme: i,
          onClick: u,
          disabled: !n.persistentTrack,
          isIconEnabled: !a,
          size: "small"
        }
      ) })
    }
  );
}
const Ak = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: e == null ? void 0 : e.className,
    viewBox: "0 0 24 24",
    fill: "#fff",
    "aria-hidden": "true",
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "m21 6.5-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2 2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z" })
  }
);
function Pk({}) {
  const e = Xe(), t = It(), n = sr(t), { format: r } = rr(), { themeOptions: i, emit: o } = xt(), a = n.isOff, u = ge(() => {
    o("controlEvent", { action: "toggleVideo", isEnabled: a }), e.setLocalVideo(a);
  }, [e, a]);
  return /* @__PURE__ */ D.jsx(
    an,
    {
      title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: r(a ? zt.cta_unmute_video : zt.cta_mute_video) }),
      children: /* @__PURE__ */ D.jsx("span", { id: "video-button", children: /* @__PURE__ */ D.jsx(
        Eo,
        {
          icon: /* @__PURE__ */ D.jsx(Ak, { fill: a ? "white" : "", className: "control-size" }),
          theme: i,
          onClick: u,
          disabled: !1,
          isIconEnabled: !a,
          size: "small"
        }
      ) })
    }
  );
}
const Ok = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: e == null ? void 0 : e.className,
    viewBox: "0 0 24 24",
    fill: "#fff",
    "aria-hidden": "true",
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z" })
  }
), Nk = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: e == null ? void 0 : e.className,
    viewBox: "0 0 24 24",
    fill: "#fff",
    "aria-hidden": "true",
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M20 18c1.1 0 1.99-.9 1.99-2L22 6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v10a2 2 0 0 0 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z" })
  }
);
function Lk({}) {
  const { themeOptions: e, emit: t } = xt(), { isSharingScreen: n, startScreenShare: r, stopScreenShare: i } = vo(), o = Ut.supportedBrowser().supportsScreenShare, { format: a } = rr();
  let u = a(zt.cta_start_screen_share);
  n && (u = a(zt.cta_stop_screen_share));
  const c = ge(
    () => (t("controlEvent", { action: "toggleScreenShare", isEnabled: !n }), n ? i() : r()),
    [n]
  );
  return o && /* @__PURE__ */ D.jsx(an, { title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: u }), children: /* @__PURE__ */ D.jsx("span", { id: "share-button", children: /* @__PURE__ */ D.jsx(
    Eo,
    {
      icon: n ? /* @__PURE__ */ D.jsx(Nk, { fill: "white", className: "control-size" }) : /* @__PURE__ */ D.jsx(Ok, { fill: "black", className: "control-size" }),
      theme: e,
      onClick: c,
      disabled: !1,
      isIconEnabled: null,
      size: "small"
    }
  ) }) });
}
const Ik = (e) => /* @__PURE__ */ D.jsx(
  "svg",
  {
    className: e == null ? void 0 : e.className,
    viewBox: "0 0 24 24",
    fill: "#fff",
    "aria-hidden": "true",
    ...e,
    children: /* @__PURE__ */ D.jsx("path", { d: "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5H5l2.5-2.5L10 13H8c0 2.21 1.79 4 4 4 .58 0 1.13-.13 1.62-.35l.74.74c-.71.37-1.5.61-2.36.61zm4.5-2.5L14 13h2c0-2.21-1.79-4-4-4-.58 0-1.13.13-1.62.35l-.74-.73C10.35 8.24 11.14 8 12 8c2.76 0 5 2.24 5 5h2l-2.5 2.5z" })
  }
);
function xk() {
  const e = Xe(), { themeOptions: t, emit: n } = xt(), r = It(), i = sr(r), o = Ut.supportedBrowser().mobile, { format: a } = rr(), u = ge(() => {
    e.cycleCamera().then(({ device: c }) => {
      n("controlEvent", { action: "toggleFacingMode", newFacingMode: c.label });
    });
  }, [e]);
  return o ? /* @__PURE__ */ D.jsx(an, { title: /* @__PURE__ */ D.jsx("span", { className: "tooltip-title", children: a(zt.cta_switch_camera) }), children: /* @__PURE__ */ D.jsx("span", { children: /* @__PURE__ */ D.jsx(
    Eo,
    {
      icon: /* @__PURE__ */ D.jsx(Ik, { fill: "black", className: "control-size" }),
      theme: t,
      onClick: u,
      disabled: !i.persistentTrack,
      isIconEnabled: null,
      size: "small"
    }
  ) }) }) : null;
}
function jk({ showControls: e = !1 }) {
  const { themeOptions: t, roomState: n } = xt();
  return /* @__PURE__ */ D.jsx("div", { className: `controls-container ${e ? "show-controls" : ""}`, children: /* @__PURE__ */ D.jsxs("div", { className: "controls", style: { borderRadius: t.userDefined.ctrlBarRadius }, children: [
    /* @__PURE__ */ D.jsx(xk, {}),
    /* @__PURE__ */ D.jsx(Mk, {}),
    /* @__PURE__ */ D.jsx(Pk, {}),
    n === "joined-meeting" && /* @__PURE__ */ D.jsxs(D.Fragment, { children: [
      /* @__PURE__ */ D.jsx(Lk, {}),
      /* @__PURE__ */ D.jsx(Ck, {})
    ] })
  ] }) });
}
const di = (e) => !["blocked", "off"].includes(e.state);
function Dk() {
  const e = Xe();
  function t({ devices: o, errorEvent: a }) {
    const { camera: u, mic: c, speaker: l } = o;
    let d = { camera: u, mic: c, speaker: l };
    if ((a == null ? void 0 : a.action) === "camera-error")
      switch (d.error = a.error, a.error.type) {
        case "not-found":
          a.error.missingMedia.includes("video") && (d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          }), a.error.missingMedia.includes("audio") && (d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          });
          break;
        case "cam-in-use":
          d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          };
          break;
        case "mic-in-use":
          d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          };
          break;
        case "cam-mic-in-use":
          d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          }, d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          };
          break;
        case "permissions":
          a.error.blockedMedia.includes("video") && (d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              blockedBy: a.error.blockedBy,
              type: a.error.type
            }
          }), a.error.blockedMedia.includes("audio") && (d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              blockedBy: a.error.blockedBy,
              type: a.error.type
            }
          });
          break;
        case "constraints":
          d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              reason: a.error.reason,
              type: a.error.type
            }
          }, d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              reason: a.error.reason,
              type: a.error.type
            }
          };
          break;
        case "unknown":
        case "undefined-mediadevices":
          d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          }, d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          };
          break;
        default:
          d.camera = {
            ...d.camera,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          }, d.mic = {
            ...d.mic,
            error: {
              message: a.error.msg,
              type: a.error.type
            }
          };
          break;
      }
    return d;
  }
  const n = ge((o) => {
    let a = Object.assign({}, { audioDeviceId: !0, videoDeviceId: !0, audioOutputDeviceId: null, startVideoOff: !1 }, o);
    const { audioDeviceId: u, videoDeviceId: c, audioOutputDeviceId: l, startVideoOff: d } = a;
    let h;
    return new Promise((g, b) => {
      const y = (_) => {
        e.off("camera-error", y), h = _;
      };
      e.on("camera-error", y);
      const v = {
        audioSource: u,
        videoSource: c,
        startVideoOff: d,
        dailyConfig: Bf(a)
      };
      qe.info("starting camera with options", { dailyOptions: v, audioOutputDeviceId: l }), e.startCamera(v).then((_) => (e.off("camera-error", y), l ? e.setOutputDeviceAsync({ outputDeviceId: l }) : Promise.resolve(_))).then((_) => {
        g(t({ devices: _, errorEvent: h }));
      }).catch((_) => {
        e.off("camera-error", y), b(_);
      });
    });
  }, [e]);
  function r() {
    e.leave();
  }
  function i() {
    return new Promise((o, a) => {
      var l;
      const u = (d) => {
        d.action === "camera-error" ? (e.off("camera-error", u), e.off("participant-updated", u), a(d.error)) : d.action === "participant-updated" && d.participant.local && di(d.participant.tracks.audio) && di(d.participant.tracks.video) && (e.off("camera-error", u), e.off("participant-updated", u), qe.info("restarting camera complete"), o());
      };
      e.on("camera-error", u), e.on("participant-updated", u);
      const c = e.participants();
      if (di(c.local.tracks.audio) && di((l = c.local.tracks) == null ? void 0 : l.video))
        return o();
      qe.info("restarting camera"), e.setLocalAudio(!0), e.setLocalVideo(!0);
    });
  }
  return { startCamera: n, stopCamera: r, restartCamera: i };
}
function Wk() {
  const e = Xe(), t = It(), n = sr(t), r = go(t), { startCamera: i, stopCamera: o, restartCamera: a } = Dk(), u = r == null ? void 0 : r.isOff, c = n == null ? void 0 : n.isOff, l = () => {
    e.setLocalAudio(u);
  }, d = () => {
    e.setLocalVideo(c);
  };
  return {
    localVideo: n == null ? void 0 : n.persistentTrack,
    localAudio: r == null ? void 0 : r.persistentTrack,
    isAudioMuted: u,
    isVideoMuted: c,
    toggleAudio: l,
    toggleVideo: d,
    startCamera: i,
    stopCamera: o,
    restartCamera: a
  };
}
function qk() {
  const e = Xe(), t = It(), n = sr(t), r = ge(async (o = 15) => {
    if (qe.info("starting to run network tests", { videoTrack: n }), !e)
      throw new Error("runTests failed becasue call object not initialized");
    try {
      const a = await e.testNetworkConnectivity(n == null ? void 0 : n.persistentTrack), u = await e.testPeerToPeerCallQuality({ videoTrack: n == null ? void 0 : n.persistentTrack, duration: o }), c = await e.testWebsocketConnectivity();
      return { networkConnectivity: a, websocketConnectivity: c, quality: u };
    } catch (a) {
      throw a;
    }
  }, [e, n]), i = ge(() => {
    e && (qe.info("network tests aborted"), e.abortTestWebsocketConnectivity(), e.abortTestNetworkConnectivity(), e.stopTestPeerToPeerCallQuality());
  }, [e]);
  return { runTests: r, abortTests: i };
}
const Jk = Ut.supportedBrowser();
function Hk({ toggleControls: e = !0, i18nFormatter: t = null }) {
  const { roomState: n } = xt();
  return /* @__PURE__ */ D.jsx(Qf, { formatter: t, children: /* @__PURE__ */ D.jsxs("div", { id: "VideoRoom", children: [
    n === "joined-meeting" && /* @__PURE__ */ D.jsx(Rk, { showOverlays: e }),
    /* @__PURE__ */ D.jsx(jk, { showControls: e })
  ] }) });
}
export {
  kk as AudioLevelIndicator,
  zk as BoutiqVideoRoomProvider,
  Jk as browserSupport,
  Hk as default,
  Fk as getLogger,
  jf as useAudioLevel,
  xt as useBoutiqVideoRoomContext,
  Uk as useDevices,
  Wk as useLocalTracks,
  qk as useNetworkTests
};
